
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Gxq1", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $598660e40b591f01$export$ffb0004e005737fa; }, function (v) { return $598660e40b591f01$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $598660e40b591f01$export$34b9dba7ce09269b; }, function (v) { return $598660e40b591f01$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $598660e40b591f01$export$25062201e9e25d76; }, function (v) { return $598660e40b591f01$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $598660e40b591f01$export$ffb0004e005737fa;
var $598660e40b591f01$export$34b9dba7ce09269b;
var $598660e40b591f01$export$25062201e9e25d76;
'use strict';

var $b7Z9x = parcelRequire("b7Z9x");
var $598660e40b591f01$var$k = Symbol.for("react.element"), $598660e40b591f01$var$l = Symbol.for("react.fragment"), $598660e40b591f01$var$m = Object.prototype.hasOwnProperty, $598660e40b591f01$var$n = $b7Z9x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $598660e40b591f01$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $598660e40b591f01$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$598660e40b591f01$var$m.call(a, b) && !$598660e40b591f01$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $598660e40b591f01$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $598660e40b591f01$var$n.current
    };
}
$598660e40b591f01$export$ffb0004e005737fa = $598660e40b591f01$var$l;
$598660e40b591f01$export$34b9dba7ce09269b = $598660e40b591f01$var$q;
$598660e40b591f01$export$25062201e9e25d76 = $598660e40b591f01$var$q;

});
parcelRegister("b7Z9x", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4WmF3"));

});
parcelRegister("4WmF3", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $398e284014f0b5df$export$dca3b0875bd9a954; }, function (v) { return $398e284014f0b5df$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $398e284014f0b5df$export$16fa2f45be04daa8; }, function (v) { return $398e284014f0b5df$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $398e284014f0b5df$export$ffb0004e005737fa; }, function (v) { return $398e284014f0b5df$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $398e284014f0b5df$export$e2c29f18771995cb; }, function (v) { return $398e284014f0b5df$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $398e284014f0b5df$export$221d75b3f55bb0bd; }, function (v) { return $398e284014f0b5df$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $398e284014f0b5df$export$5f8d39834fd61797; }, function (v) { return $398e284014f0b5df$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $398e284014f0b5df$export$74bf444e3cd11ea5; }, function (v) { return $398e284014f0b5df$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $398e284014f0b5df$export$ae55be85d98224ed; }, function (v) { return $398e284014f0b5df$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $398e284014f0b5df$export$e530037191fcd5d7; }, function (v) { return $398e284014f0b5df$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $398e284014f0b5df$export$fd42f52fd3ae1109; }, function (v) { return $398e284014f0b5df$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $398e284014f0b5df$export$c8a8987d4410bf2d; }, function (v) { return $398e284014f0b5df$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $398e284014f0b5df$export$d38cd72104c1f0e9; }, function (v) { return $398e284014f0b5df$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $398e284014f0b5df$export$7d1e3a5e95ceca43; }, function (v) { return $398e284014f0b5df$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $398e284014f0b5df$export$257a8862b851cb5b; }, function (v) { return $398e284014f0b5df$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $398e284014f0b5df$export$a8257692ac88316c; }, function (v) { return $398e284014f0b5df$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $398e284014f0b5df$export$488013bae63b21da; }, function (v) { return $398e284014f0b5df$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $398e284014f0b5df$export$7c73462e0d25e514; }, function (v) { return $398e284014f0b5df$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $398e284014f0b5df$export$7568632d0d33d16d; }, function (v) { return $398e284014f0b5df$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $398e284014f0b5df$export$88948ce120ea2619; }, function (v) { return $398e284014f0b5df$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $398e284014f0b5df$export$35808ee640e87ca7; }, function (v) { return $398e284014f0b5df$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $398e284014f0b5df$export$fae74005e78b1a27; }, function (v) { return $398e284014f0b5df$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $398e284014f0b5df$export$dc8fbce3eb94dc1e; }, function (v) { return $398e284014f0b5df$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $398e284014f0b5df$export$6a7bc4e911dc01cf; }, function (v) { return $398e284014f0b5df$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $398e284014f0b5df$export$6d9c69b0de29b591; }, function (v) { return $398e284014f0b5df$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $398e284014f0b5df$export$f680877a34711e37; }, function (v) { return $398e284014f0b5df$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $398e284014f0b5df$export$d5a552a76deda3c2; }, function (v) { return $398e284014f0b5df$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $398e284014f0b5df$export$aaabe4eda9ed9969; }, function (v) { return $398e284014f0b5df$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $398e284014f0b5df$export$e5c5a5f917a5871c; }, function (v) { return $398e284014f0b5df$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $398e284014f0b5df$export$1538c33de8887b59; }, function (v) { return $398e284014f0b5df$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $398e284014f0b5df$export$13e3392192263954; }, function (v) { return $398e284014f0b5df$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $398e284014f0b5df$export$b8f5890fc79d6aca; }, function (v) { return $398e284014f0b5df$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $398e284014f0b5df$export$60241385465d0a34; }, function (v) { return $398e284014f0b5df$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $398e284014f0b5df$export$306c0aa65ff9ec16; }, function (v) { return $398e284014f0b5df$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $398e284014f0b5df$export$7b286972b8d8ccbf; }, function (v) { return $398e284014f0b5df$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $398e284014f0b5df$export$83d89fbfd8236492; }, function (v) { return $398e284014f0b5df$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $398e284014f0b5df$export$dca3b0875bd9a954;
var $398e284014f0b5df$export$16fa2f45be04daa8;
var $398e284014f0b5df$export$ffb0004e005737fa;
var $398e284014f0b5df$export$e2c29f18771995cb;
var $398e284014f0b5df$export$221d75b3f55bb0bd;
var $398e284014f0b5df$export$5f8d39834fd61797;
var $398e284014f0b5df$export$74bf444e3cd11ea5;
var $398e284014f0b5df$export$ae55be85d98224ed;
var $398e284014f0b5df$export$e530037191fcd5d7;
var $398e284014f0b5df$export$fd42f52fd3ae1109;
var $398e284014f0b5df$export$c8a8987d4410bf2d;
var $398e284014f0b5df$export$d38cd72104c1f0e9;
var $398e284014f0b5df$export$7d1e3a5e95ceca43;
var $398e284014f0b5df$export$257a8862b851cb5b;
var $398e284014f0b5df$export$a8257692ac88316c;
var $398e284014f0b5df$export$488013bae63b21da;
var $398e284014f0b5df$export$7c73462e0d25e514;
var $398e284014f0b5df$export$7568632d0d33d16d;
var $398e284014f0b5df$export$88948ce120ea2619;
var $398e284014f0b5df$export$35808ee640e87ca7;
var $398e284014f0b5df$export$fae74005e78b1a27;
var $398e284014f0b5df$export$dc8fbce3eb94dc1e;
var $398e284014f0b5df$export$6a7bc4e911dc01cf;
var $398e284014f0b5df$export$6d9c69b0de29b591;
var $398e284014f0b5df$export$f680877a34711e37;
var $398e284014f0b5df$export$d5a552a76deda3c2;
var $398e284014f0b5df$export$aaabe4eda9ed9969;
var $398e284014f0b5df$export$e5c5a5f917a5871c;
var $398e284014f0b5df$export$1538c33de8887b59;
var $398e284014f0b5df$export$13e3392192263954;
var $398e284014f0b5df$export$b8f5890fc79d6aca;
var $398e284014f0b5df$export$60241385465d0a34;
var $398e284014f0b5df$export$306c0aa65ff9ec16;
var $398e284014f0b5df$export$7b286972b8d8ccbf;
var $398e284014f0b5df$export$83d89fbfd8236492;
'use strict';
var $398e284014f0b5df$var$l = Symbol.for("react.element"), $398e284014f0b5df$var$n = Symbol.for("react.portal"), $398e284014f0b5df$var$p = Symbol.for("react.fragment"), $398e284014f0b5df$var$q = Symbol.for("react.strict_mode"), $398e284014f0b5df$var$r = Symbol.for("react.profiler"), $398e284014f0b5df$var$t = Symbol.for("react.provider"), $398e284014f0b5df$var$u = Symbol.for("react.context"), $398e284014f0b5df$var$v = Symbol.for("react.forward_ref"), $398e284014f0b5df$var$w = Symbol.for("react.suspense"), $398e284014f0b5df$var$x = Symbol.for("react.memo"), $398e284014f0b5df$var$y = Symbol.for("react.lazy"), $398e284014f0b5df$var$z = Symbol.iterator;
function $398e284014f0b5df$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $398e284014f0b5df$var$z && a[$398e284014f0b5df$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $398e284014f0b5df$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $398e284014f0b5df$var$C = Object.assign, $398e284014f0b5df$var$D = {};
function $398e284014f0b5df$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $398e284014f0b5df$var$D;
    this.updater = e || $398e284014f0b5df$var$B;
}
$398e284014f0b5df$var$E.prototype.isReactComponent = {};
$398e284014f0b5df$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$398e284014f0b5df$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $398e284014f0b5df$var$F() {}
$398e284014f0b5df$var$F.prototype = $398e284014f0b5df$var$E.prototype;
function $398e284014f0b5df$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $398e284014f0b5df$var$D;
    this.updater = e || $398e284014f0b5df$var$B;
}
var $398e284014f0b5df$var$H = $398e284014f0b5df$var$G.prototype = new $398e284014f0b5df$var$F;
$398e284014f0b5df$var$H.constructor = $398e284014f0b5df$var$G;
$398e284014f0b5df$var$C($398e284014f0b5df$var$H, $398e284014f0b5df$var$E.prototype);
$398e284014f0b5df$var$H.isPureReactComponent = !0;
var $398e284014f0b5df$var$I = Array.isArray, $398e284014f0b5df$var$J = Object.prototype.hasOwnProperty, $398e284014f0b5df$var$K = {
    current: null
}, $398e284014f0b5df$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $398e284014f0b5df$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$398e284014f0b5df$var$J.call(b, d) && !$398e284014f0b5df$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $398e284014f0b5df$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $398e284014f0b5df$var$K.current
    };
}
function $398e284014f0b5df$var$N(a, b) {
    return {
        $$typeof: $398e284014f0b5df$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $398e284014f0b5df$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $398e284014f0b5df$var$l;
}
function $398e284014f0b5df$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $398e284014f0b5df$var$P = /\/+/g;
function $398e284014f0b5df$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $398e284014f0b5df$var$escape("" + a.key) : b.toString(36);
}
function $398e284014f0b5df$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $398e284014f0b5df$var$l:
                case $398e284014f0b5df$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $398e284014f0b5df$var$Q(h, 0) : d, $398e284014f0b5df$var$I(c) ? (e = "", null != a && (e = a.replace($398e284014f0b5df$var$P, "$&/") + "/"), $398e284014f0b5df$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($398e284014f0b5df$var$O(c) && (c = $398e284014f0b5df$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($398e284014f0b5df$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($398e284014f0b5df$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $398e284014f0b5df$var$Q(k, g);
        h += $398e284014f0b5df$var$R(k, b, e, f, c);
    }
    else if (f = $398e284014f0b5df$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $398e284014f0b5df$var$Q(k, g++), h += $398e284014f0b5df$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $398e284014f0b5df$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $398e284014f0b5df$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $398e284014f0b5df$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $398e284014f0b5df$var$U = {
    current: null
}, $398e284014f0b5df$var$V = {
    transition: null
}, $398e284014f0b5df$var$W = {
    ReactCurrentDispatcher: $398e284014f0b5df$var$U,
    ReactCurrentBatchConfig: $398e284014f0b5df$var$V,
    ReactCurrentOwner: $398e284014f0b5df$var$K
};
$398e284014f0b5df$export$dca3b0875bd9a954 = {
    map: $398e284014f0b5df$var$S,
    forEach: function(a, b, e) {
        $398e284014f0b5df$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $398e284014f0b5df$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $398e284014f0b5df$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$398e284014f0b5df$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$398e284014f0b5df$export$16fa2f45be04daa8 = $398e284014f0b5df$var$E;
$398e284014f0b5df$export$ffb0004e005737fa = $398e284014f0b5df$var$p;
$398e284014f0b5df$export$e2c29f18771995cb = $398e284014f0b5df$var$r;
$398e284014f0b5df$export$221d75b3f55bb0bd = $398e284014f0b5df$var$G;
$398e284014f0b5df$export$5f8d39834fd61797 = $398e284014f0b5df$var$q;
$398e284014f0b5df$export$74bf444e3cd11ea5 = $398e284014f0b5df$var$w;
$398e284014f0b5df$export$ae55be85d98224ed = $398e284014f0b5df$var$W;
$398e284014f0b5df$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $398e284014f0b5df$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $398e284014f0b5df$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$398e284014f0b5df$var$J.call(b, f) && !$398e284014f0b5df$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $398e284014f0b5df$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$398e284014f0b5df$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $398e284014f0b5df$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $398e284014f0b5df$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$398e284014f0b5df$export$c8a8987d4410bf2d = $398e284014f0b5df$var$M;
$398e284014f0b5df$export$d38cd72104c1f0e9 = function(a) {
    var b = $398e284014f0b5df$var$M.bind(null, a);
    b.type = a;
    return b;
};
$398e284014f0b5df$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$398e284014f0b5df$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $398e284014f0b5df$var$v,
        render: a
    };
};
$398e284014f0b5df$export$a8257692ac88316c = $398e284014f0b5df$var$O;
$398e284014f0b5df$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $398e284014f0b5df$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $398e284014f0b5df$var$T
    };
};
$398e284014f0b5df$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $398e284014f0b5df$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$398e284014f0b5df$export$7568632d0d33d16d = function(a) {
    var b = $398e284014f0b5df$var$V.transition;
    $398e284014f0b5df$var$V.transition = {};
    try {
        a();
    } finally{
        $398e284014f0b5df$var$V.transition = b;
    }
};
$398e284014f0b5df$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$398e284014f0b5df$export$35808ee640e87ca7 = function(a, b) {
    return $398e284014f0b5df$var$U.current.useCallback(a, b);
};
$398e284014f0b5df$export$fae74005e78b1a27 = function(a) {
    return $398e284014f0b5df$var$U.current.useContext(a);
};
$398e284014f0b5df$export$dc8fbce3eb94dc1e = function() {};
$398e284014f0b5df$export$6a7bc4e911dc01cf = function(a) {
    return $398e284014f0b5df$var$U.current.useDeferredValue(a);
};
$398e284014f0b5df$export$6d9c69b0de29b591 = function(a, b) {
    return $398e284014f0b5df$var$U.current.useEffect(a, b);
};
$398e284014f0b5df$export$f680877a34711e37 = function() {
    return $398e284014f0b5df$var$U.current.useId();
};
$398e284014f0b5df$export$d5a552a76deda3c2 = function(a, b, e) {
    return $398e284014f0b5df$var$U.current.useImperativeHandle(a, b, e);
};
$398e284014f0b5df$export$aaabe4eda9ed9969 = function(a, b) {
    return $398e284014f0b5df$var$U.current.useInsertionEffect(a, b);
};
$398e284014f0b5df$export$e5c5a5f917a5871c = function(a, b) {
    return $398e284014f0b5df$var$U.current.useLayoutEffect(a, b);
};
$398e284014f0b5df$export$1538c33de8887b59 = function(a, b) {
    return $398e284014f0b5df$var$U.current.useMemo(a, b);
};
$398e284014f0b5df$export$13e3392192263954 = function(a, b, e) {
    return $398e284014f0b5df$var$U.current.useReducer(a, b, e);
};
$398e284014f0b5df$export$b8f5890fc79d6aca = function(a) {
    return $398e284014f0b5df$var$U.current.useRef(a);
};
$398e284014f0b5df$export$60241385465d0a34 = function(a) {
    return $398e284014f0b5df$var$U.current.useState(a);
};
$398e284014f0b5df$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $398e284014f0b5df$var$U.current.useSyncExternalStore(a, b, e);
};
$398e284014f0b5df$export$7b286972b8d8ccbf = function() {
    return $398e284014f0b5df$var$U.current.useTransition();
};
$398e284014f0b5df$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("a2nZt", function(module, exports) {
'use strict';
function $01e2c915e3c59728$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($01e2c915e3c59728$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$01e2c915e3c59728$var$checkDCE();

module.exports = (parcelRequire("7KOGZ"));

});
parcelRegister("7KOGZ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5a5426c007ae479a$export$ae55be85d98224ed; }, function (v) { return $5a5426c007ae479a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5a5426c007ae479a$export$d39a5bbd09211389; }, function (v) { return $5a5426c007ae479a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $5a5426c007ae479a$export$882461b6382ed46c; }, function (v) { return $5a5426c007ae479a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5a5426c007ae479a$export$466bfc07425424d5; }, function (v) { return $5a5426c007ae479a$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5a5426c007ae479a$export$cd75ccfd720a3cd4; }, function (v) { return $5a5426c007ae479a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5a5426c007ae479a$export$fa8d919ba61d84db; }, function (v) { return $5a5426c007ae479a$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $5a5426c007ae479a$export$757ceba2d55c277e; }, function (v) { return $5a5426c007ae479a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $5a5426c007ae479a$export$b3890eb0ae9dca99; }, function (v) { return $5a5426c007ae479a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5a5426c007ae479a$export$502457920280e6be; }, function (v) { return $5a5426c007ae479a$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5a5426c007ae479a$export$c78a37762a8d58e1; }, function (v) { return $5a5426c007ae479a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5a5426c007ae479a$export$dc54d992c10e8a18; }, function (v) { return $5a5426c007ae479a$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5a5426c007ae479a$export$83d89fbfd8236492; }, function (v) { return $5a5426c007ae479a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5a5426c007ae479a$export$ae55be85d98224ed;
var $5a5426c007ae479a$export$d39a5bbd09211389;
var $5a5426c007ae479a$export$882461b6382ed46c;
var $5a5426c007ae479a$export$466bfc07425424d5;
var $5a5426c007ae479a$export$cd75ccfd720a3cd4;
var $5a5426c007ae479a$export$fa8d919ba61d84db;
var $5a5426c007ae479a$export$757ceba2d55c277e;
var $5a5426c007ae479a$export$b3890eb0ae9dca99;
var $5a5426c007ae479a$export$502457920280e6be;
var $5a5426c007ae479a$export$c78a37762a8d58e1;
var $5a5426c007ae479a$export$dc54d992c10e8a18;
var $5a5426c007ae479a$export$83d89fbfd8236492;
'use strict';

var $b7Z9x = parcelRequire("b7Z9x");

var $jTTQM = parcelRequire("jTTQM");
function $5a5426c007ae479a$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5a5426c007ae479a$var$da = new Set, $5a5426c007ae479a$var$ea = {};
function $5a5426c007ae479a$var$fa(a, b) {
    $5a5426c007ae479a$var$ha(a, b);
    $5a5426c007ae479a$var$ha(a + "Capture", b);
}
function $5a5426c007ae479a$var$ha(a, b) {
    $5a5426c007ae479a$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5a5426c007ae479a$var$da.add(b[a]);
}
var $5a5426c007ae479a$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5a5426c007ae479a$var$ja = Object.prototype.hasOwnProperty, $5a5426c007ae479a$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5a5426c007ae479a$var$la = {}, $5a5426c007ae479a$var$ma = {};
function $5a5426c007ae479a$var$oa(a) {
    if ($5a5426c007ae479a$var$ja.call($5a5426c007ae479a$var$ma, a)) return !0;
    if ($5a5426c007ae479a$var$ja.call($5a5426c007ae479a$var$la, a)) return !1;
    if ($5a5426c007ae479a$var$ka.test(a)) return $5a5426c007ae479a$var$ma[a] = !0;
    $5a5426c007ae479a$var$la[a] = !0;
    return !1;
}
function $5a5426c007ae479a$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5a5426c007ae479a$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5a5426c007ae479a$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5a5426c007ae479a$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5a5426c007ae479a$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5a5426c007ae479a$var$z[b] = new $5a5426c007ae479a$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5a5426c007ae479a$var$ra = /[\-:]([a-z])/g;
function $5a5426c007ae479a$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5a5426c007ae479a$var$ra, $5a5426c007ae479a$var$sa);
    $5a5426c007ae479a$var$z[b] = new $5a5426c007ae479a$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5a5426c007ae479a$var$ra, $5a5426c007ae479a$var$sa);
    $5a5426c007ae479a$var$z[b] = new $5a5426c007ae479a$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5a5426c007ae479a$var$ra, $5a5426c007ae479a$var$sa);
    $5a5426c007ae479a$var$z[b] = new $5a5426c007ae479a$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5a5426c007ae479a$var$z.xlinkHref = new $5a5426c007ae479a$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5a5426c007ae479a$var$z[a] = new $5a5426c007ae479a$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5a5426c007ae479a$var$ta(a, b, c, d) {
    var e = $5a5426c007ae479a$var$z.hasOwnProperty(b) ? $5a5426c007ae479a$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5a5426c007ae479a$var$qa(b, c, e, d) && (c = null), d || null === e ? $5a5426c007ae479a$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5a5426c007ae479a$var$ua = $b7Z9x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5a5426c007ae479a$var$va = Symbol.for("react.element"), $5a5426c007ae479a$var$wa = Symbol.for("react.portal"), $5a5426c007ae479a$var$ya = Symbol.for("react.fragment"), $5a5426c007ae479a$var$za = Symbol.for("react.strict_mode"), $5a5426c007ae479a$var$Aa = Symbol.for("react.profiler"), $5a5426c007ae479a$var$Ba = Symbol.for("react.provider"), $5a5426c007ae479a$var$Ca = Symbol.for("react.context"), $5a5426c007ae479a$var$Da = Symbol.for("react.forward_ref"), $5a5426c007ae479a$var$Ea = Symbol.for("react.suspense"), $5a5426c007ae479a$var$Fa = Symbol.for("react.suspense_list"), $5a5426c007ae479a$var$Ga = Symbol.for("react.memo"), $5a5426c007ae479a$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5a5426c007ae479a$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5a5426c007ae479a$var$Ja = Symbol.iterator;
function $5a5426c007ae479a$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5a5426c007ae479a$var$Ja && a[$5a5426c007ae479a$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5a5426c007ae479a$var$A = Object.assign, $5a5426c007ae479a$var$La;
function $5a5426c007ae479a$var$Ma(a) {
    if (void 0 === $5a5426c007ae479a$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5a5426c007ae479a$var$La = b && b[1] || "";
    }
    return "\n" + $5a5426c007ae479a$var$La + a;
}
var $5a5426c007ae479a$var$Na = !1;
function $5a5426c007ae479a$var$Oa(a, b) {
    if (!a || $5a5426c007ae479a$var$Na) return "";
    $5a5426c007ae479a$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5a5426c007ae479a$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5a5426c007ae479a$var$Ma(a) : "";
}
function $5a5426c007ae479a$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5a5426c007ae479a$var$Ma(a.type);
        case 16:
            return $5a5426c007ae479a$var$Ma("Lazy");
        case 13:
            return $5a5426c007ae479a$var$Ma("Suspense");
        case 19:
            return $5a5426c007ae479a$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5a5426c007ae479a$var$Oa(a.type, !1), a;
        case 11:
            return a = $5a5426c007ae479a$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5a5426c007ae479a$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5a5426c007ae479a$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5a5426c007ae479a$var$ya:
            return "Fragment";
        case $5a5426c007ae479a$var$wa:
            return "Portal";
        case $5a5426c007ae479a$var$Aa:
            return "Profiler";
        case $5a5426c007ae479a$var$za:
            return "StrictMode";
        case $5a5426c007ae479a$var$Ea:
            return "Suspense";
        case $5a5426c007ae479a$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5a5426c007ae479a$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5a5426c007ae479a$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5a5426c007ae479a$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5a5426c007ae479a$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5a5426c007ae479a$var$Qa(a.type) || "Memo";
        case $5a5426c007ae479a$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5a5426c007ae479a$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5a5426c007ae479a$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5a5426c007ae479a$var$Qa(b);
        case 8:
            return b === $5a5426c007ae479a$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5a5426c007ae479a$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5a5426c007ae479a$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5a5426c007ae479a$var$Ua(a) {
    var b = $5a5426c007ae479a$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5a5426c007ae479a$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5a5426c007ae479a$var$Ua(a));
}
function $5a5426c007ae479a$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5a5426c007ae479a$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5a5426c007ae479a$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5a5426c007ae479a$var$Ya(a, b) {
    var c = b.checked;
    return $5a5426c007ae479a$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5a5426c007ae479a$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5a5426c007ae479a$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5a5426c007ae479a$var$ab(a, b) {
    b = b.checked;
    null != b && $5a5426c007ae479a$var$ta(a, "checked", b, !1);
}
function $5a5426c007ae479a$var$bb(a, b) {
    $5a5426c007ae479a$var$ab(a, b);
    var c = $5a5426c007ae479a$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5a5426c007ae479a$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5a5426c007ae479a$var$cb(a, b.type, $5a5426c007ae479a$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5a5426c007ae479a$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5a5426c007ae479a$var$cb(a, b, c) {
    if ("number" !== b || $5a5426c007ae479a$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5a5426c007ae479a$var$eb = Array.isArray;
function $5a5426c007ae479a$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5a5426c007ae479a$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5a5426c007ae479a$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5a5426c007ae479a$var$p(91));
    return $5a5426c007ae479a$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5a5426c007ae479a$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5a5426c007ae479a$var$p(92));
            if ($5a5426c007ae479a$var$eb(c)) {
                if (1 < c.length) throw Error($5a5426c007ae479a$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5a5426c007ae479a$var$Sa(c)
    };
}
function $5a5426c007ae479a$var$ib(a, b) {
    var c = $5a5426c007ae479a$var$Sa(b.value), d = $5a5426c007ae479a$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5a5426c007ae479a$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5a5426c007ae479a$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5a5426c007ae479a$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5a5426c007ae479a$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5a5426c007ae479a$var$mb, $5a5426c007ae479a$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5a5426c007ae479a$var$mb = $5a5426c007ae479a$var$mb || document.createElement("div");
        $5a5426c007ae479a$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5a5426c007ae479a$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5a5426c007ae479a$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5a5426c007ae479a$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5a5426c007ae479a$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5a5426c007ae479a$var$pb).forEach(function(a) {
    $5a5426c007ae479a$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5a5426c007ae479a$var$pb[b] = $5a5426c007ae479a$var$pb[a];
    });
});
function $5a5426c007ae479a$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5a5426c007ae479a$var$pb.hasOwnProperty(a) && $5a5426c007ae479a$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5a5426c007ae479a$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5a5426c007ae479a$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5a5426c007ae479a$var$tb = $5a5426c007ae479a$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5a5426c007ae479a$var$ub(a, b) {
    if (b) {
        if ($5a5426c007ae479a$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5a5426c007ae479a$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5a5426c007ae479a$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5a5426c007ae479a$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5a5426c007ae479a$var$p(62));
    }
}
function $5a5426c007ae479a$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5a5426c007ae479a$var$wb = null;
function $5a5426c007ae479a$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5a5426c007ae479a$var$yb = null, $5a5426c007ae479a$var$zb = null, $5a5426c007ae479a$var$Ab = null;
function $5a5426c007ae479a$var$Bb(a) {
    if (a = $5a5426c007ae479a$var$Cb(a)) {
        if ("function" !== typeof $5a5426c007ae479a$var$yb) throw Error($5a5426c007ae479a$var$p(280));
        var b = a.stateNode;
        b && (b = $5a5426c007ae479a$var$Db(b), $5a5426c007ae479a$var$yb(a.stateNode, a.type, b));
    }
}
function $5a5426c007ae479a$var$Eb(a) {
    $5a5426c007ae479a$var$zb ? $5a5426c007ae479a$var$Ab ? $5a5426c007ae479a$var$Ab.push(a) : $5a5426c007ae479a$var$Ab = [
        a
    ] : $5a5426c007ae479a$var$zb = a;
}
function $5a5426c007ae479a$var$Fb() {
    if ($5a5426c007ae479a$var$zb) {
        var a = $5a5426c007ae479a$var$zb, b = $5a5426c007ae479a$var$Ab;
        $5a5426c007ae479a$var$Ab = $5a5426c007ae479a$var$zb = null;
        $5a5426c007ae479a$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5a5426c007ae479a$var$Bb(b[a]);
    }
}
function $5a5426c007ae479a$var$Gb(a, b) {
    return a(b);
}
function $5a5426c007ae479a$var$Hb() {}
var $5a5426c007ae479a$var$Ib = !1;
function $5a5426c007ae479a$var$Jb(a, b, c) {
    if ($5a5426c007ae479a$var$Ib) return a(b, c);
    $5a5426c007ae479a$var$Ib = !0;
    try {
        return $5a5426c007ae479a$var$Gb(a, b, c);
    } finally{
        if ($5a5426c007ae479a$var$Ib = !1, null !== $5a5426c007ae479a$var$zb || null !== $5a5426c007ae479a$var$Ab) $5a5426c007ae479a$var$Hb(), $5a5426c007ae479a$var$Fb();
    }
}
function $5a5426c007ae479a$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5a5426c007ae479a$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5a5426c007ae479a$var$p(231, b, typeof c));
    return c;
}
var $5a5426c007ae479a$var$Lb = !1;
if ($5a5426c007ae479a$var$ia) try {
    var $5a5426c007ae479a$var$Mb = {};
    Object.defineProperty($5a5426c007ae479a$var$Mb, "passive", {
        get: function() {
            $5a5426c007ae479a$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5a5426c007ae479a$var$Mb, $5a5426c007ae479a$var$Mb);
    window.removeEventListener("test", $5a5426c007ae479a$var$Mb, $5a5426c007ae479a$var$Mb);
} catch (a) {
    $5a5426c007ae479a$var$Lb = !1;
}
function $5a5426c007ae479a$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5a5426c007ae479a$var$Ob = !1, $5a5426c007ae479a$var$Pb = null, $5a5426c007ae479a$var$Qb = !1, $5a5426c007ae479a$var$Rb = null, $5a5426c007ae479a$var$Sb = {
    onError: function(a) {
        $5a5426c007ae479a$var$Ob = !0;
        $5a5426c007ae479a$var$Pb = a;
    }
};
function $5a5426c007ae479a$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5a5426c007ae479a$var$Ob = !1;
    $5a5426c007ae479a$var$Pb = null;
    $5a5426c007ae479a$var$Nb.apply($5a5426c007ae479a$var$Sb, arguments);
}
function $5a5426c007ae479a$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5a5426c007ae479a$var$Tb.apply(this, arguments);
    if ($5a5426c007ae479a$var$Ob) {
        if ($5a5426c007ae479a$var$Ob) {
            var l = $5a5426c007ae479a$var$Pb;
            $5a5426c007ae479a$var$Ob = !1;
            $5a5426c007ae479a$var$Pb = null;
        } else throw Error($5a5426c007ae479a$var$p(198));
        $5a5426c007ae479a$var$Qb || ($5a5426c007ae479a$var$Qb = !0, $5a5426c007ae479a$var$Rb = l);
    }
}
function $5a5426c007ae479a$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5a5426c007ae479a$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5a5426c007ae479a$var$Xb(a) {
    if ($5a5426c007ae479a$var$Vb(a) !== a) throw Error($5a5426c007ae479a$var$p(188));
}
function $5a5426c007ae479a$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5a5426c007ae479a$var$Vb(a);
        if (null === b) throw Error($5a5426c007ae479a$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5a5426c007ae479a$var$Xb(e), a;
                if (f === d) return $5a5426c007ae479a$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5a5426c007ae479a$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5a5426c007ae479a$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5a5426c007ae479a$var$p(190));
    }
    if (3 !== c.tag) throw Error($5a5426c007ae479a$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5a5426c007ae479a$var$Zb(a) {
    a = $5a5426c007ae479a$var$Yb(a);
    return null !== a ? $5a5426c007ae479a$var$$b(a) : null;
}
function $5a5426c007ae479a$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5a5426c007ae479a$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5a5426c007ae479a$var$ac = $jTTQM.unstable_scheduleCallback, $5a5426c007ae479a$var$bc = $jTTQM.unstable_cancelCallback, $5a5426c007ae479a$var$cc = $jTTQM.unstable_shouldYield, $5a5426c007ae479a$var$dc = $jTTQM.unstable_requestPaint, $5a5426c007ae479a$var$B = $jTTQM.unstable_now, $5a5426c007ae479a$var$ec = $jTTQM.unstable_getCurrentPriorityLevel, $5a5426c007ae479a$var$fc = $jTTQM.unstable_ImmediatePriority, $5a5426c007ae479a$var$gc = $jTTQM.unstable_UserBlockingPriority, $5a5426c007ae479a$var$hc = $jTTQM.unstable_NormalPriority, $5a5426c007ae479a$var$ic = $jTTQM.unstable_LowPriority, $5a5426c007ae479a$var$jc = $jTTQM.unstable_IdlePriority, $5a5426c007ae479a$var$kc = null, $5a5426c007ae479a$var$lc = null;
function $5a5426c007ae479a$var$mc(a) {
    if ($5a5426c007ae479a$var$lc && "function" === typeof $5a5426c007ae479a$var$lc.onCommitFiberRoot) try {
        $5a5426c007ae479a$var$lc.onCommitFiberRoot($5a5426c007ae479a$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5a5426c007ae479a$var$oc = Math.clz32 ? Math.clz32 : $5a5426c007ae479a$var$nc, $5a5426c007ae479a$var$pc = Math.log, $5a5426c007ae479a$var$qc = Math.LN2;
function $5a5426c007ae479a$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5a5426c007ae479a$var$pc(a) / $5a5426c007ae479a$var$qc | 0) | 0;
}
var $5a5426c007ae479a$var$rc = 64, $5a5426c007ae479a$var$sc = 4194304;
function $5a5426c007ae479a$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5a5426c007ae479a$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5a5426c007ae479a$var$tc(h) : (f &= g, 0 !== f && (d = $5a5426c007ae479a$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5a5426c007ae479a$var$tc(g) : 0 !== f && (d = $5a5426c007ae479a$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5a5426c007ae479a$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5a5426c007ae479a$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5a5426c007ae479a$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5a5426c007ae479a$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5a5426c007ae479a$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5a5426c007ae479a$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5a5426c007ae479a$var$yc() {
    var a = $5a5426c007ae479a$var$rc;
    $5a5426c007ae479a$var$rc <<= 1;
    0 === ($5a5426c007ae479a$var$rc & 4194240) && ($5a5426c007ae479a$var$rc = 64);
    return a;
}
function $5a5426c007ae479a$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5a5426c007ae479a$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5a5426c007ae479a$var$oc(b);
    a[b] = c;
}
function $5a5426c007ae479a$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5a5426c007ae479a$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5a5426c007ae479a$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5a5426c007ae479a$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5a5426c007ae479a$var$C = 0;
function $5a5426c007ae479a$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5a5426c007ae479a$var$Ec, $5a5426c007ae479a$var$Fc, $5a5426c007ae479a$var$Gc, $5a5426c007ae479a$var$Hc, $5a5426c007ae479a$var$Ic, $5a5426c007ae479a$var$Jc = !1, $5a5426c007ae479a$var$Kc = [], $5a5426c007ae479a$var$Lc = null, $5a5426c007ae479a$var$Mc = null, $5a5426c007ae479a$var$Nc = null, $5a5426c007ae479a$var$Oc = new Map, $5a5426c007ae479a$var$Pc = new Map, $5a5426c007ae479a$var$Qc = [], $5a5426c007ae479a$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5a5426c007ae479a$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5a5426c007ae479a$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5a5426c007ae479a$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5a5426c007ae479a$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5a5426c007ae479a$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5a5426c007ae479a$var$Pc.delete(b.pointerId);
    }
}
function $5a5426c007ae479a$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5a5426c007ae479a$var$Cb(b), null !== b && $5a5426c007ae479a$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5a5426c007ae479a$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5a5426c007ae479a$var$Lc = $5a5426c007ae479a$var$Tc($5a5426c007ae479a$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5a5426c007ae479a$var$Mc = $5a5426c007ae479a$var$Tc($5a5426c007ae479a$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5a5426c007ae479a$var$Nc = $5a5426c007ae479a$var$Tc($5a5426c007ae479a$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5a5426c007ae479a$var$Oc.set(f, $5a5426c007ae479a$var$Tc($5a5426c007ae479a$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5a5426c007ae479a$var$Pc.set(f, $5a5426c007ae479a$var$Tc($5a5426c007ae479a$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5a5426c007ae479a$var$Vc(a) {
    var b = $5a5426c007ae479a$var$Wc(a.target);
    if (null !== b) {
        var c = $5a5426c007ae479a$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5a5426c007ae479a$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5a5426c007ae479a$var$Ic(a.priority, function() {
                        $5a5426c007ae479a$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5a5426c007ae479a$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5a5426c007ae479a$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5a5426c007ae479a$var$wb = d;
            c.target.dispatchEvent(d);
            $5a5426c007ae479a$var$wb = null;
        } else return b = $5a5426c007ae479a$var$Cb(c), null !== b && $5a5426c007ae479a$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5a5426c007ae479a$var$Zc(a, b, c) {
    $5a5426c007ae479a$var$Xc(a) && c.delete(b);
}
function $5a5426c007ae479a$var$$c() {
    $5a5426c007ae479a$var$Jc = !1;
    null !== $5a5426c007ae479a$var$Lc && $5a5426c007ae479a$var$Xc($5a5426c007ae479a$var$Lc) && ($5a5426c007ae479a$var$Lc = null);
    null !== $5a5426c007ae479a$var$Mc && $5a5426c007ae479a$var$Xc($5a5426c007ae479a$var$Mc) && ($5a5426c007ae479a$var$Mc = null);
    null !== $5a5426c007ae479a$var$Nc && $5a5426c007ae479a$var$Xc($5a5426c007ae479a$var$Nc) && ($5a5426c007ae479a$var$Nc = null);
    $5a5426c007ae479a$var$Oc.forEach($5a5426c007ae479a$var$Zc);
    $5a5426c007ae479a$var$Pc.forEach($5a5426c007ae479a$var$Zc);
}
function $5a5426c007ae479a$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5a5426c007ae479a$var$Jc || ($5a5426c007ae479a$var$Jc = !0, $jTTQM.unstable_scheduleCallback($jTTQM.unstable_NormalPriority, $5a5426c007ae479a$var$$c)));
}
function $5a5426c007ae479a$var$bd(a) {
    function b(b) {
        return $5a5426c007ae479a$var$ad(b, a);
    }
    if (0 < $5a5426c007ae479a$var$Kc.length) {
        $5a5426c007ae479a$var$ad($5a5426c007ae479a$var$Kc[0], a);
        for(var c = 1; c < $5a5426c007ae479a$var$Kc.length; c++){
            var d = $5a5426c007ae479a$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5a5426c007ae479a$var$Lc && $5a5426c007ae479a$var$ad($5a5426c007ae479a$var$Lc, a);
    null !== $5a5426c007ae479a$var$Mc && $5a5426c007ae479a$var$ad($5a5426c007ae479a$var$Mc, a);
    null !== $5a5426c007ae479a$var$Nc && $5a5426c007ae479a$var$ad($5a5426c007ae479a$var$Nc, a);
    $5a5426c007ae479a$var$Oc.forEach(b);
    $5a5426c007ae479a$var$Pc.forEach(b);
    for(c = 0; c < $5a5426c007ae479a$var$Qc.length; c++)d = $5a5426c007ae479a$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5a5426c007ae479a$var$Qc.length && (c = $5a5426c007ae479a$var$Qc[0], null === c.blockedOn);)$5a5426c007ae479a$var$Vc(c), null === c.blockedOn && $5a5426c007ae479a$var$Qc.shift();
}
var $5a5426c007ae479a$var$cd = $5a5426c007ae479a$var$ua.ReactCurrentBatchConfig, $5a5426c007ae479a$var$dd = !0;
function $5a5426c007ae479a$var$ed(a, b, c, d) {
    var e = $5a5426c007ae479a$var$C, f = $5a5426c007ae479a$var$cd.transition;
    $5a5426c007ae479a$var$cd.transition = null;
    try {
        $5a5426c007ae479a$var$C = 1, $5a5426c007ae479a$var$fd(a, b, c, d);
    } finally{
        $5a5426c007ae479a$var$C = e, $5a5426c007ae479a$var$cd.transition = f;
    }
}
function $5a5426c007ae479a$var$gd(a, b, c, d) {
    var e = $5a5426c007ae479a$var$C, f = $5a5426c007ae479a$var$cd.transition;
    $5a5426c007ae479a$var$cd.transition = null;
    try {
        $5a5426c007ae479a$var$C = 4, $5a5426c007ae479a$var$fd(a, b, c, d);
    } finally{
        $5a5426c007ae479a$var$C = e, $5a5426c007ae479a$var$cd.transition = f;
    }
}
function $5a5426c007ae479a$var$fd(a, b, c, d) {
    if ($5a5426c007ae479a$var$dd) {
        var e = $5a5426c007ae479a$var$Yc(a, b, c, d);
        if (null === e) $5a5426c007ae479a$var$hd(a, b, d, $5a5426c007ae479a$var$id, c), $5a5426c007ae479a$var$Sc(a, d);
        else if ($5a5426c007ae479a$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5a5426c007ae479a$var$Sc(a, d), b & 4 && -1 < $5a5426c007ae479a$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5a5426c007ae479a$var$Cb(e);
                null !== f && $5a5426c007ae479a$var$Ec(f);
                f = $5a5426c007ae479a$var$Yc(a, b, c, d);
                null === f && $5a5426c007ae479a$var$hd(a, b, d, $5a5426c007ae479a$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5a5426c007ae479a$var$hd(a, b, d, null, c);
    }
}
var $5a5426c007ae479a$var$id = null;
function $5a5426c007ae479a$var$Yc(a, b, c, d) {
    $5a5426c007ae479a$var$id = null;
    a = $5a5426c007ae479a$var$xb(d);
    a = $5a5426c007ae479a$var$Wc(a);
    if (null !== a) {
        if (b = $5a5426c007ae479a$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5a5426c007ae479a$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5a5426c007ae479a$var$id = a;
    return null;
}
function $5a5426c007ae479a$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5a5426c007ae479a$var$ec()){
                case $5a5426c007ae479a$var$fc:
                    return 1;
                case $5a5426c007ae479a$var$gc:
                    return 4;
                case $5a5426c007ae479a$var$hc:
                case $5a5426c007ae479a$var$ic:
                    return 16;
                case $5a5426c007ae479a$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5a5426c007ae479a$var$kd = null, $5a5426c007ae479a$var$ld = null, $5a5426c007ae479a$var$md = null;
function $5a5426c007ae479a$var$nd() {
    if ($5a5426c007ae479a$var$md) return $5a5426c007ae479a$var$md;
    var a, b = $5a5426c007ae479a$var$ld, c = b.length, d, e = "value" in $5a5426c007ae479a$var$kd ? $5a5426c007ae479a$var$kd.value : $5a5426c007ae479a$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5a5426c007ae479a$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5a5426c007ae479a$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5a5426c007ae479a$var$pd() {
    return !0;
}
function $5a5426c007ae479a$var$qd() {
    return !1;
}
function $5a5426c007ae479a$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5a5426c007ae479a$var$pd : $5a5426c007ae479a$var$qd;
        this.isPropagationStopped = $5a5426c007ae479a$var$qd;
        return this;
    }
    $5a5426c007ae479a$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5a5426c007ae479a$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5a5426c007ae479a$var$pd);
        },
        persist: function() {},
        isPersistent: $5a5426c007ae479a$var$pd
    });
    return b;
}
var $5a5426c007ae479a$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5a5426c007ae479a$var$td = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$sd), $5a5426c007ae479a$var$ud = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$sd, {
    view: 0,
    detail: 0
}), $5a5426c007ae479a$var$vd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$ud), $5a5426c007ae479a$var$wd, $5a5426c007ae479a$var$xd, $5a5426c007ae479a$var$yd, $5a5426c007ae479a$var$Ad = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5a5426c007ae479a$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5a5426c007ae479a$var$yd && ($5a5426c007ae479a$var$yd && "mousemove" === a.type ? ($5a5426c007ae479a$var$wd = a.screenX - $5a5426c007ae479a$var$yd.screenX, $5a5426c007ae479a$var$xd = a.screenY - $5a5426c007ae479a$var$yd.screenY) : $5a5426c007ae479a$var$xd = $5a5426c007ae479a$var$wd = 0, $5a5426c007ae479a$var$yd = a);
        return $5a5426c007ae479a$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $5a5426c007ae479a$var$xd;
    }
}), $5a5426c007ae479a$var$Bd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Ad), $5a5426c007ae479a$var$Cd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$Ad, {
    dataTransfer: 0
}), $5a5426c007ae479a$var$Dd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Cd), $5a5426c007ae479a$var$Ed = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$ud, {
    relatedTarget: 0
}), $5a5426c007ae479a$var$Fd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Ed), $5a5426c007ae479a$var$Gd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5a5426c007ae479a$var$Hd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Gd), $5a5426c007ae479a$var$Id = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5a5426c007ae479a$var$Jd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Id), $5a5426c007ae479a$var$Kd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$sd, {
    data: 0
}), $5a5426c007ae479a$var$Ld = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Kd), $5a5426c007ae479a$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5a5426c007ae479a$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5a5426c007ae479a$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5a5426c007ae479a$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5a5426c007ae479a$var$Od[a]) ? !!b[a] : !1;
}
function $5a5426c007ae479a$var$zd() {
    return $5a5426c007ae479a$var$Pd;
}
var $5a5426c007ae479a$var$Qd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $5a5426c007ae479a$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5a5426c007ae479a$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5a5426c007ae479a$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5a5426c007ae479a$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $5a5426c007ae479a$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5a5426c007ae479a$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5a5426c007ae479a$var$Rd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Qd), $5a5426c007ae479a$var$Sd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5a5426c007ae479a$var$Td = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Sd), $5a5426c007ae479a$var$Ud = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5a5426c007ae479a$var$zd
}), $5a5426c007ae479a$var$Vd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Ud), $5a5426c007ae479a$var$Wd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5a5426c007ae479a$var$Xd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Wd), $5a5426c007ae479a$var$Yd = $5a5426c007ae479a$var$A({}, $5a5426c007ae479a$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5a5426c007ae479a$var$Zd = $5a5426c007ae479a$var$rd($5a5426c007ae479a$var$Yd), $5a5426c007ae479a$var$$d = [
    9,
    13,
    27,
    32
], $5a5426c007ae479a$var$ae = $5a5426c007ae479a$var$ia && "CompositionEvent" in window, $5a5426c007ae479a$var$be = null;
$5a5426c007ae479a$var$ia && "documentMode" in document && ($5a5426c007ae479a$var$be = document.documentMode);
var $5a5426c007ae479a$var$ce = $5a5426c007ae479a$var$ia && "TextEvent" in window && !$5a5426c007ae479a$var$be, $5a5426c007ae479a$var$de = $5a5426c007ae479a$var$ia && (!$5a5426c007ae479a$var$ae || $5a5426c007ae479a$var$be && 8 < $5a5426c007ae479a$var$be && 11 >= $5a5426c007ae479a$var$be), $5a5426c007ae479a$var$ee = String.fromCharCode(32), $5a5426c007ae479a$var$fe = !1;
function $5a5426c007ae479a$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5a5426c007ae479a$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5a5426c007ae479a$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5a5426c007ae479a$var$ie = !1;
function $5a5426c007ae479a$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5a5426c007ae479a$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5a5426c007ae479a$var$fe = !0;
            return $5a5426c007ae479a$var$ee;
        case "textInput":
            return a = b.data, a === $5a5426c007ae479a$var$ee && $5a5426c007ae479a$var$fe ? null : a;
        default:
            return null;
    }
}
function $5a5426c007ae479a$var$ke(a, b) {
    if ($5a5426c007ae479a$var$ie) return "compositionend" === a || !$5a5426c007ae479a$var$ae && $5a5426c007ae479a$var$ge(a, b) ? (a = $5a5426c007ae479a$var$nd(), $5a5426c007ae479a$var$md = $5a5426c007ae479a$var$ld = $5a5426c007ae479a$var$kd = null, $5a5426c007ae479a$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5a5426c007ae479a$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5a5426c007ae479a$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5a5426c007ae479a$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5a5426c007ae479a$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5a5426c007ae479a$var$ne(a, b, c, d) {
    $5a5426c007ae479a$var$Eb(d);
    b = $5a5426c007ae479a$var$oe(b, "onChange");
    0 < b.length && (c = new $5a5426c007ae479a$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5a5426c007ae479a$var$pe = null, $5a5426c007ae479a$var$qe = null;
function $5a5426c007ae479a$var$re(a) {
    $5a5426c007ae479a$var$se(a, 0);
}
function $5a5426c007ae479a$var$te(a) {
    var b = $5a5426c007ae479a$var$ue(a);
    if ($5a5426c007ae479a$var$Wa(b)) return a;
}
function $5a5426c007ae479a$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5a5426c007ae479a$var$we = !1;
if ($5a5426c007ae479a$var$ia) {
    var $5a5426c007ae479a$var$xe;
    if ($5a5426c007ae479a$var$ia) {
        var $5a5426c007ae479a$var$ye = "oninput" in document;
        if (!$5a5426c007ae479a$var$ye) {
            var $5a5426c007ae479a$var$ze = document.createElement("div");
            $5a5426c007ae479a$var$ze.setAttribute("oninput", "return;");
            $5a5426c007ae479a$var$ye = "function" === typeof $5a5426c007ae479a$var$ze.oninput;
        }
        $5a5426c007ae479a$var$xe = $5a5426c007ae479a$var$ye;
    } else $5a5426c007ae479a$var$xe = !1;
    $5a5426c007ae479a$var$we = $5a5426c007ae479a$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5a5426c007ae479a$var$Ae() {
    $5a5426c007ae479a$var$pe && ($5a5426c007ae479a$var$pe.detachEvent("onpropertychange", $5a5426c007ae479a$var$Be), $5a5426c007ae479a$var$qe = $5a5426c007ae479a$var$pe = null);
}
function $5a5426c007ae479a$var$Be(a) {
    if ("value" === a.propertyName && $5a5426c007ae479a$var$te($5a5426c007ae479a$var$qe)) {
        var b = [];
        $5a5426c007ae479a$var$ne(b, $5a5426c007ae479a$var$qe, a, $5a5426c007ae479a$var$xb(a));
        $5a5426c007ae479a$var$Jb($5a5426c007ae479a$var$re, b);
    }
}
function $5a5426c007ae479a$var$Ce(a, b, c) {
    "focusin" === a ? ($5a5426c007ae479a$var$Ae(), $5a5426c007ae479a$var$pe = b, $5a5426c007ae479a$var$qe = c, $5a5426c007ae479a$var$pe.attachEvent("onpropertychange", $5a5426c007ae479a$var$Be)) : "focusout" === a && $5a5426c007ae479a$var$Ae();
}
function $5a5426c007ae479a$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5a5426c007ae479a$var$te($5a5426c007ae479a$var$qe);
}
function $5a5426c007ae479a$var$Ee(a, b) {
    if ("click" === a) return $5a5426c007ae479a$var$te(b);
}
function $5a5426c007ae479a$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5a5426c007ae479a$var$te(b);
}
function $5a5426c007ae479a$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5a5426c007ae479a$var$He = "function" === typeof Object.is ? Object.is : $5a5426c007ae479a$var$Ge;
function $5a5426c007ae479a$var$Ie(a, b) {
    if ($5a5426c007ae479a$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5a5426c007ae479a$var$ja.call(b, e) || !$5a5426c007ae479a$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5a5426c007ae479a$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5a5426c007ae479a$var$Ke(a, b) {
    var c = $5a5426c007ae479a$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5a5426c007ae479a$var$Je(c);
    }
}
function $5a5426c007ae479a$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5a5426c007ae479a$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5a5426c007ae479a$var$Me() {
    for(var a = window, b = $5a5426c007ae479a$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5a5426c007ae479a$var$Xa(a.document);
    }
    return b;
}
function $5a5426c007ae479a$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5a5426c007ae479a$var$Oe(a) {
    var b = $5a5426c007ae479a$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5a5426c007ae479a$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5a5426c007ae479a$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5a5426c007ae479a$var$Ke(c, f);
                var g = $5a5426c007ae479a$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5a5426c007ae479a$var$Pe = $5a5426c007ae479a$var$ia && "documentMode" in document && 11 >= document.documentMode, $5a5426c007ae479a$var$Qe = null, $5a5426c007ae479a$var$Re = null, $5a5426c007ae479a$var$Se = null, $5a5426c007ae479a$var$Te = !1;
function $5a5426c007ae479a$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5a5426c007ae479a$var$Te || null == $5a5426c007ae479a$var$Qe || $5a5426c007ae479a$var$Qe !== $5a5426c007ae479a$var$Xa(d) || (d = $5a5426c007ae479a$var$Qe, "selectionStart" in d && $5a5426c007ae479a$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5a5426c007ae479a$var$Se && $5a5426c007ae479a$var$Ie($5a5426c007ae479a$var$Se, d) || ($5a5426c007ae479a$var$Se = d, d = $5a5426c007ae479a$var$oe($5a5426c007ae479a$var$Re, "onSelect"), 0 < d.length && (b = new $5a5426c007ae479a$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5a5426c007ae479a$var$Qe)));
}
function $5a5426c007ae479a$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5a5426c007ae479a$var$We = {
    animationend: $5a5426c007ae479a$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5a5426c007ae479a$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5a5426c007ae479a$var$Ve("Animation", "AnimationStart"),
    transitionend: $5a5426c007ae479a$var$Ve("Transition", "TransitionEnd")
}, $5a5426c007ae479a$var$Xe = {}, $5a5426c007ae479a$var$Ye = {};
$5a5426c007ae479a$var$ia && ($5a5426c007ae479a$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5a5426c007ae479a$var$We.animationend.animation, delete $5a5426c007ae479a$var$We.animationiteration.animation, delete $5a5426c007ae479a$var$We.animationstart.animation), "TransitionEvent" in window || delete $5a5426c007ae479a$var$We.transitionend.transition);
function $5a5426c007ae479a$var$Ze(a) {
    if ($5a5426c007ae479a$var$Xe[a]) return $5a5426c007ae479a$var$Xe[a];
    if (!$5a5426c007ae479a$var$We[a]) return a;
    var b = $5a5426c007ae479a$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5a5426c007ae479a$var$Ye) return $5a5426c007ae479a$var$Xe[a] = b[c];
    return a;
}
var $5a5426c007ae479a$var$$e = $5a5426c007ae479a$var$Ze("animationend"), $5a5426c007ae479a$var$af = $5a5426c007ae479a$var$Ze("animationiteration"), $5a5426c007ae479a$var$bf = $5a5426c007ae479a$var$Ze("animationstart"), $5a5426c007ae479a$var$cf = $5a5426c007ae479a$var$Ze("transitionend"), $5a5426c007ae479a$var$df = new Map, $5a5426c007ae479a$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5a5426c007ae479a$var$ff(a, b) {
    $5a5426c007ae479a$var$df.set(a, b);
    $5a5426c007ae479a$var$fa(b, [
        a
    ]);
}
for(var $5a5426c007ae479a$var$gf = 0; $5a5426c007ae479a$var$gf < $5a5426c007ae479a$var$ef.length; $5a5426c007ae479a$var$gf++){
    var $5a5426c007ae479a$var$hf = $5a5426c007ae479a$var$ef[$5a5426c007ae479a$var$gf], $5a5426c007ae479a$var$jf = $5a5426c007ae479a$var$hf.toLowerCase(), $5a5426c007ae479a$var$kf = $5a5426c007ae479a$var$hf[0].toUpperCase() + $5a5426c007ae479a$var$hf.slice(1);
    $5a5426c007ae479a$var$ff($5a5426c007ae479a$var$jf, "on" + $5a5426c007ae479a$var$kf);
}
$5a5426c007ae479a$var$ff($5a5426c007ae479a$var$$e, "onAnimationEnd");
$5a5426c007ae479a$var$ff($5a5426c007ae479a$var$af, "onAnimationIteration");
$5a5426c007ae479a$var$ff($5a5426c007ae479a$var$bf, "onAnimationStart");
$5a5426c007ae479a$var$ff("dblclick", "onDoubleClick");
$5a5426c007ae479a$var$ff("focusin", "onFocus");
$5a5426c007ae479a$var$ff("focusout", "onBlur");
$5a5426c007ae479a$var$ff($5a5426c007ae479a$var$cf, "onTransitionEnd");
$5a5426c007ae479a$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5a5426c007ae479a$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5a5426c007ae479a$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5a5426c007ae479a$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5a5426c007ae479a$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5a5426c007ae479a$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5a5426c007ae479a$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5a5426c007ae479a$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5a5426c007ae479a$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5a5426c007ae479a$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5a5426c007ae479a$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5a5426c007ae479a$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5a5426c007ae479a$var$lf));
function $5a5426c007ae479a$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5a5426c007ae479a$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5a5426c007ae479a$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5a5426c007ae479a$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5a5426c007ae479a$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5a5426c007ae479a$var$Qb) throw a = $5a5426c007ae479a$var$Rb, $5a5426c007ae479a$var$Qb = !1, $5a5426c007ae479a$var$Rb = null, a;
}
function $5a5426c007ae479a$var$D(a, b) {
    var c = b[$5a5426c007ae479a$var$of];
    void 0 === c && (c = b[$5a5426c007ae479a$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5a5426c007ae479a$var$pf(b, a, 2, !1), c.add(d));
}
function $5a5426c007ae479a$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5a5426c007ae479a$var$pf(c, a, d, b);
}
var $5a5426c007ae479a$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5a5426c007ae479a$var$sf(a) {
    if (!a[$5a5426c007ae479a$var$rf]) {
        a[$5a5426c007ae479a$var$rf] = !0;
        $5a5426c007ae479a$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5a5426c007ae479a$var$mf.has(b) || $5a5426c007ae479a$var$qf(b, !1, a), $5a5426c007ae479a$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5a5426c007ae479a$var$rf] || (b[$5a5426c007ae479a$var$rf] = !0, $5a5426c007ae479a$var$qf("selectionchange", !1, b));
    }
}
function $5a5426c007ae479a$var$pf(a, b, c, d) {
    switch($5a5426c007ae479a$var$jd(b)){
        case 1:
            var e = $5a5426c007ae479a$var$ed;
            break;
        case 4:
            e = $5a5426c007ae479a$var$gd;
            break;
        default:
            e = $5a5426c007ae479a$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5a5426c007ae479a$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5a5426c007ae479a$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5a5426c007ae479a$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5a5426c007ae479a$var$Jb(function() {
        var d = f, e = $5a5426c007ae479a$var$xb(c), g = [];
        a: {
            var h = $5a5426c007ae479a$var$df.get(a);
            if (void 0 !== h) {
                var k = $5a5426c007ae479a$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5a5426c007ae479a$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5a5426c007ae479a$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5a5426c007ae479a$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5a5426c007ae479a$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5a5426c007ae479a$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5a5426c007ae479a$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5a5426c007ae479a$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5a5426c007ae479a$var$Vd;
                        break;
                    case $5a5426c007ae479a$var$$e:
                    case $5a5426c007ae479a$var$af:
                    case $5a5426c007ae479a$var$bf:
                        k = $5a5426c007ae479a$var$Hd;
                        break;
                    case $5a5426c007ae479a$var$cf:
                        k = $5a5426c007ae479a$var$Xd;
                        break;
                    case "scroll":
                        k = $5a5426c007ae479a$var$vd;
                        break;
                    case "wheel":
                        k = $5a5426c007ae479a$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5a5426c007ae479a$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5a5426c007ae479a$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5a5426c007ae479a$var$Kb(w, x), null != F && t.push($5a5426c007ae479a$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5a5426c007ae479a$var$wb && (n = c.relatedTarget || c.fromElement) && ($5a5426c007ae479a$var$Wc(n) || n[$5a5426c007ae479a$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $5a5426c007ae479a$var$Wc(n) : null, null !== n && (J = $5a5426c007ae479a$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $5a5426c007ae479a$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5a5426c007ae479a$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5a5426c007ae479a$var$ue(k);
                        u = null == n ? h : $5a5426c007ae479a$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5a5426c007ae479a$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5a5426c007ae479a$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5a5426c007ae479a$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5a5426c007ae479a$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5a5426c007ae479a$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5a5426c007ae479a$var$vf(t);
                                x = $5a5426c007ae479a$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5a5426c007ae479a$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5a5426c007ae479a$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $5a5426c007ae479a$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5a5426c007ae479a$var$ve;
                else if ($5a5426c007ae479a$var$me(h)) {
                    if ($5a5426c007ae479a$var$we) na = $5a5426c007ae479a$var$Fe;
                    else {
                        na = $5a5426c007ae479a$var$De;
                        var xa = $5a5426c007ae479a$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5a5426c007ae479a$var$Ee);
                if (na && (na = na(a, d))) {
                    $5a5426c007ae479a$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5a5426c007ae479a$var$cb(h, "number", h.value);
            }
            xa = d ? $5a5426c007ae479a$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($5a5426c007ae479a$var$me(xa) || "true" === xa.contentEditable) $5a5426c007ae479a$var$Qe = xa, $5a5426c007ae479a$var$Re = d, $5a5426c007ae479a$var$Se = null;
                    break;
                case "focusout":
                    $5a5426c007ae479a$var$Se = $5a5426c007ae479a$var$Re = $5a5426c007ae479a$var$Qe = null;
                    break;
                case "mousedown":
                    $5a5426c007ae479a$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5a5426c007ae479a$var$Te = !1;
                    $5a5426c007ae479a$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($5a5426c007ae479a$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5a5426c007ae479a$var$Ue(g, c, e);
            }
            var $a;
            if ($5a5426c007ae479a$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5a5426c007ae479a$var$ie ? $5a5426c007ae479a$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5a5426c007ae479a$var$de && "ko" !== c.locale && ($5a5426c007ae479a$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5a5426c007ae479a$var$ie && ($a = $5a5426c007ae479a$var$nd()) : ($5a5426c007ae479a$var$kd = e, $5a5426c007ae479a$var$ld = "value" in $5a5426c007ae479a$var$kd ? $5a5426c007ae479a$var$kd.value : $5a5426c007ae479a$var$kd.textContent, $5a5426c007ae479a$var$ie = !0)), xa = $5a5426c007ae479a$var$oe(d, ba), 0 < xa.length && (ba = new $5a5426c007ae479a$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5a5426c007ae479a$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5a5426c007ae479a$var$ce ? $5a5426c007ae479a$var$je(a, c) : $5a5426c007ae479a$var$ke(a, c)) d = $5a5426c007ae479a$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $5a5426c007ae479a$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $5a5426c007ae479a$var$se(g, b);
    });
}
function $5a5426c007ae479a$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5a5426c007ae479a$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5a5426c007ae479a$var$Kb(a, c), null != f && d.unshift($5a5426c007ae479a$var$tf(a, f, e)), f = $5a5426c007ae479a$var$Kb(a, b), null != f && d.push($5a5426c007ae479a$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5a5426c007ae479a$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5a5426c007ae479a$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5a5426c007ae479a$var$Kb(c, f), null != k && g.unshift($5a5426c007ae479a$var$tf(c, k, h))) : e || (k = $5a5426c007ae479a$var$Kb(c, f), null != k && g.push($5a5426c007ae479a$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5a5426c007ae479a$var$xf = /\r\n?/g, $5a5426c007ae479a$var$yf = /\u0000|\uFFFD/g;
function $5a5426c007ae479a$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5a5426c007ae479a$var$xf, "\n").replace($5a5426c007ae479a$var$yf, "");
}
function $5a5426c007ae479a$var$Af(a, b, c) {
    b = $5a5426c007ae479a$var$zf(b);
    if ($5a5426c007ae479a$var$zf(a) !== b && c) throw Error($5a5426c007ae479a$var$p(425));
}
function $5a5426c007ae479a$var$Bf() {}
var $5a5426c007ae479a$var$Cf = null, $5a5426c007ae479a$var$Df = null;
function $5a5426c007ae479a$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5a5426c007ae479a$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5a5426c007ae479a$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5a5426c007ae479a$var$Hf = "function" === typeof Promise ? Promise : void 0, $5a5426c007ae479a$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5a5426c007ae479a$var$Hf ? function(a) {
    return $5a5426c007ae479a$var$Hf.resolve(null).then(a).catch($5a5426c007ae479a$var$If);
} : $5a5426c007ae479a$var$Ff;
function $5a5426c007ae479a$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5a5426c007ae479a$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5a5426c007ae479a$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5a5426c007ae479a$var$bd(b);
}
function $5a5426c007ae479a$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5a5426c007ae479a$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5a5426c007ae479a$var$Nf = Math.random().toString(36).slice(2), $5a5426c007ae479a$var$Of = "__reactFiber$" + $5a5426c007ae479a$var$Nf, $5a5426c007ae479a$var$Pf = "__reactProps$" + $5a5426c007ae479a$var$Nf, $5a5426c007ae479a$var$uf = "__reactContainer$" + $5a5426c007ae479a$var$Nf, $5a5426c007ae479a$var$of = "__reactEvents$" + $5a5426c007ae479a$var$Nf, $5a5426c007ae479a$var$Qf = "__reactListeners$" + $5a5426c007ae479a$var$Nf, $5a5426c007ae479a$var$Rf = "__reactHandles$" + $5a5426c007ae479a$var$Nf;
function $5a5426c007ae479a$var$Wc(a) {
    var b = a[$5a5426c007ae479a$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5a5426c007ae479a$var$uf] || c[$5a5426c007ae479a$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5a5426c007ae479a$var$Mf(a); null !== a;){
                if (c = a[$5a5426c007ae479a$var$Of]) return c;
                a = $5a5426c007ae479a$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5a5426c007ae479a$var$Cb(a) {
    a = a[$5a5426c007ae479a$var$Of] || a[$5a5426c007ae479a$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5a5426c007ae479a$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5a5426c007ae479a$var$p(33));
}
function $5a5426c007ae479a$var$Db(a) {
    return a[$5a5426c007ae479a$var$Pf] || null;
}
var $5a5426c007ae479a$var$Sf = [], $5a5426c007ae479a$var$Tf = -1;
function $5a5426c007ae479a$var$Uf(a) {
    return {
        current: a
    };
}
function $5a5426c007ae479a$var$E(a) {
    0 > $5a5426c007ae479a$var$Tf || (a.current = $5a5426c007ae479a$var$Sf[$5a5426c007ae479a$var$Tf], $5a5426c007ae479a$var$Sf[$5a5426c007ae479a$var$Tf] = null, $5a5426c007ae479a$var$Tf--);
}
function $5a5426c007ae479a$var$G(a, b) {
    $5a5426c007ae479a$var$Tf++;
    $5a5426c007ae479a$var$Sf[$5a5426c007ae479a$var$Tf] = a.current;
    a.current = b;
}
var $5a5426c007ae479a$var$Vf = {}, $5a5426c007ae479a$var$H = $5a5426c007ae479a$var$Uf($5a5426c007ae479a$var$Vf), $5a5426c007ae479a$var$Wf = $5a5426c007ae479a$var$Uf(!1), $5a5426c007ae479a$var$Xf = $5a5426c007ae479a$var$Vf;
function $5a5426c007ae479a$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5a5426c007ae479a$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5a5426c007ae479a$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5a5426c007ae479a$var$$f() {
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf);
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$H);
}
function $5a5426c007ae479a$var$ag(a, b, c) {
    if ($5a5426c007ae479a$var$H.current !== $5a5426c007ae479a$var$Vf) throw Error($5a5426c007ae479a$var$p(168));
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$H, b);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Wf, c);
}
function $5a5426c007ae479a$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5a5426c007ae479a$var$p(108, $5a5426c007ae479a$var$Ra(a) || "Unknown", e));
    return $5a5426c007ae479a$var$A({}, c, d);
}
function $5a5426c007ae479a$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5a5426c007ae479a$var$Vf;
    $5a5426c007ae479a$var$Xf = $5a5426c007ae479a$var$H.current;
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$H, a);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Wf, $5a5426c007ae479a$var$Wf.current);
    return !0;
}
function $5a5426c007ae479a$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5a5426c007ae479a$var$p(169));
    c ? (a = $5a5426c007ae479a$var$bg(a, b, $5a5426c007ae479a$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf), $5a5426c007ae479a$var$E($5a5426c007ae479a$var$H), $5a5426c007ae479a$var$G($5a5426c007ae479a$var$H, a)) : $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Wf, c);
}
var $5a5426c007ae479a$var$eg = null, $5a5426c007ae479a$var$fg = !1, $5a5426c007ae479a$var$gg = !1;
function $5a5426c007ae479a$var$hg(a) {
    null === $5a5426c007ae479a$var$eg ? $5a5426c007ae479a$var$eg = [
        a
    ] : $5a5426c007ae479a$var$eg.push(a);
}
function $5a5426c007ae479a$var$ig(a) {
    $5a5426c007ae479a$var$fg = !0;
    $5a5426c007ae479a$var$hg(a);
}
function $5a5426c007ae479a$var$jg() {
    if (!$5a5426c007ae479a$var$gg && null !== $5a5426c007ae479a$var$eg) {
        $5a5426c007ae479a$var$gg = !0;
        var a = 0, b = $5a5426c007ae479a$var$C;
        try {
            var c = $5a5426c007ae479a$var$eg;
            for($5a5426c007ae479a$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5a5426c007ae479a$var$eg = null;
            $5a5426c007ae479a$var$fg = !1;
        } catch (e) {
            throw null !== $5a5426c007ae479a$var$eg && ($5a5426c007ae479a$var$eg = $5a5426c007ae479a$var$eg.slice(a + 1)), $5a5426c007ae479a$var$ac($5a5426c007ae479a$var$fc, $5a5426c007ae479a$var$jg), e;
        } finally{
            $5a5426c007ae479a$var$C = b, $5a5426c007ae479a$var$gg = !1;
        }
    }
    return null;
}
var $5a5426c007ae479a$var$kg = [], $5a5426c007ae479a$var$lg = 0, $5a5426c007ae479a$var$mg = null, $5a5426c007ae479a$var$ng = 0, $5a5426c007ae479a$var$og = [], $5a5426c007ae479a$var$pg = 0, $5a5426c007ae479a$var$qg = null, $5a5426c007ae479a$var$rg = 1, $5a5426c007ae479a$var$sg = "";
function $5a5426c007ae479a$var$tg(a, b) {
    $5a5426c007ae479a$var$kg[$5a5426c007ae479a$var$lg++] = $5a5426c007ae479a$var$ng;
    $5a5426c007ae479a$var$kg[$5a5426c007ae479a$var$lg++] = $5a5426c007ae479a$var$mg;
    $5a5426c007ae479a$var$mg = a;
    $5a5426c007ae479a$var$ng = b;
}
function $5a5426c007ae479a$var$ug(a, b, c) {
    $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$rg;
    $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$sg;
    $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$qg;
    $5a5426c007ae479a$var$qg = a;
    var d = $5a5426c007ae479a$var$rg;
    a = $5a5426c007ae479a$var$sg;
    var e = 32 - $5a5426c007ae479a$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5a5426c007ae479a$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5a5426c007ae479a$var$rg = 1 << 32 - $5a5426c007ae479a$var$oc(b) + e | c << e | d;
        $5a5426c007ae479a$var$sg = f + a;
    } else $5a5426c007ae479a$var$rg = 1 << f | c << e | d, $5a5426c007ae479a$var$sg = a;
}
function $5a5426c007ae479a$var$vg(a) {
    null !== a.return && ($5a5426c007ae479a$var$tg(a, 1), $5a5426c007ae479a$var$ug(a, 1, 0));
}
function $5a5426c007ae479a$var$wg(a) {
    for(; a === $5a5426c007ae479a$var$mg;)$5a5426c007ae479a$var$mg = $5a5426c007ae479a$var$kg[--$5a5426c007ae479a$var$lg], $5a5426c007ae479a$var$kg[$5a5426c007ae479a$var$lg] = null, $5a5426c007ae479a$var$ng = $5a5426c007ae479a$var$kg[--$5a5426c007ae479a$var$lg], $5a5426c007ae479a$var$kg[$5a5426c007ae479a$var$lg] = null;
    for(; a === $5a5426c007ae479a$var$qg;)$5a5426c007ae479a$var$qg = $5a5426c007ae479a$var$og[--$5a5426c007ae479a$var$pg], $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg] = null, $5a5426c007ae479a$var$sg = $5a5426c007ae479a$var$og[--$5a5426c007ae479a$var$pg], $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg] = null, $5a5426c007ae479a$var$rg = $5a5426c007ae479a$var$og[--$5a5426c007ae479a$var$pg], $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg] = null;
}
var $5a5426c007ae479a$var$xg = null, $5a5426c007ae479a$var$yg = null, $5a5426c007ae479a$var$I = !1, $5a5426c007ae479a$var$zg = null;
function $5a5426c007ae479a$var$Ag(a, b) {
    var c = $5a5426c007ae479a$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5a5426c007ae479a$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5a5426c007ae479a$var$xg = a, $5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5a5426c007ae479a$var$xg = a, $5a5426c007ae479a$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5a5426c007ae479a$var$qg ? {
                id: $5a5426c007ae479a$var$rg,
                overflow: $5a5426c007ae479a$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5a5426c007ae479a$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5a5426c007ae479a$var$xg = a, $5a5426c007ae479a$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5a5426c007ae479a$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5a5426c007ae479a$var$Eg(a) {
    if ($5a5426c007ae479a$var$I) {
        var b = $5a5426c007ae479a$var$yg;
        if (b) {
            var c = b;
            if (!$5a5426c007ae479a$var$Cg(a, b)) {
                if ($5a5426c007ae479a$var$Dg(a)) throw Error($5a5426c007ae479a$var$p(418));
                b = $5a5426c007ae479a$var$Lf(c.nextSibling);
                var d = $5a5426c007ae479a$var$xg;
                b && $5a5426c007ae479a$var$Cg(a, b) ? $5a5426c007ae479a$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5a5426c007ae479a$var$I = !1, $5a5426c007ae479a$var$xg = a);
            }
        } else {
            if ($5a5426c007ae479a$var$Dg(a)) throw Error($5a5426c007ae479a$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5a5426c007ae479a$var$I = !1;
            $5a5426c007ae479a$var$xg = a;
        }
    }
}
function $5a5426c007ae479a$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5a5426c007ae479a$var$xg = a;
}
function $5a5426c007ae479a$var$Gg(a) {
    if (a !== $5a5426c007ae479a$var$xg) return !1;
    if (!$5a5426c007ae479a$var$I) return $5a5426c007ae479a$var$Fg(a), $5a5426c007ae479a$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5a5426c007ae479a$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5a5426c007ae479a$var$yg)) {
        if ($5a5426c007ae479a$var$Dg(a)) throw $5a5426c007ae479a$var$Hg(), Error($5a5426c007ae479a$var$p(418));
        for(; b;)$5a5426c007ae479a$var$Ag(a, b), b = $5a5426c007ae479a$var$Lf(b.nextSibling);
    }
    $5a5426c007ae479a$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5a5426c007ae479a$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5a5426c007ae479a$var$yg = null;
        }
    } else $5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$xg ? $5a5426c007ae479a$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5a5426c007ae479a$var$Hg() {
    for(var a = $5a5426c007ae479a$var$yg; a;)a = $5a5426c007ae479a$var$Lf(a.nextSibling);
}
function $5a5426c007ae479a$var$Ig() {
    $5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$xg = null;
    $5a5426c007ae479a$var$I = !1;
}
function $5a5426c007ae479a$var$Jg(a) {
    null === $5a5426c007ae479a$var$zg ? $5a5426c007ae479a$var$zg = [
        a
    ] : $5a5426c007ae479a$var$zg.push(a);
}
var $5a5426c007ae479a$var$Kg = $5a5426c007ae479a$var$ua.ReactCurrentBatchConfig;
function $5a5426c007ae479a$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $5a5426c007ae479a$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $5a5426c007ae479a$var$Mg = $5a5426c007ae479a$var$Uf(null), $5a5426c007ae479a$var$Ng = null, $5a5426c007ae479a$var$Og = null, $5a5426c007ae479a$var$Pg = null;
function $5a5426c007ae479a$var$Qg() {
    $5a5426c007ae479a$var$Pg = $5a5426c007ae479a$var$Og = $5a5426c007ae479a$var$Ng = null;
}
function $5a5426c007ae479a$var$Rg(a) {
    var b = $5a5426c007ae479a$var$Mg.current;
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Mg);
    a._currentValue = b;
}
function $5a5426c007ae479a$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5a5426c007ae479a$var$Tg(a, b) {
    $5a5426c007ae479a$var$Ng = a;
    $5a5426c007ae479a$var$Pg = $5a5426c007ae479a$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5a5426c007ae479a$var$Ug = !0), a.firstContext = null);
}
function $5a5426c007ae479a$var$Vg(a) {
    var b = a._currentValue;
    if ($5a5426c007ae479a$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5a5426c007ae479a$var$Og) {
            if (null === $5a5426c007ae479a$var$Ng) throw Error($5a5426c007ae479a$var$p(308));
            $5a5426c007ae479a$var$Og = a;
            $5a5426c007ae479a$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5a5426c007ae479a$var$Og = $5a5426c007ae479a$var$Og.next = a;
    }
    return b;
}
var $5a5426c007ae479a$var$Wg = null;
function $5a5426c007ae479a$var$Xg(a) {
    null === $5a5426c007ae479a$var$Wg ? $5a5426c007ae479a$var$Wg = [
        a
    ] : $5a5426c007ae479a$var$Wg.push(a);
}
function $5a5426c007ae479a$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5a5426c007ae479a$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5a5426c007ae479a$var$Zg(a, d);
}
function $5a5426c007ae479a$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5a5426c007ae479a$var$$g = !1;
function $5a5426c007ae479a$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5a5426c007ae479a$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5a5426c007ae479a$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5a5426c007ae479a$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5a5426c007ae479a$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5a5426c007ae479a$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5a5426c007ae479a$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5a5426c007ae479a$var$Zg(a, c);
}
function $5a5426c007ae479a$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5a5426c007ae479a$var$Cc(a, c);
    }
}
function $5a5426c007ae479a$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5a5426c007ae479a$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $5a5426c007ae479a$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5a5426c007ae479a$var$A({}, q, r);
                            break a;
                        case 2:
                            $5a5426c007ae479a$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5a5426c007ae479a$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5a5426c007ae479a$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5a5426c007ae479a$var$p(191, e));
            e.call(d);
        }
    }
}
var $5a5426c007ae479a$var$jh = (new $b7Z9x.Component).refs;
function $5a5426c007ae479a$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5a5426c007ae479a$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5a5426c007ae479a$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $5a5426c007ae479a$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5a5426c007ae479a$var$L(), e = $5a5426c007ae479a$var$lh(a), f = $5a5426c007ae479a$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5a5426c007ae479a$var$dh(a, f, e);
        null !== b && ($5a5426c007ae479a$var$mh(b, a, e, d), $5a5426c007ae479a$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5a5426c007ae479a$var$L(), e = $5a5426c007ae479a$var$lh(a), f = $5a5426c007ae479a$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5a5426c007ae479a$var$dh(a, f, e);
        null !== b && ($5a5426c007ae479a$var$mh(b, a, e, d), $5a5426c007ae479a$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $5a5426c007ae479a$var$L(), d = $5a5426c007ae479a$var$lh(a), e = $5a5426c007ae479a$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5a5426c007ae479a$var$dh(a, e, d);
        null !== b && ($5a5426c007ae479a$var$mh(b, a, d, c), $5a5426c007ae479a$var$eh(b, a, d));
    }
};
function $5a5426c007ae479a$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5a5426c007ae479a$var$Ie(c, d) || !$5a5426c007ae479a$var$Ie(e, f) : !0;
}
function $5a5426c007ae479a$var$ph(a, b, c) {
    var d = !1, e = $5a5426c007ae479a$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5a5426c007ae479a$var$Vg(f) : (e = $5a5426c007ae479a$var$Zf(b) ? $5a5426c007ae479a$var$Xf : $5a5426c007ae479a$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5a5426c007ae479a$var$Yf(a, e) : $5a5426c007ae479a$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5a5426c007ae479a$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5a5426c007ae479a$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5a5426c007ae479a$var$nh.enqueueReplaceState(b, b.state, null);
}
function $5a5426c007ae479a$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $5a5426c007ae479a$var$jh;
    $5a5426c007ae479a$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5a5426c007ae479a$var$Vg(f) : (f = $5a5426c007ae479a$var$Zf(b) ? $5a5426c007ae479a$var$Xf : $5a5426c007ae479a$var$H.current, e.context = $5a5426c007ae479a$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5a5426c007ae479a$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5a5426c007ae479a$var$nh.enqueueReplaceState(e, e.state, null), $5a5426c007ae479a$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5a5426c007ae479a$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5a5426c007ae479a$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5a5426c007ae479a$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $5a5426c007ae479a$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5a5426c007ae479a$var$p(284));
        if (!c._owner) throw Error($5a5426c007ae479a$var$p(290, a));
    }
    return a;
}
function $5a5426c007ae479a$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5a5426c007ae479a$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5a5426c007ae479a$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $5a5426c007ae479a$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5a5426c007ae479a$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5a5426c007ae479a$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5a5426c007ae479a$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5a5426c007ae479a$var$Ha && $5a5426c007ae479a$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $5a5426c007ae479a$var$sh(a, b, c), d.return = a, d;
        d = $5a5426c007ae479a$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5a5426c007ae479a$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5a5426c007ae479a$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5a5426c007ae479a$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5a5426c007ae479a$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5a5426c007ae479a$var$va:
                    return c = $5a5426c007ae479a$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $5a5426c007ae479a$var$sh(a, null, b), c.return = a, c;
                case $5a5426c007ae479a$var$wa:
                    return b = $5a5426c007ae479a$var$zh(b, a.mode, c), b.return = a, b;
                case $5a5426c007ae479a$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5a5426c007ae479a$var$eb(b) || $5a5426c007ae479a$var$Ka(b)) return b = $5a5426c007ae479a$var$Ah(b, a.mode, c, null), b.return = a, b;
            $5a5426c007ae479a$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5a5426c007ae479a$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5a5426c007ae479a$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5a5426c007ae479a$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5a5426c007ae479a$var$eb(c) || $5a5426c007ae479a$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5a5426c007ae479a$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5a5426c007ae479a$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5a5426c007ae479a$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5a5426c007ae479a$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5a5426c007ae479a$var$eb(d) || $5a5426c007ae479a$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5a5426c007ae479a$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5a5426c007ae479a$var$Ka(h);
        if ("function" !== typeof l) throw Error($5a5426c007ae479a$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5a5426c007ae479a$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5a5426c007ae479a$var$I && $5a5426c007ae479a$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5a5426c007ae479a$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5a5426c007ae479a$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5a5426c007ae479a$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5a5426c007ae479a$var$Ha && $5a5426c007ae479a$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5a5426c007ae479a$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5a5426c007ae479a$var$ya ? (d = $5a5426c007ae479a$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5a5426c007ae479a$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $5a5426c007ae479a$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5a5426c007ae479a$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5a5426c007ae479a$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5a5426c007ae479a$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5a5426c007ae479a$var$eb(f)) return n(a, d, f, h);
            if ($5a5426c007ae479a$var$Ka(f)) return t(a, d, f, h);
            $5a5426c007ae479a$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5a5426c007ae479a$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5a5426c007ae479a$var$Bh = $5a5426c007ae479a$var$vh(!0), $5a5426c007ae479a$var$Ch = $5a5426c007ae479a$var$vh(!1), $5a5426c007ae479a$var$Dh = {}, $5a5426c007ae479a$var$Eh = $5a5426c007ae479a$var$Uf($5a5426c007ae479a$var$Dh), $5a5426c007ae479a$var$Fh = $5a5426c007ae479a$var$Uf($5a5426c007ae479a$var$Dh), $5a5426c007ae479a$var$Gh = $5a5426c007ae479a$var$Uf($5a5426c007ae479a$var$Dh);
function $5a5426c007ae479a$var$Hh(a) {
    if (a === $5a5426c007ae479a$var$Dh) throw Error($5a5426c007ae479a$var$p(174));
    return a;
}
function $5a5426c007ae479a$var$Ih(a, b) {
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Gh, b);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Fh, a);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Eh, $5a5426c007ae479a$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5a5426c007ae479a$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5a5426c007ae479a$var$lb(b, a);
    }
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Eh);
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Eh, b);
}
function $5a5426c007ae479a$var$Jh() {
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Eh);
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Fh);
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Gh);
}
function $5a5426c007ae479a$var$Kh(a) {
    $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Gh.current);
    var b = $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Eh.current);
    var c = $5a5426c007ae479a$var$lb(b, a.type);
    b !== c && ($5a5426c007ae479a$var$G($5a5426c007ae479a$var$Fh, a), $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Eh, c));
}
function $5a5426c007ae479a$var$Lh(a) {
    $5a5426c007ae479a$var$Fh.current === a && ($5a5426c007ae479a$var$E($5a5426c007ae479a$var$Eh), $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Fh));
}
var $5a5426c007ae479a$var$M = $5a5426c007ae479a$var$Uf(0);
function $5a5426c007ae479a$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5a5426c007ae479a$var$Nh = [];
function $5a5426c007ae479a$var$Oh() {
    for(var a = 0; a < $5a5426c007ae479a$var$Nh.length; a++)$5a5426c007ae479a$var$Nh[a]._workInProgressVersionPrimary = null;
    $5a5426c007ae479a$var$Nh.length = 0;
}
var $5a5426c007ae479a$var$Ph = $5a5426c007ae479a$var$ua.ReactCurrentDispatcher, $5a5426c007ae479a$var$Qh = $5a5426c007ae479a$var$ua.ReactCurrentBatchConfig, $5a5426c007ae479a$var$Rh = 0, $5a5426c007ae479a$var$N = null, $5a5426c007ae479a$var$O = null, $5a5426c007ae479a$var$P = null, $5a5426c007ae479a$var$Sh = !1, $5a5426c007ae479a$var$Th = !1, $5a5426c007ae479a$var$Uh = 0, $5a5426c007ae479a$var$Vh = 0;
function $5a5426c007ae479a$var$Q() {
    throw Error($5a5426c007ae479a$var$p(321));
}
function $5a5426c007ae479a$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5a5426c007ae479a$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5a5426c007ae479a$var$Xh(a, b, c, d, e, f) {
    $5a5426c007ae479a$var$Rh = f;
    $5a5426c007ae479a$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5a5426c007ae479a$var$Ph.current = null === a || null === a.memoizedState ? $5a5426c007ae479a$var$Yh : $5a5426c007ae479a$var$Zh;
    a = c(d, e);
    if ($5a5426c007ae479a$var$Th) {
        f = 0;
        do {
            $5a5426c007ae479a$var$Th = !1;
            $5a5426c007ae479a$var$Uh = 0;
            if (25 <= f) throw Error($5a5426c007ae479a$var$p(301));
            f += 1;
            $5a5426c007ae479a$var$P = $5a5426c007ae479a$var$O = null;
            b.updateQueue = null;
            $5a5426c007ae479a$var$Ph.current = $5a5426c007ae479a$var$$h;
            a = c(d, e);
        }while ($5a5426c007ae479a$var$Th);
    }
    $5a5426c007ae479a$var$Ph.current = $5a5426c007ae479a$var$ai;
    b = null !== $5a5426c007ae479a$var$O && null !== $5a5426c007ae479a$var$O.next;
    $5a5426c007ae479a$var$Rh = 0;
    $5a5426c007ae479a$var$P = $5a5426c007ae479a$var$O = $5a5426c007ae479a$var$N = null;
    $5a5426c007ae479a$var$Sh = !1;
    if (b) throw Error($5a5426c007ae479a$var$p(300));
    return a;
}
function $5a5426c007ae479a$var$bi() {
    var a = 0 !== $5a5426c007ae479a$var$Uh;
    $5a5426c007ae479a$var$Uh = 0;
    return a;
}
function $5a5426c007ae479a$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5a5426c007ae479a$var$P ? $5a5426c007ae479a$var$N.memoizedState = $5a5426c007ae479a$var$P = a : $5a5426c007ae479a$var$P = $5a5426c007ae479a$var$P.next = a;
    return $5a5426c007ae479a$var$P;
}
function $5a5426c007ae479a$var$di() {
    if (null === $5a5426c007ae479a$var$O) {
        var a = $5a5426c007ae479a$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5a5426c007ae479a$var$O.next;
    var b = null === $5a5426c007ae479a$var$P ? $5a5426c007ae479a$var$N.memoizedState : $5a5426c007ae479a$var$P.next;
    if (null !== b) $5a5426c007ae479a$var$P = b, $5a5426c007ae479a$var$O = a;
    else {
        if (null === a) throw Error($5a5426c007ae479a$var$p(310));
        $5a5426c007ae479a$var$O = a;
        a = {
            memoizedState: $5a5426c007ae479a$var$O.memoizedState,
            baseState: $5a5426c007ae479a$var$O.baseState,
            baseQueue: $5a5426c007ae479a$var$O.baseQueue,
            queue: $5a5426c007ae479a$var$O.queue,
            next: null
        };
        null === $5a5426c007ae479a$var$P ? $5a5426c007ae479a$var$N.memoizedState = $5a5426c007ae479a$var$P = a : $5a5426c007ae479a$var$P = $5a5426c007ae479a$var$P.next = a;
    }
    return $5a5426c007ae479a$var$P;
}
function $5a5426c007ae479a$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5a5426c007ae479a$var$fi(a) {
    var b = $5a5426c007ae479a$var$di(), c = b.queue;
    if (null === c) throw Error($5a5426c007ae479a$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5a5426c007ae479a$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5a5426c007ae479a$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5a5426c007ae479a$var$N.lanes |= m;
                $5a5426c007ae479a$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5a5426c007ae479a$var$He(d, b.memoizedState) || ($5a5426c007ae479a$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5a5426c007ae479a$var$N.lanes |= f, $5a5426c007ae479a$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5a5426c007ae479a$var$gi(a) {
    var b = $5a5426c007ae479a$var$di(), c = b.queue;
    if (null === c) throw Error($5a5426c007ae479a$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5a5426c007ae479a$var$He(f, b.memoizedState) || ($5a5426c007ae479a$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5a5426c007ae479a$var$hi() {}
function $5a5426c007ae479a$var$ii(a, b) {
    var c = $5a5426c007ae479a$var$N, d = $5a5426c007ae479a$var$di(), e = b(), f = !$5a5426c007ae479a$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5a5426c007ae479a$var$Ug = !0);
    d = d.queue;
    $5a5426c007ae479a$var$ji($5a5426c007ae479a$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5a5426c007ae479a$var$P && $5a5426c007ae479a$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5a5426c007ae479a$var$li(9, $5a5426c007ae479a$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $5a5426c007ae479a$var$R) throw Error($5a5426c007ae479a$var$p(349));
        0 !== ($5a5426c007ae479a$var$Rh & 30) || $5a5426c007ae479a$var$ni(c, b, e);
    }
    return e;
}
function $5a5426c007ae479a$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5a5426c007ae479a$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5a5426c007ae479a$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5a5426c007ae479a$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5a5426c007ae479a$var$oi(b) && $5a5426c007ae479a$var$pi(a);
}
function $5a5426c007ae479a$var$ki(a, b, c) {
    return c(function() {
        $5a5426c007ae479a$var$oi(b) && $5a5426c007ae479a$var$pi(a);
    });
}
function $5a5426c007ae479a$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5a5426c007ae479a$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5a5426c007ae479a$var$pi(a) {
    var b = $5a5426c007ae479a$var$Zg(a, 1);
    null !== b && $5a5426c007ae479a$var$mh(b, a, 1, -1);
}
function $5a5426c007ae479a$var$qi(a) {
    var b = $5a5426c007ae479a$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5a5426c007ae479a$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5a5426c007ae479a$var$ri.bind(null, $5a5426c007ae479a$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5a5426c007ae479a$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5a5426c007ae479a$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5a5426c007ae479a$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5a5426c007ae479a$var$si() {
    return $5a5426c007ae479a$var$di().memoizedState;
}
function $5a5426c007ae479a$var$ti(a, b, c, d) {
    var e = $5a5426c007ae479a$var$ci();
    $5a5426c007ae479a$var$N.flags |= a;
    e.memoizedState = $5a5426c007ae479a$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5a5426c007ae479a$var$ui(a, b, c, d) {
    var e = $5a5426c007ae479a$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5a5426c007ae479a$var$O) {
        var g = $5a5426c007ae479a$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $5a5426c007ae479a$var$Wh(d, g.deps)) {
            e.memoizedState = $5a5426c007ae479a$var$li(b, c, f, d);
            return;
        }
    }
    $5a5426c007ae479a$var$N.flags |= a;
    e.memoizedState = $5a5426c007ae479a$var$li(1 | b, c, f, d);
}
function $5a5426c007ae479a$var$vi(a, b) {
    return $5a5426c007ae479a$var$ti(8390656, 8, a, b);
}
function $5a5426c007ae479a$var$ji(a, b) {
    return $5a5426c007ae479a$var$ui(2048, 8, a, b);
}
function $5a5426c007ae479a$var$wi(a, b) {
    return $5a5426c007ae479a$var$ui(4, 2, a, b);
}
function $5a5426c007ae479a$var$xi(a, b) {
    return $5a5426c007ae479a$var$ui(4, 4, a, b);
}
function $5a5426c007ae479a$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5a5426c007ae479a$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5a5426c007ae479a$var$ui(4, 4, $5a5426c007ae479a$var$yi.bind(null, b, a), c);
}
function $5a5426c007ae479a$var$Ai() {}
function $5a5426c007ae479a$var$Bi(a, b) {
    var c = $5a5426c007ae479a$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5a5426c007ae479a$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5a5426c007ae479a$var$Ci(a, b) {
    var c = $5a5426c007ae479a$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5a5426c007ae479a$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5a5426c007ae479a$var$Di(a, b, c) {
    if (0 === ($5a5426c007ae479a$var$Rh & 21)) return a.baseState && (a.baseState = !1, $5a5426c007ae479a$var$Ug = !0), a.memoizedState = c;
    $5a5426c007ae479a$var$He(c, b) || (c = $5a5426c007ae479a$var$yc(), $5a5426c007ae479a$var$N.lanes |= c, $5a5426c007ae479a$var$hh |= c, a.baseState = !0);
    return b;
}
function $5a5426c007ae479a$var$Ei(a, b) {
    var c = $5a5426c007ae479a$var$C;
    $5a5426c007ae479a$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5a5426c007ae479a$var$Qh.transition;
    $5a5426c007ae479a$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5a5426c007ae479a$var$C = c, $5a5426c007ae479a$var$Qh.transition = d;
    }
}
function $5a5426c007ae479a$var$Fi() {
    return $5a5426c007ae479a$var$di().memoizedState;
}
function $5a5426c007ae479a$var$Gi(a, b, c) {
    var d = $5a5426c007ae479a$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5a5426c007ae479a$var$Hi(a)) $5a5426c007ae479a$var$Ii(b, c);
    else if (c = $5a5426c007ae479a$var$Yg(a, b, c, d), null !== c) {
        var e = $5a5426c007ae479a$var$L();
        $5a5426c007ae479a$var$mh(c, a, d, e);
        $5a5426c007ae479a$var$Ji(c, b, d);
    }
}
function $5a5426c007ae479a$var$ri(a, b, c) {
    var d = $5a5426c007ae479a$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5a5426c007ae479a$var$Hi(a)) $5a5426c007ae479a$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5a5426c007ae479a$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5a5426c007ae479a$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5a5426c007ae479a$var$Yg(a, b, e, d);
        null !== c && (e = $5a5426c007ae479a$var$L(), $5a5426c007ae479a$var$mh(c, a, d, e), $5a5426c007ae479a$var$Ji(c, b, d));
    }
}
function $5a5426c007ae479a$var$Hi(a) {
    var b = a.alternate;
    return a === $5a5426c007ae479a$var$N || null !== b && b === $5a5426c007ae479a$var$N;
}
function $5a5426c007ae479a$var$Ii(a, b) {
    $5a5426c007ae479a$var$Th = $5a5426c007ae479a$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5a5426c007ae479a$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5a5426c007ae479a$var$Cc(a, c);
    }
}
var $5a5426c007ae479a$var$ai = {
    readContext: $5a5426c007ae479a$var$Vg,
    useCallback: $5a5426c007ae479a$var$Q,
    useContext: $5a5426c007ae479a$var$Q,
    useEffect: $5a5426c007ae479a$var$Q,
    useImperativeHandle: $5a5426c007ae479a$var$Q,
    useInsertionEffect: $5a5426c007ae479a$var$Q,
    useLayoutEffect: $5a5426c007ae479a$var$Q,
    useMemo: $5a5426c007ae479a$var$Q,
    useReducer: $5a5426c007ae479a$var$Q,
    useRef: $5a5426c007ae479a$var$Q,
    useState: $5a5426c007ae479a$var$Q,
    useDebugValue: $5a5426c007ae479a$var$Q,
    useDeferredValue: $5a5426c007ae479a$var$Q,
    useTransition: $5a5426c007ae479a$var$Q,
    useMutableSource: $5a5426c007ae479a$var$Q,
    useSyncExternalStore: $5a5426c007ae479a$var$Q,
    useId: $5a5426c007ae479a$var$Q,
    unstable_isNewReconciler: !1
}, $5a5426c007ae479a$var$Yh = {
    readContext: $5a5426c007ae479a$var$Vg,
    useCallback: function(a, b) {
        $5a5426c007ae479a$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5a5426c007ae479a$var$Vg,
    useEffect: $5a5426c007ae479a$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5a5426c007ae479a$var$ti(4194308, 4, $5a5426c007ae479a$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5a5426c007ae479a$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $5a5426c007ae479a$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5a5426c007ae479a$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5a5426c007ae479a$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5a5426c007ae479a$var$Gi.bind(null, $5a5426c007ae479a$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5a5426c007ae479a$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5a5426c007ae479a$var$qi,
    useDebugValue: $5a5426c007ae479a$var$Ai,
    useDeferredValue: function(a) {
        return $5a5426c007ae479a$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $5a5426c007ae479a$var$qi(!1), b = a[0];
        a = $5a5426c007ae479a$var$Ei.bind(null, a[1]);
        $5a5426c007ae479a$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $5a5426c007ae479a$var$N, e = $5a5426c007ae479a$var$ci();
        if ($5a5426c007ae479a$var$I) {
            if (void 0 === c) throw Error($5a5426c007ae479a$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5a5426c007ae479a$var$R) throw Error($5a5426c007ae479a$var$p(349));
            0 !== ($5a5426c007ae479a$var$Rh & 30) || $5a5426c007ae479a$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5a5426c007ae479a$var$vi($5a5426c007ae479a$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5a5426c007ae479a$var$li(9, $5a5426c007ae479a$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $5a5426c007ae479a$var$ci(), b = $5a5426c007ae479a$var$R.identifierPrefix;
        if ($5a5426c007ae479a$var$I) {
            var c = $5a5426c007ae479a$var$sg;
            var d = $5a5426c007ae479a$var$rg;
            c = (d & ~(1 << 32 - $5a5426c007ae479a$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5a5426c007ae479a$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5a5426c007ae479a$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5a5426c007ae479a$var$Zh = {
    readContext: $5a5426c007ae479a$var$Vg,
    useCallback: $5a5426c007ae479a$var$Bi,
    useContext: $5a5426c007ae479a$var$Vg,
    useEffect: $5a5426c007ae479a$var$ji,
    useImperativeHandle: $5a5426c007ae479a$var$zi,
    useInsertionEffect: $5a5426c007ae479a$var$wi,
    useLayoutEffect: $5a5426c007ae479a$var$xi,
    useMemo: $5a5426c007ae479a$var$Ci,
    useReducer: $5a5426c007ae479a$var$fi,
    useRef: $5a5426c007ae479a$var$si,
    useState: function() {
        return $5a5426c007ae479a$var$fi($5a5426c007ae479a$var$ei);
    },
    useDebugValue: $5a5426c007ae479a$var$Ai,
    useDeferredValue: function(a) {
        var b = $5a5426c007ae479a$var$di();
        return $5a5426c007ae479a$var$Di(b, $5a5426c007ae479a$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $5a5426c007ae479a$var$fi($5a5426c007ae479a$var$ei)[0], b = $5a5426c007ae479a$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5a5426c007ae479a$var$hi,
    useSyncExternalStore: $5a5426c007ae479a$var$ii,
    useId: $5a5426c007ae479a$var$Fi,
    unstable_isNewReconciler: !1
}, $5a5426c007ae479a$var$$h = {
    readContext: $5a5426c007ae479a$var$Vg,
    useCallback: $5a5426c007ae479a$var$Bi,
    useContext: $5a5426c007ae479a$var$Vg,
    useEffect: $5a5426c007ae479a$var$ji,
    useImperativeHandle: $5a5426c007ae479a$var$zi,
    useInsertionEffect: $5a5426c007ae479a$var$wi,
    useLayoutEffect: $5a5426c007ae479a$var$xi,
    useMemo: $5a5426c007ae479a$var$Ci,
    useReducer: $5a5426c007ae479a$var$gi,
    useRef: $5a5426c007ae479a$var$si,
    useState: function() {
        return $5a5426c007ae479a$var$gi($5a5426c007ae479a$var$ei);
    },
    useDebugValue: $5a5426c007ae479a$var$Ai,
    useDeferredValue: function(a) {
        var b = $5a5426c007ae479a$var$di();
        return null === $5a5426c007ae479a$var$O ? b.memoizedState = a : $5a5426c007ae479a$var$Di(b, $5a5426c007ae479a$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $5a5426c007ae479a$var$gi($5a5426c007ae479a$var$ei)[0], b = $5a5426c007ae479a$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5a5426c007ae479a$var$hi,
    useSyncExternalStore: $5a5426c007ae479a$var$ii,
    useId: $5a5426c007ae479a$var$Fi,
    unstable_isNewReconciler: !1
};
function $5a5426c007ae479a$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $5a5426c007ae479a$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5a5426c007ae479a$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5a5426c007ae479a$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5a5426c007ae479a$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $5a5426c007ae479a$var$Oi(a, b, c) {
    c = $5a5426c007ae479a$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5a5426c007ae479a$var$Pi || ($5a5426c007ae479a$var$Pi = !0, $5a5426c007ae479a$var$Qi = d);
        $5a5426c007ae479a$var$Mi(a, b);
    };
    return c;
}
function $5a5426c007ae479a$var$Ri(a, b, c) {
    c = $5a5426c007ae479a$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5a5426c007ae479a$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5a5426c007ae479a$var$Mi(a, b);
        "function" !== typeof d && (null === $5a5426c007ae479a$var$Si ? $5a5426c007ae479a$var$Si = new Set([
            this
        ]) : $5a5426c007ae479a$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $5a5426c007ae479a$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5a5426c007ae479a$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5a5426c007ae479a$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $5a5426c007ae479a$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5a5426c007ae479a$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5a5426c007ae479a$var$ch(-1, 1), b.tag = 2, $5a5426c007ae479a$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5a5426c007ae479a$var$Xi = $5a5426c007ae479a$var$ua.ReactCurrentOwner, $5a5426c007ae479a$var$Ug = !1;
function $5a5426c007ae479a$var$Yi(a, b, c, d) {
    b.child = null === a ? $5a5426c007ae479a$var$Ch(b, null, c, d) : $5a5426c007ae479a$var$Bh(b, a.child, c, d);
}
function $5a5426c007ae479a$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5a5426c007ae479a$var$Tg(b, e);
    d = $5a5426c007ae479a$var$Xh(a, b, c, d, f, e);
    c = $5a5426c007ae479a$var$bi();
    if (null !== a && !$5a5426c007ae479a$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5a5426c007ae479a$var$$i(a, b, e);
    $5a5426c007ae479a$var$I && c && $5a5426c007ae479a$var$vg(b);
    b.flags |= 1;
    $5a5426c007ae479a$var$Yi(a, b, d, e);
    return b.child;
}
function $5a5426c007ae479a$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5a5426c007ae479a$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5a5426c007ae479a$var$cj(a, b, f, d, e);
        a = $5a5426c007ae479a$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5a5426c007ae479a$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5a5426c007ae479a$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $5a5426c007ae479a$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5a5426c007ae479a$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5a5426c007ae479a$var$Ie(f, d) && a.ref === b.ref) {
            if ($5a5426c007ae479a$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5a5426c007ae479a$var$Ug = !0);
            else return b.lanes = a.lanes, $5a5426c007ae479a$var$$i(a, b, e);
        }
    }
    return $5a5426c007ae479a$var$dj(a, b, c, d, e);
}
function $5a5426c007ae479a$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5a5426c007ae479a$var$G($5a5426c007ae479a$var$fj, $5a5426c007ae479a$var$gj), $5a5426c007ae479a$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5a5426c007ae479a$var$G($5a5426c007ae479a$var$fj, $5a5426c007ae479a$var$gj), $5a5426c007ae479a$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5a5426c007ae479a$var$G($5a5426c007ae479a$var$fj, $5a5426c007ae479a$var$gj);
            $5a5426c007ae479a$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5a5426c007ae479a$var$G($5a5426c007ae479a$var$fj, $5a5426c007ae479a$var$gj), $5a5426c007ae479a$var$gj |= d;
    $5a5426c007ae479a$var$Yi(a, b, e, c);
    return b.child;
}
function $5a5426c007ae479a$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5a5426c007ae479a$var$dj(a, b, c, d, e) {
    var f = $5a5426c007ae479a$var$Zf(c) ? $5a5426c007ae479a$var$Xf : $5a5426c007ae479a$var$H.current;
    f = $5a5426c007ae479a$var$Yf(b, f);
    $5a5426c007ae479a$var$Tg(b, e);
    c = $5a5426c007ae479a$var$Xh(a, b, c, d, f, e);
    d = $5a5426c007ae479a$var$bi();
    if (null !== a && !$5a5426c007ae479a$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5a5426c007ae479a$var$$i(a, b, e);
    $5a5426c007ae479a$var$I && d && $5a5426c007ae479a$var$vg(b);
    b.flags |= 1;
    $5a5426c007ae479a$var$Yi(a, b, c, e);
    return b.child;
}
function $5a5426c007ae479a$var$ij(a, b, c, d, e) {
    if ($5a5426c007ae479a$var$Zf(c)) {
        var f = !0;
        $5a5426c007ae479a$var$cg(b);
    } else f = !1;
    $5a5426c007ae479a$var$Tg(b, e);
    if (null === b.stateNode) $5a5426c007ae479a$var$jj(a, b), $5a5426c007ae479a$var$ph(b, c, d), $5a5426c007ae479a$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5a5426c007ae479a$var$Vg(l) : (l = $5a5426c007ae479a$var$Zf(c) ? $5a5426c007ae479a$var$Xf : $5a5426c007ae479a$var$H.current, l = $5a5426c007ae479a$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5a5426c007ae479a$var$qh(b, g, d, l);
        $5a5426c007ae479a$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $5a5426c007ae479a$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5a5426c007ae479a$var$Wf.current || $5a5426c007ae479a$var$$g ? ("function" === typeof m && ($5a5426c007ae479a$var$kh(b, c, m, d), k = b.memoizedState), (h = $5a5426c007ae479a$var$$g || $5a5426c007ae479a$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5a5426c007ae479a$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5a5426c007ae479a$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5a5426c007ae479a$var$Vg(k) : (k = $5a5426c007ae479a$var$Zf(c) ? $5a5426c007ae479a$var$Xf : $5a5426c007ae479a$var$H.current, k = $5a5426c007ae479a$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5a5426c007ae479a$var$qh(b, g, d, k);
        $5a5426c007ae479a$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $5a5426c007ae479a$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5a5426c007ae479a$var$Wf.current || $5a5426c007ae479a$var$$g ? ("function" === typeof y && ($5a5426c007ae479a$var$kh(b, c, y, d), n = b.memoizedState), (l = $5a5426c007ae479a$var$$g || $5a5426c007ae479a$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5a5426c007ae479a$var$kj(a, b, c, d, f, e);
}
function $5a5426c007ae479a$var$kj(a, b, c, d, e, f) {
    $5a5426c007ae479a$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5a5426c007ae479a$var$dg(b, c, !1), $5a5426c007ae479a$var$$i(a, b, f);
    d = b.stateNode;
    $5a5426c007ae479a$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5a5426c007ae479a$var$Bh(b, a.child, null, f), b.child = $5a5426c007ae479a$var$Bh(b, null, h, f)) : $5a5426c007ae479a$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5a5426c007ae479a$var$dg(b, c, !0);
    return b.child;
}
function $5a5426c007ae479a$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5a5426c007ae479a$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5a5426c007ae479a$var$ag(a, b.context, !1);
    $5a5426c007ae479a$var$Ih(a, b.containerInfo);
}
function $5a5426c007ae479a$var$mj(a, b, c, d, e) {
    $5a5426c007ae479a$var$Ig();
    $5a5426c007ae479a$var$Jg(e);
    b.flags |= 256;
    $5a5426c007ae479a$var$Yi(a, b, c, d);
    return b.child;
}
var $5a5426c007ae479a$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5a5426c007ae479a$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5a5426c007ae479a$var$pj(a, b, c) {
    var d = b.pendingProps, e = $5a5426c007ae479a$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, e & 1);
    if (null === a) {
        $5a5426c007ae479a$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5a5426c007ae479a$var$qj(g, d, 0, null), a = $5a5426c007ae479a$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5a5426c007ae479a$var$oj(c), b.memoizedState = $5a5426c007ae479a$var$nj, a) : $5a5426c007ae479a$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5a5426c007ae479a$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5a5426c007ae479a$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5a5426c007ae479a$var$wh(h, f) : (f = $5a5426c007ae479a$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5a5426c007ae479a$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5a5426c007ae479a$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5a5426c007ae479a$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5a5426c007ae479a$var$rj(a, b) {
    b = $5a5426c007ae479a$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5a5426c007ae479a$var$tj(a, b, c, d) {
    null !== d && $5a5426c007ae479a$var$Jg(d);
    $5a5426c007ae479a$var$Bh(b, a.child, null, c);
    a = $5a5426c007ae479a$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5a5426c007ae479a$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5a5426c007ae479a$var$Li(Error($5a5426c007ae479a$var$p(422))), $5a5426c007ae479a$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5a5426c007ae479a$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5a5426c007ae479a$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5a5426c007ae479a$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $5a5426c007ae479a$var$oj(g);
        b.memoizedState = $5a5426c007ae479a$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5a5426c007ae479a$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5a5426c007ae479a$var$p(419));
        d = $5a5426c007ae479a$var$Li(f, d, void 0);
        return $5a5426c007ae479a$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5a5426c007ae479a$var$Ug || h) {
        d = $5a5426c007ae479a$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5a5426c007ae479a$var$Zg(a, e), $5a5426c007ae479a$var$mh(d, a, e, -1));
        }
        $5a5426c007ae479a$var$uj();
        d = $5a5426c007ae479a$var$Li(Error($5a5426c007ae479a$var$p(421)));
        return $5a5426c007ae479a$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5a5426c007ae479a$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$Lf(e.nextSibling);
    $5a5426c007ae479a$var$xg = b;
    $5a5426c007ae479a$var$I = !0;
    $5a5426c007ae479a$var$zg = null;
    null !== a && ($5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$rg, $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$sg, $5a5426c007ae479a$var$og[$5a5426c007ae479a$var$pg++] = $5a5426c007ae479a$var$qg, $5a5426c007ae479a$var$rg = a.id, $5a5426c007ae479a$var$sg = a.overflow, $5a5426c007ae479a$var$qg = b);
    b = $5a5426c007ae479a$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5a5426c007ae479a$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5a5426c007ae479a$var$Sg(a.return, b, c);
}
function $5a5426c007ae479a$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5a5426c007ae479a$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5a5426c007ae479a$var$Yi(a, b, d.children, c);
    d = $5a5426c007ae479a$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5a5426c007ae479a$var$wj(a, c, b);
            else if (19 === a.tag) $5a5426c007ae479a$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5a5426c007ae479a$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5a5426c007ae479a$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5a5426c007ae479a$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5a5426c007ae479a$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $5a5426c007ae479a$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5a5426c007ae479a$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5a5426c007ae479a$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5a5426c007ae479a$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5a5426c007ae479a$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5a5426c007ae479a$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5a5426c007ae479a$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5a5426c007ae479a$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $5a5426c007ae479a$var$lj(b);
            $5a5426c007ae479a$var$Ig();
            break;
        case 5:
            $5a5426c007ae479a$var$Kh(b);
            break;
        case 1:
            $5a5426c007ae479a$var$Zf(b.type) && $5a5426c007ae479a$var$cg(b);
            break;
        case 4:
            $5a5426c007ae479a$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, $5a5426c007ae479a$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5a5426c007ae479a$var$pj(a, b, c);
                $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, $5a5426c007ae479a$var$M.current & 1);
                a = $5a5426c007ae479a$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, $5a5426c007ae479a$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5a5426c007ae479a$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, $5a5426c007ae479a$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5a5426c007ae479a$var$ej(a, b, c);
    }
    return $5a5426c007ae479a$var$$i(a, b, c);
}
var $5a5426c007ae479a$var$Aj, $5a5426c007ae479a$var$Bj, $5a5426c007ae479a$var$Cj, $5a5426c007ae479a$var$Dj;
$5a5426c007ae479a$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5a5426c007ae479a$var$Bj = function() {};
$5a5426c007ae479a$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5a5426c007ae479a$var$Ya(a, e);
                d = $5a5426c007ae479a$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5a5426c007ae479a$var$A({}, e, {
                    value: void 0
                });
                d = $5a5426c007ae479a$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5a5426c007ae479a$var$gb(a, e);
                d = $5a5426c007ae479a$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5a5426c007ae479a$var$Bf);
        }
        $5a5426c007ae479a$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5a5426c007ae479a$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5a5426c007ae479a$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5a5426c007ae479a$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5a5426c007ae479a$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5a5426c007ae479a$var$Ej(a, b) {
    if (!$5a5426c007ae479a$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5a5426c007ae479a$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5a5426c007ae479a$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $5a5426c007ae479a$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5a5426c007ae479a$var$S(b), null;
        case 1:
            return $5a5426c007ae479a$var$Zf(b.type) && $5a5426c007ae479a$var$$f(), $5a5426c007ae479a$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5a5426c007ae479a$var$Jh();
            $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf);
            $5a5426c007ae479a$var$E($5a5426c007ae479a$var$H);
            $5a5426c007ae479a$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5a5426c007ae479a$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5a5426c007ae479a$var$zg && ($5a5426c007ae479a$var$Gj($5a5426c007ae479a$var$zg), $5a5426c007ae479a$var$zg = null));
            $5a5426c007ae479a$var$Bj(a, b);
            $5a5426c007ae479a$var$S(b);
            return null;
        case 5:
            $5a5426c007ae479a$var$Lh(b);
            var e = $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5a5426c007ae479a$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5a5426c007ae479a$var$p(166));
                    $5a5426c007ae479a$var$S(b);
                    return null;
                }
                a = $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Eh.current);
                if ($5a5426c007ae479a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5a5426c007ae479a$var$Of] = b;
                    d[$5a5426c007ae479a$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5a5426c007ae479a$var$D("cancel", d);
                            $5a5426c007ae479a$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5a5426c007ae479a$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5a5426c007ae479a$var$lf.length; e++)$5a5426c007ae479a$var$D($5a5426c007ae479a$var$lf[e], d);
                            break;
                        case "source":
                            $5a5426c007ae479a$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5a5426c007ae479a$var$D("error", d);
                            $5a5426c007ae479a$var$D("load", d);
                            break;
                        case "details":
                            $5a5426c007ae479a$var$D("toggle", d);
                            break;
                        case "input":
                            $5a5426c007ae479a$var$Za(d, f);
                            $5a5426c007ae479a$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5a5426c007ae479a$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5a5426c007ae479a$var$hb(d, f), $5a5426c007ae479a$var$D("invalid", d);
                    }
                    $5a5426c007ae479a$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5a5426c007ae479a$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5a5426c007ae479a$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5a5426c007ae479a$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5a5426c007ae479a$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5a5426c007ae479a$var$Va(d);
                            $5a5426c007ae479a$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5a5426c007ae479a$var$Va(d);
                            $5a5426c007ae479a$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5a5426c007ae479a$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5a5426c007ae479a$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5a5426c007ae479a$var$Of] = b;
                    a[$5a5426c007ae479a$var$Pf] = d;
                    $5a5426c007ae479a$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5a5426c007ae479a$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5a5426c007ae479a$var$D("cancel", a);
                                $5a5426c007ae479a$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5a5426c007ae479a$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5a5426c007ae479a$var$lf.length; e++)$5a5426c007ae479a$var$D($5a5426c007ae479a$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5a5426c007ae479a$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5a5426c007ae479a$var$D("error", a);
                                $5a5426c007ae479a$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5a5426c007ae479a$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5a5426c007ae479a$var$Za(a, d);
                                e = $5a5426c007ae479a$var$Ya(a, d);
                                $5a5426c007ae479a$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5a5426c007ae479a$var$A({}, d, {
                                    value: void 0
                                });
                                $5a5426c007ae479a$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5a5426c007ae479a$var$hb(a, d);
                                e = $5a5426c007ae479a$var$gb(a, d);
                                $5a5426c007ae479a$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5a5426c007ae479a$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5a5426c007ae479a$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5a5426c007ae479a$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5a5426c007ae479a$var$ob(a, k) : "number" === typeof k && $5a5426c007ae479a$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5a5426c007ae479a$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5a5426c007ae479a$var$D("scroll", a) : null != k && $5a5426c007ae479a$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5a5426c007ae479a$var$Va(a);
                                $5a5426c007ae479a$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5a5426c007ae479a$var$Va(a);
                                $5a5426c007ae479a$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5a5426c007ae479a$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5a5426c007ae479a$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5a5426c007ae479a$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5a5426c007ae479a$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5a5426c007ae479a$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5a5426c007ae479a$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5a5426c007ae479a$var$p(166));
                c = $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Gh.current);
                $5a5426c007ae479a$var$Hh($5a5426c007ae479a$var$Eh.current);
                if ($5a5426c007ae479a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5a5426c007ae479a$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5a5426c007ae479a$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5a5426c007ae479a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5a5426c007ae479a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5a5426c007ae479a$var$Of] = b, b.stateNode = d;
            }
            $5a5426c007ae479a$var$S(b);
            return null;
        case 13:
            $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5a5426c007ae479a$var$I && null !== $5a5426c007ae479a$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5a5426c007ae479a$var$Hg(), $5a5426c007ae479a$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5a5426c007ae479a$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5a5426c007ae479a$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5a5426c007ae479a$var$p(317));
                        f[$5a5426c007ae479a$var$Of] = b;
                    } else $5a5426c007ae479a$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5a5426c007ae479a$var$S(b);
                    f = !1;
                } else null !== $5a5426c007ae479a$var$zg && ($5a5426c007ae479a$var$Gj($5a5426c007ae479a$var$zg), $5a5426c007ae479a$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5a5426c007ae479a$var$M.current & 1) ? 0 === $5a5426c007ae479a$var$T && ($5a5426c007ae479a$var$T = 3) : $5a5426c007ae479a$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5a5426c007ae479a$var$S(b);
            return null;
        case 4:
            return $5a5426c007ae479a$var$Jh(), $5a5426c007ae479a$var$Bj(a, b), null === a && $5a5426c007ae479a$var$sf(b.stateNode.containerInfo), $5a5426c007ae479a$var$S(b), null;
        case 10:
            return $5a5426c007ae479a$var$Rg(b.type._context), $5a5426c007ae479a$var$S(b), null;
        case 17:
            return $5a5426c007ae479a$var$Zf(b.type) && $5a5426c007ae479a$var$$f(), $5a5426c007ae479a$var$S(b), null;
        case 19:
            $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M);
            f = b.memoizedState;
            if (null === f) return $5a5426c007ae479a$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5a5426c007ae479a$var$Ej(f, !1);
                else {
                    if (0 !== $5a5426c007ae479a$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5a5426c007ae479a$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5a5426c007ae479a$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, $5a5426c007ae479a$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5a5426c007ae479a$var$B() > $5a5426c007ae479a$var$Hj && (b.flags |= 128, d = !0, $5a5426c007ae479a$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5a5426c007ae479a$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5a5426c007ae479a$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5a5426c007ae479a$var$I) return $5a5426c007ae479a$var$S(b), null;
                    } else 2 * $5a5426c007ae479a$var$B() - f.renderingStartTime > $5a5426c007ae479a$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $5a5426c007ae479a$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5a5426c007ae479a$var$B(), b.sibling = null, c = $5a5426c007ae479a$var$M.current, $5a5426c007ae479a$var$G($5a5426c007ae479a$var$M, d ? c & 1 | 2 : c & 1), b;
            $5a5426c007ae479a$var$S(b);
            return null;
        case 22:
        case 23:
            return $5a5426c007ae479a$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5a5426c007ae479a$var$gj & 1073741824) && ($5a5426c007ae479a$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5a5426c007ae479a$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5a5426c007ae479a$var$p(156, b.tag));
}
function $5a5426c007ae479a$var$Jj(a, b) {
    $5a5426c007ae479a$var$wg(b);
    switch(b.tag){
        case 1:
            return $5a5426c007ae479a$var$Zf(b.type) && $5a5426c007ae479a$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5a5426c007ae479a$var$Jh(), $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf), $5a5426c007ae479a$var$E($5a5426c007ae479a$var$H), $5a5426c007ae479a$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5a5426c007ae479a$var$Lh(b), null;
        case 13:
            $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5a5426c007ae479a$var$p(340));
                $5a5426c007ae479a$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M), null;
        case 4:
            return $5a5426c007ae479a$var$Jh(), null;
        case 10:
            return $5a5426c007ae479a$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $5a5426c007ae479a$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5a5426c007ae479a$var$Kj = !1, $5a5426c007ae479a$var$U = !1, $5a5426c007ae479a$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $5a5426c007ae479a$var$V = null;
function $5a5426c007ae479a$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5a5426c007ae479a$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5a5426c007ae479a$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5a5426c007ae479a$var$W(a, b, d);
    }
}
var $5a5426c007ae479a$var$Oj = !1;
function $5a5426c007ae479a$var$Pj(a, b) {
    $5a5426c007ae479a$var$Cf = $5a5426c007ae479a$var$dd;
    a = $5a5426c007ae479a$var$Me();
    if ($5a5426c007ae479a$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5a5426c007ae479a$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5a5426c007ae479a$var$dd = !1;
    for($5a5426c007ae479a$var$V = b; null !== $5a5426c007ae479a$var$V;)if (b = $5a5426c007ae479a$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5a5426c007ae479a$var$V = a;
    else for(; null !== $5a5426c007ae479a$var$V;){
        b = $5a5426c007ae479a$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5a5426c007ae479a$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5a5426c007ae479a$var$p(163));
            }
        } catch (F) {
            $5a5426c007ae479a$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5a5426c007ae479a$var$V = a;
            break;
        }
        $5a5426c007ae479a$var$V = b.return;
    }
    n = $5a5426c007ae479a$var$Oj;
    $5a5426c007ae479a$var$Oj = !1;
    return n;
}
function $5a5426c007ae479a$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5a5426c007ae479a$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5a5426c007ae479a$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5a5426c007ae479a$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5a5426c007ae479a$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5a5426c007ae479a$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5a5426c007ae479a$var$Of], delete b[$5a5426c007ae479a$var$Pf], delete b[$5a5426c007ae479a$var$of], delete b[$5a5426c007ae479a$var$Qf], delete b[$5a5426c007ae479a$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5a5426c007ae479a$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5a5426c007ae479a$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5a5426c007ae479a$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5a5426c007ae479a$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5a5426c007ae479a$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5a5426c007ae479a$var$Wj(a, b, c), a = a.sibling; null !== a;)$5a5426c007ae479a$var$Wj(a, b, c), a = a.sibling;
}
function $5a5426c007ae479a$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5a5426c007ae479a$var$Xj(a, b, c), a = a.sibling; null !== a;)$5a5426c007ae479a$var$Xj(a, b, c), a = a.sibling;
}
var $5a5426c007ae479a$var$X = null, $5a5426c007ae479a$var$Yj = !1;
function $5a5426c007ae479a$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$5a5426c007ae479a$var$ak(a, b, c), c = c.sibling;
}
function $5a5426c007ae479a$var$ak(a, b, c) {
    if ($5a5426c007ae479a$var$lc && "function" === typeof $5a5426c007ae479a$var$lc.onCommitFiberUnmount) try {
        $5a5426c007ae479a$var$lc.onCommitFiberUnmount($5a5426c007ae479a$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5a5426c007ae479a$var$U || $5a5426c007ae479a$var$Mj(c, b);
        case 6:
            var d = $5a5426c007ae479a$var$X, e = $5a5426c007ae479a$var$Yj;
            $5a5426c007ae479a$var$X = null;
            $5a5426c007ae479a$var$Zj(a, b, c);
            $5a5426c007ae479a$var$X = d;
            $5a5426c007ae479a$var$Yj = e;
            null !== $5a5426c007ae479a$var$X && ($5a5426c007ae479a$var$Yj ? (a = $5a5426c007ae479a$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5a5426c007ae479a$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5a5426c007ae479a$var$X && ($5a5426c007ae479a$var$Yj ? (a = $5a5426c007ae479a$var$X, c = c.stateNode, 8 === a.nodeType ? $5a5426c007ae479a$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5a5426c007ae479a$var$Kf(a, c), $5a5426c007ae479a$var$bd(a)) : $5a5426c007ae479a$var$Kf($5a5426c007ae479a$var$X, c.stateNode));
            break;
        case 4:
            d = $5a5426c007ae479a$var$X;
            e = $5a5426c007ae479a$var$Yj;
            $5a5426c007ae479a$var$X = c.stateNode.containerInfo;
            $5a5426c007ae479a$var$Yj = !0;
            $5a5426c007ae479a$var$Zj(a, b, c);
            $5a5426c007ae479a$var$X = d;
            $5a5426c007ae479a$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5a5426c007ae479a$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5a5426c007ae479a$var$Nj(c, b, g) : 0 !== (f & 4) && $5a5426c007ae479a$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5a5426c007ae479a$var$Zj(a, b, c);
            break;
        case 1:
            if (!$5a5426c007ae479a$var$U && ($5a5426c007ae479a$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5a5426c007ae479a$var$W(c, b, h);
            }
            $5a5426c007ae479a$var$Zj(a, b, c);
            break;
        case 21:
            $5a5426c007ae479a$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5a5426c007ae479a$var$U = (d = $5a5426c007ae479a$var$U) || null !== c.memoizedState, $5a5426c007ae479a$var$Zj(a, b, c), $5a5426c007ae479a$var$U = d) : $5a5426c007ae479a$var$Zj(a, b, c);
            break;
        default:
            $5a5426c007ae479a$var$Zj(a, b, c);
    }
}
function $5a5426c007ae479a$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5a5426c007ae479a$var$Lj);
        b.forEach(function(b) {
            var d = $5a5426c007ae479a$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5a5426c007ae479a$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5a5426c007ae479a$var$X = h.stateNode;
                        $5a5426c007ae479a$var$Yj = !1;
                        break a;
                    case 3:
                        $5a5426c007ae479a$var$X = h.stateNode.containerInfo;
                        $5a5426c007ae479a$var$Yj = !0;
                        break a;
                    case 4:
                        $5a5426c007ae479a$var$X = h.stateNode.containerInfo;
                        $5a5426c007ae479a$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5a5426c007ae479a$var$X) throw Error($5a5426c007ae479a$var$p(160));
            $5a5426c007ae479a$var$ak(f, g, e);
            $5a5426c007ae479a$var$X = null;
            $5a5426c007ae479a$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5a5426c007ae479a$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5a5426c007ae479a$var$ek(b, a), b = b.sibling;
}
function $5a5426c007ae479a$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            if (d & 4) {
                try {
                    $5a5426c007ae479a$var$Qj(3, a, a.return), $5a5426c007ae479a$var$Rj(3, a);
                } catch (t) {
                    $5a5426c007ae479a$var$W(a, a.return, t);
                }
                try {
                    $5a5426c007ae479a$var$Qj(5, a, a.return);
                } catch (t) {
                    $5a5426c007ae479a$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            d & 512 && null !== c && $5a5426c007ae479a$var$Mj(c, c.return);
            break;
        case 5:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            d & 512 && null !== c && $5a5426c007ae479a$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5a5426c007ae479a$var$ob(e, "");
                } catch (t) {
                    $5a5426c007ae479a$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5a5426c007ae479a$var$ab(e, f);
                    $5a5426c007ae479a$var$vb(h, g);
                    var l = $5a5426c007ae479a$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5a5426c007ae479a$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5a5426c007ae479a$var$nb(e, q) : "children" === m ? $5a5426c007ae479a$var$ob(e, q) : $5a5426c007ae479a$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5a5426c007ae479a$var$bb(e, f);
                            break;
                        case "textarea":
                            $5a5426c007ae479a$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5a5426c007ae479a$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5a5426c007ae479a$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5a5426c007ae479a$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5a5426c007ae479a$var$Pf] = f;
                } catch (t) {
                    $5a5426c007ae479a$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5a5426c007ae479a$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5a5426c007ae479a$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5a5426c007ae479a$var$bd(b.containerInfo);
            } catch (t) {
                $5a5426c007ae479a$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            break;
        case 13:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5a5426c007ae479a$var$gk = $5a5426c007ae479a$var$B()));
            d & 4 && $5a5426c007ae479a$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5a5426c007ae479a$var$U = (l = $5a5426c007ae479a$var$U) || m, $5a5426c007ae479a$var$dk(b, a), $5a5426c007ae479a$var$U = l) : $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5a5426c007ae479a$var$V = a, m = a.child; null !== m;){
                    for(q = $5a5426c007ae479a$var$V = m; null !== $5a5426c007ae479a$var$V;){
                        r = $5a5426c007ae479a$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5a5426c007ae479a$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $5a5426c007ae479a$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5a5426c007ae479a$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5a5426c007ae479a$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5a5426c007ae479a$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5a5426c007ae479a$var$V = y) : $5a5426c007ae479a$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5a5426c007ae479a$var$rb("display", g));
                            } catch (t) {
                                $5a5426c007ae479a$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5a5426c007ae479a$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5a5426c007ae479a$var$dk(b, a);
            $5a5426c007ae479a$var$fk(a);
            d & 4 && $5a5426c007ae479a$var$bk(a);
            break;
        case 21:
            break;
        default:
            $5a5426c007ae479a$var$dk(b, a), $5a5426c007ae479a$var$fk(a);
    }
}
function $5a5426c007ae479a$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5a5426c007ae479a$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5a5426c007ae479a$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5a5426c007ae479a$var$ob(e, ""), d.flags &= -33);
                    var f = $5a5426c007ae479a$var$Vj(a);
                    $5a5426c007ae479a$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5a5426c007ae479a$var$Vj(a);
                    $5a5426c007ae479a$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($5a5426c007ae479a$var$p(161));
            }
        } catch (k) {
            $5a5426c007ae479a$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5a5426c007ae479a$var$ik(a, b, c) {
    $5a5426c007ae479a$var$V = a;
    $5a5426c007ae479a$var$jk(a, b, c);
}
function $5a5426c007ae479a$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5a5426c007ae479a$var$V;){
        var e = $5a5426c007ae479a$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5a5426c007ae479a$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5a5426c007ae479a$var$U;
                h = $5a5426c007ae479a$var$Kj;
                var l = $5a5426c007ae479a$var$U;
                $5a5426c007ae479a$var$Kj = g;
                if (($5a5426c007ae479a$var$U = k) && !l) for($5a5426c007ae479a$var$V = e; null !== $5a5426c007ae479a$var$V;)g = $5a5426c007ae479a$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5a5426c007ae479a$var$kk(e) : null !== k ? (k.return = g, $5a5426c007ae479a$var$V = k) : $5a5426c007ae479a$var$kk(e);
                for(; null !== f;)$5a5426c007ae479a$var$V = f, $5a5426c007ae479a$var$jk(f, b, c), f = f.sibling;
                $5a5426c007ae479a$var$V = e;
                $5a5426c007ae479a$var$Kj = h;
                $5a5426c007ae479a$var$U = l;
            }
            $5a5426c007ae479a$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5a5426c007ae479a$var$V = f) : $5a5426c007ae479a$var$lk(a, b, c);
    }
}
function $5a5426c007ae479a$var$lk(a) {
    for(; null !== $5a5426c007ae479a$var$V;){
        var b = $5a5426c007ae479a$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5a5426c007ae479a$var$U || $5a5426c007ae479a$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5a5426c007ae479a$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5a5426c007ae479a$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5a5426c007ae479a$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5a5426c007ae479a$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5a5426c007ae479a$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5a5426c007ae479a$var$p(163));
                }
                $5a5426c007ae479a$var$U || b.flags & 512 && $5a5426c007ae479a$var$Sj(b);
            } catch (r) {
                $5a5426c007ae479a$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5a5426c007ae479a$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5a5426c007ae479a$var$V = c;
            break;
        }
        $5a5426c007ae479a$var$V = b.return;
    }
}
function $5a5426c007ae479a$var$hk(a) {
    for(; null !== $5a5426c007ae479a$var$V;){
        var b = $5a5426c007ae479a$var$V;
        if (b === a) {
            $5a5426c007ae479a$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5a5426c007ae479a$var$V = c;
            break;
        }
        $5a5426c007ae479a$var$V = b.return;
    }
}
function $5a5426c007ae479a$var$kk(a) {
    for(; null !== $5a5426c007ae479a$var$V;){
        var b = $5a5426c007ae479a$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5a5426c007ae479a$var$Rj(4, b);
                    } catch (k) {
                        $5a5426c007ae479a$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5a5426c007ae479a$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5a5426c007ae479a$var$Sj(b);
                    } catch (k) {
                        $5a5426c007ae479a$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5a5426c007ae479a$var$Sj(b);
                    } catch (k) {
                        $5a5426c007ae479a$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5a5426c007ae479a$var$W(b, b.return, k);
        }
        if (b === a) {
            $5a5426c007ae479a$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5a5426c007ae479a$var$V = h;
            break;
        }
        $5a5426c007ae479a$var$V = b.return;
    }
}
var $5a5426c007ae479a$var$mk = Math.ceil, $5a5426c007ae479a$var$nk = $5a5426c007ae479a$var$ua.ReactCurrentDispatcher, $5a5426c007ae479a$var$ok = $5a5426c007ae479a$var$ua.ReactCurrentOwner, $5a5426c007ae479a$var$pk = $5a5426c007ae479a$var$ua.ReactCurrentBatchConfig, $5a5426c007ae479a$var$K = 0, $5a5426c007ae479a$var$R = null, $5a5426c007ae479a$var$Y = null, $5a5426c007ae479a$var$Z = 0, $5a5426c007ae479a$var$gj = 0, $5a5426c007ae479a$var$fj = $5a5426c007ae479a$var$Uf(0), $5a5426c007ae479a$var$T = 0, $5a5426c007ae479a$var$qk = null, $5a5426c007ae479a$var$hh = 0, $5a5426c007ae479a$var$rk = 0, $5a5426c007ae479a$var$sk = 0, $5a5426c007ae479a$var$tk = null, $5a5426c007ae479a$var$uk = null, $5a5426c007ae479a$var$gk = 0, $5a5426c007ae479a$var$Hj = Infinity, $5a5426c007ae479a$var$vk = null, $5a5426c007ae479a$var$Pi = !1, $5a5426c007ae479a$var$Qi = null, $5a5426c007ae479a$var$Si = null, $5a5426c007ae479a$var$wk = !1, $5a5426c007ae479a$var$xk = null, $5a5426c007ae479a$var$yk = 0, $5a5426c007ae479a$var$zk = 0, $5a5426c007ae479a$var$Ak = null, $5a5426c007ae479a$var$Bk = -1, $5a5426c007ae479a$var$Ck = 0;
function $5a5426c007ae479a$var$L() {
    return 0 !== ($5a5426c007ae479a$var$K & 6) ? $5a5426c007ae479a$var$B() : -1 !== $5a5426c007ae479a$var$Bk ? $5a5426c007ae479a$var$Bk : $5a5426c007ae479a$var$Bk = $5a5426c007ae479a$var$B();
}
function $5a5426c007ae479a$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5a5426c007ae479a$var$K & 2) && 0 !== $5a5426c007ae479a$var$Z) return $5a5426c007ae479a$var$Z & -$5a5426c007ae479a$var$Z;
    if (null !== $5a5426c007ae479a$var$Kg.transition) return 0 === $5a5426c007ae479a$var$Ck && ($5a5426c007ae479a$var$Ck = $5a5426c007ae479a$var$yc()), $5a5426c007ae479a$var$Ck;
    a = $5a5426c007ae479a$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5a5426c007ae479a$var$jd(a.type);
    return a;
}
function $5a5426c007ae479a$var$mh(a, b, c, d) {
    if (50 < $5a5426c007ae479a$var$zk) throw $5a5426c007ae479a$var$zk = 0, $5a5426c007ae479a$var$Ak = null, Error($5a5426c007ae479a$var$p(185));
    $5a5426c007ae479a$var$Ac(a, c, d);
    if (0 === ($5a5426c007ae479a$var$K & 2) || a !== $5a5426c007ae479a$var$R) a === $5a5426c007ae479a$var$R && (0 === ($5a5426c007ae479a$var$K & 2) && ($5a5426c007ae479a$var$rk |= c), 4 === $5a5426c007ae479a$var$T && $5a5426c007ae479a$var$Dk(a, $5a5426c007ae479a$var$Z)), $5a5426c007ae479a$var$Ek(a, d), 1 === c && 0 === $5a5426c007ae479a$var$K && 0 === (b.mode & 1) && ($5a5426c007ae479a$var$Hj = $5a5426c007ae479a$var$B() + 500, $5a5426c007ae479a$var$fg && $5a5426c007ae479a$var$jg());
}
function $5a5426c007ae479a$var$Ek(a, b) {
    var c = a.callbackNode;
    $5a5426c007ae479a$var$wc(a, b);
    var d = $5a5426c007ae479a$var$uc(a, a === $5a5426c007ae479a$var$R ? $5a5426c007ae479a$var$Z : 0);
    if (0 === d) null !== c && $5a5426c007ae479a$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5a5426c007ae479a$var$bc(c);
        if (1 === b) 0 === a.tag ? $5a5426c007ae479a$var$ig($5a5426c007ae479a$var$Fk.bind(null, a)) : $5a5426c007ae479a$var$hg($5a5426c007ae479a$var$Fk.bind(null, a)), $5a5426c007ae479a$var$Jf(function() {
            0 === ($5a5426c007ae479a$var$K & 6) && $5a5426c007ae479a$var$jg();
        }), c = null;
        else {
            switch($5a5426c007ae479a$var$Dc(d)){
                case 1:
                    c = $5a5426c007ae479a$var$fc;
                    break;
                case 4:
                    c = $5a5426c007ae479a$var$gc;
                    break;
                case 16:
                    c = $5a5426c007ae479a$var$hc;
                    break;
                case 536870912:
                    c = $5a5426c007ae479a$var$jc;
                    break;
                default:
                    c = $5a5426c007ae479a$var$hc;
            }
            c = $5a5426c007ae479a$var$Gk(c, $5a5426c007ae479a$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5a5426c007ae479a$var$Hk(a, b) {
    $5a5426c007ae479a$var$Bk = -1;
    $5a5426c007ae479a$var$Ck = 0;
    if (0 !== ($5a5426c007ae479a$var$K & 6)) throw Error($5a5426c007ae479a$var$p(327));
    var c = a.callbackNode;
    if ($5a5426c007ae479a$var$Ik() && a.callbackNode !== c) return null;
    var d = $5a5426c007ae479a$var$uc(a, a === $5a5426c007ae479a$var$R ? $5a5426c007ae479a$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5a5426c007ae479a$var$Jk(a, d);
    else {
        b = d;
        var e = $5a5426c007ae479a$var$K;
        $5a5426c007ae479a$var$K |= 2;
        var f = $5a5426c007ae479a$var$Kk();
        if ($5a5426c007ae479a$var$R !== a || $5a5426c007ae479a$var$Z !== b) $5a5426c007ae479a$var$vk = null, $5a5426c007ae479a$var$Hj = $5a5426c007ae479a$var$B() + 500, $5a5426c007ae479a$var$Lk(a, b);
        for(;;)try {
            $5a5426c007ae479a$var$Mk();
            break;
        } catch (h) {
            $5a5426c007ae479a$var$Nk(a, h);
        }
        $5a5426c007ae479a$var$Qg();
        $5a5426c007ae479a$var$nk.current = f;
        $5a5426c007ae479a$var$K = e;
        null !== $5a5426c007ae479a$var$Y ? b = 0 : ($5a5426c007ae479a$var$R = null, $5a5426c007ae479a$var$Z = 0, b = $5a5426c007ae479a$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5a5426c007ae479a$var$xc(a), 0 !== e && (d = e, b = $5a5426c007ae479a$var$Ok(a, e)));
        if (1 === b) throw c = $5a5426c007ae479a$var$qk, $5a5426c007ae479a$var$Lk(a, 0), $5a5426c007ae479a$var$Dk(a, d), $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B()), c;
        if (6 === b) $5a5426c007ae479a$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5a5426c007ae479a$var$Pk(e) && (b = $5a5426c007ae479a$var$Jk(a, d), 2 === b && (f = $5a5426c007ae479a$var$xc(a), 0 !== f && (d = f, b = $5a5426c007ae479a$var$Ok(a, f))), 1 === b)) throw c = $5a5426c007ae479a$var$qk, $5a5426c007ae479a$var$Lk(a, 0), $5a5426c007ae479a$var$Dk(a, d), $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5a5426c007ae479a$var$p(345));
                case 2:
                    $5a5426c007ae479a$var$Qk(a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk);
                    break;
                case 3:
                    $5a5426c007ae479a$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $5a5426c007ae479a$var$gk + 500 - $5a5426c007ae479a$var$B(), 10 < b)) {
                        if (0 !== $5a5426c007ae479a$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5a5426c007ae479a$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5a5426c007ae479a$var$Ff($5a5426c007ae479a$var$Qk.bind(null, a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk), b);
                        break;
                    }
                    $5a5426c007ae479a$var$Qk(a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk);
                    break;
                case 4:
                    $5a5426c007ae479a$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5a5426c007ae479a$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5a5426c007ae479a$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5a5426c007ae479a$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5a5426c007ae479a$var$Ff($5a5426c007ae479a$var$Qk.bind(null, a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk), d);
                        break;
                    }
                    $5a5426c007ae479a$var$Qk(a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk);
                    break;
                case 5:
                    $5a5426c007ae479a$var$Qk(a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk);
                    break;
                default:
                    throw Error($5a5426c007ae479a$var$p(329));
            }
        }
    }
    $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B());
    return a.callbackNode === c ? $5a5426c007ae479a$var$Hk.bind(null, a) : null;
}
function $5a5426c007ae479a$var$Ok(a, b) {
    var c = $5a5426c007ae479a$var$tk;
    a.current.memoizedState.isDehydrated && ($5a5426c007ae479a$var$Lk(a, b).flags |= 256);
    a = $5a5426c007ae479a$var$Jk(a, b);
    2 !== a && (b = $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$uk = c, null !== b && $5a5426c007ae479a$var$Gj(b));
    return a;
}
function $5a5426c007ae479a$var$Gj(a) {
    null === $5a5426c007ae479a$var$uk ? $5a5426c007ae479a$var$uk = a : $5a5426c007ae479a$var$uk.push.apply($5a5426c007ae479a$var$uk, a);
}
function $5a5426c007ae479a$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5a5426c007ae479a$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5a5426c007ae479a$var$Dk(a, b) {
    b &= ~$5a5426c007ae479a$var$sk;
    b &= ~$5a5426c007ae479a$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5a5426c007ae479a$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5a5426c007ae479a$var$Fk(a) {
    if (0 !== ($5a5426c007ae479a$var$K & 6)) throw Error($5a5426c007ae479a$var$p(327));
    $5a5426c007ae479a$var$Ik();
    var b = $5a5426c007ae479a$var$uc(a, 0);
    if (0 === (b & 1)) return $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B()), null;
    var c = $5a5426c007ae479a$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5a5426c007ae479a$var$xc(a);
        0 !== d && (b = d, c = $5a5426c007ae479a$var$Ok(a, d));
    }
    if (1 === c) throw c = $5a5426c007ae479a$var$qk, $5a5426c007ae479a$var$Lk(a, 0), $5a5426c007ae479a$var$Dk(a, b), $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B()), c;
    if (6 === c) throw Error($5a5426c007ae479a$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5a5426c007ae479a$var$Qk(a, $5a5426c007ae479a$var$uk, $5a5426c007ae479a$var$vk);
    $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B());
    return null;
}
function $5a5426c007ae479a$var$Rk(a, b) {
    var c = $5a5426c007ae479a$var$K;
    $5a5426c007ae479a$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5a5426c007ae479a$var$K = c, 0 === $5a5426c007ae479a$var$K && ($5a5426c007ae479a$var$Hj = $5a5426c007ae479a$var$B() + 500, $5a5426c007ae479a$var$fg && $5a5426c007ae479a$var$jg());
    }
}
function $5a5426c007ae479a$var$Sk(a) {
    null !== $5a5426c007ae479a$var$xk && 0 === $5a5426c007ae479a$var$xk.tag && 0 === ($5a5426c007ae479a$var$K & 6) && $5a5426c007ae479a$var$Ik();
    var b = $5a5426c007ae479a$var$K;
    $5a5426c007ae479a$var$K |= 1;
    var c = $5a5426c007ae479a$var$pk.transition, d = $5a5426c007ae479a$var$C;
    try {
        if ($5a5426c007ae479a$var$pk.transition = null, $5a5426c007ae479a$var$C = 1, a) return a();
    } finally{
        $5a5426c007ae479a$var$C = d, $5a5426c007ae479a$var$pk.transition = c, $5a5426c007ae479a$var$K = b, 0 === ($5a5426c007ae479a$var$K & 6) && $5a5426c007ae479a$var$jg();
    }
}
function $5a5426c007ae479a$var$Ij() {
    $5a5426c007ae479a$var$gj = $5a5426c007ae479a$var$fj.current;
    $5a5426c007ae479a$var$E($5a5426c007ae479a$var$fj);
}
function $5a5426c007ae479a$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5a5426c007ae479a$var$Gf(c));
    if (null !== $5a5426c007ae479a$var$Y) for(c = $5a5426c007ae479a$var$Y.return; null !== c;){
        var d = c;
        $5a5426c007ae479a$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5a5426c007ae479a$var$$f();
                break;
            case 3:
                $5a5426c007ae479a$var$Jh();
                $5a5426c007ae479a$var$E($5a5426c007ae479a$var$Wf);
                $5a5426c007ae479a$var$E($5a5426c007ae479a$var$H);
                $5a5426c007ae479a$var$Oh();
                break;
            case 5:
                $5a5426c007ae479a$var$Lh(d);
                break;
            case 4:
                $5a5426c007ae479a$var$Jh();
                break;
            case 13:
                $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M);
                break;
            case 19:
                $5a5426c007ae479a$var$E($5a5426c007ae479a$var$M);
                break;
            case 10:
                $5a5426c007ae479a$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $5a5426c007ae479a$var$Ij();
        }
        c = c.return;
    }
    $5a5426c007ae479a$var$R = a;
    $5a5426c007ae479a$var$Y = a = $5a5426c007ae479a$var$wh(a.current, null);
    $5a5426c007ae479a$var$Z = $5a5426c007ae479a$var$gj = b;
    $5a5426c007ae479a$var$T = 0;
    $5a5426c007ae479a$var$qk = null;
    $5a5426c007ae479a$var$sk = $5a5426c007ae479a$var$rk = $5a5426c007ae479a$var$hh = 0;
    $5a5426c007ae479a$var$uk = $5a5426c007ae479a$var$tk = null;
    if (null !== $5a5426c007ae479a$var$Wg) {
        for(b = 0; b < $5a5426c007ae479a$var$Wg.length; b++)if (c = $5a5426c007ae479a$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5a5426c007ae479a$var$Wg = null;
    }
    return a;
}
function $5a5426c007ae479a$var$Nk(a, b) {
    do {
        var c = $5a5426c007ae479a$var$Y;
        try {
            $5a5426c007ae479a$var$Qg();
            $5a5426c007ae479a$var$Ph.current = $5a5426c007ae479a$var$ai;
            if ($5a5426c007ae479a$var$Sh) {
                for(var d = $5a5426c007ae479a$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5a5426c007ae479a$var$Sh = !1;
            }
            $5a5426c007ae479a$var$Rh = 0;
            $5a5426c007ae479a$var$P = $5a5426c007ae479a$var$O = $5a5426c007ae479a$var$N = null;
            $5a5426c007ae479a$var$Th = !1;
            $5a5426c007ae479a$var$Uh = 0;
            $5a5426c007ae479a$var$ok.current = null;
            if (null === c || null === c.return) {
                $5a5426c007ae479a$var$T = 1;
                $5a5426c007ae479a$var$qk = b;
                $5a5426c007ae479a$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5a5426c007ae479a$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5a5426c007ae479a$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5a5426c007ae479a$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $5a5426c007ae479a$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5a5426c007ae479a$var$Ti(f, l, b);
                            $5a5426c007ae479a$var$uj();
                            break a;
                        }
                        k = Error($5a5426c007ae479a$var$p(426));
                    }
                } else if ($5a5426c007ae479a$var$I && h.mode & 1) {
                    var J = $5a5426c007ae479a$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5a5426c007ae479a$var$Wi(J, g, h, f, b);
                        $5a5426c007ae479a$var$Jg($5a5426c007ae479a$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $5a5426c007ae479a$var$Ki(k, h);
                4 !== $5a5426c007ae479a$var$T && ($5a5426c007ae479a$var$T = 2);
                null === $5a5426c007ae479a$var$tk ? $5a5426c007ae479a$var$tk = [
                    f
                ] : $5a5426c007ae479a$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5a5426c007ae479a$var$Oi(f, k, b);
                            $5a5426c007ae479a$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5a5426c007ae479a$var$Si || !$5a5426c007ae479a$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5a5426c007ae479a$var$Ri(f, h, b);
                                $5a5426c007ae479a$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5a5426c007ae479a$var$Tk(c);
        } catch (na) {
            b = na;
            $5a5426c007ae479a$var$Y === c && null !== c && ($5a5426c007ae479a$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5a5426c007ae479a$var$Kk() {
    var a = $5a5426c007ae479a$var$nk.current;
    $5a5426c007ae479a$var$nk.current = $5a5426c007ae479a$var$ai;
    return null === a ? $5a5426c007ae479a$var$ai : a;
}
function $5a5426c007ae479a$var$uj() {
    if (0 === $5a5426c007ae479a$var$T || 3 === $5a5426c007ae479a$var$T || 2 === $5a5426c007ae479a$var$T) $5a5426c007ae479a$var$T = 4;
    null === $5a5426c007ae479a$var$R || 0 === ($5a5426c007ae479a$var$hh & 268435455) && 0 === ($5a5426c007ae479a$var$rk & 268435455) || $5a5426c007ae479a$var$Dk($5a5426c007ae479a$var$R, $5a5426c007ae479a$var$Z);
}
function $5a5426c007ae479a$var$Jk(a, b) {
    var c = $5a5426c007ae479a$var$K;
    $5a5426c007ae479a$var$K |= 2;
    var d = $5a5426c007ae479a$var$Kk();
    if ($5a5426c007ae479a$var$R !== a || $5a5426c007ae479a$var$Z !== b) $5a5426c007ae479a$var$vk = null, $5a5426c007ae479a$var$Lk(a, b);
    for(;;)try {
        $5a5426c007ae479a$var$Uk();
        break;
    } catch (e) {
        $5a5426c007ae479a$var$Nk(a, e);
    }
    $5a5426c007ae479a$var$Qg();
    $5a5426c007ae479a$var$K = c;
    $5a5426c007ae479a$var$nk.current = d;
    if (null !== $5a5426c007ae479a$var$Y) throw Error($5a5426c007ae479a$var$p(261));
    $5a5426c007ae479a$var$R = null;
    $5a5426c007ae479a$var$Z = 0;
    return $5a5426c007ae479a$var$T;
}
function $5a5426c007ae479a$var$Uk() {
    for(; null !== $5a5426c007ae479a$var$Y;)$5a5426c007ae479a$var$Vk($5a5426c007ae479a$var$Y);
}
function $5a5426c007ae479a$var$Mk() {
    for(; null !== $5a5426c007ae479a$var$Y && !$5a5426c007ae479a$var$cc();)$5a5426c007ae479a$var$Vk($5a5426c007ae479a$var$Y);
}
function $5a5426c007ae479a$var$Vk(a) {
    var b = $5a5426c007ae479a$var$Wk(a.alternate, a, $5a5426c007ae479a$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5a5426c007ae479a$var$Tk(a) : $5a5426c007ae479a$var$Y = b;
    $5a5426c007ae479a$var$ok.current = null;
}
function $5a5426c007ae479a$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5a5426c007ae479a$var$Fj(c, b, $5a5426c007ae479a$var$gj), null !== c) {
                $5a5426c007ae479a$var$Y = c;
                return;
            }
        } else {
            c = $5a5426c007ae479a$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5a5426c007ae479a$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5a5426c007ae479a$var$T = 6;
                $5a5426c007ae479a$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5a5426c007ae479a$var$Y = b;
            return;
        }
        $5a5426c007ae479a$var$Y = b = a;
    }while (null !== b);
    0 === $5a5426c007ae479a$var$T && ($5a5426c007ae479a$var$T = 5);
}
function $5a5426c007ae479a$var$Qk(a, b, c) {
    var d = $5a5426c007ae479a$var$C, e = $5a5426c007ae479a$var$pk.transition;
    try {
        $5a5426c007ae479a$var$pk.transition = null, $5a5426c007ae479a$var$C = 1, $5a5426c007ae479a$var$Xk(a, b, c, d);
    } finally{
        $5a5426c007ae479a$var$pk.transition = e, $5a5426c007ae479a$var$C = d;
    }
    return null;
}
function $5a5426c007ae479a$var$Xk(a, b, c, d) {
    do $5a5426c007ae479a$var$Ik();
    while (null !== $5a5426c007ae479a$var$xk);
    if (0 !== ($5a5426c007ae479a$var$K & 6)) throw Error($5a5426c007ae479a$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5a5426c007ae479a$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5a5426c007ae479a$var$Bc(a, f);
    a === $5a5426c007ae479a$var$R && ($5a5426c007ae479a$var$Y = $5a5426c007ae479a$var$R = null, $5a5426c007ae479a$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5a5426c007ae479a$var$wk || ($5a5426c007ae479a$var$wk = !0, $5a5426c007ae479a$var$Gk($5a5426c007ae479a$var$hc, function() {
        $5a5426c007ae479a$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5a5426c007ae479a$var$pk.transition;
        $5a5426c007ae479a$var$pk.transition = null;
        var g = $5a5426c007ae479a$var$C;
        $5a5426c007ae479a$var$C = 1;
        var h = $5a5426c007ae479a$var$K;
        $5a5426c007ae479a$var$K |= 4;
        $5a5426c007ae479a$var$ok.current = null;
        $5a5426c007ae479a$var$Pj(a, c);
        $5a5426c007ae479a$var$ek(c, a);
        $5a5426c007ae479a$var$Oe($5a5426c007ae479a$var$Df);
        $5a5426c007ae479a$var$dd = !!$5a5426c007ae479a$var$Cf;
        $5a5426c007ae479a$var$Df = $5a5426c007ae479a$var$Cf = null;
        a.current = c;
        $5a5426c007ae479a$var$ik(c, a, e);
        $5a5426c007ae479a$var$dc();
        $5a5426c007ae479a$var$K = h;
        $5a5426c007ae479a$var$C = g;
        $5a5426c007ae479a$var$pk.transition = f;
    } else a.current = c;
    $5a5426c007ae479a$var$wk && ($5a5426c007ae479a$var$wk = !1, $5a5426c007ae479a$var$xk = a, $5a5426c007ae479a$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($5a5426c007ae479a$var$Si = null);
    $5a5426c007ae479a$var$mc(c.stateNode, d);
    $5a5426c007ae479a$var$Ek(a, $5a5426c007ae479a$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5a5426c007ae479a$var$Pi) throw $5a5426c007ae479a$var$Pi = !1, a = $5a5426c007ae479a$var$Qi, $5a5426c007ae479a$var$Qi = null, a;
    0 !== ($5a5426c007ae479a$var$yk & 1) && 0 !== a.tag && $5a5426c007ae479a$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5a5426c007ae479a$var$Ak ? $5a5426c007ae479a$var$zk++ : ($5a5426c007ae479a$var$zk = 0, $5a5426c007ae479a$var$Ak = a) : $5a5426c007ae479a$var$zk = 0;
    $5a5426c007ae479a$var$jg();
    return null;
}
function $5a5426c007ae479a$var$Ik() {
    if (null !== $5a5426c007ae479a$var$xk) {
        var a = $5a5426c007ae479a$var$Dc($5a5426c007ae479a$var$yk), b = $5a5426c007ae479a$var$pk.transition, c = $5a5426c007ae479a$var$C;
        try {
            $5a5426c007ae479a$var$pk.transition = null;
            $5a5426c007ae479a$var$C = 16 > a ? 16 : a;
            if (null === $5a5426c007ae479a$var$xk) var d = !1;
            else {
                a = $5a5426c007ae479a$var$xk;
                $5a5426c007ae479a$var$xk = null;
                $5a5426c007ae479a$var$yk = 0;
                if (0 !== ($5a5426c007ae479a$var$K & 6)) throw Error($5a5426c007ae479a$var$p(331));
                var e = $5a5426c007ae479a$var$K;
                $5a5426c007ae479a$var$K |= 4;
                for($5a5426c007ae479a$var$V = a.current; null !== $5a5426c007ae479a$var$V;){
                    var f = $5a5426c007ae479a$var$V, g = f.child;
                    if (0 !== ($5a5426c007ae479a$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5a5426c007ae479a$var$V = l; null !== $5a5426c007ae479a$var$V;){
                                    var m = $5a5426c007ae479a$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5a5426c007ae479a$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5a5426c007ae479a$var$V = q;
                                    else for(; null !== $5a5426c007ae479a$var$V;){
                                        m = $5a5426c007ae479a$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5a5426c007ae479a$var$Tj(m);
                                        if (m === l) {
                                            $5a5426c007ae479a$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5a5426c007ae479a$var$V = r;
                                            break;
                                        }
                                        $5a5426c007ae479a$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5a5426c007ae479a$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5a5426c007ae479a$var$V = g;
                    else b: for(; null !== $5a5426c007ae479a$var$V;){
                        f = $5a5426c007ae479a$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5a5426c007ae479a$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5a5426c007ae479a$var$V = x;
                            break b;
                        }
                        $5a5426c007ae479a$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5a5426c007ae479a$var$V = w; null !== $5a5426c007ae479a$var$V;){
                    g = $5a5426c007ae479a$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5a5426c007ae479a$var$V = u;
                    else b: for(g = w; null !== $5a5426c007ae479a$var$V;){
                        h = $5a5426c007ae479a$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5a5426c007ae479a$var$Rj(9, h);
                            }
                        } catch (na) {
                            $5a5426c007ae479a$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5a5426c007ae479a$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5a5426c007ae479a$var$V = F;
                            break b;
                        }
                        $5a5426c007ae479a$var$V = h.return;
                    }
                }
                $5a5426c007ae479a$var$K = e;
                $5a5426c007ae479a$var$jg();
                if ($5a5426c007ae479a$var$lc && "function" === typeof $5a5426c007ae479a$var$lc.onPostCommitFiberRoot) try {
                    $5a5426c007ae479a$var$lc.onPostCommitFiberRoot($5a5426c007ae479a$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5a5426c007ae479a$var$C = c, $5a5426c007ae479a$var$pk.transition = b;
        }
    }
    return !1;
}
function $5a5426c007ae479a$var$Yk(a, b, c) {
    b = $5a5426c007ae479a$var$Ki(c, b);
    b = $5a5426c007ae479a$var$Oi(a, b, 1);
    a = $5a5426c007ae479a$var$dh(a, b, 1);
    b = $5a5426c007ae479a$var$L();
    null !== a && ($5a5426c007ae479a$var$Ac(a, 1, b), $5a5426c007ae479a$var$Ek(a, b));
}
function $5a5426c007ae479a$var$W(a, b, c) {
    if (3 === a.tag) $5a5426c007ae479a$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5a5426c007ae479a$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5a5426c007ae479a$var$Si || !$5a5426c007ae479a$var$Si.has(d))) {
                a = $5a5426c007ae479a$var$Ki(c, a);
                a = $5a5426c007ae479a$var$Ri(b, a, 1);
                b = $5a5426c007ae479a$var$dh(b, a, 1);
                a = $5a5426c007ae479a$var$L();
                null !== b && ($5a5426c007ae479a$var$Ac(b, 1, a), $5a5426c007ae479a$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5a5426c007ae479a$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5a5426c007ae479a$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $5a5426c007ae479a$var$R === a && ($5a5426c007ae479a$var$Z & c) === c && (4 === $5a5426c007ae479a$var$T || 3 === $5a5426c007ae479a$var$T && ($5a5426c007ae479a$var$Z & 130023424) === $5a5426c007ae479a$var$Z && 500 > $5a5426c007ae479a$var$B() - $5a5426c007ae479a$var$gk ? $5a5426c007ae479a$var$Lk(a, 0) : $5a5426c007ae479a$var$sk |= c);
    $5a5426c007ae479a$var$Ek(a, b);
}
function $5a5426c007ae479a$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5a5426c007ae479a$var$sc, $5a5426c007ae479a$var$sc <<= 1, 0 === ($5a5426c007ae479a$var$sc & 130023424) && ($5a5426c007ae479a$var$sc = 4194304)));
    var c = $5a5426c007ae479a$var$L();
    a = $5a5426c007ae479a$var$Zg(a, b);
    null !== a && ($5a5426c007ae479a$var$Ac(a, b, c), $5a5426c007ae479a$var$Ek(a, c));
}
function $5a5426c007ae479a$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5a5426c007ae479a$var$Zk(a, c);
}
function $5a5426c007ae479a$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5a5426c007ae479a$var$p(314));
    }
    null !== d && d.delete(b);
    $5a5426c007ae479a$var$Zk(a, c);
}
var $5a5426c007ae479a$var$Wk;
$5a5426c007ae479a$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5a5426c007ae479a$var$Wf.current) $5a5426c007ae479a$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5a5426c007ae479a$var$Ug = !1, $5a5426c007ae479a$var$zj(a, b, c);
            $5a5426c007ae479a$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5a5426c007ae479a$var$Ug = !1, $5a5426c007ae479a$var$I && 0 !== (b.flags & 1048576) && $5a5426c007ae479a$var$ug(b, $5a5426c007ae479a$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5a5426c007ae479a$var$jj(a, b);
            a = b.pendingProps;
            var e = $5a5426c007ae479a$var$Yf(b, $5a5426c007ae479a$var$H.current);
            $5a5426c007ae479a$var$Tg(b, c);
            e = $5a5426c007ae479a$var$Xh(null, b, d, a, e, c);
            var f = $5a5426c007ae479a$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5a5426c007ae479a$var$Zf(d) ? (f = !0, $5a5426c007ae479a$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5a5426c007ae479a$var$ah(b), e.updater = $5a5426c007ae479a$var$nh, b.stateNode = e, e._reactInternals = b, $5a5426c007ae479a$var$rh(b, d, a, c), b = $5a5426c007ae479a$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $5a5426c007ae479a$var$I && f && $5a5426c007ae479a$var$vg(b), $5a5426c007ae479a$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5a5426c007ae479a$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5a5426c007ae479a$var$$k(d);
                a = $5a5426c007ae479a$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $5a5426c007ae479a$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5a5426c007ae479a$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5a5426c007ae479a$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5a5426c007ae479a$var$aj(null, b, d, $5a5426c007ae479a$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($5a5426c007ae479a$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a5426c007ae479a$var$Lg(d, e), $5a5426c007ae479a$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a5426c007ae479a$var$Lg(d, e), $5a5426c007ae479a$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $5a5426c007ae479a$var$lj(b);
                if (null === a) throw Error($5a5426c007ae479a$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5a5426c007ae479a$var$bh(a, b);
                $5a5426c007ae479a$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5a5426c007ae479a$var$Ki(Error($5a5426c007ae479a$var$p(423)), b);
                        b = $5a5426c007ae479a$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5a5426c007ae479a$var$Ki(Error($5a5426c007ae479a$var$p(424)), b);
                        b = $5a5426c007ae479a$var$mj(a, b, d, c, e);
                        break a;
                    } else for($5a5426c007ae479a$var$yg = $5a5426c007ae479a$var$Lf(b.stateNode.containerInfo.firstChild), $5a5426c007ae479a$var$xg = b, $5a5426c007ae479a$var$I = !0, $5a5426c007ae479a$var$zg = null, c = $5a5426c007ae479a$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5a5426c007ae479a$var$Ig();
                    if (d === e) {
                        b = $5a5426c007ae479a$var$$i(a, b, c);
                        break a;
                    }
                    $5a5426c007ae479a$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5a5426c007ae479a$var$Kh(b), null === a && $5a5426c007ae479a$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5a5426c007ae479a$var$Ef(d, e) ? g = null : null !== f && $5a5426c007ae479a$var$Ef(d, f) && (b.flags |= 32), $5a5426c007ae479a$var$hj(a, b), $5a5426c007ae479a$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $5a5426c007ae479a$var$Eg(b), null;
        case 13:
            return $5a5426c007ae479a$var$pj(a, b, c);
        case 4:
            return $5a5426c007ae479a$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5a5426c007ae479a$var$Bh(b, null, d, c) : $5a5426c007ae479a$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a5426c007ae479a$var$Lg(d, e), $5a5426c007ae479a$var$Zi(a, b, d, e, c);
        case 7:
            return $5a5426c007ae479a$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5a5426c007ae479a$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5a5426c007ae479a$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5a5426c007ae479a$var$G($5a5426c007ae479a$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5a5426c007ae479a$var$He(f.value, g)) {
                        if (f.children === e.children && !$5a5426c007ae479a$var$Wf.current) {
                            b = $5a5426c007ae479a$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5a5426c007ae479a$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5a5426c007ae479a$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5a5426c007ae479a$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5a5426c007ae479a$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5a5426c007ae479a$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5a5426c007ae479a$var$Tg(b, c), e = $5a5426c007ae479a$var$Vg(e), d = d(e), b.flags |= 1, $5a5426c007ae479a$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5a5426c007ae479a$var$Lg(d, b.pendingProps), e = $5a5426c007ae479a$var$Lg(d.type, e), $5a5426c007ae479a$var$aj(a, b, d, e, c);
        case 15:
            return $5a5426c007ae479a$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5a5426c007ae479a$var$Lg(d, e), $5a5426c007ae479a$var$jj(a, b), b.tag = 1, $5a5426c007ae479a$var$Zf(d) ? (a = !0, $5a5426c007ae479a$var$cg(b)) : a = !1, $5a5426c007ae479a$var$Tg(b, c), $5a5426c007ae479a$var$ph(b, d, e), $5a5426c007ae479a$var$rh(b, d, e, c), $5a5426c007ae479a$var$kj(null, b, d, !0, a, c);
        case 19:
            return $5a5426c007ae479a$var$yj(a, b, c);
        case 22:
            return $5a5426c007ae479a$var$ej(a, b, c);
    }
    throw Error($5a5426c007ae479a$var$p(156, b.tag));
};
function $5a5426c007ae479a$var$Gk(a, b) {
    return $5a5426c007ae479a$var$ac(a, b);
}
function $5a5426c007ae479a$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5a5426c007ae479a$var$Bg(a, b, c, d) {
    return new $5a5426c007ae479a$var$al(a, b, c, d);
}
function $5a5426c007ae479a$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5a5426c007ae479a$var$$k(a) {
    if ("function" === typeof a) return $5a5426c007ae479a$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5a5426c007ae479a$var$Da) return 11;
        if (a === $5a5426c007ae479a$var$Ga) return 14;
    }
    return 2;
}
function $5a5426c007ae479a$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $5a5426c007ae479a$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5a5426c007ae479a$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5a5426c007ae479a$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5a5426c007ae479a$var$ya:
            return $5a5426c007ae479a$var$Ah(c.children, e, f, b);
        case $5a5426c007ae479a$var$za:
            g = 8;
            e |= 8;
            break;
        case $5a5426c007ae479a$var$Aa:
            return a = $5a5426c007ae479a$var$Bg(12, c, b, e | 2), a.elementType = $5a5426c007ae479a$var$Aa, a.lanes = f, a;
        case $5a5426c007ae479a$var$Ea:
            return a = $5a5426c007ae479a$var$Bg(13, c, b, e), a.elementType = $5a5426c007ae479a$var$Ea, a.lanes = f, a;
        case $5a5426c007ae479a$var$Fa:
            return a = $5a5426c007ae479a$var$Bg(19, c, b, e), a.elementType = $5a5426c007ae479a$var$Fa, a.lanes = f, a;
        case $5a5426c007ae479a$var$Ia:
            return $5a5426c007ae479a$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5a5426c007ae479a$var$Ba:
                    g = 10;
                    break a;
                case $5a5426c007ae479a$var$Ca:
                    g = 9;
                    break a;
                case $5a5426c007ae479a$var$Da:
                    g = 11;
                    break a;
                case $5a5426c007ae479a$var$Ga:
                    g = 14;
                    break a;
                case $5a5426c007ae479a$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5a5426c007ae479a$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $5a5426c007ae479a$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5a5426c007ae479a$var$Ah(a, b, c, d) {
    a = $5a5426c007ae479a$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5a5426c007ae479a$var$qj(a, b, c, d) {
    a = $5a5426c007ae479a$var$Bg(22, a, d, b);
    a.elementType = $5a5426c007ae479a$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5a5426c007ae479a$var$xh(a, b, c) {
    a = $5a5426c007ae479a$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5a5426c007ae479a$var$zh(a, b, c) {
    b = $5a5426c007ae479a$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5a5426c007ae479a$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5a5426c007ae479a$var$zc(0);
    this.expirationTimes = $5a5426c007ae479a$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5a5426c007ae479a$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5a5426c007ae479a$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $5a5426c007ae479a$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5a5426c007ae479a$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5a5426c007ae479a$var$ah(f);
    return a;
}
function $5a5426c007ae479a$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5a5426c007ae479a$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5a5426c007ae479a$var$el(a) {
    if (!a) return $5a5426c007ae479a$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5a5426c007ae479a$var$Vb(a) !== a || 1 !== a.tag) throw Error($5a5426c007ae479a$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5a5426c007ae479a$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5a5426c007ae479a$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5a5426c007ae479a$var$Zf(c)) return $5a5426c007ae479a$var$bg(a, c, b);
    }
    return b;
}
function $5a5426c007ae479a$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $5a5426c007ae479a$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $5a5426c007ae479a$var$el(null);
    c = a.current;
    d = $5a5426c007ae479a$var$L();
    e = $5a5426c007ae479a$var$lh(c);
    f = $5a5426c007ae479a$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5a5426c007ae479a$var$dh(c, f, e);
    a.current.lanes = e;
    $5a5426c007ae479a$var$Ac(a, e, d);
    $5a5426c007ae479a$var$Ek(a, d);
    return a;
}
function $5a5426c007ae479a$var$gl(a, b, c, d) {
    var e = b.current, f = $5a5426c007ae479a$var$L(), g = $5a5426c007ae479a$var$lh(e);
    c = $5a5426c007ae479a$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5a5426c007ae479a$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5a5426c007ae479a$var$dh(e, b, g);
    null !== a && ($5a5426c007ae479a$var$mh(a, e, g, f), $5a5426c007ae479a$var$eh(a, e, g));
    return g;
}
function $5a5426c007ae479a$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5a5426c007ae479a$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5a5426c007ae479a$var$jl(a, b) {
    $5a5426c007ae479a$var$il(a, b);
    (a = a.alternate) && $5a5426c007ae479a$var$il(a, b);
}
function $5a5426c007ae479a$var$kl() {
    return null;
}
var $5a5426c007ae479a$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $5a5426c007ae479a$var$ml(a) {
    this._internalRoot = a;
}
$5a5426c007ae479a$var$nl.prototype.render = $5a5426c007ae479a$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5a5426c007ae479a$var$p(409));
    $5a5426c007ae479a$var$gl(a, b, null, null);
};
$5a5426c007ae479a$var$nl.prototype.unmount = $5a5426c007ae479a$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5a5426c007ae479a$var$Sk(function() {
            $5a5426c007ae479a$var$gl(null, a, null, null);
        });
        b[$5a5426c007ae479a$var$uf] = null;
    }
};
function $5a5426c007ae479a$var$nl(a) {
    this._internalRoot = a;
}
$5a5426c007ae479a$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5a5426c007ae479a$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5a5426c007ae479a$var$Qc.length && 0 !== b && b < $5a5426c007ae479a$var$Qc[c].priority; c++);
        $5a5426c007ae479a$var$Qc.splice(c, 0, a);
        0 === c && $5a5426c007ae479a$var$Vc(a);
    }
};
function $5a5426c007ae479a$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5a5426c007ae479a$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5a5426c007ae479a$var$ql() {}
function $5a5426c007ae479a$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $5a5426c007ae479a$var$hl(g);
                f.call(a);
            };
        }
        var g = $5a5426c007ae479a$var$fl(b, d, a, 0, null, !1, !1, "", $5a5426c007ae479a$var$ql);
        a._reactRootContainer = g;
        a[$5a5426c007ae479a$var$uf] = g.current;
        $5a5426c007ae479a$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5a5426c007ae479a$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $5a5426c007ae479a$var$hl(k);
            h.call(a);
        };
    }
    var k = $5a5426c007ae479a$var$cl(a, 0, !1, null, null, !1, !1, "", $5a5426c007ae479a$var$ql);
    a._reactRootContainer = k;
    a[$5a5426c007ae479a$var$uf] = k.current;
    $5a5426c007ae479a$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5a5426c007ae479a$var$Sk(function() {
        $5a5426c007ae479a$var$gl(b, k, c, d);
    });
    return k;
}
function $5a5426c007ae479a$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5a5426c007ae479a$var$hl(g);
                h.call(a);
            };
        }
        $5a5426c007ae479a$var$gl(b, g, a, e);
    } else g = $5a5426c007ae479a$var$rl(c, b, a, e, d);
    return $5a5426c007ae479a$var$hl(g);
}
$5a5426c007ae479a$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5a5426c007ae479a$var$tc(b.pendingLanes);
                0 !== c && ($5a5426c007ae479a$var$Cc(b, c | 1), $5a5426c007ae479a$var$Ek(b, $5a5426c007ae479a$var$B()), 0 === ($5a5426c007ae479a$var$K & 6) && ($5a5426c007ae479a$var$Hj = $5a5426c007ae479a$var$B() + 500, $5a5426c007ae479a$var$jg()));
            }
            break;
        case 13:
            $5a5426c007ae479a$var$Sk(function() {
                var b = $5a5426c007ae479a$var$Zg(a, 1);
                if (null !== b) {
                    var c = $5a5426c007ae479a$var$L();
                    $5a5426c007ae479a$var$mh(b, a, 1, c);
                }
            }), $5a5426c007ae479a$var$jl(a, 1);
    }
};
$5a5426c007ae479a$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $5a5426c007ae479a$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $5a5426c007ae479a$var$L();
            $5a5426c007ae479a$var$mh(b, a, 134217728, c);
        }
        $5a5426c007ae479a$var$jl(a, 134217728);
    }
};
$5a5426c007ae479a$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $5a5426c007ae479a$var$lh(a), c = $5a5426c007ae479a$var$Zg(a, b);
        if (null !== c) {
            var d = $5a5426c007ae479a$var$L();
            $5a5426c007ae479a$var$mh(c, a, b, d);
        }
        $5a5426c007ae479a$var$jl(a, b);
    }
};
$5a5426c007ae479a$var$Hc = function() {
    return $5a5426c007ae479a$var$C;
};
$5a5426c007ae479a$var$Ic = function(a, b) {
    var c = $5a5426c007ae479a$var$C;
    try {
        return $5a5426c007ae479a$var$C = a, b();
    } finally{
        $5a5426c007ae479a$var$C = c;
    }
};
$5a5426c007ae479a$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $5a5426c007ae479a$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5a5426c007ae479a$var$Db(d);
                        if (!e) throw Error($5a5426c007ae479a$var$p(90));
                        $5a5426c007ae479a$var$Wa(d);
                        $5a5426c007ae479a$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5a5426c007ae479a$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5a5426c007ae479a$var$fb(a, !!c.multiple, b, !1);
    }
};
$5a5426c007ae479a$var$Gb = $5a5426c007ae479a$var$Rk;
$5a5426c007ae479a$var$Hb = $5a5426c007ae479a$var$Sk;
var $5a5426c007ae479a$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $5a5426c007ae479a$var$Cb,
        $5a5426c007ae479a$var$ue,
        $5a5426c007ae479a$var$Db,
        $5a5426c007ae479a$var$Eb,
        $5a5426c007ae479a$var$Fb,
        $5a5426c007ae479a$var$Rk
    ]
}, $5a5426c007ae479a$var$ul = {
    findFiberByHostInstance: $5a5426c007ae479a$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $5a5426c007ae479a$var$vl = {
    bundleType: $5a5426c007ae479a$var$ul.bundleType,
    version: $5a5426c007ae479a$var$ul.version,
    rendererPackageName: $5a5426c007ae479a$var$ul.rendererPackageName,
    rendererConfig: $5a5426c007ae479a$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5a5426c007ae479a$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $5a5426c007ae479a$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5a5426c007ae479a$var$ul.findFiberByHostInstance || $5a5426c007ae479a$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5a5426c007ae479a$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5a5426c007ae479a$var$wl.isDisabled && $5a5426c007ae479a$var$wl.supportsFiber) try {
        $5a5426c007ae479a$var$kc = $5a5426c007ae479a$var$wl.inject($5a5426c007ae479a$var$vl), $5a5426c007ae479a$var$lc = $5a5426c007ae479a$var$wl;
    } catch (a) {}
}
$5a5426c007ae479a$export$ae55be85d98224ed = $5a5426c007ae479a$var$tl;
$5a5426c007ae479a$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5a5426c007ae479a$var$ol(b)) throw Error($5a5426c007ae479a$var$p(200));
    return $5a5426c007ae479a$var$dl(a, b, null, c);
};
$5a5426c007ae479a$export$882461b6382ed46c = function(a, b) {
    if (!$5a5426c007ae479a$var$ol(a)) throw Error($5a5426c007ae479a$var$p(299));
    var c = !1, d = "", e = $5a5426c007ae479a$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5a5426c007ae479a$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$5a5426c007ae479a$var$uf] = b.current;
    $5a5426c007ae479a$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5a5426c007ae479a$var$ml(b);
};
$5a5426c007ae479a$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5a5426c007ae479a$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5a5426c007ae479a$var$p(268, a));
    }
    a = $5a5426c007ae479a$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5a5426c007ae479a$export$cd75ccfd720a3cd4 = function(a) {
    return $5a5426c007ae479a$var$Sk(a);
};
$5a5426c007ae479a$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5a5426c007ae479a$var$pl(b)) throw Error($5a5426c007ae479a$var$p(200));
    return $5a5426c007ae479a$var$sl(null, a, b, !0, c);
};
$5a5426c007ae479a$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5a5426c007ae479a$var$ol(a)) throw Error($5a5426c007ae479a$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5a5426c007ae479a$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5a5426c007ae479a$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5a5426c007ae479a$var$uf] = b.current;
    $5a5426c007ae479a$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5a5426c007ae479a$var$nl(b);
};
$5a5426c007ae479a$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5a5426c007ae479a$var$pl(b)) throw Error($5a5426c007ae479a$var$p(200));
    return $5a5426c007ae479a$var$sl(null, a, b, !1, c);
};
$5a5426c007ae479a$export$502457920280e6be = function(a) {
    if (!$5a5426c007ae479a$var$pl(a)) throw Error($5a5426c007ae479a$var$p(40));
    return a._reactRootContainer ? ($5a5426c007ae479a$var$Sk(function() {
        $5a5426c007ae479a$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5a5426c007ae479a$var$uf] = null;
        });
    }), !0) : !1;
};
$5a5426c007ae479a$export$c78a37762a8d58e1 = $5a5426c007ae479a$var$Rk;
$5a5426c007ae479a$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5a5426c007ae479a$var$pl(c)) throw Error($5a5426c007ae479a$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5a5426c007ae479a$var$p(38));
    return $5a5426c007ae479a$var$sl(a, b, c, !1, d);
};
$5a5426c007ae479a$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("jTTQM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("96gzj"));

});
parcelRegister("96gzj", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6a0186c511340fdd$export$c4744153514ff05d; }, function (v) { return $6a0186c511340fdd$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6a0186c511340fdd$export$3e506c1ccc9cc1a7; }, function (v) { return $6a0186c511340fdd$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6a0186c511340fdd$export$e26fe2ed2fa76875; }, function (v) { return $6a0186c511340fdd$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6a0186c511340fdd$export$502329bbf4b505b1; }, function (v) { return $6a0186c511340fdd$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6a0186c511340fdd$export$6e3807111c4874c4; }, function (v) { return $6a0186c511340fdd$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6a0186c511340fdd$export$c27134553091fb3a; }, function (v) { return $6a0186c511340fdd$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6a0186c511340fdd$export$33ee1acdc04fd2a2; }, function (v) { return $6a0186c511340fdd$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6a0186c511340fdd$export$b00a404bbd5edef2; }, function (v) { return $6a0186c511340fdd$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6a0186c511340fdd$export$8352ce38b91d0c62; }, function (v) { return $6a0186c511340fdd$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6a0186c511340fdd$export$d66a1c1c77bd778b; }, function (v) { return $6a0186c511340fdd$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6a0186c511340fdd$export$d3dfb8e4810cb555; }, function (v) { return $6a0186c511340fdd$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6a0186c511340fdd$export$839f9183b0465a69; }, function (v) { return $6a0186c511340fdd$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6a0186c511340fdd$export$72fdf0e06517287b; }, function (v) { return $6a0186c511340fdd$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6a0186c511340fdd$export$4b844e58a3e414b4; }, function (v) { return $6a0186c511340fdd$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6a0186c511340fdd$export$816d2913ae6b83b1; }, function (v) { return $6a0186c511340fdd$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6a0186c511340fdd$export$61bcfe829111a1d0; }, function (v) { return $6a0186c511340fdd$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6a0186c511340fdd$export$7ee8c9beb337bc3f; }, function (v) { return $6a0186c511340fdd$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6a0186c511340fdd$export$b5836b71941fa3ed; }, function (v) { return $6a0186c511340fdd$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6a0186c511340fdd$export$cf845f2c119da08a; }, function (v) { return $6a0186c511340fdd$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6a0186c511340fdd$export$c4744153514ff05d;
var $6a0186c511340fdd$export$3e506c1ccc9cc1a7;
var $6a0186c511340fdd$export$e26fe2ed2fa76875;
var $6a0186c511340fdd$export$502329bbf4b505b1;
var $6a0186c511340fdd$export$6e3807111c4874c4;
var $6a0186c511340fdd$export$c27134553091fb3a;
var $6a0186c511340fdd$export$33ee1acdc04fd2a2;
var $6a0186c511340fdd$export$b00a404bbd5edef2;
var $6a0186c511340fdd$export$8352ce38b91d0c62;
var $6a0186c511340fdd$export$d66a1c1c77bd778b;
var $6a0186c511340fdd$export$d3dfb8e4810cb555;
var $6a0186c511340fdd$export$839f9183b0465a69;
var $6a0186c511340fdd$export$72fdf0e06517287b;
var $6a0186c511340fdd$export$4b844e58a3e414b4;
var $6a0186c511340fdd$export$816d2913ae6b83b1;
var $6a0186c511340fdd$export$61bcfe829111a1d0;
var $6a0186c511340fdd$export$7ee8c9beb337bc3f;
var $6a0186c511340fdd$export$b5836b71941fa3ed;
var $6a0186c511340fdd$export$cf845f2c119da08a;
'use strict';
function $6a0186c511340fdd$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6a0186c511340fdd$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6a0186c511340fdd$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6a0186c511340fdd$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6a0186c511340fdd$var$g(C, c)) n < e && 0 > $6a0186c511340fdd$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6a0186c511340fdd$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6a0186c511340fdd$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6a0186c511340fdd$var$l = performance;
    $6a0186c511340fdd$export$c4744153514ff05d = function() {
        return $6a0186c511340fdd$var$l.now();
    };
} else {
    var $6a0186c511340fdd$var$p = Date, $6a0186c511340fdd$var$q = $6a0186c511340fdd$var$p.now();
    $6a0186c511340fdd$export$c4744153514ff05d = function() {
        return $6a0186c511340fdd$var$p.now() - $6a0186c511340fdd$var$q;
    };
}
var $6a0186c511340fdd$var$r = [], $6a0186c511340fdd$var$t = [], $6a0186c511340fdd$var$u = 1, $6a0186c511340fdd$var$v = null, $6a0186c511340fdd$var$y = 3, $6a0186c511340fdd$var$z = !1, $6a0186c511340fdd$var$A = !1, $6a0186c511340fdd$var$B = !1, $6a0186c511340fdd$var$D = "function" === typeof setTimeout ? setTimeout : null, $6a0186c511340fdd$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6a0186c511340fdd$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6a0186c511340fdd$var$G(a) {
    for(var b = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$t); null !== b;){
        if (null === b.callback) $6a0186c511340fdd$var$k($6a0186c511340fdd$var$t);
        else if (b.startTime <= a) $6a0186c511340fdd$var$k($6a0186c511340fdd$var$t), b.sortIndex = b.expirationTime, $6a0186c511340fdd$var$f($6a0186c511340fdd$var$r, b);
        else break;
        b = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$t);
    }
}
function $6a0186c511340fdd$var$H(a) {
    $6a0186c511340fdd$var$B = !1;
    $6a0186c511340fdd$var$G(a);
    if (!$6a0186c511340fdd$var$A) {
        if (null !== $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r)) $6a0186c511340fdd$var$A = !0, $6a0186c511340fdd$var$I($6a0186c511340fdd$var$J);
        else {
            var b = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$t);
            null !== b && $6a0186c511340fdd$var$K($6a0186c511340fdd$var$H, b.startTime - a);
        }
    }
}
function $6a0186c511340fdd$var$J(a, b) {
    $6a0186c511340fdd$var$A = !1;
    $6a0186c511340fdd$var$B && ($6a0186c511340fdd$var$B = !1, $6a0186c511340fdd$var$E($6a0186c511340fdd$var$L), $6a0186c511340fdd$var$L = -1);
    $6a0186c511340fdd$var$z = !0;
    var c = $6a0186c511340fdd$var$y;
    try {
        $6a0186c511340fdd$var$G(b);
        for($6a0186c511340fdd$var$v = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r); null !== $6a0186c511340fdd$var$v && (!($6a0186c511340fdd$var$v.expirationTime > b) || a && !$6a0186c511340fdd$var$M());){
            var d = $6a0186c511340fdd$var$v.callback;
            if ("function" === typeof d) {
                $6a0186c511340fdd$var$v.callback = null;
                $6a0186c511340fdd$var$y = $6a0186c511340fdd$var$v.priorityLevel;
                var e = d($6a0186c511340fdd$var$v.expirationTime <= b);
                b = $6a0186c511340fdd$export$c4744153514ff05d();
                "function" === typeof e ? $6a0186c511340fdd$var$v.callback = e : $6a0186c511340fdd$var$v === $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r) && $6a0186c511340fdd$var$k($6a0186c511340fdd$var$r);
                $6a0186c511340fdd$var$G(b);
            } else $6a0186c511340fdd$var$k($6a0186c511340fdd$var$r);
            $6a0186c511340fdd$var$v = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r);
        }
        if (null !== $6a0186c511340fdd$var$v) var w = !0;
        else {
            var m = $6a0186c511340fdd$var$h($6a0186c511340fdd$var$t);
            null !== m && $6a0186c511340fdd$var$K($6a0186c511340fdd$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6a0186c511340fdd$var$v = null, $6a0186c511340fdd$var$y = c, $6a0186c511340fdd$var$z = !1;
    }
}
var $6a0186c511340fdd$var$N = !1, $6a0186c511340fdd$var$O = null, $6a0186c511340fdd$var$L = -1, $6a0186c511340fdd$var$P = 5, $6a0186c511340fdd$var$Q = -1;
function $6a0186c511340fdd$var$M() {
    return $6a0186c511340fdd$export$c4744153514ff05d() - $6a0186c511340fdd$var$Q < $6a0186c511340fdd$var$P ? !1 : !0;
}
function $6a0186c511340fdd$var$R() {
    if (null !== $6a0186c511340fdd$var$O) {
        var a = $6a0186c511340fdd$export$c4744153514ff05d();
        $6a0186c511340fdd$var$Q = a;
        var b = !0;
        try {
            b = $6a0186c511340fdd$var$O(!0, a);
        } finally{
            b ? $6a0186c511340fdd$var$S() : ($6a0186c511340fdd$var$N = !1, $6a0186c511340fdd$var$O = null);
        }
    } else $6a0186c511340fdd$var$N = !1;
}
var $6a0186c511340fdd$var$S;
if ("function" === typeof $6a0186c511340fdd$var$F) $6a0186c511340fdd$var$S = function() {
    $6a0186c511340fdd$var$F($6a0186c511340fdd$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6a0186c511340fdd$var$T = new MessageChannel, $6a0186c511340fdd$var$U = $6a0186c511340fdd$var$T.port2;
    $6a0186c511340fdd$var$T.port1.onmessage = $6a0186c511340fdd$var$R;
    $6a0186c511340fdd$var$S = function() {
        $6a0186c511340fdd$var$U.postMessage(null);
    };
} else $6a0186c511340fdd$var$S = function() {
    $6a0186c511340fdd$var$D($6a0186c511340fdd$var$R, 0);
};
function $6a0186c511340fdd$var$I(a) {
    $6a0186c511340fdd$var$O = a;
    $6a0186c511340fdd$var$N || ($6a0186c511340fdd$var$N = !0, $6a0186c511340fdd$var$S());
}
function $6a0186c511340fdd$var$K(a, b) {
    $6a0186c511340fdd$var$L = $6a0186c511340fdd$var$D(function() {
        a($6a0186c511340fdd$export$c4744153514ff05d());
    }, b);
}
$6a0186c511340fdd$export$3e506c1ccc9cc1a7 = 5;
$6a0186c511340fdd$export$e26fe2ed2fa76875 = 1;
$6a0186c511340fdd$export$502329bbf4b505b1 = 4;
$6a0186c511340fdd$export$6e3807111c4874c4 = 3;
$6a0186c511340fdd$export$c27134553091fb3a = null;
$6a0186c511340fdd$export$33ee1acdc04fd2a2 = 2;
$6a0186c511340fdd$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6a0186c511340fdd$export$8352ce38b91d0c62 = function() {
    $6a0186c511340fdd$var$A || $6a0186c511340fdd$var$z || ($6a0186c511340fdd$var$A = !0, $6a0186c511340fdd$var$I($6a0186c511340fdd$var$J));
};
$6a0186c511340fdd$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6a0186c511340fdd$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6a0186c511340fdd$export$d3dfb8e4810cb555 = function() {
    return $6a0186c511340fdd$var$y;
};
$6a0186c511340fdd$export$839f9183b0465a69 = function() {
    return $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r);
};
$6a0186c511340fdd$export$72fdf0e06517287b = function(a) {
    switch($6a0186c511340fdd$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6a0186c511340fdd$var$y;
    }
    var c = $6a0186c511340fdd$var$y;
    $6a0186c511340fdd$var$y = b;
    try {
        return a();
    } finally{
        $6a0186c511340fdd$var$y = c;
    }
};
$6a0186c511340fdd$export$4b844e58a3e414b4 = function() {};
$6a0186c511340fdd$export$816d2913ae6b83b1 = function() {};
$6a0186c511340fdd$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6a0186c511340fdd$var$y;
    $6a0186c511340fdd$var$y = a;
    try {
        return b();
    } finally{
        $6a0186c511340fdd$var$y = c;
    }
};
$6a0186c511340fdd$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6a0186c511340fdd$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6a0186c511340fdd$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6a0186c511340fdd$var$f($6a0186c511340fdd$var$t, a), null === $6a0186c511340fdd$var$h($6a0186c511340fdd$var$r) && a === $6a0186c511340fdd$var$h($6a0186c511340fdd$var$t) && ($6a0186c511340fdd$var$B ? ($6a0186c511340fdd$var$E($6a0186c511340fdd$var$L), $6a0186c511340fdd$var$L = -1) : $6a0186c511340fdd$var$B = !0, $6a0186c511340fdd$var$K($6a0186c511340fdd$var$H, c - d))) : (a.sortIndex = e, $6a0186c511340fdd$var$f($6a0186c511340fdd$var$r, a), $6a0186c511340fdd$var$A || $6a0186c511340fdd$var$z || ($6a0186c511340fdd$var$A = !0, $6a0186c511340fdd$var$I($6a0186c511340fdd$var$J)));
    return a;
};
$6a0186c511340fdd$export$b5836b71941fa3ed = $6a0186c511340fdd$var$M;
$6a0186c511340fdd$export$cf845f2c119da08a = function(a) {
    var b = $6a0186c511340fdd$var$y;
    return function() {
        var c = $6a0186c511340fdd$var$y;
        $6a0186c511340fdd$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6a0186c511340fdd$var$y = c;
        }
    };
};

});




parcelRegister("ejhsZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6b06385106ac1fc$var$ReactIs, $a6b06385106ac1fc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("8kx3A"))();

});
parcelRegister("8kx3A", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $eaOfI = parcelRequire("eaOfI");
function $6109d5604868bb20$var$emptyFunction() {}
function $6109d5604868bb20$var$emptyFunctionWithReset() {}
$6109d5604868bb20$var$emptyFunctionWithReset.resetWarningCache = $6109d5604868bb20$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $eaOfI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6109d5604868bb20$var$emptyFunctionWithReset,
        resetWarningCache: $6109d5604868bb20$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("eaOfI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a518faef0af0fe44$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $a518faef0af0fe44$var$ReactPropTypesSecret;

});



parcelRegister("e31E2", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $02a3a7ba575b919c$export$2b8d127b894957b9; }, function (v) { return $02a3a7ba575b919c$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $02a3a7ba575b919c$export$cea3a54a6425200c; }, function (v) { return $02a3a7ba575b919c$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $02a3a7ba575b919c$export$a7c73072b1a182ae; }, function (v) { return $02a3a7ba575b919c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $02a3a7ba575b919c$export$9f27bc3417b4524d; }, function (v) { return $02a3a7ba575b919c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $02a3a7ba575b919c$export$db77ccec0bb4ccac; }, function (v) { return $02a3a7ba575b919c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $02a3a7ba575b919c$export$8392c0c9d3dcbd35; }, function (v) { return $02a3a7ba575b919c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $02a3a7ba575b919c$export$ffb0004e005737fa; }, function (v) { return $02a3a7ba575b919c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $02a3a7ba575b919c$export$b624eff549462981; }, function (v) { return $02a3a7ba575b919c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $02a3a7ba575b919c$export$7897aa7841a5380c; }, function (v) { return $02a3a7ba575b919c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $02a3a7ba575b919c$export$602eac185826482c; }, function (v) { return $02a3a7ba575b919c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $02a3a7ba575b919c$export$e2c29f18771995cb; }, function (v) { return $02a3a7ba575b919c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $02a3a7ba575b919c$export$5f8d39834fd61797; }, function (v) { return $02a3a7ba575b919c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $02a3a7ba575b919c$export$74bf444e3cd11ea5; }, function (v) { return $02a3a7ba575b919c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $02a3a7ba575b919c$export$92387174baf9b227; }, function (v) { return $02a3a7ba575b919c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $02a3a7ba575b919c$export$ec112efeb987d9c6; }, function (v) { return $02a3a7ba575b919c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $02a3a7ba575b919c$export$b706b080d889d2c9; }, function (v) { return $02a3a7ba575b919c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $02a3a7ba575b919c$export$5be5a87408f70ddc; }, function (v) { return $02a3a7ba575b919c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $02a3a7ba575b919c$export$45a5e7f76e0caa8d; }, function (v) { return $02a3a7ba575b919c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $02a3a7ba575b919c$export$455c2e768291efa6; }, function (v) { return $02a3a7ba575b919c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $02a3a7ba575b919c$export$9522e17588c12572; }, function (v) { return $02a3a7ba575b919c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $02a3a7ba575b919c$export$2110ac352bb060b9; }, function (v) { return $02a3a7ba575b919c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $02a3a7ba575b919c$export$56885ab8b9c456ab; }, function (v) { return $02a3a7ba575b919c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $02a3a7ba575b919c$export$d927fcb6adf8f9de; }, function (v) { return $02a3a7ba575b919c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $02a3a7ba575b919c$export$b82d16f27459e05a; }, function (v) { return $02a3a7ba575b919c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $02a3a7ba575b919c$export$522c17b4f5e123e8; }, function (v) { return $02a3a7ba575b919c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $02a3a7ba575b919c$export$1aabd8a0274ecfd6; }, function (v) { return $02a3a7ba575b919c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $02a3a7ba575b919c$export$9b621391a187a31a; }, function (v) { return $02a3a7ba575b919c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $02a3a7ba575b919c$export$f5bbd400c2f4426f; }, function (v) { return $02a3a7ba575b919c$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $02a3a7ba575b919c$export$2b8d127b894957b9;
var $02a3a7ba575b919c$export$cea3a54a6425200c;
var $02a3a7ba575b919c$export$a7c73072b1a182ae;
var $02a3a7ba575b919c$export$9f27bc3417b4524d;
var $02a3a7ba575b919c$export$db77ccec0bb4ccac;
var $02a3a7ba575b919c$export$8392c0c9d3dcbd35;
var $02a3a7ba575b919c$export$ffb0004e005737fa;
var $02a3a7ba575b919c$export$b624eff549462981;
var $02a3a7ba575b919c$export$7897aa7841a5380c;
var $02a3a7ba575b919c$export$602eac185826482c;
var $02a3a7ba575b919c$export$e2c29f18771995cb;
var $02a3a7ba575b919c$export$5f8d39834fd61797;
var $02a3a7ba575b919c$export$74bf444e3cd11ea5;
var $02a3a7ba575b919c$export$92387174baf9b227;
var $02a3a7ba575b919c$export$ec112efeb987d9c6;
var $02a3a7ba575b919c$export$b706b080d889d2c9;
var $02a3a7ba575b919c$export$5be5a87408f70ddc;
var $02a3a7ba575b919c$export$45a5e7f76e0caa8d;
var $02a3a7ba575b919c$export$455c2e768291efa6;
var $02a3a7ba575b919c$export$9522e17588c12572;
var $02a3a7ba575b919c$export$2110ac352bb060b9;
var $02a3a7ba575b919c$export$56885ab8b9c456ab;
var $02a3a7ba575b919c$export$d927fcb6adf8f9de;
var $02a3a7ba575b919c$export$b82d16f27459e05a;
var $02a3a7ba575b919c$export$522c17b4f5e123e8;
var $02a3a7ba575b919c$export$1aabd8a0274ecfd6;
var $02a3a7ba575b919c$export$9b621391a187a31a;
var $02a3a7ba575b919c$export$f5bbd400c2f4426f;
'use strict';
var $02a3a7ba575b919c$var$b = "function" === typeof Symbol && Symbol.for, $02a3a7ba575b919c$var$c = $02a3a7ba575b919c$var$b ? Symbol.for("react.element") : 60103, $02a3a7ba575b919c$var$d = $02a3a7ba575b919c$var$b ? Symbol.for("react.portal") : 60106, $02a3a7ba575b919c$var$e = $02a3a7ba575b919c$var$b ? Symbol.for("react.fragment") : 60107, $02a3a7ba575b919c$var$f = $02a3a7ba575b919c$var$b ? Symbol.for("react.strict_mode") : 60108, $02a3a7ba575b919c$var$g = $02a3a7ba575b919c$var$b ? Symbol.for("react.profiler") : 60114, $02a3a7ba575b919c$var$h = $02a3a7ba575b919c$var$b ? Symbol.for("react.provider") : 60109, $02a3a7ba575b919c$var$k = $02a3a7ba575b919c$var$b ? Symbol.for("react.context") : 60110, $02a3a7ba575b919c$var$l = $02a3a7ba575b919c$var$b ? Symbol.for("react.async_mode") : 60111, $02a3a7ba575b919c$var$m = $02a3a7ba575b919c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $02a3a7ba575b919c$var$n = $02a3a7ba575b919c$var$b ? Symbol.for("react.forward_ref") : 60112, $02a3a7ba575b919c$var$p = $02a3a7ba575b919c$var$b ? Symbol.for("react.suspense") : 60113, $02a3a7ba575b919c$var$q = $02a3a7ba575b919c$var$b ? Symbol.for("react.suspense_list") : 60120, $02a3a7ba575b919c$var$r = $02a3a7ba575b919c$var$b ? Symbol.for("react.memo") : 60115, $02a3a7ba575b919c$var$t = $02a3a7ba575b919c$var$b ? Symbol.for("react.lazy") : 60116, $02a3a7ba575b919c$var$v = $02a3a7ba575b919c$var$b ? Symbol.for("react.block") : 60121, $02a3a7ba575b919c$var$w = $02a3a7ba575b919c$var$b ? Symbol.for("react.fundamental") : 60117, $02a3a7ba575b919c$var$x = $02a3a7ba575b919c$var$b ? Symbol.for("react.responder") : 60118, $02a3a7ba575b919c$var$y = $02a3a7ba575b919c$var$b ? Symbol.for("react.scope") : 60119;
function $02a3a7ba575b919c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $02a3a7ba575b919c$var$c:
                switch(a = a.type, a){
                    case $02a3a7ba575b919c$var$l:
                    case $02a3a7ba575b919c$var$m:
                    case $02a3a7ba575b919c$var$e:
                    case $02a3a7ba575b919c$var$g:
                    case $02a3a7ba575b919c$var$f:
                    case $02a3a7ba575b919c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $02a3a7ba575b919c$var$k:
                            case $02a3a7ba575b919c$var$n:
                            case $02a3a7ba575b919c$var$t:
                            case $02a3a7ba575b919c$var$r:
                            case $02a3a7ba575b919c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $02a3a7ba575b919c$var$d:
                return u;
        }
    }
}
function $02a3a7ba575b919c$var$A(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$m;
}
$02a3a7ba575b919c$export$2b8d127b894957b9 = $02a3a7ba575b919c$var$l;
$02a3a7ba575b919c$export$cea3a54a6425200c = $02a3a7ba575b919c$var$m;
$02a3a7ba575b919c$export$a7c73072b1a182ae = $02a3a7ba575b919c$var$k;
$02a3a7ba575b919c$export$9f27bc3417b4524d = $02a3a7ba575b919c$var$h;
$02a3a7ba575b919c$export$db77ccec0bb4ccac = $02a3a7ba575b919c$var$c;
$02a3a7ba575b919c$export$8392c0c9d3dcbd35 = $02a3a7ba575b919c$var$n;
$02a3a7ba575b919c$export$ffb0004e005737fa = $02a3a7ba575b919c$var$e;
$02a3a7ba575b919c$export$b624eff549462981 = $02a3a7ba575b919c$var$t;
$02a3a7ba575b919c$export$7897aa7841a5380c = $02a3a7ba575b919c$var$r;
$02a3a7ba575b919c$export$602eac185826482c = $02a3a7ba575b919c$var$d;
$02a3a7ba575b919c$export$e2c29f18771995cb = $02a3a7ba575b919c$var$g;
$02a3a7ba575b919c$export$5f8d39834fd61797 = $02a3a7ba575b919c$var$f;
$02a3a7ba575b919c$export$74bf444e3cd11ea5 = $02a3a7ba575b919c$var$p;
$02a3a7ba575b919c$export$92387174baf9b227 = function(a) {
    return $02a3a7ba575b919c$var$A(a) || $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$l;
};
$02a3a7ba575b919c$export$ec112efeb987d9c6 = $02a3a7ba575b919c$var$A;
$02a3a7ba575b919c$export$b706b080d889d2c9 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$k;
};
$02a3a7ba575b919c$export$5be5a87408f70ddc = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$h;
};
$02a3a7ba575b919c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $02a3a7ba575b919c$var$c;
};
$02a3a7ba575b919c$export$455c2e768291efa6 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$n;
};
$02a3a7ba575b919c$export$9522e17588c12572 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$e;
};
$02a3a7ba575b919c$export$2110ac352bb060b9 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$t;
};
$02a3a7ba575b919c$export$56885ab8b9c456ab = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$r;
};
$02a3a7ba575b919c$export$d927fcb6adf8f9de = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$d;
};
$02a3a7ba575b919c$export$b82d16f27459e05a = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$g;
};
$02a3a7ba575b919c$export$522c17b4f5e123e8 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$f;
};
$02a3a7ba575b919c$export$1aabd8a0274ecfd6 = function(a) {
    return $02a3a7ba575b919c$var$z(a) === $02a3a7ba575b919c$var$p;
};
$02a3a7ba575b919c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $02a3a7ba575b919c$var$e || a === $02a3a7ba575b919c$var$m || a === $02a3a7ba575b919c$var$g || a === $02a3a7ba575b919c$var$f || a === $02a3a7ba575b919c$var$p || a === $02a3a7ba575b919c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $02a3a7ba575b919c$var$t || a.$$typeof === $02a3a7ba575b919c$var$r || a.$$typeof === $02a3a7ba575b919c$var$h || a.$$typeof === $02a3a7ba575b919c$var$k || a.$$typeof === $02a3a7ba575b919c$var$n || a.$$typeof === $02a3a7ba575b919c$var$w || a.$$typeof === $02a3a7ba575b919c$var$x || a.$$typeof === $02a3a7ba575b919c$var$y || a.$$typeof === $02a3a7ba575b919c$var$v);
};
$02a3a7ba575b919c$export$f5bbd400c2f4426f = $02a3a7ba575b919c$var$z;

});

parcelRegister("cGznn", function(module, exports) {

var $83nx1 = parcelRequire("83nx1");

var $7Z6pY = parcelRequire("7Z6pY");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $83nx1.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7Z6pY;
module.exports = isBuffer;

});
parcelRegister("83nx1", function(module, exports) {

var $7wV0g = parcelRequire("7wV0g");
/** Detect free variable `self`. */ var $5dd0db6de9be681e$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5dd0db6de9be681e$var$root = $7wV0g || $5dd0db6de9be681e$var$freeSelf || Function('return this')();
module.exports = $5dd0db6de9be681e$var$root;

});
parcelRegister("7wV0g", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $57b7bd342b4033f8$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $57b7bd342b4033f8$var$freeGlobal;

});


parcelRegister("7Z6pY", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $5d033560db27e479$var$stubFalse() {
    return false;
}
module.exports = $5d033560db27e479$var$stubFalse;

});


parcelRegister("6bKK7", function(module, exports) {

var $7wV0g = parcelRequire("7wV0g");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $7wV0g.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("1zRNb", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("4AMAc"));

});
parcelRegister("4AMAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $lAVpK.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $lAVpK.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $lGkDT.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $lGkDT.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $iCRrk.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $iCRrk.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $iCRrk.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $iCRrk.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $358035be63548981$var$_symbol.symbolsStroke;
    }
});

var $358035be63548981$var$_arc = $358035be63548981$var$_interopRequireDefault((parcelRequire("qP7j3")));

var $358035be63548981$var$_area = $358035be63548981$var$_interopRequireDefault((parcelRequire("bqDxL")));

var $358035be63548981$var$_line = $358035be63548981$var$_interopRequireDefault((parcelRequire("iPEaB")));

var $358035be63548981$var$_pie = $358035be63548981$var$_interopRequireDefault((parcelRequire("7SpZ4")));

var $358035be63548981$var$_areaRadial = $358035be63548981$var$_interopRequireDefault((parcelRequire("ayk4R")));

var $358035be63548981$var$_lineRadial = $358035be63548981$var$_interopRequireDefault((parcelRequire("iry9S")));

var $358035be63548981$var$_pointRadial = $358035be63548981$var$_interopRequireDefault((parcelRequire("jwTEw")));

var $iCRrk = parcelRequire("iCRrk");

var $358035be63548981$var$_symbol = $358035be63548981$var$_interopRequireWildcard((parcelRequire("eMQ0J")));

var $358035be63548981$var$_asterisk = $358035be63548981$var$_interopRequireDefault((parcelRequire("iJgnY")));

var $358035be63548981$var$_circle = $358035be63548981$var$_interopRequireDefault((parcelRequire("d5KXA")));

var $358035be63548981$var$_cross = $358035be63548981$var$_interopRequireDefault((parcelRequire("gzJbU")));

var $358035be63548981$var$_diamond = $358035be63548981$var$_interopRequireDefault((parcelRequire("iUOXi")));

var $358035be63548981$var$_diamond2 = $358035be63548981$var$_interopRequireDefault((parcelRequire("jECtF")));

var $358035be63548981$var$_plus = $358035be63548981$var$_interopRequireDefault((parcelRequire("aVBqt")));

var $358035be63548981$var$_square = $358035be63548981$var$_interopRequireDefault((parcelRequire("8q5zc")));

var $358035be63548981$var$_square2 = $358035be63548981$var$_interopRequireDefault((parcelRequire("8x7l7")));

var $358035be63548981$var$_star = $358035be63548981$var$_interopRequireDefault((parcelRequire("lyoFV")));

var $358035be63548981$var$_triangle = $358035be63548981$var$_interopRequireDefault((parcelRequire("gsLW6")));

var $358035be63548981$var$_triangle2 = $358035be63548981$var$_interopRequireDefault((parcelRequire("eoSyH")));

var $358035be63548981$var$_wye = $358035be63548981$var$_interopRequireDefault((parcelRequire("hiPue")));

var $358035be63548981$var$_x = $358035be63548981$var$_interopRequireDefault((parcelRequire("1rxAI")));

var $358035be63548981$var$_basisClosed = $358035be63548981$var$_interopRequireDefault((parcelRequire("d30L4")));

var $358035be63548981$var$_basisOpen = $358035be63548981$var$_interopRequireDefault((parcelRequire("2Hkih")));

var $358035be63548981$var$_basis = $358035be63548981$var$_interopRequireDefault((parcelRequire("ax3vi")));

var $lAVpK = parcelRequire("lAVpK");

var $358035be63548981$var$_bundle = $358035be63548981$var$_interopRequireDefault((parcelRequire("l81Us")));

var $358035be63548981$var$_cardinalClosed = $358035be63548981$var$_interopRequireDefault((parcelRequire("jig3N")));

var $358035be63548981$var$_cardinalOpen = $358035be63548981$var$_interopRequireDefault((parcelRequire("jEboo")));

var $358035be63548981$var$_cardinal = $358035be63548981$var$_interopRequireDefault((parcelRequire("549wv")));

var $358035be63548981$var$_catmullRomClosed = $358035be63548981$var$_interopRequireDefault((parcelRequire("3TMeh")));

var $358035be63548981$var$_catmullRomOpen = $358035be63548981$var$_interopRequireDefault((parcelRequire("6RzVI")));

var $358035be63548981$var$_catmullRom = $358035be63548981$var$_interopRequireDefault((parcelRequire("k07ll")));

var $358035be63548981$var$_linearClosed = $358035be63548981$var$_interopRequireDefault((parcelRequire("l3nao")));

var $358035be63548981$var$_linear = $358035be63548981$var$_interopRequireDefault((parcelRequire("cNZpu")));

var $lGkDT = parcelRequire("lGkDT");

var $358035be63548981$var$_natural = $358035be63548981$var$_interopRequireDefault((parcelRequire("7Mu4q")));

var $358035be63548981$var$_step = $358035be63548981$var$_interopRequireWildcard((parcelRequire("i8ypb")));

var $358035be63548981$var$_stack = $358035be63548981$var$_interopRequireDefault((parcelRequire("18aaC")));

var $358035be63548981$var$_expand = $358035be63548981$var$_interopRequireDefault((parcelRequire("euYC1")));

var $358035be63548981$var$_diverging = $358035be63548981$var$_interopRequireDefault((parcelRequire("hlKUW")));

var $358035be63548981$var$_none = $358035be63548981$var$_interopRequireDefault((parcelRequire("iVvGb")));

var $358035be63548981$var$_silhouette = $358035be63548981$var$_interopRequireDefault((parcelRequire("2ySjo")));

var $358035be63548981$var$_wiggle = $358035be63548981$var$_interopRequireDefault((parcelRequire("3z7Mu")));

var $358035be63548981$var$_appearance = $358035be63548981$var$_interopRequireDefault((parcelRequire("azk8s")));

var $358035be63548981$var$_ascending = $358035be63548981$var$_interopRequireDefault((parcelRequire("98J8M")));

var $358035be63548981$var$_descending = $358035be63548981$var$_interopRequireDefault((parcelRequire("1IpYS")));

var $358035be63548981$var$_insideOut = $358035be63548981$var$_interopRequireDefault((parcelRequire("8miQT")));

var $358035be63548981$var$_none2 = $358035be63548981$var$_interopRequireDefault((parcelRequire("1pna7")));

var $358035be63548981$var$_reverse = $358035be63548981$var$_interopRequireDefault((parcelRequire("gknjn")));
function $358035be63548981$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($358035be63548981$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $358035be63548981$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $358035be63548981$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $358035be63548981$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("qP7j3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $050a1490399a5110$var$_default;

var $50eL2 = parcelRequire("50eL2");

var $050a1490399a5110$var$_constant = $050a1490399a5110$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $aT8ec = parcelRequire("aT8ec");
function $050a1490399a5110$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $050a1490399a5110$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $050a1490399a5110$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $050a1490399a5110$var$arcStartAngle(d) {
    return d.startAngle;
}
function $050a1490399a5110$var$arcEndAngle(d) {
    return d.endAngle;
}
function $050a1490399a5110$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $050a1490399a5110$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $aT8ec.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $050a1490399a5110$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $aT8ec.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $aT8ec.sqrt)((0, $aT8ec.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $050a1490399a5110$var$_default() {
    var innerRadius = $050a1490399a5110$var$arcInnerRadius, outerRadius = $050a1490399a5110$var$arcOuterRadius, cornerRadius = (0, $050a1490399a5110$var$_constant.default)(0), padRadius = null, startAngle = $050a1490399a5110$var$arcStartAngle, endAngle = $050a1490399a5110$var$arcEndAngle, padAngle = $050a1490399a5110$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $aT8ec.halfPi, a1 = endAngle.apply(this, arguments) - $aT8ec.halfPi, da = (0, $aT8ec.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $50eL2.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $aT8ec.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $aT8ec.tau - $aT8ec.epsilon) {
            context.moveTo(r1 * (0, $aT8ec.cos)(a0), r1 * (0, $aT8ec.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $aT8ec.epsilon) {
                context.moveTo(r0 * (0, $aT8ec.cos)(a1), r0 * (0, $aT8ec.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $aT8ec.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $aT8ec.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $aT8ec.min)((0, $aT8ec.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $aT8ec.epsilon) {
                var p0 = (0, $aT8ec.asin)(rp / r0 * (0, $aT8ec.sin)(ap)), p1 = (0, $aT8ec.asin)(rp / r1 * (0, $aT8ec.sin)(ap));
                if ((da0 -= p0 * 2) > $aT8ec.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $aT8ec.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $aT8ec.cos)(a01), y01 = r1 * (0, $aT8ec.sin)(a01), x10 = r0 * (0, $aT8ec.cos)(a10), y10 = r0 * (0, $aT8ec.sin)(a10); // Apply rounded corners?
            if (rc > $aT8ec.epsilon) {
                var x11 = r1 * (0, $aT8ec.cos)(a11), y11 = r1 * (0, $aT8ec.sin)(a11), x00 = r0 * (0, $aT8ec.cos)(a00), y00 = r0 * (0, $aT8ec.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $aT8ec.pi && (oc = $050a1490399a5110$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $aT8ec.sin)((0, $aT8ec.acos)((ax * bx + ay * by) / ((0, $aT8ec.sqrt)(ax * ax + ay * ay) * (0, $aT8ec.sqrt)(bx * bx + by * by))) / 2), lc = (0, $aT8ec.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $aT8ec.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $aT8ec.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $aT8ec.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $aT8ec.epsilon) {
                t0 = $050a1490399a5110$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $050a1490399a5110$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $aT8ec.atan2)(t0.y01, t0.x01), (0, $aT8ec.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $aT8ec.atan2)(t0.y01, t0.x01), (0, $aT8ec.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $aT8ec.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $aT8ec.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $aT8ec.atan2)(t1.y11, t1.x11), (0, $aT8ec.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $aT8ec.epsilon) || !(da0 > $aT8ec.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $aT8ec.epsilon) {
                t0 = $050a1490399a5110$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $050a1490399a5110$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $aT8ec.atan2)(t0.y01, t0.x01), (0, $aT8ec.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $aT8ec.atan2)(t0.y01, t0.x01), (0, $aT8ec.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $aT8ec.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $aT8ec.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $aT8ec.atan2)(t1.y11, t1.x11), (0, $aT8ec.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $aT8ec.pi / 2;
        return [
            (0, $aT8ec.cos)(a) * r,
            (0, $aT8ec.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $050a1490399a5110$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("50eL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $3a48666e710554f0$var$_path.default;
    }
});

var $3a48666e710554f0$var$_path = $3a48666e710554f0$var$_interopRequireDefault((parcelRequire("gPZEW")));
function $3a48666e710554f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gPZEW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $c4213d06a256d718$var$pi = Math.PI, $c4213d06a256d718$var$tau = 2 * $c4213d06a256d718$var$pi, $c4213d06a256d718$var$epsilon = 1e-6, $c4213d06a256d718$var$tauEpsilon = $c4213d06a256d718$var$tau - $c4213d06a256d718$var$epsilon;
function $c4213d06a256d718$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $c4213d06a256d718$var$path() {
    return new $c4213d06a256d718$var$Path();
}
$c4213d06a256d718$var$Path.prototype = $c4213d06a256d718$var$path.prototype = {
    constructor: $c4213d06a256d718$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $c4213d06a256d718$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c4213d06a256d718$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c4213d06a256d718$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c4213d06a256d718$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $c4213d06a256d718$var$epsilon || Math.abs(this._y1 - y0) > $c4213d06a256d718$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c4213d06a256d718$var$tau + $c4213d06a256d718$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c4213d06a256d718$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $c4213d06a256d718$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $c4213d06a256d718$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $c4213d06a256d718$var$_default = $c4213d06a256d718$var$path;
module.exports.default = $c4213d06a256d718$var$_default;

});


parcelRegister("dMgfW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a07c5e295ae72b21$var$_default;
function $a07c5e295ae72b21$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("aT8ec", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $7ed56c60773aacbf$var$acos;
module.exports.asin = $7ed56c60773aacbf$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $7ed56c60773aacbf$var$abs = Math.abs;
module.exports.abs = $7ed56c60773aacbf$var$abs;
const $7ed56c60773aacbf$var$atan2 = Math.atan2;
module.exports.atan2 = $7ed56c60773aacbf$var$atan2;
const $7ed56c60773aacbf$var$cos = Math.cos;
module.exports.cos = $7ed56c60773aacbf$var$cos;
const $7ed56c60773aacbf$var$max = Math.max;
module.exports.max = $7ed56c60773aacbf$var$max;
const $7ed56c60773aacbf$var$min = Math.min;
module.exports.min = $7ed56c60773aacbf$var$min;
const $7ed56c60773aacbf$var$sin = Math.sin;
module.exports.sin = $7ed56c60773aacbf$var$sin;
const $7ed56c60773aacbf$var$sqrt = Math.sqrt;
module.exports.sqrt = $7ed56c60773aacbf$var$sqrt;
const $7ed56c60773aacbf$var$epsilon = 1e-12;
module.exports.epsilon = $7ed56c60773aacbf$var$epsilon;
const $7ed56c60773aacbf$var$pi = Math.PI;
module.exports.pi = $7ed56c60773aacbf$var$pi;
const $7ed56c60773aacbf$var$halfPi = $7ed56c60773aacbf$var$pi / 2;
module.exports.halfPi = $7ed56c60773aacbf$var$halfPi;
const $7ed56c60773aacbf$var$tau = 2 * $7ed56c60773aacbf$var$pi;
module.exports.tau = $7ed56c60773aacbf$var$tau;
function $7ed56c60773aacbf$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $7ed56c60773aacbf$var$pi : Math.acos(x);
}
function $7ed56c60773aacbf$var$asin(x) {
    return x >= 1 ? $7ed56c60773aacbf$var$halfPi : x <= -1 ? -$7ed56c60773aacbf$var$halfPi : Math.asin(x);
}

});


parcelRegister("bqDxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8520cbf1fc2acca6$var$_default;

var $50eL2 = parcelRequire("50eL2");

var $8520cbf1fc2acca6$var$_array = $8520cbf1fc2acca6$var$_interopRequireDefault((parcelRequire("kiHzb")));

var $8520cbf1fc2acca6$var$_constant = $8520cbf1fc2acca6$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $8520cbf1fc2acca6$var$_linear = $8520cbf1fc2acca6$var$_interopRequireDefault((parcelRequire("cNZpu")));

var $8520cbf1fc2acca6$var$_line = $8520cbf1fc2acca6$var$_interopRequireDefault((parcelRequire("iPEaB")));

var $125Er = parcelRequire("125Er");
function $8520cbf1fc2acca6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8520cbf1fc2acca6$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $8520cbf1fc2acca6$var$_constant.default)(true), context = null, curve = $8520cbf1fc2acca6$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $125Er.x : (0, $8520cbf1fc2acca6$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $8520cbf1fc2acca6$var$_constant.default)(0) : (0, $8520cbf1fc2acca6$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $125Er.y : (0, $8520cbf1fc2acca6$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $8520cbf1fc2acca6$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $50eL2.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $8520cbf1fc2acca6$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $8520cbf1fc2acca6$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("kiHzb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec7748810576fc70$var$_default;
module.exports.slice = void 0;
var $ec7748810576fc70$var$slice = Array.prototype.slice;
module.exports.slice = $ec7748810576fc70$var$slice;
function $ec7748810576fc70$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("cNZpu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9529b266271be40c$var$_default;
function $9529b266271be40c$var$Linear(context) {
    this._context = context;
}
$9529b266271be40c$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $9529b266271be40c$var$_default(context) {
    return new $9529b266271be40c$var$Linear(context);
}

});

parcelRegister("iPEaB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db5c265b169e183b$var$_default;

var $50eL2 = parcelRequire("50eL2");

var $db5c265b169e183b$var$_array = $db5c265b169e183b$var$_interopRequireDefault((parcelRequire("kiHzb")));

var $db5c265b169e183b$var$_constant = $db5c265b169e183b$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $db5c265b169e183b$var$_linear = $db5c265b169e183b$var$_interopRequireDefault((parcelRequire("cNZpu")));

var $125Er = parcelRequire("125Er");
function $db5c265b169e183b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $db5c265b169e183b$var$_default(x, y) {
    var defined = (0, $db5c265b169e183b$var$_constant.default)(true), context = null, curve = $db5c265b169e183b$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $125Er.x : (0, $db5c265b169e183b$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $125Er.y : (0, $db5c265b169e183b$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $db5c265b169e183b$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $50eL2.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $db5c265b169e183b$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $db5c265b169e183b$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $db5c265b169e183b$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("125Er", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $0c0a5c945acf4318$var$x;
module.exports.y = $0c0a5c945acf4318$var$y;
function $0c0a5c945acf4318$var$x(p) {
    return p[0];
}
function $0c0a5c945acf4318$var$y(p) {
    return p[1];
}

});



parcelRegister("7SpZ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5bc1bb746f61371b$var$_default;

var $5bc1bb746f61371b$var$_array = $5bc1bb746f61371b$var$_interopRequireDefault((parcelRequire("kiHzb")));

var $5bc1bb746f61371b$var$_constant = $5bc1bb746f61371b$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $5bc1bb746f61371b$var$_descending = $5bc1bb746f61371b$var$_interopRequireDefault((parcelRequire("loF8f")));

var $5bc1bb746f61371b$var$_identity = $5bc1bb746f61371b$var$_interopRequireDefault((parcelRequire("3U1iY")));

var $aT8ec = parcelRequire("aT8ec");
function $5bc1bb746f61371b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5bc1bb746f61371b$var$_default() {
    var value = $5bc1bb746f61371b$var$_identity.default, sortValues = $5bc1bb746f61371b$var$_descending.default, sort = null, startAngle = (0, $5bc1bb746f61371b$var$_constant.default)(0), endAngle = (0, $5bc1bb746f61371b$var$_constant.default)($aT8ec.tau), padAngle = (0, $5bc1bb746f61371b$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $5bc1bb746f61371b$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($aT8ec.tau, Math.max(-$aT8ec.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5bc1bb746f61371b$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $5bc1bb746f61371b$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $5bc1bb746f61371b$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $5bc1bb746f61371b$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("loF8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f93bbecf41a5f6bf$var$_default;
function $f93bbecf41a5f6bf$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("3U1iY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d779d3ad77c80e2$var$_default;
function $2d779d3ad77c80e2$var$_default(d) {
    return d;
}

});


parcelRegister("ayk4R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7aeca74bea3b1130$var$_default;

var $7aeca74bea3b1130$var$_radial = $7aeca74bea3b1130$var$_interopRequireWildcard((parcelRequire("dux7B")));

var $7aeca74bea3b1130$var$_area = $7aeca74bea3b1130$var$_interopRequireDefault((parcelRequire("bqDxL")));

var $iry9S = parcelRequire("iry9S");
function $7aeca74bea3b1130$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7aeca74bea3b1130$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7aeca74bea3b1130$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7aeca74bea3b1130$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7aeca74bea3b1130$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7aeca74bea3b1130$var$_default() {
    var a = (0, $7aeca74bea3b1130$var$_area.default)().curve($7aeca74bea3b1130$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $iry9S.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $iry9S.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $iry9S.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $iry9S.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $7aeca74bea3b1130$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dux7B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9d27c4f9c0ccbf68$var$curveRadial;

var $9d27c4f9c0ccbf68$var$_linear = $9d27c4f9c0ccbf68$var$_interopRequireDefault((parcelRequire("cNZpu")));
function $9d27c4f9c0ccbf68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9d27c4f9c0ccbf68$var$curveRadialLinear = $9d27c4f9c0ccbf68$var$curveRadial($9d27c4f9c0ccbf68$var$_linear.default);
module.exports.curveRadialLinear = $9d27c4f9c0ccbf68$var$curveRadialLinear;
function $9d27c4f9c0ccbf68$var$Radial(curve) {
    this._curve = curve;
}
$9d27c4f9c0ccbf68$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9d27c4f9c0ccbf68$var$curveRadial(curve) {
    function radial(context) {
        return new $9d27c4f9c0ccbf68$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("iry9S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6d53ebb97e982aa$var$_default;
module.exports.lineRadial = $d6d53ebb97e982aa$var$lineRadial;

var $d6d53ebb97e982aa$var$_radial = $d6d53ebb97e982aa$var$_interopRequireWildcard((parcelRequire("dux7B")));

var $d6d53ebb97e982aa$var$_line = $d6d53ebb97e982aa$var$_interopRequireDefault((parcelRequire("iPEaB")));
function $d6d53ebb97e982aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d6d53ebb97e982aa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d6d53ebb97e982aa$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d6d53ebb97e982aa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d6d53ebb97e982aa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d6d53ebb97e982aa$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $d6d53ebb97e982aa$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $d6d53ebb97e982aa$var$_default() {
    return $d6d53ebb97e982aa$var$lineRadial((0, $d6d53ebb97e982aa$var$_line.default)().curve($d6d53ebb97e982aa$var$_radial.curveRadialLinear));
}

});


parcelRegister("jwTEw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e37c2ce85f96734a$var$_default;
function $e37c2ce85f96734a$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("iCRrk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $d8f53aa39d22001e$var$link;
module.exports.linkHorizontal = $d8f53aa39d22001e$var$linkHorizontal;
module.exports.linkRadial = $d8f53aa39d22001e$var$linkRadial;
module.exports.linkVertical = $d8f53aa39d22001e$var$linkVertical;

var $50eL2 = parcelRequire("50eL2");

var $kiHzb = parcelRequire("kiHzb");

var $d8f53aa39d22001e$var$_constant = $d8f53aa39d22001e$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $lAVpK = parcelRequire("lAVpK");

var $125Er = parcelRequire("125Er");
function $d8f53aa39d22001e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d8f53aa39d22001e$var$linkSource(d) {
    return d.source;
}
function $d8f53aa39d22001e$var$linkTarget(d) {
    return d.target;
}
function $d8f53aa39d22001e$var$link(curve) {
    let source = $d8f53aa39d22001e$var$linkSource;
    let target = $d8f53aa39d22001e$var$linkTarget;
    let x = $125Er.x;
    let y = $125Er.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $kiHzb.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $50eL2.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $d8f53aa39d22001e$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $d8f53aa39d22001e$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $d8f53aa39d22001e$var$linkHorizontal() {
    return $d8f53aa39d22001e$var$link($lAVpK.bumpX);
}
function $d8f53aa39d22001e$var$linkVertical() {
    return $d8f53aa39d22001e$var$link($lAVpK.bumpY);
}
function $d8f53aa39d22001e$var$linkRadial() {
    const l = $d8f53aa39d22001e$var$link($lAVpK.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("lAVpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $fb897f10099b1abf$var$bumpRadial;
module.exports.bumpX = $fb897f10099b1abf$var$bumpX;
module.exports.bumpY = $fb897f10099b1abf$var$bumpY;

var $fb897f10099b1abf$var$_pointRadial = $fb897f10099b1abf$var$_interopRequireDefault((parcelRequire("jwTEw")));
function $fb897f10099b1abf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $fb897f10099b1abf$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $fb897f10099b1abf$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $fb897f10099b1abf$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $fb897f10099b1abf$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $fb897f10099b1abf$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $fb897f10099b1abf$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $fb897f10099b1abf$var$bumpX(context) {
    return new $fb897f10099b1abf$var$Bump(context, true);
}
function $fb897f10099b1abf$var$bumpY(context) {
    return new $fb897f10099b1abf$var$Bump(context, false);
}
function $fb897f10099b1abf$var$bumpRadial(context) {
    return new $fb897f10099b1abf$var$BumpRadial(context);
}

});


parcelRegister("eMQ0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac3de4aa800f3ada$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $50eL2 = parcelRequire("50eL2");

var $ac3de4aa800f3ada$var$_constant = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $ac3de4aa800f3ada$var$_asterisk = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("iJgnY")));

var $ac3de4aa800f3ada$var$_circle = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("d5KXA")));

var $ac3de4aa800f3ada$var$_cross = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("gzJbU")));

var $ac3de4aa800f3ada$var$_diamond = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("iUOXi")));

var $ac3de4aa800f3ada$var$_diamond2 = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("jECtF")));

var $ac3de4aa800f3ada$var$_plus = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("aVBqt")));

var $ac3de4aa800f3ada$var$_square = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("8q5zc")));

var $ac3de4aa800f3ada$var$_square2 = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("8x7l7")));

var $ac3de4aa800f3ada$var$_star = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("lyoFV")));

var $ac3de4aa800f3ada$var$_triangle = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("gsLW6")));

var $ac3de4aa800f3ada$var$_triangle2 = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("eoSyH")));

var $ac3de4aa800f3ada$var$_wye = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("hiPue")));

var $ac3de4aa800f3ada$var$_x = $ac3de4aa800f3ada$var$_interopRequireDefault((parcelRequire("1rxAI")));
function $ac3de4aa800f3ada$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $ac3de4aa800f3ada$var$symbolsFill = [
    $ac3de4aa800f3ada$var$_circle.default,
    $ac3de4aa800f3ada$var$_cross.default,
    $ac3de4aa800f3ada$var$_diamond.default,
    $ac3de4aa800f3ada$var$_square.default,
    $ac3de4aa800f3ada$var$_star.default,
    $ac3de4aa800f3ada$var$_triangle.default,
    $ac3de4aa800f3ada$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $ac3de4aa800f3ada$var$symbolsFill;
const $ac3de4aa800f3ada$var$symbolsStroke = [
    $ac3de4aa800f3ada$var$_circle.default,
    $ac3de4aa800f3ada$var$_plus.default,
    $ac3de4aa800f3ada$var$_x.default,
    $ac3de4aa800f3ada$var$_triangle2.default,
    $ac3de4aa800f3ada$var$_asterisk.default,
    $ac3de4aa800f3ada$var$_square2.default,
    $ac3de4aa800f3ada$var$_diamond2.default
];
module.exports.symbolsStroke = $ac3de4aa800f3ada$var$symbolsStroke;
function $ac3de4aa800f3ada$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $ac3de4aa800f3ada$var$_constant.default)(type || $ac3de4aa800f3ada$var$_circle.default);
    size = typeof size === "function" ? size : (0, $ac3de4aa800f3ada$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $50eL2.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $ac3de4aa800f3ada$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $ac3de4aa800f3ada$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("iJgnY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $da2923d632049cf9$var$sqrt3 = (0, $aT8ec.sqrt)(3);
var $da2923d632049cf9$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size + (0, $aT8ec.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $da2923d632049cf9$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $da2923d632049cf9$var$_default;

});

parcelRegister("d5KXA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $98802b496abb13c5$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size / $aT8ec.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $aT8ec.tau);
    }
};
module.exports.default = $98802b496abb13c5$var$_default;

});

parcelRegister("gzJbU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $c112f8401301b525$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $c112f8401301b525$var$_default;

});

parcelRegister("iUOXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $dc54fba1aa89963f$var$tan30 = (0, $aT8ec.sqrt)(1 / 3);
const $dc54fba1aa89963f$var$tan30_2 = $dc54fba1aa89963f$var$tan30 * 2;
var $dc54fba1aa89963f$var$_default = {
    draw (context, size) {
        const y = (0, $aT8ec.sqrt)(size / $dc54fba1aa89963f$var$tan30_2);
        const x = y * $dc54fba1aa89963f$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $dc54fba1aa89963f$var$_default;

});

parcelRegister("jECtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $e4ef9999ca79162b$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $e4ef9999ca79162b$var$_default;

});

parcelRegister("aVBqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $7f4c424473f87211$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size - (0, $aT8ec.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $7f4c424473f87211$var$_default;

});

parcelRegister("8q5zc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $621511dfc85b8d01$var$_default = {
    draw (context, size) {
        const w = (0, $aT8ec.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $621511dfc85b8d01$var$_default;

});

parcelRegister("8x7l7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $63671947435c8b8e$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $63671947435c8b8e$var$_default;

});

parcelRegister("lyoFV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $fb0fe9f0e437cd9b$var$ka = 0.89081309152928522810;
const $fb0fe9f0e437cd9b$var$kr = (0, $aT8ec.sin)($aT8ec.pi / 10) / (0, $aT8ec.sin)(7 * $aT8ec.pi / 10);
const $fb0fe9f0e437cd9b$var$kx = (0, $aT8ec.sin)($aT8ec.tau / 10) * $fb0fe9f0e437cd9b$var$kr;
const $fb0fe9f0e437cd9b$var$ky = -(0, $aT8ec.cos)($aT8ec.tau / 10) * $fb0fe9f0e437cd9b$var$kr;
var $fb0fe9f0e437cd9b$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size * $fb0fe9f0e437cd9b$var$ka);
        const x = $fb0fe9f0e437cd9b$var$kx * r;
        const y = $fb0fe9f0e437cd9b$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $aT8ec.tau * i / 5;
            const c = (0, $aT8ec.cos)(a);
            const s = (0, $aT8ec.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $fb0fe9f0e437cd9b$var$_default;

});

parcelRegister("gsLW6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $bfc471fa8082c206$var$sqrt3 = (0, $aT8ec.sqrt)(3);
var $bfc471fa8082c206$var$_default = {
    draw (context, size) {
        const y = -(0, $aT8ec.sqrt)(size / ($bfc471fa8082c206$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$bfc471fa8082c206$var$sqrt3 * y, -y);
        context.lineTo($bfc471fa8082c206$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $bfc471fa8082c206$var$_default;

});

parcelRegister("eoSyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $a7bda0cc80028524$var$sqrt3 = (0, $aT8ec.sqrt)(3);
var $a7bda0cc80028524$var$_default = {
    draw (context, size) {
        const s = (0, $aT8ec.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $a7bda0cc80028524$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $a7bda0cc80028524$var$_default;

});

parcelRegister("hiPue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
const $c98c0e43856fb4bb$var$c = -0.5;
const $c98c0e43856fb4bb$var$s = (0, $aT8ec.sqrt)(3) / 2;
const $c98c0e43856fb4bb$var$k = 1 / (0, $aT8ec.sqrt)(12);
const $c98c0e43856fb4bb$var$a = ($c98c0e43856fb4bb$var$k / 2 + 1) * 3;
var $c98c0e43856fb4bb$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size / $c98c0e43856fb4bb$var$a);
        const x0 = r / 2, y0 = r * $c98c0e43856fb4bb$var$k;
        const x1 = x0, y1 = r * $c98c0e43856fb4bb$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($c98c0e43856fb4bb$var$c * x0 - $c98c0e43856fb4bb$var$s * y0, $c98c0e43856fb4bb$var$s * x0 + $c98c0e43856fb4bb$var$c * y0);
        context.lineTo($c98c0e43856fb4bb$var$c * x1 - $c98c0e43856fb4bb$var$s * y1, $c98c0e43856fb4bb$var$s * x1 + $c98c0e43856fb4bb$var$c * y1);
        context.lineTo($c98c0e43856fb4bb$var$c * x2 - $c98c0e43856fb4bb$var$s * y2, $c98c0e43856fb4bb$var$s * x2 + $c98c0e43856fb4bb$var$c * y2);
        context.lineTo($c98c0e43856fb4bb$var$c * x0 + $c98c0e43856fb4bb$var$s * y0, $c98c0e43856fb4bb$var$c * y0 - $c98c0e43856fb4bb$var$s * x0);
        context.lineTo($c98c0e43856fb4bb$var$c * x1 + $c98c0e43856fb4bb$var$s * y1, $c98c0e43856fb4bb$var$c * y1 - $c98c0e43856fb4bb$var$s * x1);
        context.lineTo($c98c0e43856fb4bb$var$c * x2 + $c98c0e43856fb4bb$var$s * y2, $c98c0e43856fb4bb$var$c * y2 - $c98c0e43856fb4bb$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $c98c0e43856fb4bb$var$_default;

});

parcelRegister("1rxAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aT8ec = parcelRequire("aT8ec");
var $10d25e966dd65592$var$_default = {
    draw (context, size) {
        const r = (0, $aT8ec.sqrt)(size - (0, $aT8ec.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $10d25e966dd65592$var$_default;

});


parcelRegister("d30L4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97fc24c2b709ee0e$var$_default;

var $97fc24c2b709ee0e$var$_noop = $97fc24c2b709ee0e$var$_interopRequireDefault((parcelRequire("idkNk")));

var $ax3vi = parcelRequire("ax3vi");
function $97fc24c2b709ee0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97fc24c2b709ee0e$var$BasisClosed(context) {
    this._context = context;
}
$97fc24c2b709ee0e$var$BasisClosed.prototype = {
    areaStart: $97fc24c2b709ee0e$var$_noop.default,
    areaEnd: $97fc24c2b709ee0e$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $ax3vi.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $97fc24c2b709ee0e$var$_default(context) {
    return new $97fc24c2b709ee0e$var$BasisClosed(context);
}

});
parcelRegister("idkNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4299247f32fd66f$var$_default;
function $d4299247f32fd66f$var$_default() {}

});

parcelRegister("ax3vi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $7aafb43cd48002fa$var$Basis;
module.exports.default = $7aafb43cd48002fa$var$_default;
module.exports.point = $7aafb43cd48002fa$var$point;
function $7aafb43cd48002fa$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $7aafb43cd48002fa$var$Basis(context) {
    this._context = context;
}
$7aafb43cd48002fa$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $7aafb43cd48002fa$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $7aafb43cd48002fa$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7aafb43cd48002fa$var$_default(context) {
    return new $7aafb43cd48002fa$var$Basis(context);
}

});


parcelRegister("2Hkih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f6f56da8064fee4$var$_default;

var $ax3vi = parcelRequire("ax3vi");
function $1f6f56da8064fee4$var$BasisOpen(context) {
    this._context = context;
}
$1f6f56da8064fee4$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $ax3vi.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1f6f56da8064fee4$var$_default(context) {
    return new $1f6f56da8064fee4$var$BasisOpen(context);
}

});

parcelRegister("l81Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ax3vi = parcelRequire("ax3vi");
function $f61bd384f5b49585$var$Bundle(context, beta) {
    this._basis = new $ax3vi.Basis(context);
    this._beta = beta;
}
$f61bd384f5b49585$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f61bd384f5b49585$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $ax3vi.Basis(context) : new $f61bd384f5b49585$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $f61bd384f5b49585$var$_default;

});

parcelRegister("jig3N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $e0bc27f84c9644a9$var$CardinalClosed;
module.exports.default = void 0;

var $e0bc27f84c9644a9$var$_noop = $e0bc27f84c9644a9$var$_interopRequireDefault((parcelRequire("idkNk")));

var $549wv = parcelRequire("549wv");
function $e0bc27f84c9644a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e0bc27f84c9644a9$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e0bc27f84c9644a9$var$CardinalClosed.prototype = {
    areaStart: $e0bc27f84c9644a9$var$_noop.default,
    areaEnd: $e0bc27f84c9644a9$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $549wv.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e0bc27f84c9644a9$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e0bc27f84c9644a9$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e0bc27f84c9644a9$var$_default;

});
parcelRegister("549wv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $3b04b69908fae2bd$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $3b04b69908fae2bd$var$point;
function $3b04b69908fae2bd$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $3b04b69908fae2bd$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3b04b69908fae2bd$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $3b04b69908fae2bd$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $3b04b69908fae2bd$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3b04b69908fae2bd$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $3b04b69908fae2bd$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $3b04b69908fae2bd$var$_default;

});


parcelRegister("jEboo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $e4da9710b74b163e$var$CardinalOpen;
module.exports.default = void 0;

var $549wv = parcelRequire("549wv");
function $e4da9710b74b163e$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e4da9710b74b163e$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $549wv.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e4da9710b74b163e$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e4da9710b74b163e$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e4da9710b74b163e$var$_default;

});

parcelRegister("3TMeh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jig3N = parcelRequire("jig3N");

var $2d6beb7b130ed458$var$_noop = $2d6beb7b130ed458$var$_interopRequireDefault((parcelRequire("idkNk")));

var $k07ll = parcelRequire("k07ll");
function $2d6beb7b130ed458$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2d6beb7b130ed458$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$2d6beb7b130ed458$var$CatmullRomClosed.prototype = {
    areaStart: $2d6beb7b130ed458$var$_noop.default,
    areaEnd: $2d6beb7b130ed458$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $k07ll.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2d6beb7b130ed458$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $2d6beb7b130ed458$var$CatmullRomClosed(context, alpha) : new $jig3N.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $2d6beb7b130ed458$var$_default;

});
parcelRegister("k07ll", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $aT8ec = parcelRequire("aT8ec");

var $549wv = parcelRequire("549wv");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $aT8ec.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $aT8ec.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $549wv.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("6RzVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jEboo = parcelRequire("jEboo");

var $k07ll = parcelRequire("k07ll");
function $4ff390444b9704c9$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$4ff390444b9704c9$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $k07ll.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4ff390444b9704c9$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $4ff390444b9704c9$var$CatmullRomOpen(context, alpha) : new $jEboo.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $4ff390444b9704c9$var$_default;

});

parcelRegister("l3nao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f53bd9373f179dd6$var$_default;

var $f53bd9373f179dd6$var$_noop = $f53bd9373f179dd6$var$_interopRequireDefault((parcelRequire("idkNk")));
function $f53bd9373f179dd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f53bd9373f179dd6$var$LinearClosed(context) {
    this._context = context;
}
$f53bd9373f179dd6$var$LinearClosed.prototype = {
    areaStart: $f53bd9373f179dd6$var$_noop.default,
    areaEnd: $f53bd9373f179dd6$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $f53bd9373f179dd6$var$_default(context) {
    return new $f53bd9373f179dd6$var$LinearClosed(context);
}

});

parcelRegister("lGkDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $fc8d885d8a5d3403$var$monotoneX;
module.exports.monotoneY = $fc8d885d8a5d3403$var$monotoneY;
function $fc8d885d8a5d3403$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $fc8d885d8a5d3403$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($fc8d885d8a5d3403$var$sign(s0) + $fc8d885d8a5d3403$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $fc8d885d8a5d3403$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $fc8d885d8a5d3403$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $fc8d885d8a5d3403$var$MonotoneX(context) {
    this._context = context;
}
$fc8d885d8a5d3403$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $fc8d885d8a5d3403$var$point(this, this._t0, $fc8d885d8a5d3403$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $fc8d885d8a5d3403$var$point(this, $fc8d885d8a5d3403$var$slope2(this, t1 = $fc8d885d8a5d3403$var$slope3(this, x, y)), t1);
                break;
            default:
                $fc8d885d8a5d3403$var$point(this, this._t0, t1 = $fc8d885d8a5d3403$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $fc8d885d8a5d3403$var$MonotoneY(context) {
    this._context = new $fc8d885d8a5d3403$var$ReflectContext(context);
}
($fc8d885d8a5d3403$var$MonotoneY.prototype = Object.create($fc8d885d8a5d3403$var$MonotoneX.prototype)).point = function(x, y) {
    $fc8d885d8a5d3403$var$MonotoneX.prototype.point.call(this, y, x);
};
function $fc8d885d8a5d3403$var$ReflectContext(context) {
    this._context = context;
}
$fc8d885d8a5d3403$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $fc8d885d8a5d3403$var$monotoneX(context) {
    return new $fc8d885d8a5d3403$var$MonotoneX(context);
}
function $fc8d885d8a5d3403$var$monotoneY(context) {
    return new $fc8d885d8a5d3403$var$MonotoneY(context);
}

});

parcelRegister("7Mu4q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5aa457737897173d$var$_default;
function $5aa457737897173d$var$Natural(context) {
    this._context = context;
}
$5aa457737897173d$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $5aa457737897173d$var$controlPoints(x), py = $5aa457737897173d$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $5aa457737897173d$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $5aa457737897173d$var$_default(context) {
    return new $5aa457737897173d$var$Natural(context);
}

});

parcelRegister("i8ypb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d343a97ed06afd8f$var$_default;
module.exports.stepAfter = $d343a97ed06afd8f$var$stepAfter;
module.exports.stepBefore = $d343a97ed06afd8f$var$stepBefore;
function $d343a97ed06afd8f$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$d343a97ed06afd8f$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $d343a97ed06afd8f$var$_default(context) {
    return new $d343a97ed06afd8f$var$Step(context, 0.5);
}
function $d343a97ed06afd8f$var$stepBefore(context) {
    return new $d343a97ed06afd8f$var$Step(context, 0);
}
function $d343a97ed06afd8f$var$stepAfter(context) {
    return new $d343a97ed06afd8f$var$Step(context, 1);
}

});

parcelRegister("18aaC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d2e6d61c8bb04a3$var$_default;

var $0d2e6d61c8bb04a3$var$_array = $0d2e6d61c8bb04a3$var$_interopRequireDefault((parcelRequire("kiHzb")));

var $0d2e6d61c8bb04a3$var$_constant = $0d2e6d61c8bb04a3$var$_interopRequireDefault((parcelRequire("dMgfW")));

var $0d2e6d61c8bb04a3$var$_none = $0d2e6d61c8bb04a3$var$_interopRequireDefault((parcelRequire("iVvGb")));

var $0d2e6d61c8bb04a3$var$_none2 = $0d2e6d61c8bb04a3$var$_interopRequireDefault((parcelRequire("1pna7")));
function $0d2e6d61c8bb04a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d2e6d61c8bb04a3$var$stackValue(d, key) {
    return d[key];
}
function $0d2e6d61c8bb04a3$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $0d2e6d61c8bb04a3$var$_default() {
    var keys = (0, $0d2e6d61c8bb04a3$var$_constant.default)([]), order = $0d2e6d61c8bb04a3$var$_none2.default, offset = $0d2e6d61c8bb04a3$var$_none.default, value = $0d2e6d61c8bb04a3$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $0d2e6d61c8bb04a3$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $0d2e6d61c8bb04a3$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $0d2e6d61c8bb04a3$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $0d2e6d61c8bb04a3$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $0d2e6d61c8bb04a3$var$_none2.default : typeof _ === "function" ? _ : (0, $0d2e6d61c8bb04a3$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $0d2e6d61c8bb04a3$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("iVvGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc761fbf02d5d3d1$var$_default;
function $dc761fbf02d5d3d1$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("1pna7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $106a17cab3b7c4a9$var$_default;
function $106a17cab3b7c4a9$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("euYC1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8e2e257e11ab727$var$_default;

var $a8e2e257e11ab727$var$_none = $a8e2e257e11ab727$var$_interopRequireDefault((parcelRequire("iVvGb")));
function $a8e2e257e11ab727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8e2e257e11ab727$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $a8e2e257e11ab727$var$_none.default)(series, order);
}

});

parcelRegister("hlKUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca18caad7fc37ab1$var$_default;
function $ca18caad7fc37ab1$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("2ySjo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dd8e2efdbe108a4$var$_default;

var $1dd8e2efdbe108a4$var$_none = $1dd8e2efdbe108a4$var$_interopRequireDefault((parcelRequire("iVvGb")));
function $1dd8e2efdbe108a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1dd8e2efdbe108a4$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $1dd8e2efdbe108a4$var$_none.default)(series, order);
}

});

parcelRegister("3z7Mu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $298aad2461653f3f$var$_default;

var $298aad2461653f3f$var$_none = $298aad2461653f3f$var$_interopRequireDefault((parcelRequire("iVvGb")));
function $298aad2461653f3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $298aad2461653f3f$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $298aad2461653f3f$var$_none.default)(series, order);
}

});

parcelRegister("azk8s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b1ccabc7776e0ce$var$_default;

var $7b1ccabc7776e0ce$var$_none = $7b1ccabc7776e0ce$var$_interopRequireDefault((parcelRequire("1pna7")));
function $7b1ccabc7776e0ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7b1ccabc7776e0ce$var$_default(series) {
    var peaks = series.map($7b1ccabc7776e0ce$var$peak);
    return (0, $7b1ccabc7776e0ce$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $7b1ccabc7776e0ce$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("98J8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a77e0649b69ea84$var$_default;
module.exports.sum = $6a77e0649b69ea84$var$sum;

var $6a77e0649b69ea84$var$_none = $6a77e0649b69ea84$var$_interopRequireDefault((parcelRequire("1pna7")));
function $6a77e0649b69ea84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6a77e0649b69ea84$var$_default(series) {
    var sums = series.map($6a77e0649b69ea84$var$sum);
    return (0, $6a77e0649b69ea84$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $6a77e0649b69ea84$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("1IpYS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $13fe0dc0d1c95758$var$_default;

var $13fe0dc0d1c95758$var$_ascending = $13fe0dc0d1c95758$var$_interopRequireDefault((parcelRequire("98J8M")));
function $13fe0dc0d1c95758$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $13fe0dc0d1c95758$var$_default(series) {
    return (0, $13fe0dc0d1c95758$var$_ascending.default)(series).reverse();
}

});

parcelRegister("8miQT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $615f0076923f2aa2$var$_default;

var $615f0076923f2aa2$var$_appearance = $615f0076923f2aa2$var$_interopRequireDefault((parcelRequire("azk8s")));

var $98J8M = parcelRequire("98J8M");
function $615f0076923f2aa2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $615f0076923f2aa2$var$_default(series) {
    var n = series.length, i, j, sums = series.map($98J8M.sum), order = (0, $615f0076923f2aa2$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("gknjn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be3098cd7c801f50$var$_default;

var $be3098cd7c801f50$var$_none = $be3098cd7c801f50$var$_interopRequireDefault((parcelRequire("1pna7")));
function $be3098cd7c801f50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $be3098cd7c801f50$var$_default(series) {
    return (0, $be3098cd7c801f50$var$_none.default)(series).reverse();
}

});



parcelRegister("b38uU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $80b690ef7443cce4$var$PropTypes = $80b690ef7443cce4$var$_interopRequireWildcard((parcelRequire("ejhsZ")));

var $80b690ef7443cce4$var$_addClass = $80b690ef7443cce4$var$_interopRequireDefault((parcelRequire("kyKym")));

var $80b690ef7443cce4$var$_removeClass = $80b690ef7443cce4$var$_interopRequireDefault((parcelRequire("k2IOJ")));

var $80b690ef7443cce4$var$_react = $80b690ef7443cce4$var$_interopRequireDefault((parcelRequire("b7Z9x")));

var $80b690ef7443cce4$var$_Transition = $80b690ef7443cce4$var$_interopRequireDefault((parcelRequire("bPfYh")));

function $80b690ef7443cce4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80b690ef7443cce4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $80b690ef7443cce4$var$_extends() {
    $80b690ef7443cce4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $80b690ef7443cce4$var$_extends.apply(this, arguments);
}
function $80b690ef7443cce4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $80b690ef7443cce4$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $80b690ef7443cce4$var$_addClass.default)(node, c);
    });
};
var $80b690ef7443cce4$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $80b690ef7443cce4$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $80b690ef7443cce4$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $80b690ef7443cce4$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            $80b690ef7443cce4$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            $80b690ef7443cce4$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            $80b690ef7443cce4$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            $80b690ef7443cce4$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $80b690ef7443cce4$var$removeClass(node, className);
        activeClassName && $80b690ef7443cce4$var$removeClass(node, activeClassName);
        doneClassName && $80b690ef7443cce4$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $80b690ef7443cce4$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $80b690ef7443cce4$var$_extends({}, this.props);
        delete props.classNames;
        return $80b690ef7443cce4$var$_react.default.createElement($80b690ef7443cce4$var$_Transition.default, $80b690ef7443cce4$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($80b690ef7443cce4$var$_react.default.Component);
$80b690ef7443cce4$var$CSSTransition.defaultProps = {
    classNames: ''
};
$80b690ef7443cce4$var$CSSTransition.propTypes = {};
var $80b690ef7443cce4$var$_default = $80b690ef7443cce4$var$CSSTransition;
module.exports.default = $80b690ef7443cce4$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("kyKym", function(module, exports) {
"use strict";

var $5SYyw = parcelRequire("5SYyw");
module.exports.__esModule = true;
module.exports.default = $ef7b1819b69515f0$var$addClass;

var $ef7b1819b69515f0$var$_hasClass = $5SYyw((parcelRequire("lLZhT")));
function $ef7b1819b69515f0$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $ef7b1819b69515f0$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("5SYyw", function(module, exports) {
function $4490f8057da20f5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $4490f8057da20f5b$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lLZhT", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $fd9d873299a7e225$var$hasClass;
function $fd9d873299a7e225$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("k2IOJ", function(module, exports) {
'use strict';
function $e976c24ddb87a644$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $e976c24ddb87a644$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $e976c24ddb87a644$var$replaceClassName(element.className && element.className.baseVal || '', className));
};

});

parcelRegister("bPfYh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $89c0d8b3ab9cdd18$export$1e511d4a378977f5; }, function (v) { return $89c0d8b3ab9cdd18$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $89c0d8b3ab9cdd18$export$2e2bcd8739ae039; }, function (v) { return $89c0d8b3ab9cdd18$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $89c0d8b3ab9cdd18$export$4aacc83d4d59139f; }, function (v) { return $89c0d8b3ab9cdd18$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $89c0d8b3ab9cdd18$export$78e9e6e3e014d60a; }, function (v) { return $89c0d8b3ab9cdd18$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $89c0d8b3ab9cdd18$export$df38205c966be359; }, function (v) { return $89c0d8b3ab9cdd18$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $89c0d8b3ab9cdd18$export$84cbff306f539230; }, function (v) { return $89c0d8b3ab9cdd18$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $89c0d8b3ab9cdd18$export$bb38bb9a1161268; }, function (v) { return $89c0d8b3ab9cdd18$export$bb38bb9a1161268 = v; });
var $89c0d8b3ab9cdd18$export$1e511d4a378977f5;
var $89c0d8b3ab9cdd18$export$2e2bcd8739ae039;
var $89c0d8b3ab9cdd18$export$4aacc83d4d59139f;
var $89c0d8b3ab9cdd18$export$78e9e6e3e014d60a;
var $89c0d8b3ab9cdd18$export$df38205c966be359;
var $89c0d8b3ab9cdd18$export$84cbff306f539230;
var $89c0d8b3ab9cdd18$export$bb38bb9a1161268;
"use strict";
$89c0d8b3ab9cdd18$export$1e511d4a378977f5 = true;
$89c0d8b3ab9cdd18$export$2e2bcd8739ae039 = $89c0d8b3ab9cdd18$export$4aacc83d4d59139f = $89c0d8b3ab9cdd18$export$78e9e6e3e014d60a = $89c0d8b3ab9cdd18$export$df38205c966be359 = $89c0d8b3ab9cdd18$export$84cbff306f539230 = $89c0d8b3ab9cdd18$export$bb38bb9a1161268 = void 0;

var $89c0d8b3ab9cdd18$var$PropTypes = $89c0d8b3ab9cdd18$var$_interopRequireWildcard((parcelRequire("ejhsZ")));

var $89c0d8b3ab9cdd18$var$_react = $89c0d8b3ab9cdd18$var$_interopRequireDefault((parcelRequire("b7Z9x")));

var $89c0d8b3ab9cdd18$var$_reactDom = $89c0d8b3ab9cdd18$var$_interopRequireDefault((parcelRequire("a2nZt")));

var $fxUgr = parcelRequire("fxUgr");

function $89c0d8b3ab9cdd18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89c0d8b3ab9cdd18$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $89c0d8b3ab9cdd18$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $89c0d8b3ab9cdd18$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $89c0d8b3ab9cdd18$var$UNMOUNTED = 'unmounted';
$89c0d8b3ab9cdd18$export$bb38bb9a1161268 = $89c0d8b3ab9cdd18$var$UNMOUNTED;
var $89c0d8b3ab9cdd18$var$EXITED = 'exited';
$89c0d8b3ab9cdd18$export$84cbff306f539230 = $89c0d8b3ab9cdd18$var$EXITED;
var $89c0d8b3ab9cdd18$var$ENTERING = 'entering';
$89c0d8b3ab9cdd18$export$df38205c966be359 = $89c0d8b3ab9cdd18$var$ENTERING;
var $89c0d8b3ab9cdd18$var$ENTERED = 'entered';
$89c0d8b3ab9cdd18$export$78e9e6e3e014d60a = $89c0d8b3ab9cdd18$var$ENTERED;
var $89c0d8b3ab9cdd18$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $89c0d8b3ab9cdd18$export$4aacc83d4d59139f = $89c0d8b3ab9cdd18$var$EXITING;
var $89c0d8b3ab9cdd18$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $89c0d8b3ab9cdd18$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $89c0d8b3ab9cdd18$var$EXITED;
                _this.appearStatus = $89c0d8b3ab9cdd18$var$ENTERING;
            } else initialStatus = $89c0d8b3ab9cdd18$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $89c0d8b3ab9cdd18$var$UNMOUNTED;
        else initialStatus = $89c0d8b3ab9cdd18$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $89c0d8b3ab9cdd18$var$UNMOUNTED) return {
            status: $89c0d8b3ab9cdd18$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $89c0d8b3ab9cdd18$var$ENTERING && status !== $89c0d8b3ab9cdd18$var$ENTERED) nextStatus = $89c0d8b3ab9cdd18$var$ENTERING;
            } else if (status === $89c0d8b3ab9cdd18$var$ENTERING || status === $89c0d8b3ab9cdd18$var$ENTERED) nextStatus = $89c0d8b3ab9cdd18$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $89c0d8b3ab9cdd18$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $89c0d8b3ab9cdd18$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $89c0d8b3ab9cdd18$var$EXITED) this.setState({
            status: $89c0d8b3ab9cdd18$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $89c0d8b3ab9cdd18$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $89c0d8b3ab9cdd18$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $89c0d8b3ab9cdd18$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $89c0d8b3ab9cdd18$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $89c0d8b3ab9cdd18$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $89c0d8b3ab9cdd18$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $89c0d8b3ab9cdd18$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $89c0d8b3ab9cdd18$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $89c0d8b3ab9cdd18$var$_react.default.Children.only(children);
        return $89c0d8b3ab9cdd18$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($89c0d8b3ab9cdd18$var$_react.default.Component);
$89c0d8b3ab9cdd18$var$Transition.contextTypes = {
    transitionGroup: $89c0d8b3ab9cdd18$var$PropTypes.object
};
$89c0d8b3ab9cdd18$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$89c0d8b3ab9cdd18$var$Transition.propTypes = {};
function $89c0d8b3ab9cdd18$var$noop() {}
$89c0d8b3ab9cdd18$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $89c0d8b3ab9cdd18$var$noop,
    onEntering: $89c0d8b3ab9cdd18$var$noop,
    onEntered: $89c0d8b3ab9cdd18$var$noop,
    onExit: $89c0d8b3ab9cdd18$var$noop,
    onExiting: $89c0d8b3ab9cdd18$var$noop,
    onExited: $89c0d8b3ab9cdd18$var$noop
};
$89c0d8b3ab9cdd18$var$Transition.UNMOUNTED = 0;
$89c0d8b3ab9cdd18$var$Transition.EXITED = 1;
$89c0d8b3ab9cdd18$var$Transition.ENTERING = 2;
$89c0d8b3ab9cdd18$var$Transition.ENTERED = 3;
$89c0d8b3ab9cdd18$var$Transition.EXITING = 4;
var $89c0d8b3ab9cdd18$var$_default = (0, $fxUgr.polyfill)($89c0d8b3ab9cdd18$var$Transition);
$89c0d8b3ab9cdd18$export$2e2bcd8739ae039 = $89c0d8b3ab9cdd18$var$_default;

});
parcelRegister("fxUgr", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $b51594fa06674e95$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $b51594fa06674e95$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $b51594fa06674e95$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $b51594fa06674e95$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$b51594fa06674e95$var$componentWillMount.__suppressDeprecationWarning = true;
$b51594fa06674e95$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$b51594fa06674e95$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $b51594fa06674e95$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $b51594fa06674e95$var$componentWillMount;
        prototype.componentWillReceiveProps = $b51594fa06674e95$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $b51594fa06674e95$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("c3wW1", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $8c6f4fff044919db$var$_propTypes = $8c6f4fff044919db$var$_interopRequireDefault((parcelRequire("ejhsZ")));

var $8c6f4fff044919db$var$_react = $8c6f4fff044919db$var$_interopRequireDefault((parcelRequire("b7Z9x")));

var $a2nZt = parcelRequire("a2nZt");

var $8c6f4fff044919db$var$_TransitionGroup = $8c6f4fff044919db$var$_interopRequireDefault((parcelRequire("eqPBe")));
function $8c6f4fff044919db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c6f4fff044919db$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8c6f4fff044919db$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $8c6f4fff044919db$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $8c6f4fff044919db$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $8c6f4fff044919db$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $a2nZt.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $8c6f4fff044919db$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $8c6f4fff044919db$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $8c6f4fff044919db$var$_react.default.createElement($8c6f4fff044919db$var$_TransitionGroup.default, props, inProp ? $8c6f4fff044919db$var$_react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $8c6f4fff044919db$var$_react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($8c6f4fff044919db$var$_react.default.Component);
$8c6f4fff044919db$var$ReplaceTransition.propTypes = {};
var $8c6f4fff044919db$var$_default = $8c6f4fff044919db$var$ReplaceTransition;
module.exports.default = $8c6f4fff044919db$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("eqPBe", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $a81b84fdcf546645$var$_propTypes = $a81b84fdcf546645$var$_interopRequireDefault((parcelRequire("ejhsZ")));

var $a81b84fdcf546645$var$_react = $a81b84fdcf546645$var$_interopRequireDefault((parcelRequire("b7Z9x")));

var $fxUgr = parcelRequire("fxUgr");

var $5laGj = parcelRequire("5laGj");
function $a81b84fdcf546645$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a81b84fdcf546645$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a81b84fdcf546645$var$_extends() {
    $a81b84fdcf546645$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a81b84fdcf546645$var$_extends.apply(this, arguments);
}
function $a81b84fdcf546645$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $a81b84fdcf546645$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $a81b84fdcf546645$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $a81b84fdcf546645$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var $a81b84fdcf546645$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $a81b84fdcf546645$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($a81b84fdcf546645$var$_assertThisInitialized($a81b84fdcf546645$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $5laGj.getInitialChildMapping)(nextProps, handleExited) : (0, $5laGj.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $5laGj.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $a81b84fdcf546645$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $a81b84fdcf546645$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $a81b84fdcf546645$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $a81b84fdcf546645$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($a81b84fdcf546645$var$_react.default.Component);
$a81b84fdcf546645$var$TransitionGroup.childContextTypes = {
    transitionGroup: $a81b84fdcf546645$var$_propTypes.default.object.isRequired
};
$a81b84fdcf546645$var$TransitionGroup.propTypes = {};
$a81b84fdcf546645$var$TransitionGroup.defaultProps = $a81b84fdcf546645$var$defaultProps;
var $a81b84fdcf546645$var$_default = (0, $fxUgr.polyfill)($a81b84fdcf546645$var$TransitionGroup);
module.exports.default = $a81b84fdcf546645$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("5laGj", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $3e3733025bc77442$export$bbc8a025727ea824; }, function (v) { return $3e3733025bc77442$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $3e3733025bc77442$export$fa71e2345c31d7a2; }, function (v) { return $3e3733025bc77442$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $3e3733025bc77442$export$36fd1af28d383ec0; }, function (v) { return $3e3733025bc77442$export$36fd1af28d383ec0 = v; });
var $3e3733025bc77442$export$1e511d4a378977f5;
var $3e3733025bc77442$export$bbc8a025727ea824;
var $3e3733025bc77442$export$7a874f95ccf533dd;
var $3e3733025bc77442$export$fa71e2345c31d7a2;
var $3e3733025bc77442$export$36fd1af28d383ec0;
"use strict";
$3e3733025bc77442$export$1e511d4a378977f5 = true;
$3e3733025bc77442$export$bbc8a025727ea824 = $3e3733025bc77442$var$getChildMapping;
$3e3733025bc77442$export$7a874f95ccf533dd = $3e3733025bc77442$var$mergeChildMappings;
$3e3733025bc77442$export$fa71e2345c31d7a2 = $3e3733025bc77442$var$getInitialChildMapping;
$3e3733025bc77442$export$36fd1af28d383ec0 = $3e3733025bc77442$var$getNextChildMapping;

var $b7Z9x = parcelRequire("b7Z9x");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $3e3733025bc77442$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $b7Z9x.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $b7Z9x.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $3e3733025bc77442$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $3e3733025bc77442$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $3e3733025bc77442$var$getInitialChildMapping(props, onExited) {
    return $3e3733025bc77442$var$getChildMapping(props.children, function(child) {
        return (0, $b7Z9x.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $3e3733025bc77442$var$getProp(child, 'appear', props),
            enter: $3e3733025bc77442$var$getProp(child, 'enter', props),
            exit: $3e3733025bc77442$var$getProp(child, 'exit', props)
        });
    });
}
function $3e3733025bc77442$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $3e3733025bc77442$var$getChildMapping(nextProps.children);
    var children = $3e3733025bc77442$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $b7Z9x.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $b7Z9x.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $b7Z9x.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $3e3733025bc77442$var$getProp(child, 'exit', nextProps),
            enter: $3e3733025bc77442$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $b7Z9x.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $b7Z9x.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $b7Z9x.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $3e3733025bc77442$var$getProp(child, 'exit', nextProps),
            enter: $3e3733025bc77442$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});



parcelRegister("7kayC", function(module, exports) {
var $5552972408b0cb04$var$minus = "-".charCodeAt(0);
var $5552972408b0cb04$var$plus = "+".charCodeAt(0);
var $5552972408b0cb04$var$dot = ".".charCodeAt(0);
var $5552972408b0cb04$var$exp = "e".charCodeAt(0);
var $5552972408b0cb04$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $5552972408b0cb04$var$exp || code === $5552972408b0cb04$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $5552972408b0cb04$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $5552972408b0cb04$var$plus || code === $5552972408b0cb04$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRegister("fH8Mx", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("9gI5y"));

});
parcelRegister("9gI5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $6bf7cebd446ea492$var$_tickFormat.default;
    }
});

var $6bf7cebd446ea492$var$_band = $6bf7cebd446ea492$var$_interopRequireWildcard((parcelRequire("gf860")));

var $6bf7cebd446ea492$var$_identity = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("55lHa")));

var $6bf7cebd446ea492$var$_linear = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("lhUfg")));

var $6bf7cebd446ea492$var$_log = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("54ETL")));

var $6bf7cebd446ea492$var$_symlog = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("2xdrB")));

var $6bf7cebd446ea492$var$_ordinal = $6bf7cebd446ea492$var$_interopRequireWildcard((parcelRequire("3vvtT")));

var $6bf7cebd446ea492$var$_pow = $6bf7cebd446ea492$var$_interopRequireWildcard((parcelRequire("gnzjo")));

var $6bf7cebd446ea492$var$_radial = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("11nyh")));

var $6bf7cebd446ea492$var$_quantile = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("1ktCZ")));

var $6bf7cebd446ea492$var$_quantize = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("4BvTs")));

var $6bf7cebd446ea492$var$_threshold = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("c2tKO")));

var $6bf7cebd446ea492$var$_time = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("awB3R")));

var $6bf7cebd446ea492$var$_utcTime = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("dW5nm")));

var $6bf7cebd446ea492$var$_sequential = $6bf7cebd446ea492$var$_interopRequireWildcard((parcelRequire("22usg")));

var $6bf7cebd446ea492$var$_sequentialQuantile = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("gvK97")));

var $6bf7cebd446ea492$var$_diverging = $6bf7cebd446ea492$var$_interopRequireWildcard((parcelRequire("jAxLn")));

var $6bf7cebd446ea492$var$_tickFormat = $6bf7cebd446ea492$var$_interopRequireDefault((parcelRequire("3av0p")));
function $6bf7cebd446ea492$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6bf7cebd446ea492$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6bf7cebd446ea492$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6bf7cebd446ea492$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6bf7cebd446ea492$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("gf860", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd3453b763879d5b$var$band;
module.exports.point = $bd3453b763879d5b$var$point;

var $aPhjF = parcelRequire("aPhjF");

var $3cC0P = parcelRequire("3cC0P");

var $bd3453b763879d5b$var$_ordinal = $bd3453b763879d5b$var$_interopRequireDefault((parcelRequire("3vvtT")));
function $bd3453b763879d5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd3453b763879d5b$var$band() {
    var scale = (0, $bd3453b763879d5b$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $aPhjF.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $bd3453b763879d5b$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $3cC0P.initRange.apply(rescale(), arguments);
}
function $bd3453b763879d5b$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $bd3453b763879d5b$var$pointish(copy());
    };
    return scale;
}
function $bd3453b763879d5b$var$point() {
    return $bd3453b763879d5b$var$pointish($bd3453b763879d5b$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("aPhjF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $i6tfG.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $eTtHt.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $eTtHt.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $i6tfG.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $i6tfG.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $7e1c1976be3b8b39$var$_zip.default;
    }
});

var $7e1c1976be3b8b39$var$_bisect = $7e1c1976be3b8b39$var$_interopRequireWildcard((parcelRequire("7cY40")));

var $7e1c1976be3b8b39$var$_ascending = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $7e1c1976be3b8b39$var$_bisector = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("6CJZn")));

var $7e1c1976be3b8b39$var$_count = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("fDBzn")));

var $7e1c1976be3b8b39$var$_cross = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("4i4CA")));

var $7e1c1976be3b8b39$var$_cumsum = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("gb0ww")));

var $7e1c1976be3b8b39$var$_descending = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("cCLHL")));

var $7e1c1976be3b8b39$var$_deviation = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("9IRwE")));

var $7e1c1976be3b8b39$var$_extent = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("jEF0d")));

var $i6tfG = parcelRequire("i6tfG");

var $7e1c1976be3b8b39$var$_group = $7e1c1976be3b8b39$var$_interopRequireWildcard((parcelRequire("d2z9e")));

var $7e1c1976be3b8b39$var$_groupSort = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("75rFb")));

var $7e1c1976be3b8b39$var$_bin = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("ckoG9")));

var $7e1c1976be3b8b39$var$_freedmanDiaconis = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("1fMZf")));

var $7e1c1976be3b8b39$var$_scott = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("8Uoxq")));

var $7e1c1976be3b8b39$var$_sturges = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("6WZsB")));

var $7e1c1976be3b8b39$var$_max = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("7RyvL")));

var $7e1c1976be3b8b39$var$_maxIndex = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("fNpn0")));

var $7e1c1976be3b8b39$var$_mean = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("c1eEJ")));

var $7e1c1976be3b8b39$var$_median = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("esxwo")));

var $7e1c1976be3b8b39$var$_merge = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("emEKV")));

var $7e1c1976be3b8b39$var$_min = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("WVuoa")));

var $7e1c1976be3b8b39$var$_minIndex = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("6J9B9")));

var $7e1c1976be3b8b39$var$_mode = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("1fqBK")));

var $7e1c1976be3b8b39$var$_nice = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("7Hz7r")));

var $7e1c1976be3b8b39$var$_pairs = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("awuUH")));

var $7e1c1976be3b8b39$var$_permute = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("EGzq6")));

var $7e1c1976be3b8b39$var$_quantile = $7e1c1976be3b8b39$var$_interopRequireWildcard((parcelRequire("7ctZR")));

var $7e1c1976be3b8b39$var$_quickselect = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("b7JMz")));

var $7e1c1976be3b8b39$var$_range = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("b91Ya")));

var $7e1c1976be3b8b39$var$_rank = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("btAme")));

var $7e1c1976be3b8b39$var$_least = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("jwG1k")));

var $7e1c1976be3b8b39$var$_leastIndex = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("6uxaa")));

var $7e1c1976be3b8b39$var$_greatest = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("4at99")));

var $7e1c1976be3b8b39$var$_greatestIndex = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("2nV49")));

var $7e1c1976be3b8b39$var$_scan = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("2rg6u")));

var $7e1c1976be3b8b39$var$_shuffle = $7e1c1976be3b8b39$var$_interopRequireWildcard((parcelRequire("bFvzK")));

var $7e1c1976be3b8b39$var$_sum = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("bBw2H")));

var $7e1c1976be3b8b39$var$_ticks = $7e1c1976be3b8b39$var$_interopRequireWildcard((parcelRequire("3Ojow")));

var $7e1c1976be3b8b39$var$_transpose = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("8QMi4")));

var $7e1c1976be3b8b39$var$_variance = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("eShik")));

var $7e1c1976be3b8b39$var$_zip = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("60HNW")));

var $7e1c1976be3b8b39$var$_every = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("lrMCj")));

var $7e1c1976be3b8b39$var$_some = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("bcmDY")));

var $7e1c1976be3b8b39$var$_filter = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("jXTUT")));

var $7e1c1976be3b8b39$var$_map = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("j3aWU")));

var $7e1c1976be3b8b39$var$_reduce = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("bhA3W")));

var $7e1c1976be3b8b39$var$_reverse = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("fthdK")));

var $7e1c1976be3b8b39$var$_sort = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("2XvUc")));

var $7e1c1976be3b8b39$var$_difference = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("7cdEq")));

var $7e1c1976be3b8b39$var$_disjoint = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("6JtUG")));

var $7e1c1976be3b8b39$var$_intersection = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("hwnG8")));

var $7e1c1976be3b8b39$var$_subset = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("bxu61")));

var $7e1c1976be3b8b39$var$_superset = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("8TFwa")));

var $7e1c1976be3b8b39$var$_union = $7e1c1976be3b8b39$var$_interopRequireDefault((parcelRequire("jyzgO")));

var $eTtHt = parcelRequire("eTtHt");
function $7e1c1976be3b8b39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e1c1976be3b8b39$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7e1c1976be3b8b39$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7e1c1976be3b8b39$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7e1c1976be3b8b39$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7cY40", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $53f83ecc98b8aa08$var$_ascending = $53f83ecc98b8aa08$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $53f83ecc98b8aa08$var$_bisector = $53f83ecc98b8aa08$var$_interopRequireDefault((parcelRequire("6CJZn")));

var $53f83ecc98b8aa08$var$_number = $53f83ecc98b8aa08$var$_interopRequireDefault((parcelRequire("dwNlJ")));
function $53f83ecc98b8aa08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $53f83ecc98b8aa08$var$ascendingBisect = (0, $53f83ecc98b8aa08$var$_bisector.default)($53f83ecc98b8aa08$var$_ascending.default);
const $53f83ecc98b8aa08$var$bisectRight = $53f83ecc98b8aa08$var$ascendingBisect.right;
module.exports.bisectRight = $53f83ecc98b8aa08$var$bisectRight;
const $53f83ecc98b8aa08$var$bisectLeft = $53f83ecc98b8aa08$var$ascendingBisect.left;
module.exports.bisectLeft = $53f83ecc98b8aa08$var$bisectLeft;
const $53f83ecc98b8aa08$var$bisectCenter = (0, $53f83ecc98b8aa08$var$_bisector.default)($53f83ecc98b8aa08$var$_number.default).center;
module.exports.bisectCenter = $53f83ecc98b8aa08$var$bisectCenter;
var $53f83ecc98b8aa08$var$_default = $53f83ecc98b8aa08$var$bisectRight;
module.exports.default = $53f83ecc98b8aa08$var$_default;

});
parcelRegister("ffLGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1ad3e5606a6b7db$var$ascending;
function $b1ad3e5606a6b7db$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("6CJZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d29f728738e28cf$var$bisector;

var $4d29f728738e28cf$var$_ascending = $4d29f728738e28cf$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $4d29f728738e28cf$var$_descending = $4d29f728738e28cf$var$_interopRequireDefault((parcelRequire("cCLHL")));
function $4d29f728738e28cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d29f728738e28cf$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $4d29f728738e28cf$var$_ascending.default;
        compare2 = (d, x)=>(0, $4d29f728738e28cf$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $4d29f728738e28cf$var$_ascending.default || f === $4d29f728738e28cf$var$_descending.default ? f : $4d29f728738e28cf$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $4d29f728738e28cf$var$zero() {
    return 0;
}

});
parcelRegister("cCLHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $930e09dc75480a2d$var$descending;
function $930e09dc75480a2d$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("dwNlJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d948b4d6fb9f65a$var$number;
module.exports.numbers = $9d948b4d6fb9f65a$var$numbers;
function $9d948b4d6fb9f65a$var$number(x) {
    return x === null ? NaN : +x;
}
function* $9d948b4d6fb9f65a$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("fDBzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b627a40e817bf7a8$var$count;
function $b627a40e817bf7a8$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("4i4CA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31fc6d8dd58f4159$var$cross;
function $31fc6d8dd58f4159$var$length(array) {
    return array.length | 0;
}
function $31fc6d8dd58f4159$var$empty(length) {
    return !(length > 0);
}
function $31fc6d8dd58f4159$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $31fc6d8dd58f4159$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $31fc6d8dd58f4159$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $31fc6d8dd58f4159$var$reducer(values.pop());
    values = values.map($31fc6d8dd58f4159$var$arrayify);
    const lengths = values.map($31fc6d8dd58f4159$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($31fc6d8dd58f4159$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("gb0ww", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc6e146544f7f309$var$cumsum;
function $bc6e146544f7f309$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("9IRwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7141be2cb2f31e29$var$deviation;

var $7141be2cb2f31e29$var$_variance = $7141be2cb2f31e29$var$_interopRequireDefault((parcelRequire("eShik")));
function $7141be2cb2f31e29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7141be2cb2f31e29$var$deviation(values, valueof) {
    const v = (0, $7141be2cb2f31e29$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("eShik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad43862ae1a722d7$var$variance;
function $ad43862ae1a722d7$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("jEF0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4f18efb10ed7eeb$var$extent;
function $e4f18efb10ed7eeb$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("i6tfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $d2df7a5c8aad799a$var$fcumsum;
module.exports.fsum = $d2df7a5c8aad799a$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $d2df7a5c8aad799a$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $d2df7a5c8aad799a$var$Adder;
function $d2df7a5c8aad799a$var$fsum(values, valueof) {
    const adder = new $d2df7a5c8aad799a$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $d2df7a5c8aad799a$var$fcumsum(values, valueof) {
    const adder = new $d2df7a5c8aad799a$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("d2z9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97e6b9e1dca72de4$var$group;
module.exports.flatGroup = $97e6b9e1dca72de4$var$flatGroup;
module.exports.flatRollup = $97e6b9e1dca72de4$var$flatRollup;
module.exports.groups = $97e6b9e1dca72de4$var$groups;
module.exports.index = $97e6b9e1dca72de4$var$index;
module.exports.indexes = $97e6b9e1dca72de4$var$indexes;
module.exports.rollup = $97e6b9e1dca72de4$var$rollup;
module.exports.rollups = $97e6b9e1dca72de4$var$rollups;

var $eTtHt = parcelRequire("eTtHt");

var $97e6b9e1dca72de4$var$_identity = $97e6b9e1dca72de4$var$_interopRequireDefault((parcelRequire("hBH4f")));
function $97e6b9e1dca72de4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97e6b9e1dca72de4$var$group(values, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, $97e6b9e1dca72de4$var$_identity.default, $97e6b9e1dca72de4$var$_identity.default, keys);
}
function $97e6b9e1dca72de4$var$groups(values, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, Array.from, $97e6b9e1dca72de4$var$_identity.default, keys);
}
function $97e6b9e1dca72de4$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $97e6b9e1dca72de4$var$flatGroup(values, ...keys) {
    return $97e6b9e1dca72de4$var$flatten($97e6b9e1dca72de4$var$groups(values, ...keys), keys);
}
function $97e6b9e1dca72de4$var$flatRollup(values, reduce, ...keys) {
    return $97e6b9e1dca72de4$var$flatten($97e6b9e1dca72de4$var$rollups(values, reduce, ...keys), keys);
}
function $97e6b9e1dca72de4$var$rollup(values, reduce, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, $97e6b9e1dca72de4$var$_identity.default, reduce, keys);
}
function $97e6b9e1dca72de4$var$rollups(values, reduce, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, Array.from, reduce, keys);
}
function $97e6b9e1dca72de4$var$index(values, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, $97e6b9e1dca72de4$var$_identity.default, $97e6b9e1dca72de4$var$unique, keys);
}
function $97e6b9e1dca72de4$var$indexes(values, ...keys) {
    return $97e6b9e1dca72de4$var$nest(values, Array.from, $97e6b9e1dca72de4$var$unique, keys);
}
function $97e6b9e1dca72de4$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $97e6b9e1dca72de4$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $eTtHt.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("eTtHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $ad7d3d9964279f3f$var$InternMap extends Map {
    constructor(entries, key = $ad7d3d9964279f3f$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($ad7d3d9964279f3f$var$intern_get(this, key));
    }
    has(key) {
        return super.has($ad7d3d9964279f3f$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($ad7d3d9964279f3f$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($ad7d3d9964279f3f$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $ad7d3d9964279f3f$var$InternMap;
class $ad7d3d9964279f3f$var$InternSet extends Set {
    constructor(values, key = $ad7d3d9964279f3f$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($ad7d3d9964279f3f$var$intern_get(this, value));
    }
    add(value) {
        return super.add($ad7d3d9964279f3f$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($ad7d3d9964279f3f$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $ad7d3d9964279f3f$var$InternSet;
function $ad7d3d9964279f3f$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $ad7d3d9964279f3f$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $ad7d3d9964279f3f$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $ad7d3d9964279f3f$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("hBH4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd174ca8fb943e4d$var$identity;
function $cd174ca8fb943e4d$var$identity(x) {
    return x;
}

});


parcelRegister("75rFb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $528e755d4a9d8ac3$var$groupSort;

var $528e755d4a9d8ac3$var$_ascending = $528e755d4a9d8ac3$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $528e755d4a9d8ac3$var$_group = $528e755d4a9d8ac3$var$_interopRequireWildcard((parcelRequire("d2z9e")));

var $528e755d4a9d8ac3$var$_sort = $528e755d4a9d8ac3$var$_interopRequireDefault((parcelRequire("2XvUc")));
function $528e755d4a9d8ac3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($528e755d4a9d8ac3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $528e755d4a9d8ac3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $528e755d4a9d8ac3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $528e755d4a9d8ac3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $528e755d4a9d8ac3$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $528e755d4a9d8ac3$var$_sort.default)((0, $528e755d4a9d8ac3$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $528e755d4a9d8ac3$var$_ascending.default)(av, bv) || (0, $528e755d4a9d8ac3$var$_ascending.default)(ak, bk)) : (0, $528e755d4a9d8ac3$var$_sort.default)((0, $528e755d4a9d8ac3$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $528e755d4a9d8ac3$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("2XvUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $2279d73b67e546f4$var$ascendingDefined;
module.exports.compareDefined = $2279d73b67e546f4$var$compareDefined;
module.exports.default = $2279d73b67e546f4$var$sort;

var $2279d73b67e546f4$var$_ascending = $2279d73b67e546f4$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $2279d73b67e546f4$var$_permute = $2279d73b67e546f4$var$_interopRequireDefault((parcelRequire("EGzq6")));
function $2279d73b67e546f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2279d73b67e546f4$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $2279d73b67e546f4$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$2279d73b67e546f4$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $2279d73b67e546f4$var$_permute.default)(values, index);
    }
    return values.sort($2279d73b67e546f4$var$compareDefined(f));
}
function $2279d73b67e546f4$var$compareDefined(compare = $2279d73b67e546f4$var$_ascending.default) {
    if (compare === $2279d73b67e546f4$var$_ascending.default) return $2279d73b67e546f4$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $2279d73b67e546f4$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("EGzq6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07a4c21d3ea22050$var$permute;
function $07a4c21d3ea22050$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("ckoG9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f9a7f00f2ac4594$var$bin;

var $bLPon = parcelRequire("bLPon");

var $8f9a7f00f2ac4594$var$_bisect = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("7cY40")));

var $8f9a7f00f2ac4594$var$_constant = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("a5HbB")));

var $8f9a7f00f2ac4594$var$_extent = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("jEF0d")));

var $8f9a7f00f2ac4594$var$_identity = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("hBH4f")));

var $8f9a7f00f2ac4594$var$_nice = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("7Hz7r")));

var $8f9a7f00f2ac4594$var$_ticks = $8f9a7f00f2ac4594$var$_interopRequireWildcard((parcelRequire("3Ojow")));

var $8f9a7f00f2ac4594$var$_sturges = $8f9a7f00f2ac4594$var$_interopRequireDefault((parcelRequire("6WZsB")));
function $8f9a7f00f2ac4594$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8f9a7f00f2ac4594$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8f9a7f00f2ac4594$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8f9a7f00f2ac4594$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8f9a7f00f2ac4594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f9a7f00f2ac4594$var$bin() {
    var value = $8f9a7f00f2ac4594$var$_identity.default, domain = $8f9a7f00f2ac4594$var$_extent.default, threshold = $8f9a7f00f2ac4594$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $8f9a7f00f2ac4594$var$_extent.default) [x0, x1] = (0, $8f9a7f00f2ac4594$var$_nice.default)(x0, x1, tn);
            tz = (0, $8f9a7f00f2ac4594$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $8f9a7f00f2ac4594$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $8f9a7f00f2ac4594$var$_extent.default) {
                    const step = (0, $8f9a7f00f2ac4594$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $8f9a7f00f2ac4594$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $8f9a7f00f2ac4594$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $8f9a7f00f2ac4594$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $8f9a7f00f2ac4594$var$_constant.default)($bLPon.slice.call(_)) : (0, $8f9a7f00f2ac4594$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("bLPon", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $891bf2ead0e46b53$var$array = Array.prototype;
var $891bf2ead0e46b53$var$slice = $891bf2ead0e46b53$var$array.slice;
module.exports.slice = $891bf2ead0e46b53$var$slice;
var $891bf2ead0e46b53$var$map = $891bf2ead0e46b53$var$array.map;
module.exports.map = $891bf2ead0e46b53$var$map;

});

parcelRegister("a5HbB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $758bdee374875e3e$var$constant;
function $758bdee374875e3e$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("7Hz7r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59b7ca7c84434fe2$var$nice;

var $3Ojow = parcelRequire("3Ojow");
function $59b7ca7c84434fe2$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $3Ojow.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("3Ojow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c6515f438b4012f$var$ticks;
module.exports.tickIncrement = $2c6515f438b4012f$var$tickIncrement;
module.exports.tickStep = $2c6515f438b4012f$var$tickStep;
var $2c6515f438b4012f$var$e10 = Math.sqrt(50), $2c6515f438b4012f$var$e5 = Math.sqrt(10), $2c6515f438b4012f$var$e2 = Math.sqrt(2);
function $2c6515f438b4012f$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $2c6515f438b4012f$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $2c6515f438b4012f$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $2c6515f438b4012f$var$e10 ? 10 : error >= $2c6515f438b4012f$var$e5 ? 5 : error >= $2c6515f438b4012f$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $2c6515f438b4012f$var$e10 ? 10 : error >= $2c6515f438b4012f$var$e5 ? 5 : error >= $2c6515f438b4012f$var$e2 ? 2 : 1);
}
function $2c6515f438b4012f$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $2c6515f438b4012f$var$e10) step1 *= 10;
    else if (error >= $2c6515f438b4012f$var$e5) step1 *= 5;
    else if (error >= $2c6515f438b4012f$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("6WZsB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50f7d59ac0317e9b$var$thresholdSturges;

var $50f7d59ac0317e9b$var$_count = $50f7d59ac0317e9b$var$_interopRequireDefault((parcelRequire("fDBzn")));
function $50f7d59ac0317e9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $50f7d59ac0317e9b$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $50f7d59ac0317e9b$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("1fMZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e9d30f0dcbf7427$var$thresholdFreedmanDiaconis;

var $0e9d30f0dcbf7427$var$_count = $0e9d30f0dcbf7427$var$_interopRequireDefault((parcelRequire("fDBzn")));

var $0e9d30f0dcbf7427$var$_quantile = $0e9d30f0dcbf7427$var$_interopRequireDefault((parcelRequire("7ctZR")));
function $0e9d30f0dcbf7427$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e9d30f0dcbf7427$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $0e9d30f0dcbf7427$var$_quantile.default)(values, 0.75) - (0, $0e9d30f0dcbf7427$var$_quantile.default)(values, 0.25)) * Math.pow((0, $0e9d30f0dcbf7427$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("7ctZR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53e0ec1d22886954$var$quantile;
module.exports.quantileSorted = $53e0ec1d22886954$var$quantileSorted;

var $53e0ec1d22886954$var$_max = $53e0ec1d22886954$var$_interopRequireDefault((parcelRequire("7RyvL")));

var $53e0ec1d22886954$var$_min = $53e0ec1d22886954$var$_interopRequireDefault((parcelRequire("WVuoa")));

var $53e0ec1d22886954$var$_quickselect = $53e0ec1d22886954$var$_interopRequireDefault((parcelRequire("b7JMz")));

var $53e0ec1d22886954$var$_number = $53e0ec1d22886954$var$_interopRequireWildcard((parcelRequire("dwNlJ")));
function $53e0ec1d22886954$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($53e0ec1d22886954$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $53e0ec1d22886954$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $53e0ec1d22886954$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $53e0ec1d22886954$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $53e0ec1d22886954$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $53e0ec1d22886954$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $53e0ec1d22886954$var$_min.default)(values);
    if (p >= 1) return (0, $53e0ec1d22886954$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $53e0ec1d22886954$var$_max.default)((0, $53e0ec1d22886954$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $53e0ec1d22886954$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $53e0ec1d22886954$var$quantileSorted(values, p, valueof = $53e0ec1d22886954$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("7RyvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b9840e3556fa5b4$var$max;
function $5b9840e3556fa5b4$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("WVuoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b12030a4ce44652$var$min;
function $0b12030a4ce44652$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("b7JMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8193dc99e7bf689c$var$quickselect;

var $2XvUc = parcelRequire("2XvUc");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $8193dc99e7bf689c$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $2XvUc.ascendingDefined : (0, $2XvUc.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $8193dc99e7bf689c$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $8193dc99e7bf689c$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $8193dc99e7bf689c$var$swap(array, left, right);
        while(i < j){
            $8193dc99e7bf689c$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $8193dc99e7bf689c$var$swap(array, left, j);
        else ++j, $8193dc99e7bf689c$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $8193dc99e7bf689c$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("8Uoxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67c6966e3c1a6bb3$var$thresholdScott;

var $67c6966e3c1a6bb3$var$_count = $67c6966e3c1a6bb3$var$_interopRequireDefault((parcelRequire("fDBzn")));

var $67c6966e3c1a6bb3$var$_deviation = $67c6966e3c1a6bb3$var$_interopRequireDefault((parcelRequire("9IRwE")));
function $67c6966e3c1a6bb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $67c6966e3c1a6bb3$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $67c6966e3c1a6bb3$var$_count.default)(values)) / (3.49 * (0, $67c6966e3c1a6bb3$var$_deviation.default)(values)));
}

});

parcelRegister("fNpn0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7ff1c98f5b9dc61$var$maxIndex;
function $b7ff1c98f5b9dc61$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("c1eEJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c00f266f6dc5753$var$mean;
function $8c00f266f6dc5753$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("esxwo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a86daee0c91b95c8$var$median;

var $a86daee0c91b95c8$var$_quantile = $a86daee0c91b95c8$var$_interopRequireDefault((parcelRequire("7ctZR")));
function $a86daee0c91b95c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a86daee0c91b95c8$var$median(values, valueof) {
    return (0, $a86daee0c91b95c8$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("emEKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a752bc018b35c4a7$var$merge;
function* $a752bc018b35c4a7$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $a752bc018b35c4a7$var$merge(arrays) {
    return Array.from($a752bc018b35c4a7$var$flatten(arrays));
}

});

parcelRegister("6J9B9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e5e640b1ce0fb44$var$minIndex;
function $4e5e640b1ce0fb44$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("1fqBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e8bd4e85796d623$var$mode;

var $eTtHt = parcelRequire("eTtHt");
function $0e8bd4e85796d623$var$mode(values, valueof) {
    const counts = new $eTtHt.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("awuUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a94df525520217f$var$pairs;
module.exports.pair = $7a94df525520217f$var$pair;
function $7a94df525520217f$var$pairs(values, pairof = $7a94df525520217f$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $7a94df525520217f$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("b91Ya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81d2100ca2c48e06$var$range;
function $81d2100ca2c48e06$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("btAme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85ae9afe2d1409d8$var$rank;

var $85ae9afe2d1409d8$var$_ascending = $85ae9afe2d1409d8$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $2XvUc = parcelRequire("2XvUc");
function $85ae9afe2d1409d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85ae9afe2d1409d8$var$rank(values, valueof = $85ae9afe2d1409d8$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $85ae9afe2d1409d8$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $85ae9afe2d1409d8$var$_ascending.default ? (i, j)=>(0, $2XvUc.ascendingDefined)(V[i], V[j]) : (0, $2XvUc.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("jwG1k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e37199de2b1f7761$var$least;

var $e37199de2b1f7761$var$_ascending = $e37199de2b1f7761$var$_interopRequireDefault((parcelRequire("ffLGk")));
function $e37199de2b1f7761$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e37199de2b1f7761$var$least(values, compare = $e37199de2b1f7761$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $e37199de2b1f7761$var$_ascending.default)(value, minValue) < 0 : (0, $e37199de2b1f7761$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("6uxaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b9f44eba027aac2$var$leastIndex;

var $4b9f44eba027aac2$var$_ascending = $4b9f44eba027aac2$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $4b9f44eba027aac2$var$_minIndex = $4b9f44eba027aac2$var$_interopRequireDefault((parcelRequire("6J9B9")));
function $4b9f44eba027aac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b9f44eba027aac2$var$leastIndex(values, compare = $4b9f44eba027aac2$var$_ascending.default) {
    if (compare.length === 1) return (0, $4b9f44eba027aac2$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("4at99", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $308eb47f038d6c09$var$greatest;

var $308eb47f038d6c09$var$_ascending = $308eb47f038d6c09$var$_interopRequireDefault((parcelRequire("ffLGk")));
function $308eb47f038d6c09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $308eb47f038d6c09$var$greatest(values, compare = $308eb47f038d6c09$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $308eb47f038d6c09$var$_ascending.default)(value, maxValue) > 0 : (0, $308eb47f038d6c09$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("2nV49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bc9fee03b352de5$var$greatestIndex;

var $1bc9fee03b352de5$var$_ascending = $1bc9fee03b352de5$var$_interopRequireDefault((parcelRequire("ffLGk")));

var $1bc9fee03b352de5$var$_maxIndex = $1bc9fee03b352de5$var$_interopRequireDefault((parcelRequire("fNpn0")));
function $1bc9fee03b352de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1bc9fee03b352de5$var$greatestIndex(values, compare = $1bc9fee03b352de5$var$_ascending.default) {
    if (compare.length === 1) return (0, $1bc9fee03b352de5$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("2rg6u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c6a983ab69a07cb$var$scan;

var $1c6a983ab69a07cb$var$_leastIndex = $1c6a983ab69a07cb$var$_interopRequireDefault((parcelRequire("6uxaa")));
function $1c6a983ab69a07cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c6a983ab69a07cb$var$scan(values, compare) {
    const index = (0, $1c6a983ab69a07cb$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("bFvzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $87ec0448daf8df1c$var$shuffler;
var $87ec0448daf8df1c$var$_default = $87ec0448daf8df1c$var$shuffler(Math.random);
module.exports.default = $87ec0448daf8df1c$var$_default;
function $87ec0448daf8df1c$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("bBw2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $872c0160dcd1c5e7$var$sum;
function $872c0160dcd1c5e7$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("8QMi4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6718a384b143fae8$var$transpose;

var $6718a384b143fae8$var$_min = $6718a384b143fae8$var$_interopRequireDefault((parcelRequire("WVuoa")));
function $6718a384b143fae8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6718a384b143fae8$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $6718a384b143fae8$var$_min.default)(matrix, $6718a384b143fae8$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $6718a384b143fae8$var$length(d) {
    return d.length;
}

});

parcelRegister("60HNW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4604b8d0a4420af5$var$zip;

var $4604b8d0a4420af5$var$_transpose = $4604b8d0a4420af5$var$_interopRequireDefault((parcelRequire("8QMi4")));
function $4604b8d0a4420af5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4604b8d0a4420af5$var$zip() {
    return (0, $4604b8d0a4420af5$var$_transpose.default)(arguments);
}

});

parcelRegister("lrMCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9d1d4e51d7d1ac9$var$every;
function $f9d1d4e51d7d1ac9$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("bcmDY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8272614a9d7ed09a$var$some;
function $8272614a9d7ed09a$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("jXTUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e88ee6e37198bcf5$var$filter;
function $e88ee6e37198bcf5$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("j3aWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dde6ca6647d1ffbe$var$map;
function $dde6ca6647d1ffbe$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("bhA3W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $836d4186252e09ce$var$reduce;
function $836d4186252e09ce$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("fthdK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b436ec1ad20694d2$var$reverse;
function $b436ec1ad20694d2$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("7cdEq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53d43e365f595d6e$var$difference;

var $eTtHt = parcelRequire("eTtHt");
function $53d43e365f595d6e$var$difference(values, ...others) {
    values = new $eTtHt.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("6JtUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e6e2637edf46197$var$disjoint;

var $eTtHt = parcelRequire("eTtHt");
function $4e6e2637edf46197$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $eTtHt.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("hwnG8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc17cae79b7fa94d$var$intersection;

var $eTtHt = parcelRequire("eTtHt");
function $cc17cae79b7fa94d$var$intersection(values, ...others) {
    values = new $eTtHt.InternSet(values);
    others = others.map($cc17cae79b7fa94d$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $cc17cae79b7fa94d$var$set(values) {
    return values instanceof $eTtHt.InternSet ? values : new $eTtHt.InternSet(values);
}

});

parcelRegister("bxu61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $022b0080e84c0249$var$subset;

var $022b0080e84c0249$var$_superset = $022b0080e84c0249$var$_interopRequireDefault((parcelRequire("8TFwa")));
function $022b0080e84c0249$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $022b0080e84c0249$var$subset(values, other) {
    return (0, $022b0080e84c0249$var$_superset.default)(other, values);
}

});
parcelRegister("8TFwa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67a3aa61cbe5e87c$var$superset;
function $67a3aa61cbe5e87c$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $67a3aa61cbe5e87c$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $67a3aa61cbe5e87c$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $67a3aa61cbe5e87c$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("jyzgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3cc8d35fa9878d5$var$union;

var $eTtHt = parcelRequire("eTtHt");
function $e3cc8d35fa9878d5$var$union(...others) {
    const set = new $eTtHt.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("3cC0P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $254ffa921f264f63$var$initInterpolator;
module.exports.initRange = $254ffa921f264f63$var$initRange;
function $254ffa921f264f63$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $254ffa921f264f63$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("3vvtT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28dcafd68b53e739$var$ordinal;
module.exports.implicit = void 0;

var $aPhjF = parcelRequire("aPhjF");

var $3cC0P = parcelRequire("3cC0P");
const $28dcafd68b53e739$var$implicit = Symbol("implicit");
module.exports.implicit = $28dcafd68b53e739$var$implicit;
function $28dcafd68b53e739$var$ordinal() {
    var index = new $aPhjF.InternMap(), domain = [], range = [], unknown = $28dcafd68b53e739$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $28dcafd68b53e739$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $aPhjF.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $28dcafd68b53e739$var$ordinal(domain, range).unknown(unknown);
    };
    $3cC0P.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("55lHa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b3e3fa0b0c4b485$var$identity;

var $lhUfg = parcelRequire("lhUfg");

var $3b3e3fa0b0c4b485$var$_number = $3b3e3fa0b0c4b485$var$_interopRequireDefault((parcelRequire("bKTAH")));
function $3b3e3fa0b0c4b485$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b3e3fa0b0c4b485$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $3b3e3fa0b0c4b485$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3b3e3fa0b0c4b485$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $3b3e3fa0b0c4b485$var$_number.default) : [
        0,
        1
    ];
    return (0, $lhUfg.linearish)(scale);
}

});
parcelRegister("lhUfg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7f6d0a4350b1d88$var$linear;
module.exports.linearish = $f7f6d0a4350b1d88$var$linearish;

var $aPhjF = parcelRequire("aPhjF");

var $f7f6d0a4350b1d88$var$_continuous = $f7f6d0a4350b1d88$var$_interopRequireWildcard((parcelRequire("8XQpm")));

var $3cC0P = parcelRequire("3cC0P");

var $f7f6d0a4350b1d88$var$_tickFormat = $f7f6d0a4350b1d88$var$_interopRequireDefault((parcelRequire("3av0p")));
function $f7f6d0a4350b1d88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7f6d0a4350b1d88$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f7f6d0a4350b1d88$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f7f6d0a4350b1d88$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f7f6d0a4350b1d88$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f7f6d0a4350b1d88$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $aPhjF.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $f7f6d0a4350b1d88$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $aPhjF.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $f7f6d0a4350b1d88$var$linear() {
    var scale = (0, $f7f6d0a4350b1d88$var$_continuous.default)();
    scale.copy = function() {
        return (0, $f7f6d0a4350b1d88$var$_continuous.copy)(scale, $f7f6d0a4350b1d88$var$linear());
    };
    $3cC0P.initRange.apply(scale, arguments);
    return $f7f6d0a4350b1d88$var$linearish(scale);
}

});
parcelRegister("8XQpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $686c7c95ec77ceff$var$copy;
module.exports.default = $686c7c95ec77ceff$var$continuous;
module.exports.identity = $686c7c95ec77ceff$var$identity;
module.exports.transformer = $686c7c95ec77ceff$var$transformer;

var $aPhjF = parcelRequire("aPhjF");

var $dfHvL = parcelRequire("dfHvL");

var $686c7c95ec77ceff$var$_constant = $686c7c95ec77ceff$var$_interopRequireDefault((parcelRequire("hU02O")));

var $686c7c95ec77ceff$var$_number = $686c7c95ec77ceff$var$_interopRequireDefault((parcelRequire("bKTAH")));
function $686c7c95ec77ceff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $686c7c95ec77ceff$var$unit = [
    0,
    1
];
function $686c7c95ec77ceff$var$identity(x) {
    return x;
}
function $686c7c95ec77ceff$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $686c7c95ec77ceff$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $686c7c95ec77ceff$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $686c7c95ec77ceff$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $686c7c95ec77ceff$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $686c7c95ec77ceff$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $686c7c95ec77ceff$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $686c7c95ec77ceff$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $aPhjF.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $686c7c95ec77ceff$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $686c7c95ec77ceff$var$transformer() {
    var domain = $686c7c95ec77ceff$var$unit, range = $686c7c95ec77ceff$var$unit, interpolate = $dfHvL.interpolate, transform, untransform, unknown, clamp = $686c7c95ec77ceff$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $686c7c95ec77ceff$var$identity) clamp = $686c7c95ec77ceff$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $686c7c95ec77ceff$var$polymap : $686c7c95ec77ceff$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $dfHvL.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $686c7c95ec77ceff$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $dfHvL.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $686c7c95ec77ceff$var$identity, rescale()) : clamp !== $686c7c95ec77ceff$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $686c7c95ec77ceff$var$continuous() {
    return $686c7c95ec77ceff$var$transformer()($686c7c95ec77ceff$var$identity, $686c7c95ec77ceff$var$identity);
}

});
parcelRegister("dfHvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $ftxA1.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $ftxA1.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $9a5e6d87946d3081$var$_quantize.default;
    }
});

var $9a5e6d87946d3081$var$_value = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("2cT3J")));

var $9a5e6d87946d3081$var$_array = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("ksgwb")));

var $9a5e6d87946d3081$var$_basis = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("946hk")));

var $9a5e6d87946d3081$var$_basisClosed = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("gAk4h")));

var $9a5e6d87946d3081$var$_date = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("jQMMh")));

var $9a5e6d87946d3081$var$_discrete = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("2NWsE")));

var $9a5e6d87946d3081$var$_hue = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("A4pxc")));

var $9a5e6d87946d3081$var$_number = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("huiyw")));

var $9a5e6d87946d3081$var$_numberArray = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("abai3")));

var $9a5e6d87946d3081$var$_object = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("8EHow")));

var $9a5e6d87946d3081$var$_round = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("hlCkk")));

var $9a5e6d87946d3081$var$_string = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("2psCx")));

var $ftxA1 = parcelRequire("ftxA1");

var $9a5e6d87946d3081$var$_zoom = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("4p85x")));

var $9a5e6d87946d3081$var$_rgb = $9a5e6d87946d3081$var$_interopRequireWildcard((parcelRequire("bYJE8")));

var $9a5e6d87946d3081$var$_hsl = $9a5e6d87946d3081$var$_interopRequireWildcard((parcelRequire("et1yO")));

var $9a5e6d87946d3081$var$_lab = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("jbHko")));

var $9a5e6d87946d3081$var$_hcl = $9a5e6d87946d3081$var$_interopRequireWildcard((parcelRequire("7eJ5y")));

var $9a5e6d87946d3081$var$_cubehelix = $9a5e6d87946d3081$var$_interopRequireWildcard((parcelRequire("g9Fqj")));

var $9a5e6d87946d3081$var$_piecewise = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("8Y2Fj")));

var $9a5e6d87946d3081$var$_quantize = $9a5e6d87946d3081$var$_interopRequireDefault((parcelRequire("8g00Y")));
function $9a5e6d87946d3081$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9a5e6d87946d3081$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9a5e6d87946d3081$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9a5e6d87946d3081$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9a5e6d87946d3081$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2cT3J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19b7695d30ca0f1d$var$_default;

var $lUQrs = parcelRequire("lUQrs");

var $19b7695d30ca0f1d$var$_rgb = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("bYJE8")));

var $ksgwb = parcelRequire("ksgwb");

var $19b7695d30ca0f1d$var$_date = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("jQMMh")));

var $19b7695d30ca0f1d$var$_number = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("huiyw")));

var $19b7695d30ca0f1d$var$_object = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("8EHow")));

var $19b7695d30ca0f1d$var$_string = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("2psCx")));

var $19b7695d30ca0f1d$var$_constant = $19b7695d30ca0f1d$var$_interopRequireDefault((parcelRequire("evxkT")));

var $19b7695d30ca0f1d$var$_numberArray = $19b7695d30ca0f1d$var$_interopRequireWildcard((parcelRequire("abai3")));
function $19b7695d30ca0f1d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($19b7695d30ca0f1d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $19b7695d30ca0f1d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $19b7695d30ca0f1d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $19b7695d30ca0f1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19b7695d30ca0f1d$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $19b7695d30ca0f1d$var$_constant.default)(b) : (t === "number" ? $19b7695d30ca0f1d$var$_number.default : t === "string" ? (c = (0, $lUQrs.color)(b)) ? (b = c, $19b7695d30ca0f1d$var$_rgb.default) : $19b7695d30ca0f1d$var$_string.default : b instanceof $lUQrs.color ? $19b7695d30ca0f1d$var$_rgb.default : b instanceof Date ? $19b7695d30ca0f1d$var$_date.default : (0, $19b7695d30ca0f1d$var$_numberArray.isNumberArray)(b) ? $19b7695d30ca0f1d$var$_numberArray.default : Array.isArray(b) ? $ksgwb.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $19b7695d30ca0f1d$var$_object.default : $19b7695d30ca0f1d$var$_number.default)(a, b);
}

});
parcelRegister("lUQrs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $ff4781cddcdf6fae$var$_color.rgb;
    }
});

var $ff4781cddcdf6fae$var$_color = $ff4781cddcdf6fae$var$_interopRequireWildcard((parcelRequire("huXr8")));

var $ff4781cddcdf6fae$var$_lab = $ff4781cddcdf6fae$var$_interopRequireWildcard((parcelRequire("dVeDh")));

var $ff4781cddcdf6fae$var$_cubehelix = $ff4781cddcdf6fae$var$_interopRequireDefault((parcelRequire("GQbZT")));
function $ff4781cddcdf6fae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ff4781cddcdf6fae$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ff4781cddcdf6fae$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ff4781cddcdf6fae$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ff4781cddcdf6fae$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("huXr8", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("gmF2e")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("gmF2e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be9e881e9613a4bb$var$_default;
module.exports.extend = $be9e881e9613a4bb$var$extend;
function $be9e881e9613a4bb$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $be9e881e9613a4bb$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dVeDh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $a22bf2f5fc7920b5$var$Hcl;
module.exports.Lab = $a22bf2f5fc7920b5$var$Lab;
module.exports.default = $a22bf2f5fc7920b5$var$lab;
module.exports.gray = $a22bf2f5fc7920b5$var$gray;
module.exports.hcl = $a22bf2f5fc7920b5$var$hcl;
module.exports.lch = $a22bf2f5fc7920b5$var$lch;

var $a22bf2f5fc7920b5$var$_define = $a22bf2f5fc7920b5$var$_interopRequireWildcard((parcelRequire("gmF2e")));

var $huXr8 = parcelRequire("huXr8");

var $hIGyV = parcelRequire("hIGyV");
function $a22bf2f5fc7920b5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a22bf2f5fc7920b5$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a22bf2f5fc7920b5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a22bf2f5fc7920b5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $a22bf2f5fc7920b5$var$K = 18, $a22bf2f5fc7920b5$var$Xn = 0.96422, $a22bf2f5fc7920b5$var$Yn = 1, $a22bf2f5fc7920b5$var$Zn = 0.82521, $a22bf2f5fc7920b5$var$t0 = 4 / 29, $a22bf2f5fc7920b5$var$t1 = 6 / 29, $a22bf2f5fc7920b5$var$t2 = 3 * $a22bf2f5fc7920b5$var$t1 * $a22bf2f5fc7920b5$var$t1, $a22bf2f5fc7920b5$var$t3 = $a22bf2f5fc7920b5$var$t1 * $a22bf2f5fc7920b5$var$t1 * $a22bf2f5fc7920b5$var$t1;
function $a22bf2f5fc7920b5$var$labConvert(o) {
    if (o instanceof $a22bf2f5fc7920b5$var$Lab) return new $a22bf2f5fc7920b5$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $a22bf2f5fc7920b5$var$Hcl) return $a22bf2f5fc7920b5$var$hcl2lab(o);
    if (!(o instanceof $huXr8.Rgb)) o = (0, $huXr8.rgbConvert)(o);
    var r = $a22bf2f5fc7920b5$var$rgb2lrgb(o.r), g = $a22bf2f5fc7920b5$var$rgb2lrgb(o.g), b = $a22bf2f5fc7920b5$var$rgb2lrgb(o.b), y = $a22bf2f5fc7920b5$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $a22bf2f5fc7920b5$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $a22bf2f5fc7920b5$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $a22bf2f5fc7920b5$var$Xn);
        z = $a22bf2f5fc7920b5$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $a22bf2f5fc7920b5$var$Zn);
    }
    return new $a22bf2f5fc7920b5$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $a22bf2f5fc7920b5$var$gray(l, opacity) {
    return new $a22bf2f5fc7920b5$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $a22bf2f5fc7920b5$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $a22bf2f5fc7920b5$var$labConvert(l) : new $a22bf2f5fc7920b5$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $a22bf2f5fc7920b5$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $a22bf2f5fc7920b5$var$_define.default)($a22bf2f5fc7920b5$var$Lab, $a22bf2f5fc7920b5$var$lab, (0, $a22bf2f5fc7920b5$var$_define.extend)($huXr8.Color, {
    brighter (k) {
        return new $a22bf2f5fc7920b5$var$Lab(this.l + $a22bf2f5fc7920b5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $a22bf2f5fc7920b5$var$Lab(this.l - $a22bf2f5fc7920b5$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $a22bf2f5fc7920b5$var$Xn * $a22bf2f5fc7920b5$var$lab2xyz(x);
        y = $a22bf2f5fc7920b5$var$Yn * $a22bf2f5fc7920b5$var$lab2xyz(y);
        z = $a22bf2f5fc7920b5$var$Zn * $a22bf2f5fc7920b5$var$lab2xyz(z);
        return new $huXr8.Rgb($a22bf2f5fc7920b5$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $a22bf2f5fc7920b5$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $a22bf2f5fc7920b5$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $a22bf2f5fc7920b5$var$xyz2lab(t) {
    return t > $a22bf2f5fc7920b5$var$t3 ? Math.pow(t, 1 / 3) : t / $a22bf2f5fc7920b5$var$t2 + $a22bf2f5fc7920b5$var$t0;
}
function $a22bf2f5fc7920b5$var$lab2xyz(t) {
    return t > $a22bf2f5fc7920b5$var$t1 ? t * t * t : $a22bf2f5fc7920b5$var$t2 * (t - $a22bf2f5fc7920b5$var$t0);
}
function $a22bf2f5fc7920b5$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $a22bf2f5fc7920b5$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $a22bf2f5fc7920b5$var$hclConvert(o) {
    if (o instanceof $a22bf2f5fc7920b5$var$Hcl) return new $a22bf2f5fc7920b5$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $a22bf2f5fc7920b5$var$Lab)) o = $a22bf2f5fc7920b5$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $a22bf2f5fc7920b5$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $hIGyV.degrees;
    return new $a22bf2f5fc7920b5$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $a22bf2f5fc7920b5$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $a22bf2f5fc7920b5$var$hclConvert(l) : new $a22bf2f5fc7920b5$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a22bf2f5fc7920b5$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $a22bf2f5fc7920b5$var$hclConvert(h) : new $a22bf2f5fc7920b5$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a22bf2f5fc7920b5$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $a22bf2f5fc7920b5$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $a22bf2f5fc7920b5$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $hIGyV.radians;
    return new $a22bf2f5fc7920b5$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $a22bf2f5fc7920b5$var$_define.default)($a22bf2f5fc7920b5$var$Hcl, $a22bf2f5fc7920b5$var$hcl, (0, $a22bf2f5fc7920b5$var$_define.extend)($huXr8.Color, {
    brighter (k) {
        return new $a22bf2f5fc7920b5$var$Hcl(this.h, this.c, this.l + $a22bf2f5fc7920b5$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $a22bf2f5fc7920b5$var$Hcl(this.h, this.c, this.l - $a22bf2f5fc7920b5$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $a22bf2f5fc7920b5$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("hIGyV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $ce678fb5ddf2ddea$var$radians = Math.PI / 180;
module.exports.radians = $ce678fb5ddf2ddea$var$radians;
const $ce678fb5ddf2ddea$var$degrees = 180 / Math.PI;
module.exports.degrees = $ce678fb5ddf2ddea$var$degrees;

});


parcelRegister("GQbZT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $080c68b3e0fbeceb$var$Cubehelix;
module.exports.default = $080c68b3e0fbeceb$var$cubehelix;

var $080c68b3e0fbeceb$var$_define = $080c68b3e0fbeceb$var$_interopRequireWildcard((parcelRequire("gmF2e")));

var $huXr8 = parcelRequire("huXr8");

var $hIGyV = parcelRequire("hIGyV");
function $080c68b3e0fbeceb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($080c68b3e0fbeceb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $080c68b3e0fbeceb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $080c68b3e0fbeceb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $080c68b3e0fbeceb$var$A = -0.14861, $080c68b3e0fbeceb$var$B = 1.78277, $080c68b3e0fbeceb$var$C = -0.29227, $080c68b3e0fbeceb$var$D = -0.90649, $080c68b3e0fbeceb$var$E = 1.97294, $080c68b3e0fbeceb$var$ED = $080c68b3e0fbeceb$var$E * $080c68b3e0fbeceb$var$D, $080c68b3e0fbeceb$var$EB = $080c68b3e0fbeceb$var$E * $080c68b3e0fbeceb$var$B, $080c68b3e0fbeceb$var$BC_DA = $080c68b3e0fbeceb$var$B * $080c68b3e0fbeceb$var$C - $080c68b3e0fbeceb$var$D * $080c68b3e0fbeceb$var$A;
function $080c68b3e0fbeceb$var$cubehelixConvert(o) {
    if (o instanceof $080c68b3e0fbeceb$var$Cubehelix) return new $080c68b3e0fbeceb$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $huXr8.Rgb)) o = (0, $huXr8.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($080c68b3e0fbeceb$var$BC_DA * b + $080c68b3e0fbeceb$var$ED * r - $080c68b3e0fbeceb$var$EB * g) / ($080c68b3e0fbeceb$var$BC_DA + $080c68b3e0fbeceb$var$ED - $080c68b3e0fbeceb$var$EB), bl = b - l, k = ($080c68b3e0fbeceb$var$E * (g - l) - $080c68b3e0fbeceb$var$C * bl) / $080c68b3e0fbeceb$var$D, s = Math.sqrt(k * k + bl * bl) / ($080c68b3e0fbeceb$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $hIGyV.degrees - 120 : NaN;
    return new $080c68b3e0fbeceb$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $080c68b3e0fbeceb$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $080c68b3e0fbeceb$var$cubehelixConvert(h) : new $080c68b3e0fbeceb$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $080c68b3e0fbeceb$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $080c68b3e0fbeceb$var$_define.default)($080c68b3e0fbeceb$var$Cubehelix, $080c68b3e0fbeceb$var$cubehelix, (0, $080c68b3e0fbeceb$var$_define.extend)($huXr8.Color, {
    brighter (k) {
        k = k == null ? $huXr8.brighter : Math.pow($huXr8.brighter, k);
        return new $080c68b3e0fbeceb$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $huXr8.darker : Math.pow($huXr8.darker, k);
        return new $080c68b3e0fbeceb$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $hIGyV.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $huXr8.Rgb(255 * (l + a * ($080c68b3e0fbeceb$var$A * cosh + $080c68b3e0fbeceb$var$B * sinh)), 255 * (l + a * ($080c68b3e0fbeceb$var$C * cosh + $080c68b3e0fbeceb$var$D * sinh)), 255 * (l + a * ($080c68b3e0fbeceb$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("bYJE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $lUQrs = parcelRequire("lUQrs");

var $8b88b4b78a6941d6$var$_basis = $8b88b4b78a6941d6$var$_interopRequireDefault((parcelRequire("946hk")));

var $8b88b4b78a6941d6$var$_basisClosed = $8b88b4b78a6941d6$var$_interopRequireDefault((parcelRequire("gAk4h")));

var $8b88b4b78a6941d6$var$_color = $8b88b4b78a6941d6$var$_interopRequireWildcard((parcelRequire("RyQAS")));
function $8b88b4b78a6941d6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8b88b4b78a6941d6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8b88b4b78a6941d6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8b88b4b78a6941d6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8b88b4b78a6941d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b88b4b78a6941d6$var$_default = function rgbGamma(y) {
    var color = (0, $8b88b4b78a6941d6$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $lUQrs.rgb)(start)).r, (end = (0, $lUQrs.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8b88b4b78a6941d6$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $8b88b4b78a6941d6$var$_default;
function $8b88b4b78a6941d6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $lUQrs.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $8b88b4b78a6941d6$var$rgbBasis = $8b88b4b78a6941d6$var$rgbSpline($8b88b4b78a6941d6$var$_basis.default);
module.exports.rgbBasis = $8b88b4b78a6941d6$var$rgbBasis;
var $8b88b4b78a6941d6$var$rgbBasisClosed = $8b88b4b78a6941d6$var$rgbSpline($8b88b4b78a6941d6$var$_basisClosed.default);
module.exports.rgbBasisClosed = $8b88b4b78a6941d6$var$rgbBasisClosed;

});
parcelRegister("946hk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $69995b87bdd05658$var$basis;
module.exports.default = $69995b87bdd05658$var$_default;
function $69995b87bdd05658$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $69995b87bdd05658$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $69995b87bdd05658$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("gAk4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c12f9336d5c8fb89$var$_default;

var $946hk = parcelRequire("946hk");
function $c12f9336d5c8fb89$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $946hk.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("RyQAS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a0ffb4c03038eb7$var$nogamma;
module.exports.gamma = $0a0ffb4c03038eb7$var$gamma;
module.exports.hue = $0a0ffb4c03038eb7$var$hue;

var $0a0ffb4c03038eb7$var$_constant = $0a0ffb4c03038eb7$var$_interopRequireDefault((parcelRequire("evxkT")));
function $0a0ffb4c03038eb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a0ffb4c03038eb7$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $0a0ffb4c03038eb7$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $0a0ffb4c03038eb7$var$hue(a, b) {
    var d = b - a;
    return d ? $0a0ffb4c03038eb7$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $0a0ffb4c03038eb7$var$_constant.default)(isNaN(a) ? b : a);
}
function $0a0ffb4c03038eb7$var$gamma(y) {
    return (y = +y) === 1 ? $0a0ffb4c03038eb7$var$nogamma : function(a, b) {
        return b - a ? $0a0ffb4c03038eb7$var$exponential(a, b, y) : (0, $0a0ffb4c03038eb7$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $0a0ffb4c03038eb7$var$nogamma(a, b) {
    var d = b - a;
    return d ? $0a0ffb4c03038eb7$var$linear(a, d) : (0, $0a0ffb4c03038eb7$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("evxkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a8fdd1c62497b4f1$var$_default = (x)=>()=>x;
module.exports.default = $a8fdd1c62497b4f1$var$_default;

});



parcelRegister("ksgwb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee433c583d25110f$var$_default;
module.exports.genericArray = $ee433c583d25110f$var$genericArray;

var $ee433c583d25110f$var$_value = $ee433c583d25110f$var$_interopRequireDefault((parcelRequire("2cT3J")));

var $ee433c583d25110f$var$_numberArray = $ee433c583d25110f$var$_interopRequireWildcard((parcelRequire("abai3")));
function $ee433c583d25110f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ee433c583d25110f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ee433c583d25110f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ee433c583d25110f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ee433c583d25110f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee433c583d25110f$var$_default(a, b) {
    return ((0, $ee433c583d25110f$var$_numberArray.isNumberArray)(b) ? $ee433c583d25110f$var$_numberArray.default : $ee433c583d25110f$var$genericArray)(a, b);
}
function $ee433c583d25110f$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $ee433c583d25110f$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("abai3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7692e9e0e532f8bd$var$_default;
module.exports.isNumberArray = $7692e9e0e532f8bd$var$isNumberArray;
function $7692e9e0e532f8bd$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7692e9e0e532f8bd$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("jQMMh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e738b5e9a2303cf6$var$_default;
function $e738b5e9a2303cf6$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("huiyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbb3a1c8645275b3$var$_default;
function $cbb3a1c8645275b3$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("8EHow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64d3b86485b3dbd8$var$_default;

var $64d3b86485b3dbd8$var$_value = $64d3b86485b3dbd8$var$_interopRequireDefault((parcelRequire("2cT3J")));
function $64d3b86485b3dbd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $64d3b86485b3dbd8$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $64d3b86485b3dbd8$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("2psCx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c141e0ad40ec63d$var$_default;

var $1c141e0ad40ec63d$var$_number = $1c141e0ad40ec63d$var$_interopRequireDefault((parcelRequire("huiyw")));
function $1c141e0ad40ec63d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1c141e0ad40ec63d$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $1c141e0ad40ec63d$var$reB = new RegExp($1c141e0ad40ec63d$var$reA.source, "g");
function $1c141e0ad40ec63d$var$zero(b) {
    return function() {
        return b;
    };
}
function $1c141e0ad40ec63d$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $1c141e0ad40ec63d$var$_default(a, b) {
    var bi = $1c141e0ad40ec63d$var$reA.lastIndex = $1c141e0ad40ec63d$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $1c141e0ad40ec63d$var$reA.exec(a)) && (bm = $1c141e0ad40ec63d$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $1c141e0ad40ec63d$var$_number.default)(am, bm)
            });
        }
        bi = $1c141e0ad40ec63d$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $1c141e0ad40ec63d$var$one(q[0].x) : $1c141e0ad40ec63d$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("2NWsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20ad818869cfc657$var$_default;
function $20ad818869cfc657$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("A4pxc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06c6c8cf62f94e0d$var$_default;

var $RyQAS = parcelRequire("RyQAS");
function $06c6c8cf62f94e0d$var$_default(a, b) {
    var i = (0, $RyQAS.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("hlCkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca1220c44105ef55$var$_default;
function $ca1220c44105ef55$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ftxA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $b4439cbf85b446ae$var$_number = $b4439cbf85b446ae$var$_interopRequireDefault((parcelRequire("huiyw")));

var $7GbIS = parcelRequire("7GbIS");
function $b4439cbf85b446ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4439cbf85b446ae$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $b4439cbf85b446ae$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b4439cbf85b446ae$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $b4439cbf85b446ae$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $b4439cbf85b446ae$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $b4439cbf85b446ae$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b4439cbf85b446ae$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $b4439cbf85b446ae$var$interpolateTransformCss = $b4439cbf85b446ae$var$interpolateTransform($7GbIS.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $b4439cbf85b446ae$var$interpolateTransformCss;
var $b4439cbf85b446ae$var$interpolateTransformSvg = $b4439cbf85b446ae$var$interpolateTransform($7GbIS.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $b4439cbf85b446ae$var$interpolateTransformSvg;

});
parcelRegister("7GbIS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $59758c9146e32e94$var$parseCss;
module.exports.parseSvg = $59758c9146e32e94$var$parseSvg;

var $59758c9146e32e94$var$_decompose = $59758c9146e32e94$var$_interopRequireWildcard((parcelRequire("4tkDm")));
function $59758c9146e32e94$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59758c9146e32e94$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59758c9146e32e94$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59758c9146e32e94$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $59758c9146e32e94$var$svgNode;
/* eslint-disable no-undef */ function $59758c9146e32e94$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $59758c9146e32e94$var$_decompose.identity : (0, $59758c9146e32e94$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $59758c9146e32e94$var$parseSvg(value) {
    if (value == null) return $59758c9146e32e94$var$_decompose.identity;
    if (!$59758c9146e32e94$var$svgNode) $59758c9146e32e94$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $59758c9146e32e94$var$svgNode.setAttribute("transform", value);
    if (!(value = $59758c9146e32e94$var$svgNode.transform.baseVal.consolidate())) return $59758c9146e32e94$var$_decompose.identity;
    value = value.matrix;
    return (0, $59758c9146e32e94$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("4tkDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3419e05026d9a7e1$var$_default;
module.exports.identity = void 0;
var $3419e05026d9a7e1$var$degrees = 180 / Math.PI;
var $3419e05026d9a7e1$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $3419e05026d9a7e1$var$identity;
function $3419e05026d9a7e1$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $3419e05026d9a7e1$var$degrees,
        skewX: Math.atan(skewX) * $3419e05026d9a7e1$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("4p85x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $334fc56136e91a7f$var$epsilon2 = 1e-12;
function $334fc56136e91a7f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $334fc56136e91a7f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $334fc56136e91a7f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $334fc56136e91a7f$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $334fc56136e91a7f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $334fc56136e91a7f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $334fc56136e91a7f$var$tanh(rho * s + r0) - $334fc56136e91a7f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $334fc56136e91a7f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $334fc56136e91a7f$var$_default;

});

parcelRegister("et1yO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $lUQrs = parcelRequire("lUQrs");

var $a884fbfe7409f3ba$var$_color = $a884fbfe7409f3ba$var$_interopRequireWildcard((parcelRequire("RyQAS")));
function $a884fbfe7409f3ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a884fbfe7409f3ba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a884fbfe7409f3ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a884fbfe7409f3ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a884fbfe7409f3ba$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $lUQrs.hsl)(start)).h, (end = (0, $lUQrs.hsl)(end)).h), s = (0, $a884fbfe7409f3ba$var$_color.default)(start.s, end.s), l = (0, $a884fbfe7409f3ba$var$_color.default)(start.l, end.l), opacity = (0, $a884fbfe7409f3ba$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a884fbfe7409f3ba$var$_default = $a884fbfe7409f3ba$var$hsl($a884fbfe7409f3ba$var$_color.hue);
module.exports.default = $a884fbfe7409f3ba$var$_default;
var $a884fbfe7409f3ba$var$hslLong = $a884fbfe7409f3ba$var$hsl($a884fbfe7409f3ba$var$_color.default);
module.exports.hslLong = $a884fbfe7409f3ba$var$hslLong;

});

parcelRegister("jbHko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df80a76cde2aa81c$var$lab;

var $lUQrs = parcelRequire("lUQrs");

var $df80a76cde2aa81c$var$_color = $df80a76cde2aa81c$var$_interopRequireDefault((parcelRequire("RyQAS")));
function $df80a76cde2aa81c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df80a76cde2aa81c$var$lab(start, end) {
    var l = (0, $df80a76cde2aa81c$var$_color.default)((start = (0, $lUQrs.lab)(start)).l, (end = (0, $lUQrs.lab)(end)).l), a = (0, $df80a76cde2aa81c$var$_color.default)(start.a, end.a), b = (0, $df80a76cde2aa81c$var$_color.default)(start.b, end.b), opacity = (0, $df80a76cde2aa81c$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("7eJ5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $lUQrs = parcelRequire("lUQrs");

var $544cd0de90b8ceee$var$_color = $544cd0de90b8ceee$var$_interopRequireWildcard((parcelRequire("RyQAS")));
function $544cd0de90b8ceee$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($544cd0de90b8ceee$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $544cd0de90b8ceee$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $544cd0de90b8ceee$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $544cd0de90b8ceee$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $lUQrs.hcl)(start)).h, (end = (0, $lUQrs.hcl)(end)).h), c = (0, $544cd0de90b8ceee$var$_color.default)(start.c, end.c), l = (0, $544cd0de90b8ceee$var$_color.default)(start.l, end.l), opacity = (0, $544cd0de90b8ceee$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $544cd0de90b8ceee$var$_default = $544cd0de90b8ceee$var$hcl($544cd0de90b8ceee$var$_color.hue);
module.exports.default = $544cd0de90b8ceee$var$_default;
var $544cd0de90b8ceee$var$hclLong = $544cd0de90b8ceee$var$hcl($544cd0de90b8ceee$var$_color.default);
module.exports.hclLong = $544cd0de90b8ceee$var$hclLong;

});

parcelRegister("g9Fqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $lUQrs = parcelRequire("lUQrs");

var $bc2d9e723f15ae34$var$_color = $bc2d9e723f15ae34$var$_interopRequireWildcard((parcelRequire("RyQAS")));
function $bc2d9e723f15ae34$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bc2d9e723f15ae34$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bc2d9e723f15ae34$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bc2d9e723f15ae34$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bc2d9e723f15ae34$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $lUQrs.cubehelix)(start)).h, (end = (0, $lUQrs.cubehelix)(end)).h), s = (0, $bc2d9e723f15ae34$var$_color.default)(start.s, end.s), l = (0, $bc2d9e723f15ae34$var$_color.default)(start.l, end.l), opacity = (0, $bc2d9e723f15ae34$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $bc2d9e723f15ae34$var$_default = $bc2d9e723f15ae34$var$cubehelix($bc2d9e723f15ae34$var$_color.hue);
module.exports.default = $bc2d9e723f15ae34$var$_default;
var $bc2d9e723f15ae34$var$cubehelixLong = $bc2d9e723f15ae34$var$cubehelix($bc2d9e723f15ae34$var$_color.default);
module.exports.cubehelixLong = $bc2d9e723f15ae34$var$cubehelixLong;

});

parcelRegister("8Y2Fj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6875fe9eec0352f0$var$piecewise;

var $6875fe9eec0352f0$var$_value = $6875fe9eec0352f0$var$_interopRequireDefault((parcelRequire("2cT3J")));
function $6875fe9eec0352f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6875fe9eec0352f0$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $6875fe9eec0352f0$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("8g00Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $602fd441d9a05967$var$_default;
function $602fd441d9a05967$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("hU02O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d087b36daea00a18$var$constants;
function $d087b36daea00a18$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("bKTAH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88ef1cc79318aa33$var$number;
function $88ef1cc79318aa33$var$number(x) {
    return +x;
}

});


parcelRegister("3av0p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24ea5b506ed07f2f$var$tickFormat;

var $aPhjF = parcelRequire("aPhjF");

var $bgM31 = parcelRequire("bgM31");
function $24ea5b506ed07f2f$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $aPhjF.tickStep)(start, stop, count), precision;
    specifier = (0, $bgM31.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $bgM31.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $bgM31.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $bgM31.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $bgM31.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $bgM31.format)(specifier);
}

});
parcelRegister("bgM31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $8346759ba34bc8de$var$_precisionRound.default;
    }
});

var $8346759ba34bc8de$var$_defaultLocale = $8346759ba34bc8de$var$_interopRequireWildcard((parcelRequire("AzoBb")));

var $8346759ba34bc8de$var$_locale = $8346759ba34bc8de$var$_interopRequireDefault((parcelRequire("e6Hv3")));

var $8346759ba34bc8de$var$_formatSpecifier = $8346759ba34bc8de$var$_interopRequireWildcard((parcelRequire("72nIE")));

var $8346759ba34bc8de$var$_precisionFixed = $8346759ba34bc8de$var$_interopRequireDefault((parcelRequire("btfhZ")));

var $8346759ba34bc8de$var$_precisionPrefix = $8346759ba34bc8de$var$_interopRequireDefault((parcelRequire("fc1nl")));

var $8346759ba34bc8de$var$_precisionRound = $8346759ba34bc8de$var$_interopRequireDefault((parcelRequire("3QhCy")));
function $8346759ba34bc8de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8346759ba34bc8de$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8346759ba34bc8de$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8346759ba34bc8de$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8346759ba34bc8de$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("AzoBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06ded1c454f0cfbe$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $06ded1c454f0cfbe$var$_locale = $06ded1c454f0cfbe$var$_interopRequireDefault((parcelRequire("e6Hv3")));
function $06ded1c454f0cfbe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $06ded1c454f0cfbe$var$locale;
var $06ded1c454f0cfbe$var$format;
module.exports.format = $06ded1c454f0cfbe$var$format;
var $06ded1c454f0cfbe$var$formatPrefix;
module.exports.formatPrefix = $06ded1c454f0cfbe$var$formatPrefix;
$06ded1c454f0cfbe$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $06ded1c454f0cfbe$var$defaultLocale(definition) {
    $06ded1c454f0cfbe$var$locale = (0, $06ded1c454f0cfbe$var$_locale.default)(definition);
    module.exports.format = $06ded1c454f0cfbe$var$format = $06ded1c454f0cfbe$var$locale.format;
    module.exports.formatPrefix = $06ded1c454f0cfbe$var$formatPrefix = $06ded1c454f0cfbe$var$locale.formatPrefix;
    return $06ded1c454f0cfbe$var$locale;
}

});
parcelRegister("e6Hv3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4535e5ed53b1909$var$_default;

var $a4535e5ed53b1909$var$_exponent = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("6zgJ2")));

var $a4535e5ed53b1909$var$_formatGroup = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("39E6E")));

var $a4535e5ed53b1909$var$_formatNumerals = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("e8PdH")));

var $a4535e5ed53b1909$var$_formatSpecifier = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("72nIE")));

var $a4535e5ed53b1909$var$_formatTrim = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("bdZl0")));

var $a4535e5ed53b1909$var$_formatTypes = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("LX6Di")));

var $bBhlf = parcelRequire("bBhlf");

var $a4535e5ed53b1909$var$_identity = $a4535e5ed53b1909$var$_interopRequireDefault((parcelRequire("22lxr")));
function $a4535e5ed53b1909$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a4535e5ed53b1909$var$map = Array.prototype.map, $a4535e5ed53b1909$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $a4535e5ed53b1909$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $a4535e5ed53b1909$var$_identity.default : (0, $a4535e5ed53b1909$var$_formatGroup.default)($a4535e5ed53b1909$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $a4535e5ed53b1909$var$_identity.default : (0, $a4535e5ed53b1909$var$_formatNumerals.default)($a4535e5ed53b1909$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $a4535e5ed53b1909$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$a4535e5ed53b1909$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $a4535e5ed53b1909$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $a4535e5ed53b1909$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $a4535e5ed53b1909$var$prefixes[8 + $bBhlf.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $a4535e5ed53b1909$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $a4535e5ed53b1909$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $a4535e5ed53b1909$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("6zgJ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c82fc4af8be03c1$var$_default;

var $g2cY3 = parcelRequire("g2cY3");
function $4c82fc4af8be03c1$var$_default(x) {
    return x = (0, $g2cY3.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("g2cY3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bac6e4553e5b5e79$var$_default;
module.exports.formatDecimalParts = $bac6e4553e5b5e79$var$formatDecimalParts;
function $bac6e4553e5b5e79$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $bac6e4553e5b5e79$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("39E6E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c1529d9a2f0ff1$var$_default;
function $24c1529d9a2f0ff1$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("e8PdH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4b98b42f061be35$var$_default;
function $a4b98b42f061be35$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("72nIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $51fb1e75d25e5ef7$var$FormatSpecifier;
module.exports.default = $51fb1e75d25e5ef7$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $51fb1e75d25e5ef7$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $51fb1e75d25e5ef7$var$formatSpecifier(specifier) {
    if (!(match = $51fb1e75d25e5ef7$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $51fb1e75d25e5ef7$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$51fb1e75d25e5ef7$var$formatSpecifier.prototype = $51fb1e75d25e5ef7$var$FormatSpecifier.prototype; // instanceof
function $51fb1e75d25e5ef7$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$51fb1e75d25e5ef7$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("bdZl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82c07cfe4b215bf6$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $82c07cfe4b215bf6$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("LX6Di", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09023d1e2385db94$var$_formatDecimal = $09023d1e2385db94$var$_interopRequireDefault((parcelRequire("g2cY3")));

var $09023d1e2385db94$var$_formatPrefixAuto = $09023d1e2385db94$var$_interopRequireDefault((parcelRequire("bBhlf")));

var $09023d1e2385db94$var$_formatRounded = $09023d1e2385db94$var$_interopRequireDefault((parcelRequire("2lbRM")));
function $09023d1e2385db94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $09023d1e2385db94$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $09023d1e2385db94$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $09023d1e2385db94$var$_formatRounded.default)(x * 100, p),
    "r": $09023d1e2385db94$var$_formatRounded.default,
    "s": $09023d1e2385db94$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $09023d1e2385db94$var$_default;

});
parcelRegister("bBhlf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87209a1e1b1801c9$var$_default;
module.exports.prefixExponent = void 0;

var $g2cY3 = parcelRequire("g2cY3");
var $87209a1e1b1801c9$var$prefixExponent;
module.exports.prefixExponent = $87209a1e1b1801c9$var$prefixExponent;
function $87209a1e1b1801c9$var$_default(x, p) {
    var d = (0, $g2cY3.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $87209a1e1b1801c9$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $g2cY3.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("2lbRM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b46bf563616559b$var$_default;

var $g2cY3 = parcelRequire("g2cY3");
function $1b46bf563616559b$var$_default(x, p) {
    var d = (0, $g2cY3.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("22lxr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17bc79c4e94416e9$var$_default;
function $17bc79c4e94416e9$var$_default(x) {
    return x;
}

});



parcelRegister("btfhZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $859e433d73c59153$var$_default;

var $859e433d73c59153$var$_exponent = $859e433d73c59153$var$_interopRequireDefault((parcelRequire("6zgJ2")));
function $859e433d73c59153$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $859e433d73c59153$var$_default(step) {
    return Math.max(0, -(0, $859e433d73c59153$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("fc1nl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0f90b29f30448a4$var$_default;

var $b0f90b29f30448a4$var$_exponent = $b0f90b29f30448a4$var$_interopRequireDefault((parcelRequire("6zgJ2")));
function $b0f90b29f30448a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b0f90b29f30448a4$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $b0f90b29f30448a4$var$_exponent.default)(value) / 3))) * 3 - (0, $b0f90b29f30448a4$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("3QhCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cc3e592ee564f59$var$_default;

var $2cc3e592ee564f59$var$_exponent = $2cc3e592ee564f59$var$_interopRequireDefault((parcelRequire("6zgJ2")));
function $2cc3e592ee564f59$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2cc3e592ee564f59$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $2cc3e592ee564f59$var$_exponent.default)(max) - (0, $2cc3e592ee564f59$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("54ETL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b1d0d0e0a30cd60$var$log;
module.exports.loggish = $3b1d0d0e0a30cd60$var$loggish;

var $aPhjF = parcelRequire("aPhjF");

var $bgM31 = parcelRequire("bgM31");

var $3b1d0d0e0a30cd60$var$_nice = $3b1d0d0e0a30cd60$var$_interopRequireDefault((parcelRequire("91VoA")));

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");
function $3b1d0d0e0a30cd60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b1d0d0e0a30cd60$var$transformLog(x) {
    return Math.log(x);
}
function $3b1d0d0e0a30cd60$var$transformExp(x) {
    return Math.exp(x);
}
function $3b1d0d0e0a30cd60$var$transformLogn(x) {
    return -Math.log(-x);
}
function $3b1d0d0e0a30cd60$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $3b1d0d0e0a30cd60$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $3b1d0d0e0a30cd60$var$powp(base) {
    return base === 10 ? $3b1d0d0e0a30cd60$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $3b1d0d0e0a30cd60$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $3b1d0d0e0a30cd60$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $3b1d0d0e0a30cd60$var$loggish(transform) {
    const scale = transform($3b1d0d0e0a30cd60$var$transformLog, $3b1d0d0e0a30cd60$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $3b1d0d0e0a30cd60$var$logp(base), pows = $3b1d0d0e0a30cd60$var$powp(base);
        if (domain()[0] < 0) {
            logs = $3b1d0d0e0a30cd60$var$reflect(logs), pows = $3b1d0d0e0a30cd60$var$reflect(pows);
            transform($3b1d0d0e0a30cd60$var$transformLogn, $3b1d0d0e0a30cd60$var$transformExpn);
        } else transform($3b1d0d0e0a30cd60$var$transformLog, $3b1d0d0e0a30cd60$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $aPhjF.ticks)(u, v, n);
        } else z = (0, $aPhjF.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $bgM31.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $bgM31.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $3b1d0d0e0a30cd60$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $3b1d0d0e0a30cd60$var$log() {
    const scale = $3b1d0d0e0a30cd60$var$loggish((0, $8XQpm.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $8XQpm.copy)(scale, $3b1d0d0e0a30cd60$var$log()).base(scale.base());
    $3cC0P.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("91VoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6930ba998a87e004$var$nice;
function $6930ba998a87e004$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("2xdrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d89179791ffb2a0$var$symlog;
module.exports.symlogish = $1d89179791ffb2a0$var$symlogish;

var $lhUfg = parcelRequire("lhUfg");

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");
function $1d89179791ffb2a0$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $1d89179791ffb2a0$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $1d89179791ffb2a0$var$symlogish(transform) {
    var c = 1, scale = transform($1d89179791ffb2a0$var$transformSymlog(c), $1d89179791ffb2a0$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($1d89179791ffb2a0$var$transformSymlog(c = +_), $1d89179791ffb2a0$var$transformSymexp(c)) : c;
    };
    return (0, $lhUfg.linearish)(scale);
}
function $1d89179791ffb2a0$var$symlog() {
    var scale = $1d89179791ffb2a0$var$symlogish((0, $8XQpm.transformer)());
    scale.copy = function() {
        return (0, $8XQpm.copy)(scale, $1d89179791ffb2a0$var$symlog()).constant(scale.constant());
    };
    return $3cC0P.initRange.apply(scale, arguments);
}

});

parcelRegister("gnzjo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $beca2f859165bc58$var$pow;
module.exports.powish = $beca2f859165bc58$var$powish;
module.exports.sqrt = $beca2f859165bc58$var$sqrt;

var $lhUfg = parcelRequire("lhUfg");

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");
function $beca2f859165bc58$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $beca2f859165bc58$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $beca2f859165bc58$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $beca2f859165bc58$var$powish(transform) {
    var scale = transform($8XQpm.identity, $8XQpm.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($8XQpm.identity, $8XQpm.identity) : exponent === 0.5 ? transform($beca2f859165bc58$var$transformSqrt, $beca2f859165bc58$var$transformSquare) : transform($beca2f859165bc58$var$transformPow(exponent), $beca2f859165bc58$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $lhUfg.linearish)(scale);
}
function $beca2f859165bc58$var$pow() {
    var scale = $beca2f859165bc58$var$powish((0, $8XQpm.transformer)());
    scale.copy = function() {
        return (0, $8XQpm.copy)(scale, $beca2f859165bc58$var$pow()).exponent(scale.exponent());
    };
    $3cC0P.initRange.apply(scale, arguments);
    return scale;
}
function $beca2f859165bc58$var$sqrt() {
    return $beca2f859165bc58$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("11nyh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0be8275ff467f319$var$radial;

var $0be8275ff467f319$var$_continuous = $0be8275ff467f319$var$_interopRequireDefault((parcelRequire("8XQpm")));

var $3cC0P = parcelRequire("3cC0P");

var $lhUfg = parcelRequire("lhUfg");

var $0be8275ff467f319$var$_number = $0be8275ff467f319$var$_interopRequireDefault((parcelRequire("bKTAH")));
function $0be8275ff467f319$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0be8275ff467f319$var$square(x) {
    return Math.sign(x) * x * x;
}
function $0be8275ff467f319$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $0be8275ff467f319$var$radial() {
    var squared = (0, $0be8275ff467f319$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $0be8275ff467f319$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($0be8275ff467f319$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $0be8275ff467f319$var$_number.default)).map($0be8275ff467f319$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0be8275ff467f319$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $3cC0P.initRange.apply(scale, arguments);
    return (0, $lhUfg.linearish)(scale);
}

});

parcelRegister("1ktCZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f7ea42f7688af11$var$quantile;

var $aPhjF = parcelRequire("aPhjF");

var $3cC0P = parcelRequire("3cC0P");
function $0f7ea42f7688af11$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $aPhjF.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $aPhjF.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($aPhjF.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $0f7ea42f7688af11$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $3cC0P.initRange.apply(scale, arguments);
}

});

parcelRegister("4BvTs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35a35b8601219f90$var$quantize;

var $aPhjF = parcelRequire("aPhjF");

var $lhUfg = parcelRequire("lhUfg");

var $3cC0P = parcelRequire("3cC0P");
function $35a35b8601219f90$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $aPhjF.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $35a35b8601219f90$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $3cC0P.initRange.apply((0, $lhUfg.linearish)(scale), arguments);
}

});

parcelRegister("c2tKO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c3cc078e398707d$var$threshold;

var $aPhjF = parcelRequire("aPhjF");

var $3cC0P = parcelRequire("3cC0P");
function $8c3cc078e398707d$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $aPhjF.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8c3cc078e398707d$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $3cC0P.initRange.apply(scale, arguments);
}

});

parcelRegister("awB3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $7a99a4232ff78556$var$calendar;
module.exports.default = $7a99a4232ff78556$var$time;

var $6lxC3 = parcelRequire("6lxC3");

var $3eA3R = parcelRequire("3eA3R");

var $7a99a4232ff78556$var$_continuous = $7a99a4232ff78556$var$_interopRequireWildcard((parcelRequire("8XQpm")));

var $3cC0P = parcelRequire("3cC0P");

var $7a99a4232ff78556$var$_nice = $7a99a4232ff78556$var$_interopRequireDefault((parcelRequire("91VoA")));
function $7a99a4232ff78556$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a99a4232ff78556$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7a99a4232ff78556$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7a99a4232ff78556$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7a99a4232ff78556$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7a99a4232ff78556$var$date(t) {
    return new Date(t);
}
function $7a99a4232ff78556$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $7a99a4232ff78556$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $7a99a4232ff78556$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $7a99a4232ff78556$var$number)) : domain().map($7a99a4232ff78556$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $7a99a4232ff78556$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $7a99a4232ff78556$var$_continuous.copy)(scale, $7a99a4232ff78556$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $7a99a4232ff78556$var$time() {
    return $3cC0P.initRange.apply($7a99a4232ff78556$var$calendar($6lxC3.timeTicks, $6lxC3.timeTickInterval, $6lxC3.timeYear, $6lxC3.timeMonth, $6lxC3.timeWeek, $6lxC3.timeDay, $6lxC3.timeHour, $6lxC3.timeMinute, $6lxC3.timeSecond, $3eA3R.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("6lxC3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $bI7QP.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $bI7QP.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $bI7QP.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $bI7QP.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $bI7QP.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $bI7QP.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $bI7QP.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $bI7QP.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $bI7QP.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $bI7QP.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $5oUND.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $5oUND.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $bI7QP.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $bI7QP.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $bI7QP.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $bI7QP.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $bI7QP.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $bI7QP.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $5oUND.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $5oUND.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $cRB55.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $cRB55.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $cRB55.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $49eec707cc7a9dcb$var$_utcYear.utcYears;
    }
});

var $49eec707cc7a9dcb$var$_interval = $49eec707cc7a9dcb$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $49eec707cc7a9dcb$var$_millisecond = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("dNw0e")));

var $49eec707cc7a9dcb$var$_second = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("h5Evl")));

var $49eec707cc7a9dcb$var$_minute = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("hr12S")));

var $49eec707cc7a9dcb$var$_hour = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("2D8Ur")));

var $49eec707cc7a9dcb$var$_day = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("1uY1B")));

var $bI7QP = parcelRequire("bI7QP");

var $49eec707cc7a9dcb$var$_month = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("5StDE")));

var $49eec707cc7a9dcb$var$_year = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("eVKjm")));

var $49eec707cc7a9dcb$var$_utcMinute = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("8wCD5")));

var $49eec707cc7a9dcb$var$_utcHour = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("7VDcR")));

var $49eec707cc7a9dcb$var$_utcDay = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("jxt66")));

var $cRB55 = parcelRequire("cRB55");

var $49eec707cc7a9dcb$var$_utcMonth = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("a1NmT")));

var $49eec707cc7a9dcb$var$_utcYear = $49eec707cc7a9dcb$var$_interopRequireWildcard((parcelRequire("34u6k")));

var $5oUND = parcelRequire("5oUND");
function $49eec707cc7a9dcb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($49eec707cc7a9dcb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $49eec707cc7a9dcb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $49eec707cc7a9dcb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $49eec707cc7a9dcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9jk0Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c7569eaddf6efe3$var$newInterval;
var $6c7569eaddf6efe3$var$t0 = new Date(), $6c7569eaddf6efe3$var$t1 = new Date();
function $6c7569eaddf6efe3$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $6c7569eaddf6efe3$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $6c7569eaddf6efe3$var$t0.setTime(+start), $6c7569eaddf6efe3$var$t1.setTime(+end);
            floori($6c7569eaddf6efe3$var$t0), floori($6c7569eaddf6efe3$var$t1);
            return Math.floor(count($6c7569eaddf6efe3$var$t0, $6c7569eaddf6efe3$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("dNw0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $a0b8ad0a71a87a29$var$_interval = $a0b8ad0a71a87a29$var$_interopRequireDefault((parcelRequire("9jk0Y")));
function $a0b8ad0a71a87a29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a0b8ad0a71a87a29$var$millisecond = (0, $a0b8ad0a71a87a29$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$a0b8ad0a71a87a29$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $a0b8ad0a71a87a29$var$millisecond;
    return (0, $a0b8ad0a71a87a29$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $a0b8ad0a71a87a29$var$_default = $a0b8ad0a71a87a29$var$millisecond;
module.exports.default = $a0b8ad0a71a87a29$var$_default;
var $a0b8ad0a71a87a29$var$milliseconds = $a0b8ad0a71a87a29$var$millisecond.range;
module.exports.milliseconds = $a0b8ad0a71a87a29$var$milliseconds;

});

parcelRegister("h5Evl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $c71252a6ec61bc67$var$_interval = $c71252a6ec61bc67$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $c71252a6ec61bc67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c71252a6ec61bc67$var$second = (0, $c71252a6ec61bc67$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $hcxuK.durationSecond);
}, function(start, end) {
    return (end - start) / $hcxuK.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $c71252a6ec61bc67$var$_default = $c71252a6ec61bc67$var$second;
module.exports.default = $c71252a6ec61bc67$var$_default;
var $c71252a6ec61bc67$var$seconds = $c71252a6ec61bc67$var$second.range;
module.exports.seconds = $c71252a6ec61bc67$var$seconds;

});
parcelRegister("hcxuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $c85d8a0738bd1b40$var$durationSecond = 1000;
module.exports.durationSecond = $c85d8a0738bd1b40$var$durationSecond;
const $c85d8a0738bd1b40$var$durationMinute = $c85d8a0738bd1b40$var$durationSecond * 60;
module.exports.durationMinute = $c85d8a0738bd1b40$var$durationMinute;
const $c85d8a0738bd1b40$var$durationHour = $c85d8a0738bd1b40$var$durationMinute * 60;
module.exports.durationHour = $c85d8a0738bd1b40$var$durationHour;
const $c85d8a0738bd1b40$var$durationDay = $c85d8a0738bd1b40$var$durationHour * 24;
module.exports.durationDay = $c85d8a0738bd1b40$var$durationDay;
const $c85d8a0738bd1b40$var$durationWeek = $c85d8a0738bd1b40$var$durationDay * 7;
module.exports.durationWeek = $c85d8a0738bd1b40$var$durationWeek;
const $c85d8a0738bd1b40$var$durationMonth = $c85d8a0738bd1b40$var$durationDay * 30;
module.exports.durationMonth = $c85d8a0738bd1b40$var$durationMonth;
const $c85d8a0738bd1b40$var$durationYear = $c85d8a0738bd1b40$var$durationDay * 365;
module.exports.durationYear = $c85d8a0738bd1b40$var$durationYear;

});


parcelRegister("hr12S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $cb15c4e3d73fd6ea$var$_interval = $cb15c4e3d73fd6ea$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $cb15c4e3d73fd6ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cb15c4e3d73fd6ea$var$minute = (0, $cb15c4e3d73fd6ea$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $hcxuK.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $hcxuK.durationMinute);
}, function(start, end) {
    return (end - start) / $hcxuK.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $cb15c4e3d73fd6ea$var$_default = $cb15c4e3d73fd6ea$var$minute;
module.exports.default = $cb15c4e3d73fd6ea$var$_default;
var $cb15c4e3d73fd6ea$var$minutes = $cb15c4e3d73fd6ea$var$minute.range;
module.exports.minutes = $cb15c4e3d73fd6ea$var$minutes;

});

parcelRegister("2D8Ur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $1ea622830725d869$var$_interval = $1ea622830725d869$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $1ea622830725d869$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1ea622830725d869$var$hour = (0, $1ea622830725d869$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $hcxuK.durationSecond - date.getMinutes() * $hcxuK.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $hcxuK.durationHour);
}, function(start, end) {
    return (end - start) / $hcxuK.durationHour;
}, function(date) {
    return date.getHours();
});
var $1ea622830725d869$var$_default = $1ea622830725d869$var$hour;
module.exports.default = $1ea622830725d869$var$_default;
var $1ea622830725d869$var$hours = $1ea622830725d869$var$hour.range;
module.exports.hours = $1ea622830725d869$var$hours;

});

parcelRegister("1uY1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $1177277ec79e8723$var$_interval = $1177277ec79e8723$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $1177277ec79e8723$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1177277ec79e8723$var$day = (0, $1177277ec79e8723$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $hcxuK.durationMinute) / $hcxuK.durationDay, (date)=>date.getDate() - 1);
var $1177277ec79e8723$var$_default = $1177277ec79e8723$var$day;
module.exports.default = $1177277ec79e8723$var$_default;
var $1177277ec79e8723$var$days = $1177277ec79e8723$var$day.range;
module.exports.days = $1177277ec79e8723$var$days;

});

parcelRegister("bI7QP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $8869e4cfe4623fb4$var$_interval = $8869e4cfe4623fb4$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $8869e4cfe4623fb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8869e4cfe4623fb4$var$weekday(i) {
    return (0, $8869e4cfe4623fb4$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $hcxuK.durationMinute) / $hcxuK.durationWeek;
    });
}
var $8869e4cfe4623fb4$var$sunday = $8869e4cfe4623fb4$var$weekday(0);
module.exports.sunday = $8869e4cfe4623fb4$var$sunday;
var $8869e4cfe4623fb4$var$monday = $8869e4cfe4623fb4$var$weekday(1);
module.exports.monday = $8869e4cfe4623fb4$var$monday;
var $8869e4cfe4623fb4$var$tuesday = $8869e4cfe4623fb4$var$weekday(2);
module.exports.tuesday = $8869e4cfe4623fb4$var$tuesday;
var $8869e4cfe4623fb4$var$wednesday = $8869e4cfe4623fb4$var$weekday(3);
module.exports.wednesday = $8869e4cfe4623fb4$var$wednesday;
var $8869e4cfe4623fb4$var$thursday = $8869e4cfe4623fb4$var$weekday(4);
module.exports.thursday = $8869e4cfe4623fb4$var$thursday;
var $8869e4cfe4623fb4$var$friday = $8869e4cfe4623fb4$var$weekday(5);
module.exports.friday = $8869e4cfe4623fb4$var$friday;
var $8869e4cfe4623fb4$var$saturday = $8869e4cfe4623fb4$var$weekday(6);
module.exports.saturday = $8869e4cfe4623fb4$var$saturday;
var $8869e4cfe4623fb4$var$sundays = $8869e4cfe4623fb4$var$sunday.range;
module.exports.sundays = $8869e4cfe4623fb4$var$sundays;
var $8869e4cfe4623fb4$var$mondays = $8869e4cfe4623fb4$var$monday.range;
module.exports.mondays = $8869e4cfe4623fb4$var$mondays;
var $8869e4cfe4623fb4$var$tuesdays = $8869e4cfe4623fb4$var$tuesday.range;
module.exports.tuesdays = $8869e4cfe4623fb4$var$tuesdays;
var $8869e4cfe4623fb4$var$wednesdays = $8869e4cfe4623fb4$var$wednesday.range;
module.exports.wednesdays = $8869e4cfe4623fb4$var$wednesdays;
var $8869e4cfe4623fb4$var$thursdays = $8869e4cfe4623fb4$var$thursday.range;
module.exports.thursdays = $8869e4cfe4623fb4$var$thursdays;
var $8869e4cfe4623fb4$var$fridays = $8869e4cfe4623fb4$var$friday.range;
module.exports.fridays = $8869e4cfe4623fb4$var$fridays;
var $8869e4cfe4623fb4$var$saturdays = $8869e4cfe4623fb4$var$saturday.range;
module.exports.saturdays = $8869e4cfe4623fb4$var$saturdays;

});

parcelRegister("5StDE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $4478fc78958943ab$var$_interval = $4478fc78958943ab$var$_interopRequireDefault((parcelRequire("9jk0Y")));
function $4478fc78958943ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4478fc78958943ab$var$month = (0, $4478fc78958943ab$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $4478fc78958943ab$var$_default = $4478fc78958943ab$var$month;
module.exports.default = $4478fc78958943ab$var$_default;
var $4478fc78958943ab$var$months = $4478fc78958943ab$var$month.range;
module.exports.months = $4478fc78958943ab$var$months;

});

parcelRegister("eVKjm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $adea500866f90324$var$_interval = $adea500866f90324$var$_interopRequireDefault((parcelRequire("9jk0Y")));
function $adea500866f90324$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $adea500866f90324$var$year = (0, $adea500866f90324$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$adea500866f90324$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $adea500866f90324$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $adea500866f90324$var$_default = $adea500866f90324$var$year;
module.exports.default = $adea500866f90324$var$_default;
var $adea500866f90324$var$years = $adea500866f90324$var$year.range;
module.exports.years = $adea500866f90324$var$years;

});

parcelRegister("8wCD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $634f46e675021c37$var$_interval = $634f46e675021c37$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $634f46e675021c37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $634f46e675021c37$var$utcMinute = (0, $634f46e675021c37$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $hcxuK.durationMinute);
}, function(start, end) {
    return (end - start) / $hcxuK.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $634f46e675021c37$var$_default = $634f46e675021c37$var$utcMinute;
module.exports.default = $634f46e675021c37$var$_default;
var $634f46e675021c37$var$utcMinutes = $634f46e675021c37$var$utcMinute.range;
module.exports.utcMinutes = $634f46e675021c37$var$utcMinutes;

});

parcelRegister("7VDcR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $5c5c44d5061744e5$var$_interval = $5c5c44d5061744e5$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $5c5c44d5061744e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5c5c44d5061744e5$var$utcHour = (0, $5c5c44d5061744e5$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $hcxuK.durationHour);
}, function(start, end) {
    return (end - start) / $hcxuK.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $5c5c44d5061744e5$var$_default = $5c5c44d5061744e5$var$utcHour;
module.exports.default = $5c5c44d5061744e5$var$_default;
var $5c5c44d5061744e5$var$utcHours = $5c5c44d5061744e5$var$utcHour.range;
module.exports.utcHours = $5c5c44d5061744e5$var$utcHours;

});

parcelRegister("jxt66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $e397ab86e68750f6$var$_interval = $e397ab86e68750f6$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $e397ab86e68750f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e397ab86e68750f6$var$utcDay = (0, $e397ab86e68750f6$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $hcxuK.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $e397ab86e68750f6$var$_default = $e397ab86e68750f6$var$utcDay;
module.exports.default = $e397ab86e68750f6$var$_default;
var $e397ab86e68750f6$var$utcDays = $e397ab86e68750f6$var$utcDay.range;
module.exports.utcDays = $e397ab86e68750f6$var$utcDays;

});

parcelRegister("cRB55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $95d732cccbb8b532$var$_interval = $95d732cccbb8b532$var$_interopRequireDefault((parcelRequire("9jk0Y")));

var $hcxuK = parcelRequire("hcxuK");
function $95d732cccbb8b532$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $95d732cccbb8b532$var$utcWeekday(i) {
    return (0, $95d732cccbb8b532$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $hcxuK.durationWeek;
    });
}
var $95d732cccbb8b532$var$utcSunday = $95d732cccbb8b532$var$utcWeekday(0);
module.exports.utcSunday = $95d732cccbb8b532$var$utcSunday;
var $95d732cccbb8b532$var$utcMonday = $95d732cccbb8b532$var$utcWeekday(1);
module.exports.utcMonday = $95d732cccbb8b532$var$utcMonday;
var $95d732cccbb8b532$var$utcTuesday = $95d732cccbb8b532$var$utcWeekday(2);
module.exports.utcTuesday = $95d732cccbb8b532$var$utcTuesday;
var $95d732cccbb8b532$var$utcWednesday = $95d732cccbb8b532$var$utcWeekday(3);
module.exports.utcWednesday = $95d732cccbb8b532$var$utcWednesday;
var $95d732cccbb8b532$var$utcThursday = $95d732cccbb8b532$var$utcWeekday(4);
module.exports.utcThursday = $95d732cccbb8b532$var$utcThursday;
var $95d732cccbb8b532$var$utcFriday = $95d732cccbb8b532$var$utcWeekday(5);
module.exports.utcFriday = $95d732cccbb8b532$var$utcFriday;
var $95d732cccbb8b532$var$utcSaturday = $95d732cccbb8b532$var$utcWeekday(6);
module.exports.utcSaturday = $95d732cccbb8b532$var$utcSaturday;
var $95d732cccbb8b532$var$utcSundays = $95d732cccbb8b532$var$utcSunday.range;
module.exports.utcSundays = $95d732cccbb8b532$var$utcSundays;
var $95d732cccbb8b532$var$utcMondays = $95d732cccbb8b532$var$utcMonday.range;
module.exports.utcMondays = $95d732cccbb8b532$var$utcMondays;
var $95d732cccbb8b532$var$utcTuesdays = $95d732cccbb8b532$var$utcTuesday.range;
module.exports.utcTuesdays = $95d732cccbb8b532$var$utcTuesdays;
var $95d732cccbb8b532$var$utcWednesdays = $95d732cccbb8b532$var$utcWednesday.range;
module.exports.utcWednesdays = $95d732cccbb8b532$var$utcWednesdays;
var $95d732cccbb8b532$var$utcThursdays = $95d732cccbb8b532$var$utcThursday.range;
module.exports.utcThursdays = $95d732cccbb8b532$var$utcThursdays;
var $95d732cccbb8b532$var$utcFridays = $95d732cccbb8b532$var$utcFriday.range;
module.exports.utcFridays = $95d732cccbb8b532$var$utcFridays;
var $95d732cccbb8b532$var$utcSaturdays = $95d732cccbb8b532$var$utcSaturday.range;
module.exports.utcSaturdays = $95d732cccbb8b532$var$utcSaturdays;

});

parcelRegister("a1NmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $74d04ae565c19267$var$_interval = $74d04ae565c19267$var$_interopRequireDefault((parcelRequire("9jk0Y")));
function $74d04ae565c19267$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $74d04ae565c19267$var$utcMonth = (0, $74d04ae565c19267$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $74d04ae565c19267$var$_default = $74d04ae565c19267$var$utcMonth;
module.exports.default = $74d04ae565c19267$var$_default;
var $74d04ae565c19267$var$utcMonths = $74d04ae565c19267$var$utcMonth.range;
module.exports.utcMonths = $74d04ae565c19267$var$utcMonths;

});

parcelRegister("34u6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $23c9183efdbeb4b7$var$_interval = $23c9183efdbeb4b7$var$_interopRequireDefault((parcelRequire("9jk0Y")));
function $23c9183efdbeb4b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $23c9183efdbeb4b7$var$utcYear = (0, $23c9183efdbeb4b7$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$23c9183efdbeb4b7$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $23c9183efdbeb4b7$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $23c9183efdbeb4b7$var$_default = $23c9183efdbeb4b7$var$utcYear;
module.exports.default = $23c9183efdbeb4b7$var$_default;
var $23c9183efdbeb4b7$var$utcYears = $23c9183efdbeb4b7$var$utcYear.range;
module.exports.utcYears = $23c9183efdbeb4b7$var$utcYears;

});

parcelRegister("5oUND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $aPhjF = parcelRequire("aPhjF");

var $hcxuK = parcelRequire("hcxuK");

var $3eeb40dc157a4106$var$_millisecond = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("dNw0e")));

var $3eeb40dc157a4106$var$_second = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("h5Evl")));

var $3eeb40dc157a4106$var$_minute = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("hr12S")));

var $3eeb40dc157a4106$var$_hour = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("2D8Ur")));

var $3eeb40dc157a4106$var$_day = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("1uY1B")));

var $bI7QP = parcelRequire("bI7QP");

var $3eeb40dc157a4106$var$_month = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("5StDE")));

var $3eeb40dc157a4106$var$_year = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("eVKjm")));

var $3eeb40dc157a4106$var$_utcMinute = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("8wCD5")));

var $3eeb40dc157a4106$var$_utcHour = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("7VDcR")));

var $3eeb40dc157a4106$var$_utcDay = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("jxt66")));

var $cRB55 = parcelRequire("cRB55");

var $3eeb40dc157a4106$var$_utcMonth = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("a1NmT")));

var $3eeb40dc157a4106$var$_utcYear = $3eeb40dc157a4106$var$_interopRequireDefault((parcelRequire("34u6k")));
function $3eeb40dc157a4106$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3eeb40dc157a4106$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $3eeb40dc157a4106$var$_second.default,
            1,
            $hcxuK.durationSecond
        ],
        [
            $3eeb40dc157a4106$var$_second.default,
            5,
            5 * $hcxuK.durationSecond
        ],
        [
            $3eeb40dc157a4106$var$_second.default,
            15,
            15 * $hcxuK.durationSecond
        ],
        [
            $3eeb40dc157a4106$var$_second.default,
            30,
            30 * $hcxuK.durationSecond
        ],
        [
            minute,
            1,
            $hcxuK.durationMinute
        ],
        [
            minute,
            5,
            5 * $hcxuK.durationMinute
        ],
        [
            minute,
            15,
            15 * $hcxuK.durationMinute
        ],
        [
            minute,
            30,
            30 * $hcxuK.durationMinute
        ],
        [
            hour,
            1,
            $hcxuK.durationHour
        ],
        [
            hour,
            3,
            3 * $hcxuK.durationHour
        ],
        [
            hour,
            6,
            6 * $hcxuK.durationHour
        ],
        [
            hour,
            12,
            12 * $hcxuK.durationHour
        ],
        [
            day,
            1,
            $hcxuK.durationDay
        ],
        [
            day,
            2,
            2 * $hcxuK.durationDay
        ],
        [
            week,
            1,
            $hcxuK.durationWeek
        ],
        [
            month,
            1,
            $hcxuK.durationMonth
        ],
        [
            month,
            3,
            3 * $hcxuK.durationMonth
        ],
        [
            year,
            1,
            $hcxuK.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $aPhjF.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $aPhjF.tickStep)(start / $hcxuK.durationYear, stop / $hcxuK.durationYear, count));
        if (i === 0) return $3eeb40dc157a4106$var$_millisecond.default.every(Math.max((0, $aPhjF.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$3eeb40dc157a4106$var$utcTicks, $3eeb40dc157a4106$var$utcTickInterval] = $3eeb40dc157a4106$var$ticker($3eeb40dc157a4106$var$_utcYear.default, $3eeb40dc157a4106$var$_utcMonth.default, $cRB55.utcSunday, $3eeb40dc157a4106$var$_utcDay.default, $3eeb40dc157a4106$var$_utcHour.default, $3eeb40dc157a4106$var$_utcMinute.default);
module.exports.utcTickInterval = $3eeb40dc157a4106$var$utcTickInterval;
module.exports.utcTicks = $3eeb40dc157a4106$var$utcTicks;
const [$3eeb40dc157a4106$var$timeTicks, $3eeb40dc157a4106$var$timeTickInterval] = $3eeb40dc157a4106$var$ticker($3eeb40dc157a4106$var$_year.default, $3eeb40dc157a4106$var$_month.default, $bI7QP.sunday, $3eeb40dc157a4106$var$_day.default, $3eeb40dc157a4106$var$_hour.default, $3eeb40dc157a4106$var$_minute.default);
module.exports.timeTickInterval = $3eeb40dc157a4106$var$timeTickInterval;
module.exports.timeTicks = $3eeb40dc157a4106$var$timeTicks;

});


parcelRegister("3eA3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $25aea6e9f0983493$var$_defaultLocale.utcParse;
    }
});

var $25aea6e9f0983493$var$_defaultLocale = $25aea6e9f0983493$var$_interopRequireWildcard((parcelRequire("3fxko")));

var $25aea6e9f0983493$var$_locale = $25aea6e9f0983493$var$_interopRequireDefault((parcelRequire("7tsYz")));

var $25aea6e9f0983493$var$_isoFormat = $25aea6e9f0983493$var$_interopRequireDefault((parcelRequire("68L2G")));

var $25aea6e9f0983493$var$_isoParse = $25aea6e9f0983493$var$_interopRequireDefault((parcelRequire("4UTdK")));
function $25aea6e9f0983493$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25aea6e9f0983493$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($25aea6e9f0983493$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $25aea6e9f0983493$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $25aea6e9f0983493$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("3fxko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25dca006a4b215ac$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $25dca006a4b215ac$var$_locale = $25dca006a4b215ac$var$_interopRequireDefault((parcelRequire("7tsYz")));
function $25dca006a4b215ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $25dca006a4b215ac$var$locale;
var $25dca006a4b215ac$var$timeFormat;
module.exports.timeFormat = $25dca006a4b215ac$var$timeFormat;
var $25dca006a4b215ac$var$timeParse;
module.exports.timeParse = $25dca006a4b215ac$var$timeParse;
var $25dca006a4b215ac$var$utcFormat;
module.exports.utcFormat = $25dca006a4b215ac$var$utcFormat;
var $25dca006a4b215ac$var$utcParse;
module.exports.utcParse = $25dca006a4b215ac$var$utcParse;
$25dca006a4b215ac$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $25dca006a4b215ac$var$defaultLocale(definition) {
    $25dca006a4b215ac$var$locale = (0, $25dca006a4b215ac$var$_locale.default)(definition);
    module.exports.timeFormat = $25dca006a4b215ac$var$timeFormat = $25dca006a4b215ac$var$locale.format;
    module.exports.timeParse = $25dca006a4b215ac$var$timeParse = $25dca006a4b215ac$var$locale.parse;
    module.exports.utcFormat = $25dca006a4b215ac$var$utcFormat = $25dca006a4b215ac$var$locale.utcFormat;
    module.exports.utcParse = $25dca006a4b215ac$var$utcParse = $25dca006a4b215ac$var$locale.utcParse;
    return $25dca006a4b215ac$var$locale;
}

});
parcelRegister("7tsYz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5711b7d8b238ed93$var$formatLocale;

var $6lxC3 = parcelRequire("6lxC3");
function $5711b7d8b238ed93$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $5711b7d8b238ed93$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $5711b7d8b238ed93$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $5711b7d8b238ed93$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $5711b7d8b238ed93$var$formatRe(locale_periods), periodLookup = $5711b7d8b238ed93$var$formatLookup(locale_periods), weekdayRe = $5711b7d8b238ed93$var$formatRe(locale_weekdays), weekdayLookup = $5711b7d8b238ed93$var$formatLookup(locale_weekdays), shortWeekdayRe = $5711b7d8b238ed93$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $5711b7d8b238ed93$var$formatLookup(locale_shortWeekdays), monthRe = $5711b7d8b238ed93$var$formatRe(locale_months), monthLookup = $5711b7d8b238ed93$var$formatLookup(locale_months), shortMonthRe = $5711b7d8b238ed93$var$formatRe(locale_shortMonths), shortMonthLookup = $5711b7d8b238ed93$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $5711b7d8b238ed93$var$formatDayOfMonth,
        "e": $5711b7d8b238ed93$var$formatDayOfMonth,
        "f": $5711b7d8b238ed93$var$formatMicroseconds,
        "g": $5711b7d8b238ed93$var$formatYearISO,
        "G": $5711b7d8b238ed93$var$formatFullYearISO,
        "H": $5711b7d8b238ed93$var$formatHour24,
        "I": $5711b7d8b238ed93$var$formatHour12,
        "j": $5711b7d8b238ed93$var$formatDayOfYear,
        "L": $5711b7d8b238ed93$var$formatMilliseconds,
        "m": $5711b7d8b238ed93$var$formatMonthNumber,
        "M": $5711b7d8b238ed93$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $5711b7d8b238ed93$var$formatUnixTimestamp,
        "s": $5711b7d8b238ed93$var$formatUnixTimestampSeconds,
        "S": $5711b7d8b238ed93$var$formatSeconds,
        "u": $5711b7d8b238ed93$var$formatWeekdayNumberMonday,
        "U": $5711b7d8b238ed93$var$formatWeekNumberSunday,
        "V": $5711b7d8b238ed93$var$formatWeekNumberISO,
        "w": $5711b7d8b238ed93$var$formatWeekdayNumberSunday,
        "W": $5711b7d8b238ed93$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5711b7d8b238ed93$var$formatYear,
        "Y": $5711b7d8b238ed93$var$formatFullYear,
        "Z": $5711b7d8b238ed93$var$formatZone,
        "%": $5711b7d8b238ed93$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $5711b7d8b238ed93$var$formatUTCDayOfMonth,
        "e": $5711b7d8b238ed93$var$formatUTCDayOfMonth,
        "f": $5711b7d8b238ed93$var$formatUTCMicroseconds,
        "g": $5711b7d8b238ed93$var$formatUTCYearISO,
        "G": $5711b7d8b238ed93$var$formatUTCFullYearISO,
        "H": $5711b7d8b238ed93$var$formatUTCHour24,
        "I": $5711b7d8b238ed93$var$formatUTCHour12,
        "j": $5711b7d8b238ed93$var$formatUTCDayOfYear,
        "L": $5711b7d8b238ed93$var$formatUTCMilliseconds,
        "m": $5711b7d8b238ed93$var$formatUTCMonthNumber,
        "M": $5711b7d8b238ed93$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $5711b7d8b238ed93$var$formatUnixTimestamp,
        "s": $5711b7d8b238ed93$var$formatUnixTimestampSeconds,
        "S": $5711b7d8b238ed93$var$formatUTCSeconds,
        "u": $5711b7d8b238ed93$var$formatUTCWeekdayNumberMonday,
        "U": $5711b7d8b238ed93$var$formatUTCWeekNumberSunday,
        "V": $5711b7d8b238ed93$var$formatUTCWeekNumberISO,
        "w": $5711b7d8b238ed93$var$formatUTCWeekdayNumberSunday,
        "W": $5711b7d8b238ed93$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $5711b7d8b238ed93$var$formatUTCYear,
        "Y": $5711b7d8b238ed93$var$formatUTCFullYear,
        "Z": $5711b7d8b238ed93$var$formatUTCZone,
        "%": $5711b7d8b238ed93$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $5711b7d8b238ed93$var$parseDayOfMonth,
        "e": $5711b7d8b238ed93$var$parseDayOfMonth,
        "f": $5711b7d8b238ed93$var$parseMicroseconds,
        "g": $5711b7d8b238ed93$var$parseYear,
        "G": $5711b7d8b238ed93$var$parseFullYear,
        "H": $5711b7d8b238ed93$var$parseHour24,
        "I": $5711b7d8b238ed93$var$parseHour24,
        "j": $5711b7d8b238ed93$var$parseDayOfYear,
        "L": $5711b7d8b238ed93$var$parseMilliseconds,
        "m": $5711b7d8b238ed93$var$parseMonthNumber,
        "M": $5711b7d8b238ed93$var$parseMinutes,
        "p": parsePeriod,
        "q": $5711b7d8b238ed93$var$parseQuarter,
        "Q": $5711b7d8b238ed93$var$parseUnixTimestamp,
        "s": $5711b7d8b238ed93$var$parseUnixTimestampSeconds,
        "S": $5711b7d8b238ed93$var$parseSeconds,
        "u": $5711b7d8b238ed93$var$parseWeekdayNumberMonday,
        "U": $5711b7d8b238ed93$var$parseWeekNumberSunday,
        "V": $5711b7d8b238ed93$var$parseWeekNumberISO,
        "w": $5711b7d8b238ed93$var$parseWeekdayNumberSunday,
        "W": $5711b7d8b238ed93$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $5711b7d8b238ed93$var$parseYear,
        "Y": $5711b7d8b238ed93$var$parseFullYear,
        "Z": $5711b7d8b238ed93$var$parseZone,
        "%": $5711b7d8b238ed93$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $5711b7d8b238ed93$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $5711b7d8b238ed93$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $5711b7d8b238ed93$var$utcDate($5711b7d8b238ed93$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $6lxC3.utcMonday.ceil(week) : (0, $6lxC3.utcMonday)(week);
                    week = $6lxC3.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $5711b7d8b238ed93$var$localDate($5711b7d8b238ed93$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $6lxC3.timeMonday.ceil(week) : (0, $6lxC3.timeMonday)(week);
                    week = $6lxC3.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $5711b7d8b238ed93$var$utcDate($5711b7d8b238ed93$var$newDate(d.y, 0, 1)).getUTCDay() : $5711b7d8b238ed93$var$localDate($5711b7d8b238ed93$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $5711b7d8b238ed93$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $5711b7d8b238ed93$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $5711b7d8b238ed93$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $5711b7d8b238ed93$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $5711b7d8b238ed93$var$numberRe = /^\s*\d+/, // note: ignores next directive
$5711b7d8b238ed93$var$percentRe = /^%/, $5711b7d8b238ed93$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $5711b7d8b238ed93$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $5711b7d8b238ed93$var$requote(s) {
    return s.replace($5711b7d8b238ed93$var$requoteRe, "\\$&");
}
function $5711b7d8b238ed93$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($5711b7d8b238ed93$var$requote).join("|") + ")", "i");
}
function $5711b7d8b238ed93$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $5711b7d8b238ed93$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseWeekNumberSunday(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseWeekNumberISO(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseWeekNumberMonday(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseFullYear(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseYear(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseQuarter(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseMonthNumber(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseDayOfMonth(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseDayOfYear(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseHour24(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseMinutes(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseSeconds(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseMilliseconds(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseMicroseconds(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseLiteralPercent(d, string, i) {
    var n = $5711b7d8b238ed93$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $5711b7d8b238ed93$var$parseUnixTimestamp(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $5711b7d8b238ed93$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $5711b7d8b238ed93$var$formatDayOfMonth(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getDate(), p, 2);
}
function $5711b7d8b238ed93$var$formatHour24(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getHours(), p, 2);
}
function $5711b7d8b238ed93$var$formatHour12(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $5711b7d8b238ed93$var$formatDayOfYear(d, p) {
    return $5711b7d8b238ed93$var$pad(1 + $6lxC3.timeDay.count((0, $6lxC3.timeYear)(d), d), p, 3);
}
function $5711b7d8b238ed93$var$formatMilliseconds(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getMilliseconds(), p, 3);
}
function $5711b7d8b238ed93$var$formatMicroseconds(d, p) {
    return $5711b7d8b238ed93$var$formatMilliseconds(d, p) + "000";
}
function $5711b7d8b238ed93$var$formatMonthNumber(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getMonth() + 1, p, 2);
}
function $5711b7d8b238ed93$var$formatMinutes(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getMinutes(), p, 2);
}
function $5711b7d8b238ed93$var$formatSeconds(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getSeconds(), p, 2);
}
function $5711b7d8b238ed93$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $5711b7d8b238ed93$var$formatWeekNumberSunday(d, p) {
    return $5711b7d8b238ed93$var$pad($6lxC3.timeSunday.count((0, $6lxC3.timeYear)(d) - 1, d), p, 2);
}
function $5711b7d8b238ed93$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $6lxC3.timeThursday)(d) : $6lxC3.timeThursday.ceil(d);
}
function $5711b7d8b238ed93$var$formatWeekNumberISO(d, p) {
    d = $5711b7d8b238ed93$var$dISO(d);
    return $5711b7d8b238ed93$var$pad($6lxC3.timeThursday.count((0, $6lxC3.timeYear)(d), d) + ((0, $6lxC3.timeYear)(d).getDay() === 4), p, 2);
}
function $5711b7d8b238ed93$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $5711b7d8b238ed93$var$formatWeekNumberMonday(d, p) {
    return $5711b7d8b238ed93$var$pad($6lxC3.timeMonday.count((0, $6lxC3.timeYear)(d) - 1, d), p, 2);
}
function $5711b7d8b238ed93$var$formatYear(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getFullYear() % 100, p, 2);
}
function $5711b7d8b238ed93$var$formatYearISO(d, p) {
    d = $5711b7d8b238ed93$var$dISO(d);
    return $5711b7d8b238ed93$var$pad(d.getFullYear() % 100, p, 2);
}
function $5711b7d8b238ed93$var$formatFullYear(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5711b7d8b238ed93$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $6lxC3.timeThursday)(d) : $6lxC3.timeThursday.ceil(d);
    return $5711b7d8b238ed93$var$pad(d.getFullYear() % 10000, p, 4);
}
function $5711b7d8b238ed93$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $5711b7d8b238ed93$var$pad(z / 60 | 0, "0", 2) + $5711b7d8b238ed93$var$pad(z % 60, "0", 2);
}
function $5711b7d8b238ed93$var$formatUTCDayOfMonth(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCDate(), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCHour24(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCHours(), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCHour12(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $5711b7d8b238ed93$var$formatUTCDayOfYear(d, p) {
    return $5711b7d8b238ed93$var$pad(1 + $6lxC3.utcDay.count((0, $6lxC3.utcYear)(d), d), p, 3);
}
function $5711b7d8b238ed93$var$formatUTCMilliseconds(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $5711b7d8b238ed93$var$formatUTCMicroseconds(d, p) {
    return $5711b7d8b238ed93$var$formatUTCMilliseconds(d, p) + "000";
}
function $5711b7d8b238ed93$var$formatUTCMonthNumber(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $5711b7d8b238ed93$var$formatUTCMinutes(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCMinutes(), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCSeconds(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCSeconds(), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $5711b7d8b238ed93$var$formatUTCWeekNumberSunday(d, p) {
    return $5711b7d8b238ed93$var$pad($6lxC3.utcSunday.count((0, $6lxC3.utcYear)(d) - 1, d), p, 2);
}
function $5711b7d8b238ed93$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $6lxC3.utcThursday)(d) : $6lxC3.utcThursday.ceil(d);
}
function $5711b7d8b238ed93$var$formatUTCWeekNumberISO(d, p) {
    d = $5711b7d8b238ed93$var$UTCdISO(d);
    return $5711b7d8b238ed93$var$pad($6lxC3.utcThursday.count((0, $6lxC3.utcYear)(d), d) + ((0, $6lxC3.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $5711b7d8b238ed93$var$formatUTCWeekNumberMonday(d, p) {
    return $5711b7d8b238ed93$var$pad($6lxC3.utcMonday.count((0, $6lxC3.utcYear)(d) - 1, d), p, 2);
}
function $5711b7d8b238ed93$var$formatUTCYear(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5711b7d8b238ed93$var$formatUTCYearISO(d, p) {
    d = $5711b7d8b238ed93$var$UTCdISO(d);
    return $5711b7d8b238ed93$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $5711b7d8b238ed93$var$formatUTCFullYear(d, p) {
    return $5711b7d8b238ed93$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5711b7d8b238ed93$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $6lxC3.utcThursday)(d) : $6lxC3.utcThursday.ceil(d);
    return $5711b7d8b238ed93$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $5711b7d8b238ed93$var$formatUTCZone() {
    return "+0000";
}
function $5711b7d8b238ed93$var$formatLiteralPercent() {
    return "%";
}
function $5711b7d8b238ed93$var$formatUnixTimestamp(d) {
    return +d;
}
function $5711b7d8b238ed93$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("68L2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $3fxko = parcelRequire("3fxko");
var $4787fb0aa84bec47$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $4787fb0aa84bec47$var$isoSpecifier;
function $4787fb0aa84bec47$var$formatIsoNative(date) {
    return date.toISOString();
}
var $4787fb0aa84bec47$var$formatIso = Date.prototype.toISOString ? $4787fb0aa84bec47$var$formatIsoNative : (0, $3fxko.utcFormat)($4787fb0aa84bec47$var$isoSpecifier);
var $4787fb0aa84bec47$var$_default = $4787fb0aa84bec47$var$formatIso;
module.exports.default = $4787fb0aa84bec47$var$_default;

});

parcelRegister("4UTdK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68L2G = parcelRequire("68L2G");

var $3fxko = parcelRequire("3fxko");
function $39473a105a9cd367$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $39473a105a9cd367$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $39473a105a9cd367$var$parseIsoNative : (0, $3fxko.utcParse)($68L2G.isoSpecifier);
var $39473a105a9cd367$var$_default = $39473a105a9cd367$var$parseIso;
module.exports.default = $39473a105a9cd367$var$_default;

});



parcelRegister("dW5nm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a254dca94dd23d60$var$utcTime;

var $6lxC3 = parcelRequire("6lxC3");

var $3eA3R = parcelRequire("3eA3R");

var $awB3R = parcelRequire("awB3R");

var $3cC0P = parcelRequire("3cC0P");
function $a254dca94dd23d60$var$utcTime() {
    return $3cC0P.initRange.apply((0, $awB3R.calendar)($6lxC3.utcTicks, $6lxC3.utcTickInterval, $6lxC3.utcYear, $6lxC3.utcMonth, $6lxC3.utcWeek, $6lxC3.utcDay, $6lxC3.utcHour, $6lxC3.utcMinute, $6lxC3.utcSecond, $3eA3R.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("22usg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $17c36464eb16315e$var$copy;
module.exports.default = $17c36464eb16315e$var$sequential;
module.exports.sequentialLog = $17c36464eb16315e$var$sequentialLog;
module.exports.sequentialPow = $17c36464eb16315e$var$sequentialPow;
module.exports.sequentialSqrt = $17c36464eb16315e$var$sequentialSqrt;
module.exports.sequentialSymlog = $17c36464eb16315e$var$sequentialSymlog;

var $dfHvL = parcelRequire("dfHvL");

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");

var $lhUfg = parcelRequire("lhUfg");

var $54ETL = parcelRequire("54ETL");

var $2xdrB = parcelRequire("2xdrB");

var $gnzjo = parcelRequire("gnzjo");
function $17c36464eb16315e$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $8XQpm.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($dfHvL.interpolate);
    scale.rangeRound = range($dfHvL.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $17c36464eb16315e$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $17c36464eb16315e$var$sequential() {
    var scale = (0, $lhUfg.linearish)($17c36464eb16315e$var$transformer()($8XQpm.identity));
    scale.copy = function() {
        return $17c36464eb16315e$var$copy(scale, $17c36464eb16315e$var$sequential());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $17c36464eb16315e$var$sequentialLog() {
    var scale = (0, $54ETL.loggish)($17c36464eb16315e$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $17c36464eb16315e$var$copy(scale, $17c36464eb16315e$var$sequentialLog()).base(scale.base());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $17c36464eb16315e$var$sequentialSymlog() {
    var scale = (0, $2xdrB.symlogish)($17c36464eb16315e$var$transformer());
    scale.copy = function() {
        return $17c36464eb16315e$var$copy(scale, $17c36464eb16315e$var$sequentialSymlog()).constant(scale.constant());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $17c36464eb16315e$var$sequentialPow() {
    var scale = (0, $gnzjo.powish)($17c36464eb16315e$var$transformer());
    scale.copy = function() {
        return $17c36464eb16315e$var$copy(scale, $17c36464eb16315e$var$sequentialPow()).exponent(scale.exponent());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $17c36464eb16315e$var$sequentialSqrt() {
    return $17c36464eb16315e$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("gvK97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c053563fbfdaa5e7$var$sequentialQuantile;

var $aPhjF = parcelRequire("aPhjF");

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");
function $c053563fbfdaa5e7$var$sequentialQuantile() {
    var domain = [], interpolator = $8XQpm.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $aPhjF.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($aPhjF.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $aPhjF.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $c053563fbfdaa5e7$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("jAxLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e42b91c7e9ba56ed$var$diverging;
module.exports.divergingLog = $e42b91c7e9ba56ed$var$divergingLog;
module.exports.divergingPow = $e42b91c7e9ba56ed$var$divergingPow;
module.exports.divergingSqrt = $e42b91c7e9ba56ed$var$divergingSqrt;
module.exports.divergingSymlog = $e42b91c7e9ba56ed$var$divergingSymlog;

var $dfHvL = parcelRequire("dfHvL");

var $8XQpm = parcelRequire("8XQpm");

var $3cC0P = parcelRequire("3cC0P");

var $lhUfg = parcelRequire("lhUfg");

var $54ETL = parcelRequire("54ETL");

var $22usg = parcelRequire("22usg");

var $2xdrB = parcelRequire("2xdrB");

var $gnzjo = parcelRequire("gnzjo");
function $e42b91c7e9ba56ed$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $8XQpm.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $dfHvL.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($dfHvL.interpolate);
    scale.rangeRound = range($dfHvL.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $e42b91c7e9ba56ed$var$diverging() {
    var scale = (0, $lhUfg.linearish)($e42b91c7e9ba56ed$var$transformer()($8XQpm.identity));
    scale.copy = function() {
        return (0, $22usg.copy)(scale, $e42b91c7e9ba56ed$var$diverging());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $e42b91c7e9ba56ed$var$divergingLog() {
    var scale = (0, $54ETL.loggish)($e42b91c7e9ba56ed$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $22usg.copy)(scale, $e42b91c7e9ba56ed$var$divergingLog()).base(scale.base());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $e42b91c7e9ba56ed$var$divergingSymlog() {
    var scale = (0, $2xdrB.symlogish)($e42b91c7e9ba56ed$var$transformer());
    scale.copy = function() {
        return (0, $22usg.copy)(scale, $e42b91c7e9ba56ed$var$divergingSymlog()).constant(scale.constant());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $e42b91c7e9ba56ed$var$divergingPow() {
    var scale = (0, $gnzjo.powish)($e42b91c7e9ba56ed$var$transformer());
    scale.copy = function() {
        return (0, $22usg.copy)(scale, $e42b91c7e9ba56ed$var$divergingPow()).exponent(scale.exponent());
    };
    return $3cC0P.initInterpolator.apply(scale, arguments);
}
function $e42b91c7e9ba56ed$var$divergingSqrt() {
    return $e42b91c7e9ba56ed$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



/* @leny/bowlstats
 *
 * /src/app.tsx
 */ var $fcb5aa05d5cac59c$exports = {};
'use strict';

$fcb5aa05d5cac59c$exports = (parcelRequire("7Gxq1"));






var $47a9201888aae4ca$export$882461b6382ed46c;
var $47a9201888aae4ca$export$757ceba2d55c277e;
'use strict';

var $a2nZt = parcelRequire("a2nZt");
var $47a9201888aae4ca$var$i;
$47a9201888aae4ca$export$882461b6382ed46c = $a2nZt.createRoot;
$47a9201888aae4ca$export$757ceba2d55c277e = $a2nZt.hydrateRoot;


/* @leny/bowlstats
 *
 * /src/containers/root.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");
var $db31a18109b31285$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, $db31a18109b31285$exports) {
        classNames.default = classNames;
        $db31a18109b31285$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


/* @leny/bowlstats
 *
 * /src/components/header.tsx
 */ 

var $d3298d1f5bb4b7c6$exports = {};
$d3298d1f5bb4b7c6$exports = JSON.parse("{\"title\":\"Rosack Bowling Stats\",\"goals\":{}}");



var $ejhsZ = parcelRequire("ejhsZ");
var $181641949ae44c6a$exports = {};
'use strict';
function $181641949ae44c6a$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $b7Z9x = parcelRequire("b7Z9x");
var $181641949ae44c6a$var$React__default = $181641949ae44c6a$var$_interopDefault($b7Z9x);
function $181641949ae44c6a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $181641949ae44c6a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $181641949ae44c6a$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $181641949ae44c6a$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $181641949ae44c6a$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $181641949ae44c6a$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($b7Z9x.PureComponent);
        $181641949ae44c6a$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $181641949ae44c6a$var$_defineProperty(SideEffect, "canUseDOM", $181641949ae44c6a$var$canUseDOM);
        return SideEffect;
    };
}
$181641949ae44c6a$exports = $181641949ae44c6a$var$withSideEffect;


var $4e7173fb678617f4$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $4e7173fb678617f4$var$hasElementType = typeof Element !== 'undefined';
var $4e7173fb678617f4$var$hasMap = typeof Map === 'function';
var $4e7173fb678617f4$var$hasSet = typeof Set === 'function';
var $4e7173fb678617f4$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $4e7173fb678617f4$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4e7173fb678617f4$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($4e7173fb678617f4$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$4e7173fb678617f4$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($4e7173fb678617f4$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($4e7173fb678617f4$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($4e7173fb678617f4$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$4e7173fb678617f4$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$4e7173fb678617f4$exports = function isEqual(a, b) {
    try {
        return $4e7173fb678617f4$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $b7Z9x = parcelRequire("b7Z9x");
var $abfa412a13faae96$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $abfa412a13faae96$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $abfa412a13faae96$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $abfa412a13faae96$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $abfa412a13faae96$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $abfa412a13faae96$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$abfa412a13faae96$exports = $abfa412a13faae96$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $abfa412a13faae96$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($abfa412a13faae96$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($abfa412a13faae96$var$getOwnPropertySymbols) {
            symbols = $abfa412a13faae96$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($abfa412a13faae96$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $e87c28160c8fdb39$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $e87c28160c8fdb39$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $e87c28160c8fdb39$var$VALID_TAG_NAMES = Object.keys($e87c28160c8fdb39$var$TAG_NAMES).map(function(name) {
    return $e87c28160c8fdb39$var$TAG_NAMES[name];
});
var $e87c28160c8fdb39$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $e87c28160c8fdb39$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $e87c28160c8fdb39$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $e87c28160c8fdb39$var$HTML_TAG_MAP = Object.keys($e87c28160c8fdb39$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$e87c28160c8fdb39$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $e87c28160c8fdb39$var$SELF_CLOSING_TAGS = [
    $e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT,
    $e87c28160c8fdb39$var$TAG_NAMES.SCRIPT,
    $e87c28160c8fdb39$var$TAG_NAMES.STYLE
];
var $e87c28160c8fdb39$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $e87c28160c8fdb39$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e87c28160c8fdb39$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $e87c28160c8fdb39$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $e87c28160c8fdb39$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e87c28160c8fdb39$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $e87c28160c8fdb39$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $e87c28160c8fdb39$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $e87c28160c8fdb39$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $e87c28160c8fdb39$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$TAG_NAMES.TITLE);
    var innermostTemplate = $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $e87c28160c8fdb39$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $e87c28160c8fdb39$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $e87c28160c8fdb39$var$_extends({}, tagAttrs, current);
    }, {});
};
var $e87c28160c8fdb39$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$e87c28160c8fdb39$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$e87c28160c8fdb39$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $e87c28160c8fdb39$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $e87c28160c8fdb39$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $e87c28160c8fdb39$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $e87c28160c8fdb39$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $e87c28160c8fdb39$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $e87c28160c8fdb39$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $e87c28160c8fdb39$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($abfa412a13faae96$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $e87c28160c8fdb39$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $e87c28160c8fdb39$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $e87c28160c8fdb39$var$getBaseTagFromPropsList([
            $e87c28160c8fdb39$var$TAG_PROPERTIES.HREF,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $e87c28160c8fdb39$var$getAttributesFromPropsList($e87c28160c8fdb39$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$HELMET_PROPS.DEFER),
        encode: $e87c28160c8fdb39$var$getInnermostProperty(propsList, $e87c28160c8fdb39$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $e87c28160c8fdb39$var$getAttributesFromPropsList($e87c28160c8fdb39$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $e87c28160c8fdb39$var$getTagsFromPropsList($e87c28160c8fdb39$var$TAG_NAMES.LINK, [
            $e87c28160c8fdb39$var$TAG_PROPERTIES.REL,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $e87c28160c8fdb39$var$getTagsFromPropsList($e87c28160c8fdb39$var$TAG_NAMES.META, [
            $e87c28160c8fdb39$var$TAG_PROPERTIES.NAME,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.CHARSET,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.HTTPEQUIV,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.PROPERTY,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $e87c28160c8fdb39$var$getTagsFromPropsList($e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT, [
            $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $e87c28160c8fdb39$var$getOnChangeClientState(propsList),
        scriptTags: $e87c28160c8fdb39$var$getTagsFromPropsList($e87c28160c8fdb39$var$TAG_NAMES.SCRIPT, [
            $e87c28160c8fdb39$var$TAG_PROPERTIES.SRC,
            $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $e87c28160c8fdb39$var$getTagsFromPropsList($e87c28160c8fdb39$var$TAG_NAMES.STYLE, [
            $e87c28160c8fdb39$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $e87c28160c8fdb39$var$getTitleFromPropsList(propsList),
        titleAttributes: $e87c28160c8fdb39$var$getAttributesFromPropsList($e87c28160c8fdb39$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $e87c28160c8fdb39$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $e87c28160c8fdb39$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $e87c28160c8fdb39$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $e87c28160c8fdb39$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $e87c28160c8fdb39$var$rafPolyfill : $parcel$global.requestAnimationFrame || $e87c28160c8fdb39$var$rafPolyfill;
var $e87c28160c8fdb39$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $e87c28160c8fdb39$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $e87c28160c8fdb39$var$cafPolyfill;
var $e87c28160c8fdb39$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $e87c28160c8fdb39$var$_helmetCallback = null;
var $e87c28160c8fdb39$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($e87c28160c8fdb39$var$_helmetCallback) $e87c28160c8fdb39$var$cancelAnimationFrame($e87c28160c8fdb39$var$_helmetCallback);
    if (newState.defer) $e87c28160c8fdb39$var$_helmetCallback = $e87c28160c8fdb39$var$requestAnimationFrame(function() {
        $e87c28160c8fdb39$var$commitTagChanges(newState, function() {
            $e87c28160c8fdb39$var$_helmetCallback = null;
        });
    });
    else {
        $e87c28160c8fdb39$var$commitTagChanges(newState);
        $e87c28160c8fdb39$var$_helmetCallback = null;
    }
};
var $e87c28160c8fdb39$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $e87c28160c8fdb39$var$updateAttributes($e87c28160c8fdb39$var$TAG_NAMES.BODY, bodyAttributes);
    $e87c28160c8fdb39$var$updateAttributes($e87c28160c8fdb39$var$TAG_NAMES.HTML, htmlAttributes);
    $e87c28160c8fdb39$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.BASE, baseTag),
        linkTags: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.LINK, linkTags),
        metaTags: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.META, metaTags),
        noscriptTags: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $e87c28160c8fdb39$var$updateTags($e87c28160c8fdb39$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $e87c28160c8fdb39$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $e87c28160c8fdb39$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $e87c28160c8fdb39$var$flattenArray(title);
    $e87c28160c8fdb39$var$updateAttributes($e87c28160c8fdb39$var$TAG_NAMES.TITLE, attributes);
};
var $e87c28160c8fdb39$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($e87c28160c8fdb39$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($e87c28160c8fdb39$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($e87c28160c8fdb39$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($e87c28160c8fdb39$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $e87c28160c8fdb39$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($e87c28160c8fdb39$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $e87c28160c8fdb39$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($e87c28160c8fdb39$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $e87c28160c8fdb39$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $e87c28160c8fdb39$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $e87c28160c8fdb39$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $e87c28160c8fdb39$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $e87c28160c8fdb39$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $e87c28160c8fdb39$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $e87c28160c8fdb39$var$HELMET_ATTRIBUTE + "=\"true\">" + $e87c28160c8fdb39$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $e87c28160c8fdb39$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML || attribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $e87c28160c8fdb39$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $e87c28160c8fdb39$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $e87c28160c8fdb39$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $e87c28160c8fdb39$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$e87c28160c8fdb39$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $e87c28160c8fdb39$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$e87c28160c8fdb39$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $e87c28160c8fdb39$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$e87c28160c8fdb39$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $e87c28160c8fdb39$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($e87c28160c8fdb39$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $e87c28160c8fdb39$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$e87c28160c8fdb39$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $e87c28160c8fdb39$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $e87c28160c8fdb39$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(type, mappedTag);
    });
};
var $e87c28160c8fdb39$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $e87c28160c8fdb39$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $e87c28160c8fdb39$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $e87c28160c8fdb39$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $e87c28160c8fdb39$var$ATTRIBUTE_NAMES.BODY:
        case $e87c28160c8fdb39$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $e87c28160c8fdb39$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $e87c28160c8fdb39$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $e87c28160c8fdb39$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $e87c28160c8fdb39$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $e87c28160c8fdb39$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.META, metaTags, encode),
        noscript: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $e87c28160c8fdb39$var$getMethodsForTag($e87c28160c8fdb39$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $e87c28160c8fdb39$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $e87c28160c8fdb39$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $e87c28160c8fdb39$var$classCallCheck(this, HelmetWrapper);
            return $e87c28160c8fdb39$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($4e7173fb678617f4$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $e87c28160c8fdb39$var$TAG_NAMES.SCRIPT:
                case $e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $e87c28160c8fdb39$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $e87c28160c8fdb39$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $e87c28160c8fdb39$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $e87c28160c8fdb39$var$TAG_NAMES.TITLE:
                    return $e87c28160c8fdb39$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $e87c28160c8fdb39$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $e87c28160c8fdb39$var$TAG_NAMES.BODY:
                    return $e87c28160c8fdb39$var$_extends({}, newProps, {
                        bodyAttributes: $e87c28160c8fdb39$var$_extends({}, newChildProps)
                    });
                case $e87c28160c8fdb39$var$TAG_NAMES.HTML:
                    return $e87c28160c8fdb39$var$_extends({}, newProps, {
                        htmlAttributes: $e87c28160c8fdb39$var$_extends({}, newChildProps)
                    });
            }
            return $e87c28160c8fdb39$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $e87c28160c8fdb39$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $e87c28160c8fdb39$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $e87c28160c8fdb39$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $e87c28160c8fdb39$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $e87c28160c8fdb39$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $e87c28160c8fdb39$var$TAG_NAMES.LINK:
                    case $e87c28160c8fdb39$var$TAG_NAMES.META:
                    case $e87c28160c8fdb39$var$TAG_NAMES.NOSCRIPT:
                    case $e87c28160c8fdb39$var$TAG_NAMES.SCRIPT:
                    case $e87c28160c8fdb39$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $e87c28160c8fdb39$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $e87c28160c8fdb39$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(Component, newProps);
        };
        $e87c28160c8fdb39$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $e87c28160c8fdb39$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $e87c28160c8fdb39$var$NullComponent = function NullComponent() {
    return null;
};
var $e87c28160c8fdb39$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($181641949ae44c6a$exports)))($e87c28160c8fdb39$var$reducePropsToState, $e87c28160c8fdb39$var$handleClientStateChange, $e87c28160c8fdb39$var$mapStateOnServer)($e87c28160c8fdb39$var$NullComponent);
var $e87c28160c8fdb39$export$dcef8f9bb9a41431 = $e87c28160c8fdb39$var$Helmet($e87c28160c8fdb39$var$HelmetSideEffects);
$e87c28160c8fdb39$export$dcef8f9bb9a41431.renderStatic = $e87c28160c8fdb39$export$dcef8f9bb9a41431.rewind;
var $e87c28160c8fdb39$export$2e2bcd8739ae039 = $e87c28160c8fdb39$export$dcef8f9bb9a41431;


const $a59ed6e022fedf74$var$Header = ({ mode: mode, onChangeMode: onChangeMode })=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $e87c28160c8fdb39$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("title", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).title
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("meta", {
                        name: "description",
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("header", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero", "is-small", "is-primary"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero-body", "is-flex", "is-justify-content-space-between", "is-align-items-end"),
                    children: [
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex-1"),
                            children: [
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h1", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("title"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).title
                                }),
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h2", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex-1")
                        })
                    ]
                })
            })
        ]
    });
var $a59ed6e022fedf74$export$2e2bcd8739ae039 = $a59ed6e022fedf74$var$Header;


/* @leny/bowlstats
 *
 * /src/containers/games.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");

/* @leny/bowlstats
 *
 * /src/components/numbers.tsx
 */ 

/* @leny/bowlstats
 *
 * /src/core/hooks/use-data.js
 */ 
var $b7Z9x = parcelRequire("b7Z9x");
/* @leny/bowlstats
 *
 * /src/core/data-store.ts
 */ // NOTE: this is a "static" store, as the data will not change during the app lifecycle.

var $b7Z9x = parcelRequire("b7Z9x");
var $b9927f3a23cabf27$exports = {};
$b9927f3a23cabf27$exports = JSON.parse("{\"games\":[{\"id\":\"Mike:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":28,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":68,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":108,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":134,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":143,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":152,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":152,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":31,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":51,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":78,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":97,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":106,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":125,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":144,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":144,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":133,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":152,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":161,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":181,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":181,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":53,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":93,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":113,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":141,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",7,2],\"cumulative\":160,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":160,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":0,\"multiple\":4},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":38,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":124,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":181,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":181,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":39,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":156,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":175,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":184,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":192,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":201,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":201,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":28,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":47,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":92,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":100,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":118,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":126,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":49,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":68,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":95,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":103,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":111,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":129,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":147,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\",8],\"cumulative\":165,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":165,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":5,\"single\":2,\"multiple\":3},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":56,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":134,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":164,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":194,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":194,\"pins\":115,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":58,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":78,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":107,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":154,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":163,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",6],\"cumulative\":179,\"score\":16,\"pins\":16,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":179,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":68,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":131,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":151,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":171,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":199,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":199,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":45,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":123,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":150,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":167,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":174,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":174,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":5,\"single\":1,\"multiple\":4},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-10-22:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":120,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":129,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":129,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2023-10-22:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":92,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":99,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":118,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",7,\"/\"],\"cumulative\":158,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":158,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":40,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":57,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":76,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":95,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":113,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":122,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":161,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":180,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":180,\"pins\":108,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":7,\"single\":5,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":59,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":79,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":97,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":133,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":163,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":193,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":193,\"pins\":118,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":38,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":55,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":63,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":81,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":90,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":112,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":88,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":84,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":114,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":143,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":163,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":182,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":202,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":202,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-12-03:1\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":60,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":120,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":169,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":188,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":207,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":226,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":235,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":235,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-12-03:2\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":60,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":89,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":146,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":174,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":193,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":202,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":202,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":71,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":81,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",\"/\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":121,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":141,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":141,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":38,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":83,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":102,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":121,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":140,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":159,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":179,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":179,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":8,\"single\":5,\"multiple\":3},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":49,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":88,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":144,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":163,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":163,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":4,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":78,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":138,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":166,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":185,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":194,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":203,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":203,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":35,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":55,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":75,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":93,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":102,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":109,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":137,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":156,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":165,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":165,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",7],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":14,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":33,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":52,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":137,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":145,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":145,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:3\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,3],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":28,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":65,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":84,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":93,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":181,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",8,1],\"cumulative\":200,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":200,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-05-19:1\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":57,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":128,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":148,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":167,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":176,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":196,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":196,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-05-19:2\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":138,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":165,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":165,\"pins\":108,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-07-07:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,2],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":80,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":116,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":124,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":154,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":181,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":181,\"pins\":110,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-07-07:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":112,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":131,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":150,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":169,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",7],\"cumulative\":186,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":186,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":6,\"single\":4,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":24,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":44,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":102,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":144,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":164,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":164,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":6,\"single\":4,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":28,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":57,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":117,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":126,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":44,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":63,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":91,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":121,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":151,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":178,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":178,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":33,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":93,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":150,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":170,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":187,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":196,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":196,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":73,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,1],\"cumulative\":80,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":116,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":136,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":153,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":161,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":161,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":35,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":55,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":145,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":175,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":205,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",6],\"cumulative\":231,\"score\":26,\"pins\":26,\"split\":false,\"spare\":false,\"open\":false}],\"score\":231,\"pins\":114,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":37,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":95,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":125,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":155,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":185,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":215,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":245,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":245,\"pins\":119,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":9,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":77,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":97,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":116,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":125,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":155,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":184,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":203,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":203,\"pins\":107,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":46,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":99,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":159,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":187,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":187,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":69,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":78,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":128,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":158,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":188,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",6],\"cumulative\":214,\"score\":26,\"pins\":26,\"split\":false,\"spare\":false,\"open\":false}],\"score\":214,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":47,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":94,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":114,\"score\":20,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":140,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":148,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":168,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":168,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":3,\"converted\":1},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":76,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":115,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":135,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":195,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":225,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":225,\"pins\":119,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":42,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":62,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":109,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":127,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":135,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":36,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":73,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":100,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":128,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":148,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":168,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":188,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":188,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":4,\"single\":4,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":76,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":93,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":112,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":121,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":148,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":172,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"X\",9],\"cumulative\":201,\"score\":29,\"pins\":29,\"split\":false,\"spare\":false,\"open\":false}],\"score\":201,\"pins\":115,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":86,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":112,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":149,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":158,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":167,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":167,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":66,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":112,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":120,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",7],\"cumulative\":137,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":137,\"pins\":101,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":26,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":63,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":82,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":102,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":142,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":202,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":229,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":229,\"pins\":117,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":95,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":124,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":144,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":162,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":171,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":180,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":180,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":58,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":77,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":104,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":162,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":181,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":181,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":49,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":89,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":179,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":208,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":228,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":247,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":247,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":53,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":88,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":107,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":123,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"/\",9],\"cumulative\":142,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":142,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":6,\"single\":3,\"multiple\":3},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":61,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":85,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":85,\"pins\":67,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":10,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":26,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":133,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":142,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":142,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-05-07:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,\"-\"],\"cumulative\":5,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":12,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":21,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":39,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":55,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":71,\"score\":16,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":90,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":99,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":0,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-05-07:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":73,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":100,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":110,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",1],\"cumulative\":111,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true}],\"score\":111,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":22,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":46,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":53,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":62,\"pins\":62,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":10,\"fouls\":0}},{\"id\":\"Sara:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":28,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":35,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":38,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":82,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":90,\"pins\":73,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.4,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":0,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-05-16:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":49,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":57,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":66,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":71,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",1],\"cumulative\":72,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true}],\"score\":72,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-05-16:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":35,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":91,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":111,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":137,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":159,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":159,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":58,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":86,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":105,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":114,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":123,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":141,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":150,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":150,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":16,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,6],\"cumulative\":23,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":32,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":51,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":79,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":107,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",9],\"cumulative\":126,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":126,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":59,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":81,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":86,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",9],\"cumulative\":105,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":105,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":46,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":54,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":103,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":121,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":138,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":145,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":153,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":153,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",9],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":26,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":70,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":80,\"score\":10,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":89,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":96,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":96,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":39,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":45,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":52,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":80,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":80,\"pins\":74,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",8],\"cumulative\":108,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":108,\"pins\":98,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":18,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",7],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":89,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":98,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":98,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":46,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":56,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":94,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":111,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":118,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":118,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":51,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":80,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",8],\"cumulative\":135,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":135,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":75,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":103,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":131,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",8,\"/\"],\"cumulative\":151,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":151,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,8],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":61,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":69,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":77,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":85,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":93,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",4],\"cumulative\":107,\"score\":14,\"pins\":14,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":107,\"pins\":91,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":57,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":76,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":85,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":102,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":110,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":139,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":158,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":158,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":35,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":61,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":88,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":96,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":104,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":104,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":25,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":70,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",1],\"cumulative\":71,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\",9],\"cumulative\":118,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":118,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":63,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":87,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":115,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":115,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":92,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":111,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":120,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":147,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":147,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":52,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":72,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":100,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",8],\"cumulative\":167,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":167,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2024-05-19:1\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":51,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":78,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":87,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":91,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":100,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",8],\"cumulative\":118,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":118,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-05-19:2\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":34,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":60,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":68,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":107,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":126,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":91,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-07-14:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,7],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":86,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.8,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-07-14:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[4,1],\"cumulative\":5,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":14,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":47,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":55,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":101,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":101,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":43,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":61,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":77,\"score\":16,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":97,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":123,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":132,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":140,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":140,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":5,\"single\":0,\"multiple\":5},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,3],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":23,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"/\"],\"cumulative\":42,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":51,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":59,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"X\",3],\"cumulative\":118,\"score\":23,\"pins\":23,\"split\":false,\"spare\":false,\"open\":false}],\"score\":118,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":61,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":79,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":107,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",7],\"cumulative\":124,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":124,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":57,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":66,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":84,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":102,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":110,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":140,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":170,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":170,\"pins\":114,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":86,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":103,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":111,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",8],\"cumulative\":129,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":129,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":41,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":58,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":75,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":82,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":103,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":112,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":46,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":63,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":79,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":109,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":139,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",9],\"cumulative\":168,\"score\":29,\"pins\":29,\"split\":false,\"spare\":false,\"open\":false}],\"score\":168,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":72,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":79,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":96,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":116,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\",8,\"-\"],\"cumulative\":134,\"score\":18,\"pins\":18,\"split\":false,\"spare\":false,\"open\":false}],\"score\":134,\"pins\":101,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":38,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":65,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":93,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":102,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":111,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":120,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",9],\"cumulative\":139,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":139,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":5,\"single\":3,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":40,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":49,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":62,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":80,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":96,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,2],\"cumulative\":104,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":131,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":131,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":5,\"single\":0,\"multiple\":5},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[4,3],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":73,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":86,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":93,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":93,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,3],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":37,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":57,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":134,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":134,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",3],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":10,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":45,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":52,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":69,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":81,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":22,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,5],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":37,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\",7],\"cumulative\":99,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":99,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":26,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":44,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":72,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"/\"],\"cumulative\":98,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":106,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":106,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.3,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":5,\"single\":2,\"multiple\":3},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":40,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":47,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":101,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":109,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":118,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2025-05-14:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":26,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":72,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":90,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,3],\"cumulative\":109,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":117,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":131,\"score\":14,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[4,\"/\",\"X\"],\"cumulative\":151,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":151,\"pins\":102,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":4,\"single\":1,\"multiple\":3},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2025-05-14:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":14,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":42,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":51,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":68,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":75,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":94,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":103,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":121,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":121,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",8],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":35,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":112,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":200,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":200,\"pins\":113,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":37,\"score\":19,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":55,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":99,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"-\",9],\"cumulative\":136,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":136,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":5,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":21,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,2],\"cumulative\":28,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":54,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":101,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":109,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":118,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":85,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":141,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":141,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":10,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":32,\"score\":13,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",3],\"cumulative\":35,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":44,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":10,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",\"-\"],\"cumulative\":54,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":64,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":72,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":81,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":81,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":46,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":72,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":88,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":106,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",9],\"cumulative\":125,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":125,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[1,3],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":11,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":26,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":33,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":42,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":48,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":56,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":62,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":65,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":65,\"pins\":65,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":24,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":41,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":48,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":66,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":82,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":97,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.1,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-05-07:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":28,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":47,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":71,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":79,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":86,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":86,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Calvin:2023-05-07:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,4],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":33,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":42,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":47,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":53,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":59,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":72,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":72,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,5],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":37,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":44,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":56,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":71,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":14,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":22,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":25,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":38,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":64,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":73,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":19,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":27,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":33,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":39,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":46,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":65,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":92,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":68,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":76,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":83,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":92,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":20,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":28,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":51,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":67,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":76,\"pins\":76,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.9,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":30,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,5],\"cumulative\":38,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":67,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":37,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,4],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":70,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":85,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":105,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":105,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":29,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":45,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":54,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":61,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":67,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":41,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,1],\"cumulative\":46,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":52,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":67,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":74,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":74,\"pins\":74,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,5],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":59,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":75,\"pins\":75,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-22:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":26,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":83,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":92,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-22:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":15,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":45,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":50,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":58,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":67,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":78,\"pins\":73,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"-\"],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":11,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":27,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":34,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":49,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":55,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":62,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,5],\"cumulative\":68,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":68,\"pins\":68,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5,\"splits\":{\"total\":4,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"-\"],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":20,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":27,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":59,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,3],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":70,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":77,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,4],\"cumulative\":82,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":82,\"pins\":69,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,1],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":12,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":32,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,3],\"cumulative\":54,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":61,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":67,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":77,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":86,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":12,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":19,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":50,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":71,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-12-03:1\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":50,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":70,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":6,\"fouls\":0}},{\"id\":\"Calvin:2023-12-03:2\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,2],\"cumulative\":18,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"-\"],\"cumulative\":36,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":45,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":54,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",7],\"cumulative\":71,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":23,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":46,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":52,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,1],\"cumulative\":64,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":81,\"pins\":75,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":37,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":62,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":80,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,\"-\"],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":11,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":18,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":32,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":44,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[2,1],\"cumulative\":54,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":62,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":62,\"pins\":62,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,1],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":21,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":36,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":50,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":66,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,1],\"cumulative\":73,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":89,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":89,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,1],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":21,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":36,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":54,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":58,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",\"X\"],\"cumulative\":78,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":78,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.7,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":23,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":32,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":86,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":103,\"score\":17,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":120,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":129,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":129,\"pins\":88,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:3\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":68,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":73,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":90,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":97,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-07-07:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,2],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":21,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":36,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":39,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":52,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,3],\"cumulative\":58,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":71,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":78,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":78,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-07-07:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,6],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":23,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":39,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":54,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,1],\"cumulative\":59,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"/\"],\"cumulative\":76,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":91,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":96,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":96,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":62,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":70,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":75,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":83,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":100,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":107,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":107,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":15,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":27,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":49,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":58,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":75,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":84,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":84,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":24,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":40,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":59,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":89,\"score\":23,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":102,\"score\":13,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"-\"],\"cumulative\":105,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":112,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,2],\"cumulative\":12,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":23,\"score\":11,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[1,5],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":44,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":22,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":38,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":54,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":74,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":82,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":82,\"pins\":76,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":34,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[3,2],\"cumulative\":52,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":79,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":88,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Calvin:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,4],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":55,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[4,5],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":99,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":49,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,4],\"cumulative\":54,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":60,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":78,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":87,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":105,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":105,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,1],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":23,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":30,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":33,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":50,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":57,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":63,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",7,1],\"cumulative\":108,\"score\":18,\"pins\":18,\"split\":false,\"spare\":false,\"open\":false}],\"score\":108,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":45,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":53,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",5],\"cumulative\":93,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":93,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",7],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":10,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":11,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":18,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":25,\"pins\":25,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":0.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":15,\"fouls\":0}},{\"id\":\"Calvin:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":4,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":4,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":7,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":15,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":15,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":23,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":23,\"pins\":23,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":1.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":14,\"fouls\":0}},{\"id\":\"Calvin:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":20,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":20,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":20,\"pins\":20,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":17,\"fouls\":0}},{\"id\":\"Calvin:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":6,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":25,\"score\":11,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",1],\"cumulative\":26,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":32,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":32,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":41,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":41,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":41,\"pins\":40,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":13,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":14,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":23,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":27,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":30,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":37,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":43,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":43,\"pins\":43,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":11,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":11,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":17,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":25,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":30,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":33,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":33,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":33,\"pins\":33,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":14,\"fouls\":0}},{\"id\":\"Calvin:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":7,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":23,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":43,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":57,\"score\":14,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",4],\"cumulative\":61,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":69,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",3],\"cumulative\":82,\"score\":13,\"pins\":13,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":82,\"pins\":68,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":18,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":33,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":38,\"score\":5,\"pins\":5,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":82,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":90,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":16,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":21,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":24,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":39,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":48,\"pins\":48,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":8,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":24,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":24,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",2],\"cumulative\":41,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":44,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":44,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":44,\"pins\":44,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":1.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":8,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":14,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":14,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":14,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":22,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":34,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",\"-\"],\"cumulative\":44,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":44,\"pins\":44,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":11,\"fouls\":0}},{\"id\":\"Calvin:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":1,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":9,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"-\"],\"cumulative\":11,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":22,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":28,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":42,\"pins\":42,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}}],\"leagues\":[]}");


const $7b5212127b697ff5$var$allGames = (0, (/*@__PURE__*/$parcel$interopDefault($b9927f3a23cabf27$exports))).games;
const $7b5212127b697ff5$var$avgReducer = (acc, game)=>acc + game.score;
const $7b5212127b697ff5$var$pinsReducer = (acc, game)=>acc + game.pins;
const $7b5212127b697ff5$var$absDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg);
const $7b5212127b697ff5$var$stdDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg) ** 2;
const $7b5212127b697ff5$var$bestReducer = (acc, game)=>Math.max(acc, game.score);
const $7b5212127b697ff5$var$worstReducer = (acc, game)=>Math.min(acc, game.score);
const $7b5212127b697ff5$var$strikesReducer = (acc, game)=>acc + game.stats.strikes;
const $7b5212127b697ff5$var$sparesReducer = (acc, game)=>acc + game.stats.spares.total;
const $7b5212127b697ff5$var$avgFBPReducer = (acc, game)=>acc + game.stats.avgFirstBallPinfall;
const $7b5212127b697ff5$export$431f78a03a8ddc84 = (user = "Mike", year = null, month = null, day = null, withHouseBallGames = true, withDryLaneGames = true)=>{
    const filteredGames = $7b5212127b697ff5$var$allGames.filter((game)=>withHouseBallGames ? true : !game.ball.startsWith("H")).filter((game)=>withDryLaneGames ? true : !!game.oilPattern).filter((game)=>game.user === user);
    const games = filteredGames.filter((game)=>year === null ? true : game.date.year === year && (month === null ? true : game.date.month === month && (day === null ? true : game.date.day === day)));
    const avg = Math.round(games.reduce($7b5212127b697ff5$var$avgReducer, 0) / games.length);
    return {
        games: games,
        leagues: (0, (/*@__PURE__*/$parcel$interopDefault($b9927f3a23cabf27$exports))).leagues,
        filters: {
            year: year,
            month: month,
            day: day,
            lists: {
                years: filteredGames.reduce((acc, game)=>{
                    const set = new Set(acc);
                    set.add(game.date.year);
                    return Array.from(set);
                }, []),
                months: Array.from(new Array(12).keys()).filter((mnth)=>!!filteredGames.find((game)=>game.date.year === year && game.date.month === mnth + 1)),
                days: filteredGames.filter((game)=>game.date.year === year && game.date.month === month).reduce((acc, game)=>Array.from(new Set(acc).add(game.date.day)), [])
            },
            withHouseBallGames: withHouseBallGames,
            withDryLaneGames: withDryLaneGames
        },
        stats: {
            games: games.length,
            pins: games.reduce($7b5212127b697ff5$var$pinsReducer, 0),
            avg: {
                value: avg,
                best: games.reduce($7b5212127b697ff5$var$bestReducer, 0),
                worst: games.reduce($7b5212127b697ff5$var$worstReducer, 300),
                stdDeviation: +Math.sqrt(games.reduce($7b5212127b697ff5$var$stdDeviationReducer(avg), 0) / games.length).toFixed(2),
                absDeviation: +(games.reduce($7b5212127b697ff5$var$absDeviationReducer(avg), 0) / avg).toFixed(2)
            },
            strikes: {
                value: +(games.reduce($7b5212127b697ff5$var$strikesReducer, 0) / (games.length * 12) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.strikes)) / 12 * 100).toFixed(2)
            },
            spares: {
                value: +(games.reduce($7b5212127b697ff5$var$sparesReducer, 0) / (games.length * 10) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.spares.total)) / 10 * 100).toFixed(2)
            },
            avgFirstBallPinfall: {
                value: +(games.reduce($7b5212127b697ff5$var$avgFBPReducer, 0) / games.length).toFixed(2),
                best: +Math.max(...games.map((game)=>game.stats.avgFirstBallPinfall)).toFixed(2)
            }
        }
    };
};
const $7b5212127b697ff5$export$129055f0840a203c = (0, $b7Z9x.createContext)($7b5212127b697ff5$export$431f78a03a8ddc84(true));
const $7b5212127b697ff5$export$b514f4c5cf6dd8e6 = $7b5212127b697ff5$export$129055f0840a203c.Provider;


const $2cbc9a738009361c$export$c1cf1cf4c5d51937 = ()=>(0, $b7Z9x.useContext)((0, $7b5212127b697ff5$export$129055f0840a203c));



const $d1d8966ef2294ff3$var$BSP = "\u0020";
const $d1d8966ef2294ff3$var$Numbers = ()=>{
    const { stats: stats } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("level", "is-align-items-start"),
        children: [
            [
                "Games",
                stats.games
            ],
            [
                "Avg Score",
                stats.avg.value,
                stats.avg.best,
                stats.avg.stdDeviation,
                (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgScorePerGame
            ],
            [
                "Avg First Ball Pinfall",
                stats.avgFirstBallPinfall.value,
                stats.avgFirstBallPinfall.best,
                null,
                (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgFirstBallPinfall
            ],
            [
                "Strikes",
                `${stats.strikes.value}%`,
                `${stats.strikes.best}%`
            ],
            [
                "Spares",
                `${stats.spares.value}%`,
                `${stats.spares.best}%`
            ],
            [
                "Pins",
                stats.pins
            ]
        ].map(([label, value, best, stdDeviation, goal])=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("level-item", "has-text-centered"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("p", {
                            className: "heading",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("p", {
                            className: "title",
                            children: value
                        }),
                        !!(goal && value) && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-6"),
                            children: [
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "goal:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                    className: value >= goal ? "has-text-success" : "has-text-danger",
                                    children: goal
                                })
                            ]
                        }),
                        !!stdDeviation && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "std. deviation:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                    className: "has-text-info",
                                    children: stdDeviation
                                })
                            ]
                        }),
                        !!best && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "best:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("strong", {
                                    className: "has-text-success",
                                    children: [
                                        " ",
                                        best,
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, label))
    });
};
var $d1d8966ef2294ff3$export$2e2bcd8739ae039 = $d1d8966ef2294ff3$var$Numbers;


/* @leny/bowlstats
 *
 * /src/components/filters.tsx
 */ 



var $b7Z9x = parcelRequire("b7Z9x");
/* @leny/bowlstats
 *
 * /src/core/utils.ts
 */ /* eslint-disable @typescript-eslint/no-unused-expressions */ const $a6962441c258f009$export$2fc09de897439556 = (outcome, isLastFrame = false)=>{
    if (!isLastFrame) {
        if (outcome.includes("X") || outcome.includes("/")) return 10;
        return outcome.reduce((acc, ball)=>acc + (typeof ball === "number" ? ball : 0), 0);
    }
    let pinsCount = 0;
    const [one, two, three] = outcome;
    if (one === "X") pinsCount += 10;
    else if (typeof one === "number" && two !== "/" && three !== "/") pinsCount += one;
    if (two === "/" || two === "X") pinsCount += 10;
    else if (typeof two === "number" && three !== "/") pinsCount += two;
    if (three === "/" || three === "X") pinsCount += 10;
    else if (typeof three === "number") pinsCount += three;
    return pinsCount;
};
const $a6962441c258f009$export$fa3b29edae795ef4 = (handler, stopPropagation = false)=>(e)=>{
        e.preventDefault();
        stopPropagation && e.stopPropagation();
        handler(e);
    };


var $a256cbbcc8ae3716$exports = {};
!function(t, e) {
    $a256cbbcc8ae3716$exports = e();
}($a256cbbcc8ae3716$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $af6a744d86cd9c4a$var$currentYear = new Date().getFullYear();
const $af6a744d86cd9c4a$var$currentMonth = new Date().getMonth();
const $af6a744d86cd9c4a$var$NBSP = "\u00a0";
const $af6a744d86cd9c4a$var$Filters = ({ user: user, year: year, month: month, day: day, withHouseBallGames: withHouseBallGames, withDryLaneGames: withDryLaneGames, onYearChange: onYearChange, onMonthChange: onMonthChange, onDayChange: onDayChange, onUserChange: onUserChange, toggleHouseBallGames: toggleHouseBallGames, toggleDryLaneGames: toggleDryLaneGames })=>{
    const { filters: filters } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const years = (0, $b7Z9x.useMemo)(()=>[
            "All",
            ...filters.lists.years.reverse()
        ], [
        filters
    ]);
    const months = (0, $b7Z9x.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.months
        ];
    }, [
        year,
        filters
    ]);
    const days = (0, $b7Z9x.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.days
        ];
    }, [
        year,
        filters
    ]);
    const users = [
        "Mike",
        "Sara",
        "Calvin"
    ];
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("columns"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column"),
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("tabs", "is-large"),
                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                            children: users.map((u)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))(user === u && "is-active"),
                                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                                        href: "#",
                                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                            onUserChange(u);
                                        }),
                                        children: u
                                    })
                                }, u))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("columns"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column"),
                    children: [
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("tabs", "is-large"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                                children: years.map((yr)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))((year === null && yr === "All" || year === yr) && "is-active"),
                                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                                            href: "#",
                                            onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                                onYearChange(yr === "All" ? null : yr);
                                                onMonthChange(null);
                                                onDayChange(null);
                                            }),
                                            children: yr
                                        })
                                    }, yr))
                            })
                        }),
                        year !== null && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("tabs"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                                children: months.map((i)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))((i === "All" && month === null || i + 1 === month) && "is-active"),
                                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("px-3"),
                                            href: "#",
                                            onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                                onMonthChange(i === "All" ? null : i + 1);
                                                onDayChange(null);
                                            }),
                                            children: i === "All" ? "All" : (0, (/*@__PURE__*/$parcel$interopDefault($a256cbbcc8ae3716$exports)))().set("month", i).format("MMM")
                                        })
                                    }, i))
                            })
                        }),
                        year !== null && month !== null && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("tabs", "is-small"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                                children: days.map((i)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))((i === "All" && day === null || i === day) && "is-active"),
                                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("px-1"),
                                            href: "#",
                                            onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                                onDayChange(i === "All" ? null : i);
                                            }),
                                            children: i === "All" ? "All" : `${i}`.padStart(2, "0")
                                        })
                                    }, i))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $af6a744d86cd9c4a$export$2e2bcd8739ae039 = $af6a744d86cd9c4a$var$Filters;


/* @leny/bowlstats
 *
 * /src/components/games.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $b7Z9x = parcelRequire("b7Z9x");


/* @leny/bowlstats
 *
 * /src/components/game.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");

/* @leny/bowlstats
 *
 * /src/components/game-frames.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.

/* @leny/bowlstats
 *
 * /src/components/game-frame-outcome.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $b7Z9x = parcelRequire("b7Z9x");

const $2df78ca71bd51dd2$var$NBSP = "\u00a0";
const $2df78ca71bd51dd2$var$ballStyles = {
    marginTop: -1,
    marginRight: -1,
    marginLeft: "auto"
};
const $2df78ca71bd51dd2$var$GameFrameOutcome = ({ frame: frame, lastFrame: lastFrame, compact: compact = false })=>{
    // convert the outcome tuple to an array of strings
    const frameOutcome = (0, $b7Z9x.useMemo)(()=>{
        let outcome = frame.outcome;
        if (lastFrame) {
            if (outcome.length === 2) outcome.push($2df78ca71bd51dd2$var$NBSP);
        } else if (outcome.length === 1 && outcome[0] === "X") outcome = [
            $2df78ca71bd51dd2$var$NBSP,
            "X"
        ];
        return outcome;
    }, [
        frame
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("table", {
        style: $2df78ca71bd51dd2$var$ballStyles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("table", "is-bordered"),
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("tr", {
                children: frameOutcome.map((outcome, index)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-family-monospace", "is-size-7", "py-1", "px-1", outcome === "X" && "has-text-success", outcome === "/" && "has-text-info", outcome === "F" && "has-text-danger", outcome === "-" && "has-text-danger", frame.split && index === 0 && "is-split-frame"),
                        children: outcome
                    }, index))
            })
        })
    });
};
var $2df78ca71bd51dd2$export$2e2bcd8739ae039 = $2df78ca71bd51dd2$var$GameFrameOutcome;



const $9ea79497e4749eac$var$GameFrames = ({ frames: frames, scratch: scratch, handicap: handicap, score: score, compact: compact = false, hideHeader: hideHeader = false })=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("table", "is-bordered", "is-fullwidth", `mb-${compact ? 0 : 4}`),
        children: [
            !hideHeader && (compact || /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("tr", {
                    children: [
                        Array.from(new Array(10).keys()).map((i)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("th", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                                width: i === 9 ? "11.25%" : "8.6%",
                                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                    children: i + 1
                                })
                            }, i)),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("th", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                            width: "11.2%",
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                children: scratch ? "Result" : ""
                            })
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("tr", {
                    children: [
                        frames.map((frame, index)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("td", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("p-0", "pb-1"),
                                width: index === 9 ? "11.25%" : "8.6%",
                                children: [
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-right", "mb-2"),
                                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $2df78ca71bd51dd2$export$2e2bcd8739ae039), {
                                            frame: frame,
                                            lastFrame: index === 9,
                                            compact: compact
                                        })
                                    }),
                                    compact || /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-centered", "is-block", "has-text-grey"),
                                        children: frame.cumulative
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-vcentered", "is-size-5", "has-text-centered", "has-text-weight-medium", scratch ? [
                                "pb-1",
                                "pt-0",
                                "pr-0",
                                "pl-2"
                            ] : compact && [
                                "py-1",
                                "px-2"
                            ]),
                            width: "11.2%",
                            children: [
                                scratch && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-right", "mb-2"),
                                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $2df78ca71bd51dd2$export$2e2bcd8739ae039), {
                                        frame: {
                                            outcome: [
                                                scratch,
                                                handicap || 0
                                            ]
                                        },
                                        compact: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))(scratch && "pr-2"),
                                    children: score
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
var $9ea79497e4749eac$export$2e2bcd8739ae039 = $9ea79497e4749eac$var$GameFrames;


/* @leny/bowlstats
 *
 * /src/components/game-stats.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");

var $3946d51b8802f963$exports = {};
var $bf759a7d004b6e9c$exports = {};
var $aa9ebce293fb2e09$exports = {};

var $83nx1 = parcelRequire("83nx1");
/** Built-in value references. */ var $aa9ebce293fb2e09$var$Symbol = $83nx1.Symbol;
$aa9ebce293fb2e09$exports = $aa9ebce293fb2e09$var$Symbol;


var $040851b4eb15669d$exports = {};

/** Used for built-in method references. */ var $040851b4eb15669d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $040851b4eb15669d$var$hasOwnProperty = $040851b4eb15669d$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $040851b4eb15669d$var$nativeObjectToString = $040851b4eb15669d$var$objectProto.toString;
/** Built-in value references. */ var $040851b4eb15669d$var$symToStringTag = $aa9ebce293fb2e09$exports ? $aa9ebce293fb2e09$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $040851b4eb15669d$var$getRawTag(value) {
    var isOwn = $040851b4eb15669d$var$hasOwnProperty.call(value, $040851b4eb15669d$var$symToStringTag), tag = value[$040851b4eb15669d$var$symToStringTag];
    try {
        value[$040851b4eb15669d$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $040851b4eb15669d$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$040851b4eb15669d$var$symToStringTag] = tag;
        else delete value[$040851b4eb15669d$var$symToStringTag];
    }
    return result;
}
$040851b4eb15669d$exports = $040851b4eb15669d$var$getRawTag;


var $bfc664c1961d700c$exports = {};
/** Used for built-in method references. */ var $bfc664c1961d700c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bfc664c1961d700c$var$nativeObjectToString = $bfc664c1961d700c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $bfc664c1961d700c$var$objectToString(value) {
    return $bfc664c1961d700c$var$nativeObjectToString.call(value);
}
$bfc664c1961d700c$exports = $bfc664c1961d700c$var$objectToString;


/** `Object#toString` result references. */ var $bf759a7d004b6e9c$var$nullTag = '[object Null]', $bf759a7d004b6e9c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $bf759a7d004b6e9c$var$symToStringTag = $aa9ebce293fb2e09$exports ? $aa9ebce293fb2e09$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $bf759a7d004b6e9c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $bf759a7d004b6e9c$var$undefinedTag : $bf759a7d004b6e9c$var$nullTag;
    return $bf759a7d004b6e9c$var$symToStringTag && $bf759a7d004b6e9c$var$symToStringTag in Object(value) ? $040851b4eb15669d$exports(value) : $bfc664c1961d700c$exports(value);
}
$bf759a7d004b6e9c$exports = $bf759a7d004b6e9c$var$baseGetTag;


var $3cf8bb2e7defbbff$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3cf8bb2e7defbbff$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$3cf8bb2e7defbbff$exports = $3cf8bb2e7defbbff$var$isObject;


/** `Object#toString` result references. */ var $3946d51b8802f963$var$asyncTag = '[object AsyncFunction]', $3946d51b8802f963$var$funcTag = '[object Function]', $3946d51b8802f963$var$genTag = '[object GeneratorFunction]', $3946d51b8802f963$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3946d51b8802f963$var$isFunction(value) {
    if (!$3cf8bb2e7defbbff$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $bf759a7d004b6e9c$exports(value);
    return tag == $3946d51b8802f963$var$funcTag || tag == $3946d51b8802f963$var$genTag || tag == $3946d51b8802f963$var$asyncTag || tag == $3946d51b8802f963$var$proxyTag;
}
$3946d51b8802f963$exports = $3946d51b8802f963$var$isFunction;



var $b7Z9x = parcelRequire("b7Z9x");
var $d946048a435dc4a5$exports = {};
var $ea39284deca3da9b$exports = {};
var $231d0d199b5440f4$exports = {};
var $e9f4eab8a3ba19aa$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e9f4eab8a3ba19aa$var$isArray = Array.isArray;
$e9f4eab8a3ba19aa$exports = $e9f4eab8a3ba19aa$var$isArray;


var $3dbb9373dff9ef1d$exports = {};

var $df0bd783b3fde9a7$exports = {};

var $30ec207d7cd7a4f3$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $30ec207d7cd7a4f3$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$30ec207d7cd7a4f3$exports = $30ec207d7cd7a4f3$var$isObjectLike;


/** `Object#toString` result references. */ var $df0bd783b3fde9a7$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $df0bd783b3fde9a7$var$isSymbol(value) {
    return typeof value == 'symbol' || $30ec207d7cd7a4f3$exports(value) && $bf759a7d004b6e9c$exports(value) == $df0bd783b3fde9a7$var$symbolTag;
}
$df0bd783b3fde9a7$exports = $df0bd783b3fde9a7$var$isSymbol;


/** Used to match property names within property paths. */ var $3dbb9373dff9ef1d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $3dbb9373dff9ef1d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $3dbb9373dff9ef1d$var$isKey(value, object) {
    if ($e9f4eab8a3ba19aa$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $df0bd783b3fde9a7$exports(value)) return true;
    return $3dbb9373dff9ef1d$var$reIsPlainProp.test(value) || !$3dbb9373dff9ef1d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$3dbb9373dff9ef1d$exports = $3dbb9373dff9ef1d$var$isKey;


var $87ddf13d782f02c7$exports = {};
var $e1e1ce93abd6b472$exports = {};
var $5ecb3d387c162e11$exports = {};
var $a3097376b2983dfe$exports = {};
var $61872e228a8d0894$exports = {};
var $44544d11583c1f02$exports = {};
var $244ff1016c104c26$exports = {};
var $5e46a292bd90b761$exports = {};
var $21ba99941d8ab1d0$exports = {};
var $70b3b5813e2140e9$exports = {};

var $89f2803ea63f36d8$exports = {};
var $f0faa20e5bf97680$exports = {};

var $83nx1 = parcelRequire("83nx1");
/** Used to detect overreaching core-js shims. */ var $f0faa20e5bf97680$var$coreJsData = $83nx1["__core-js_shared__"];
$f0faa20e5bf97680$exports = $f0faa20e5bf97680$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $89f2803ea63f36d8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($f0faa20e5bf97680$exports && $f0faa20e5bf97680$exports.keys && $f0faa20e5bf97680$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $89f2803ea63f36d8$var$isMasked(func) {
    return !!$89f2803ea63f36d8$var$maskSrcKey && $89f2803ea63f36d8$var$maskSrcKey in func;
}
$89f2803ea63f36d8$exports = $89f2803ea63f36d8$var$isMasked;



var $4f779702c2fe3a19$exports = {};
/** Used for built-in method references. */ var $4f779702c2fe3a19$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $4f779702c2fe3a19$var$funcToString = $4f779702c2fe3a19$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $4f779702c2fe3a19$var$toSource(func) {
    if (func != null) {
        try {
            return $4f779702c2fe3a19$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$4f779702c2fe3a19$exports = $4f779702c2fe3a19$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $70b3b5813e2140e9$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $70b3b5813e2140e9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $70b3b5813e2140e9$var$funcProto = Function.prototype, $70b3b5813e2140e9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $70b3b5813e2140e9$var$funcToString = $70b3b5813e2140e9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $70b3b5813e2140e9$var$hasOwnProperty = $70b3b5813e2140e9$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $70b3b5813e2140e9$var$reIsNative = RegExp('^' + $70b3b5813e2140e9$var$funcToString.call($70b3b5813e2140e9$var$hasOwnProperty).replace($70b3b5813e2140e9$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $70b3b5813e2140e9$var$baseIsNative(value) {
    if (!$3cf8bb2e7defbbff$exports(value) || $89f2803ea63f36d8$exports(value)) return false;
    var pattern = $3946d51b8802f963$exports(value) ? $70b3b5813e2140e9$var$reIsNative : $70b3b5813e2140e9$var$reIsHostCtor;
    return pattern.test($4f779702c2fe3a19$exports(value));
}
$70b3b5813e2140e9$exports = $70b3b5813e2140e9$var$baseIsNative;


var $9b177c3cf7fff0a0$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9b177c3cf7fff0a0$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$9b177c3cf7fff0a0$exports = $9b177c3cf7fff0a0$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $21ba99941d8ab1d0$var$getNative(object, key) {
    var value = $9b177c3cf7fff0a0$exports(object, key);
    return $70b3b5813e2140e9$exports(value) ? value : undefined;
}
$21ba99941d8ab1d0$exports = $21ba99941d8ab1d0$var$getNative;


/* Built-in method references that are verified to be native. */ var $5e46a292bd90b761$var$nativeCreate = $21ba99941d8ab1d0$exports(Object, 'create');
$5e46a292bd90b761$exports = $5e46a292bd90b761$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $244ff1016c104c26$var$hashClear() {
    this.__data__ = $5e46a292bd90b761$exports ? $5e46a292bd90b761$exports(null) : {};
    this.size = 0;
}
$244ff1016c104c26$exports = $244ff1016c104c26$var$hashClear;


var $66daacaf287d1f16$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $66daacaf287d1f16$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$66daacaf287d1f16$exports = $66daacaf287d1f16$var$hashDelete;


var $9ec8d927c892e013$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $9ec8d927c892e013$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $9ec8d927c892e013$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ec8d927c892e013$var$hasOwnProperty = $9ec8d927c892e013$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9ec8d927c892e013$var$hashGet(key) {
    var data = this.__data__;
    if ($5e46a292bd90b761$exports) {
        var result = data[key];
        return result === $9ec8d927c892e013$var$HASH_UNDEFINED ? undefined : result;
    }
    return $9ec8d927c892e013$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$9ec8d927c892e013$exports = $9ec8d927c892e013$var$hashGet;


var $7c11683a0ecf5304$exports = {};

/** Used for built-in method references. */ var $7c11683a0ecf5304$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c11683a0ecf5304$var$hasOwnProperty = $7c11683a0ecf5304$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7c11683a0ecf5304$var$hashHas(key) {
    var data = this.__data__;
    return $5e46a292bd90b761$exports ? data[key] !== undefined : $7c11683a0ecf5304$var$hasOwnProperty.call(data, key);
}
$7c11683a0ecf5304$exports = $7c11683a0ecf5304$var$hashHas;


var $b076c6401154c41f$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $b076c6401154c41f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b076c6401154c41f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $5e46a292bd90b761$exports && value === undefined ? $b076c6401154c41f$var$HASH_UNDEFINED : value;
    return this;
}
$b076c6401154c41f$exports = $b076c6401154c41f$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $44544d11583c1f02$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$44544d11583c1f02$var$Hash.prototype.clear = $244ff1016c104c26$exports;
$44544d11583c1f02$var$Hash.prototype['delete'] = $66daacaf287d1f16$exports;
$44544d11583c1f02$var$Hash.prototype.get = $9ec8d927c892e013$exports;
$44544d11583c1f02$var$Hash.prototype.has = $7c11683a0ecf5304$exports;
$44544d11583c1f02$var$Hash.prototype.set = $b076c6401154c41f$exports;
$44544d11583c1f02$exports = $44544d11583c1f02$var$Hash;


var $d9f7c7fedb7f5ff7$exports = {};
var $4fd7a9925e5f1bb2$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4fd7a9925e5f1bb2$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$4fd7a9925e5f1bb2$exports = $4fd7a9925e5f1bb2$var$listCacheClear;


var $7b99c7bdb875a04f$exports = {};
var $ee9d445eaa640127$exports = {};
var $40ef67da37ce76ef$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $40ef67da37ce76ef$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$40ef67da37ce76ef$exports = $40ef67da37ce76ef$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ee9d445eaa640127$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($40ef67da37ce76ef$exports(array[length][0], key)) return length;
    }
    return -1;
}
$ee9d445eaa640127$exports = $ee9d445eaa640127$var$assocIndexOf;


/** Used for built-in method references. */ var $7b99c7bdb875a04f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7b99c7bdb875a04f$var$splice = $7b99c7bdb875a04f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7b99c7bdb875a04f$var$listCacheDelete(key) {
    var data = this.__data__, index = $ee9d445eaa640127$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7b99c7bdb875a04f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$7b99c7bdb875a04f$exports = $7b99c7bdb875a04f$var$listCacheDelete;


var $24d0e4a0e39398c1$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $24d0e4a0e39398c1$var$listCacheGet(key) {
    var data = this.__data__, index = $ee9d445eaa640127$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$24d0e4a0e39398c1$exports = $24d0e4a0e39398c1$var$listCacheGet;


var $0ddab16b912d66b6$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0ddab16b912d66b6$var$listCacheHas(key) {
    return $ee9d445eaa640127$exports(this.__data__, key) > -1;
}
$0ddab16b912d66b6$exports = $0ddab16b912d66b6$var$listCacheHas;


var $e8d1e55b6e2aba2e$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e8d1e55b6e2aba2e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ee9d445eaa640127$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$e8d1e55b6e2aba2e$exports = $e8d1e55b6e2aba2e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d9f7c7fedb7f5ff7$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d9f7c7fedb7f5ff7$var$ListCache.prototype.clear = $4fd7a9925e5f1bb2$exports;
$d9f7c7fedb7f5ff7$var$ListCache.prototype['delete'] = $7b99c7bdb875a04f$exports;
$d9f7c7fedb7f5ff7$var$ListCache.prototype.get = $24d0e4a0e39398c1$exports;
$d9f7c7fedb7f5ff7$var$ListCache.prototype.has = $0ddab16b912d66b6$exports;
$d9f7c7fedb7f5ff7$var$ListCache.prototype.set = $e8d1e55b6e2aba2e$exports;
$d9f7c7fedb7f5ff7$exports = $d9f7c7fedb7f5ff7$var$ListCache;


var $478198d25e7d8609$exports = {};


var $83nx1 = parcelRequire("83nx1");
/* Built-in method references that are verified to be native. */ var $478198d25e7d8609$var$Map = $21ba99941d8ab1d0$exports($83nx1, 'Map');
$478198d25e7d8609$exports = $478198d25e7d8609$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $61872e228a8d0894$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $44544d11583c1f02$exports,
        'map': new ($478198d25e7d8609$exports || $d9f7c7fedb7f5ff7$exports),
        'string': new $44544d11583c1f02$exports
    };
}
$61872e228a8d0894$exports = $61872e228a8d0894$var$mapCacheClear;


var $06027bb2729ea74a$exports = {};
var $d27e32e4ac0f4081$exports = {};
var $7744efd4d6eb63c8$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $7744efd4d6eb63c8$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$7744efd4d6eb63c8$exports = $7744efd4d6eb63c8$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d27e32e4ac0f4081$var$getMapData(map, key) {
    var data = map.__data__;
    return $7744efd4d6eb63c8$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$d27e32e4ac0f4081$exports = $d27e32e4ac0f4081$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $06027bb2729ea74a$var$mapCacheDelete(key) {
    var result = $d27e32e4ac0f4081$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$06027bb2729ea74a$exports = $06027bb2729ea74a$var$mapCacheDelete;


var $ee9a4427b2278041$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ee9a4427b2278041$var$mapCacheGet(key) {
    return $d27e32e4ac0f4081$exports(this, key).get(key);
}
$ee9a4427b2278041$exports = $ee9a4427b2278041$var$mapCacheGet;


var $01145b8827a1976a$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $01145b8827a1976a$var$mapCacheHas(key) {
    return $d27e32e4ac0f4081$exports(this, key).has(key);
}
$01145b8827a1976a$exports = $01145b8827a1976a$var$mapCacheHas;


var $31dd1ae29856ec24$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $31dd1ae29856ec24$var$mapCacheSet(key, value) {
    var data = $d27e32e4ac0f4081$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$31dd1ae29856ec24$exports = $31dd1ae29856ec24$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a3097376b2983dfe$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a3097376b2983dfe$var$MapCache.prototype.clear = $61872e228a8d0894$exports;
$a3097376b2983dfe$var$MapCache.prototype['delete'] = $06027bb2729ea74a$exports;
$a3097376b2983dfe$var$MapCache.prototype.get = $ee9a4427b2278041$exports;
$a3097376b2983dfe$var$MapCache.prototype.has = $01145b8827a1976a$exports;
$a3097376b2983dfe$var$MapCache.prototype.set = $31dd1ae29856ec24$exports;
$a3097376b2983dfe$exports = $a3097376b2983dfe$var$MapCache;


/** Error message constants. */ var $5ecb3d387c162e11$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5ecb3d387c162e11$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5ecb3d387c162e11$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5ecb3d387c162e11$var$memoize.Cache || $a3097376b2983dfe$exports);
    return memoized;
}
// Expose `MapCache`.
$5ecb3d387c162e11$var$memoize.Cache = $a3097376b2983dfe$exports;
$5ecb3d387c162e11$exports = $5ecb3d387c162e11$var$memoize;


/** Used as the maximum memoize cache size. */ var $e1e1ce93abd6b472$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e1e1ce93abd6b472$var$memoizeCapped(func) {
    var result = $5ecb3d387c162e11$exports(func, function(key) {
        if (cache.size === $e1e1ce93abd6b472$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$e1e1ce93abd6b472$exports = $e1e1ce93abd6b472$var$memoizeCapped;


/** Used to match property names within property paths. */ var $87ddf13d782f02c7$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $87ddf13d782f02c7$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $87ddf13d782f02c7$var$stringToPath = $e1e1ce93abd6b472$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($87ddf13d782f02c7$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($87ddf13d782f02c7$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$87ddf13d782f02c7$exports = $87ddf13d782f02c7$var$stringToPath;


var $d89e3302df84e87e$exports = {};
var $9a87d8669729059b$exports = {};

var $a39ed7a356e41a02$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a39ed7a356e41a02$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a39ed7a356e41a02$exports = $a39ed7a356e41a02$var$arrayMap;




/** Used as references for various `Number` constants. */ var $9a87d8669729059b$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $9a87d8669729059b$var$symbolProto = $aa9ebce293fb2e09$exports ? $aa9ebce293fb2e09$exports.prototype : undefined, $9a87d8669729059b$var$symbolToString = $9a87d8669729059b$var$symbolProto ? $9a87d8669729059b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $9a87d8669729059b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($e9f4eab8a3ba19aa$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a39ed7a356e41a02$exports(value, $9a87d8669729059b$var$baseToString) + '';
    if ($df0bd783b3fde9a7$exports(value)) return $9a87d8669729059b$var$symbolToString ? $9a87d8669729059b$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$9a87d8669729059b$var$INFINITY ? '-0' : result;
}
$9a87d8669729059b$exports = $9a87d8669729059b$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d89e3302df84e87e$var$toString(value) {
    return value == null ? '' : $9a87d8669729059b$exports(value);
}
$d89e3302df84e87e$exports = $d89e3302df84e87e$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $231d0d199b5440f4$var$castPath(value, object) {
    if ($e9f4eab8a3ba19aa$exports(value)) return value;
    return $3dbb9373dff9ef1d$exports(value, object) ? [
        value
    ] : $87ddf13d782f02c7$exports($d89e3302df84e87e$exports(value));
}
$231d0d199b5440f4$exports = $231d0d199b5440f4$var$castPath;


var $fb63eade37bbe6b1$exports = {};

/** Used as references for various `Number` constants. */ var $fb63eade37bbe6b1$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $fb63eade37bbe6b1$var$toKey(value) {
    if (typeof value == 'string' || $df0bd783b3fde9a7$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$fb63eade37bbe6b1$var$INFINITY ? '-0' : result;
}
$fb63eade37bbe6b1$exports = $fb63eade37bbe6b1$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ea39284deca3da9b$var$baseGet(object, path) {
    path = $231d0d199b5440f4$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$fb63eade37bbe6b1$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$ea39284deca3da9b$exports = $ea39284deca3da9b$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d946048a435dc4a5$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $ea39284deca3da9b$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d946048a435dc4a5$exports = $d946048a435dc4a5$var$get;



var $de32b1105f498fbd$exports = {};
var $1083f3e9d8d8baef$exports = {};


/** `Object#toString` result references. */ var $1083f3e9d8d8baef$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $1083f3e9d8d8baef$var$isNumber(value) {
    return typeof value == 'number' || $30ec207d7cd7a4f3$exports(value) && $bf759a7d004b6e9c$exports(value) == $1083f3e9d8d8baef$var$numberTag;
}
$1083f3e9d8d8baef$exports = $1083f3e9d8d8baef$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $de32b1105f498fbd$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $1083f3e9d8d8baef$exports(value) && value != +value;
}
$de32b1105f498fbd$exports = $de32b1105f498fbd$var$isNaN;



var $4599bb014160114d$exports = {};



/** `Object#toString` result references. */ var $4599bb014160114d$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $4599bb014160114d$var$isString(value) {
    return typeof value == 'string' || !$e9f4eab8a3ba19aa$exports(value) && $30ec207d7cd7a4f3$exports(value) && $bf759a7d004b6e9c$exports(value) == $4599bb014160114d$var$stringTag;
}
$4599bb014160114d$exports = $4599bb014160114d$var$isString;


var $201aa8e07b0747a2$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $201aa8e07b0747a2$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4599bb014160114d$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $201aa8e07b0747a2$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1083f3e9d8d8baef$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(value);
};
var $201aa8e07b0747a2$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $201aa8e07b0747a2$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($4599bb014160114d$exports)))(value);
};
var $201aa8e07b0747a2$var$idCounter = 0;
var $201aa8e07b0747a2$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$201aa8e07b0747a2$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $201aa8e07b0747a2$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$201aa8e07b0747a2$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($4599bb014160114d$exports)))(percent)) return defaultValue;
    var value;
    if ($201aa8e07b0747a2$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $201aa8e07b0747a2$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $201aa8e07b0747a2$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $201aa8e07b0747a2$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($201aa8e07b0747a2$export$7e4aa119212bc614(numberA) && $201aa8e07b0747a2$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $201aa8e07b0747a2$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $201aa8e07b0747a2$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};






var $ee60f1bf9820924c$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $ee60f1bf9820924c$var$isNil(value) {
    return value == null;
}
$ee60f1bf9820924c$exports = $ee60f1bf9820924c$var$isNil;




var $b7Z9x = parcelRequire("b7Z9x");
var $e11d176fb25d7aff$exports = {};
'use strict';

$e11d176fb25d7aff$exports = (parcelRequire("e31E2"));



function $c84fad9052295dcc$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}




var $b7Z9x = parcelRequire("b7Z9x");
function $f321872aac18bbfb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f321872aac18bbfb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f321872aac18bbfb$var$_typeof(obj);
}
//
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $f321872aac18bbfb$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $f321872aac18bbfb$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $f321872aac18bbfb$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $f321872aac18bbfb$export$2b22758266a6fa48 = {
    svg: $f321872aac18bbfb$var$SVGContainerPropKeys,
    polygon: $f321872aac18bbfb$var$PolyElementKeys,
    polyline: $f321872aac18bbfb$var$PolyElementKeys
};
var $f321872aac18bbfb$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $f321872aac18bbfb$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($f321872aac18bbfb$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $f321872aac18bbfb$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $f321872aac18bbfb$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(props) || $f321872aac18bbfb$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($f321872aac18bbfb$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $f321872aac18bbfb$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $423c5b3e35d96d0c$var$_excluded = [
    "children"
], $423c5b3e35d96d0c$var$_excluded2 = [
    "children"
];
function $423c5b3e35d96d0c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $423c5b3e35d96d0c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $423c5b3e35d96d0c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $423c5b3e35d96d0c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $423c5b3e35d96d0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $423c5b3e35d96d0c$var$_typeof(obj);
}
var $423c5b3e35d96d0c$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var $423c5b3e35d96d0c$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $423c5b3e35d96d0c$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $423c5b3e35d96d0c$export$59a4d7d024cf1025 = [
    'none'
];
var $423c5b3e35d96d0c$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $423c5b3e35d96d0c$var$lastChildren = null;
var $423c5b3e35d96d0c$var$lastResult = null;
var $423c5b3e35d96d0c$export$45b10814cc054894 = function toArray(children) {
    if (children === $423c5b3e35d96d0c$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))($423c5b3e35d96d0c$var$lastResult)) return $423c5b3e35d96d0c$var$lastResult;
    var result = [];
    (0, $b7Z9x.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(child)) return;
        if ((0, $e11d176fb25d7aff$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $423c5b3e35d96d0c$var$lastResult = result;
    $423c5b3e35d96d0c$var$lastChildren = children;
    return result;
};
function $423c5b3e35d96d0c$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(type)) types = type.map(function(t) {
        return $423c5b3e35d96d0c$export$be63e0664592e141(t);
    });
    else types = [
        $423c5b3e35d96d0c$export$be63e0664592e141(type)
    ];
    $423c5b3e35d96d0c$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $423c5b3e35d96d0c$export$64c61536a2b72e0f(children, type) {
    var result = $423c5b3e35d96d0c$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $423c5b3e35d96d0c$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(type)) types = type.map(function(t) {
        return $423c5b3e35d96d0c$export$be63e0664592e141(t);
    });
    else types = [
        $423c5b3e35d96d0c$export$be63e0664592e141(type)
    ];
    $423c5b3e35d96d0c$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $423c5b3e35d96d0c$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $423c5b3e35d96d0c$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $423c5b3e35d96d0c$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($4599bb014160114d$exports)))(child.type) && $423c5b3e35d96d0c$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $423c5b3e35d96d0c$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $423c5b3e35d96d0c$var$_typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var $423c5b3e35d96d0c$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $f321872aac18bbfb$export$2b22758266a6fa48) === null || (0, $f321872aac18bbfb$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $f321872aac18bbfb$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $f321872aac18bbfb$export$190f430946f96110).includes(key)) || includeEvents && (0, $f321872aac18bbfb$export$f30789245f2c4d11).includes(key);
};
var $423c5b3e35d96d0c$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $423c5b3e35d96d0c$export$45b10814cc054894(children).forEach(function(entry) {
        if ($423c5b3e35d96d0c$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $423c5b3e35d96d0c$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($423c5b3e35d96d0c$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $423c5b3e35d96d0c$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $b7Z9x.Children).count(nextChildren);
    if (count !== (0, $b7Z9x.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $423c5b3e35d96d0c$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$423c5b3e35d96d0c$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $423c5b3e35d96d0c$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $423c5b3e35d96d0c$var$_objectWithoutProperties(_ref, $423c5b3e35d96d0c$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $423c5b3e35d96d0c$var$_objectWithoutProperties(_ref2, $423c5b3e35d96d0c$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $c84fad9052295dcc$export$d36bdfa510afb180)(nextProps, prevProps) && $423c5b3e35d96d0c$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $c84fad9052295dcc$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $423c5b3e35d96d0c$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $423c5b3e35d96d0c$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($423c5b3e35d96d0c$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $423c5b3e35d96d0c$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $423c5b3e35d96d0c$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $423c5b3e35d96d0c$var$REACT_BROWSER_EVENT_MAP[type]) return $423c5b3e35d96d0c$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $423c5b3e35d96d0c$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $423c5b3e35d96d0c$export$45b10814cc054894(children).indexOf(child);
};


var $6774215ffc20680c$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
];
function $6774215ffc20680c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6774215ffc20680c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6774215ffc20680c$var$_typeof(obj);
}
function $6774215ffc20680c$var$_extends() {
    $6774215ffc20680c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6774215ffc20680c$var$_extends.apply(this, arguments);
}
function $6774215ffc20680c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6774215ffc20680c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6774215ffc20680c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6774215ffc20680c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6774215ffc20680c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6774215ffc20680c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6774215ffc20680c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6774215ffc20680c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6774215ffc20680c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6774215ffc20680c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6774215ffc20680c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6774215ffc20680c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6774215ffc20680c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6774215ffc20680c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6774215ffc20680c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6774215ffc20680c$var$_setPrototypeOf(subClass, superClass);
}
function $6774215ffc20680c$var$_setPrototypeOf(o, p) {
    $6774215ffc20680c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6774215ffc20680c$var$_setPrototypeOf(o, p);
}
function $6774215ffc20680c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6774215ffc20680c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6774215ffc20680c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6774215ffc20680c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6774215ffc20680c$var$_possibleConstructorReturn(this, result);
    };
}
function $6774215ffc20680c$var$_possibleConstructorReturn(self, call) {
    if (call && ($6774215ffc20680c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6774215ffc20680c$var$_assertThisInitialized(self);
}
function $6774215ffc20680c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6774215ffc20680c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6774215ffc20680c$var$_getPrototypeOf(o) {
    $6774215ffc20680c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6774215ffc20680c$var$_getPrototypeOf(o);
}
function $6774215ffc20680c$var$_defineProperty(obj, key, value) {
    key = $6774215ffc20680c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6774215ffc20680c$var$_toPropertyKey(arg) {
    var key = $6774215ffc20680c$var$_toPrimitive(arg, "string");
    return $6774215ffc20680c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6774215ffc20680c$var$_toPrimitive(input, hint) {
    if ($6774215ffc20680c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6774215ffc20680c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6774215ffc20680c$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $6774215ffc20680c$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $6774215ffc20680c$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $6774215ffc20680c$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $6774215ffc20680c$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $6774215ffc20680c$var$_objectSpread($6774215ffc20680c$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $6774215ffc20680c$var$_objectSpread($6774215ffc20680c$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === 'none') return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(x) || x !== +x || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $6774215ffc20680c$var$_objectWithoutProperties(props, $6774215ffc20680c$var$_excluded);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", $6774215ffc20680c$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $b7Z9x.PureComponent));
$6774215ffc20680c$var$_defineProperty($6774215ffc20680c$export$6440e27b9f186856, "displayName", 'CartesianGrid');
$6774215ffc20680c$var$_defineProperty($6774215ffc20680c$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});


var $fead821d6e5c4378$exports = {};
var $a3e1cb58c2a61f92$exports = {};
var $6e42a1b159f70c7d$exports = {};
var $0feaba80faf7ff59$exports = {};
var $24b9dab4eebce549$exports = {};

var $6384792408a39500$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6384792408a39500$var$stackClear() {
    this.__data__ = new $d9f7c7fedb7f5ff7$exports;
    this.size = 0;
}
$6384792408a39500$exports = $6384792408a39500$var$stackClear;


var $c21c3cad3e3c9f16$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c21c3cad3e3c9f16$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$c21c3cad3e3c9f16$exports = $c21c3cad3e3c9f16$var$stackDelete;


var $88504c1bac44e6b9$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $88504c1bac44e6b9$var$stackGet(key) {
    return this.__data__.get(key);
}
$88504c1bac44e6b9$exports = $88504c1bac44e6b9$var$stackGet;


var $2836f45fb25917d0$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2836f45fb25917d0$var$stackHas(key) {
    return this.__data__.has(key);
}
$2836f45fb25917d0$exports = $2836f45fb25917d0$var$stackHas;


var $9b0e620b517ba777$exports = {};



/** Used as the size to enable large array optimizations. */ var $9b0e620b517ba777$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9b0e620b517ba777$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $d9f7c7fedb7f5ff7$exports) {
        var pairs = data.__data__;
        if (!$478198d25e7d8609$exports || pairs.length < $9b0e620b517ba777$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $a3097376b2983dfe$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9b0e620b517ba777$exports = $9b0e620b517ba777$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $24b9dab4eebce549$var$Stack(entries) {
    var data = this.__data__ = new $d9f7c7fedb7f5ff7$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$24b9dab4eebce549$var$Stack.prototype.clear = $6384792408a39500$exports;
$24b9dab4eebce549$var$Stack.prototype['delete'] = $c21c3cad3e3c9f16$exports;
$24b9dab4eebce549$var$Stack.prototype.get = $88504c1bac44e6b9$exports;
$24b9dab4eebce549$var$Stack.prototype.has = $2836f45fb25917d0$exports;
$24b9dab4eebce549$var$Stack.prototype.set = $9b0e620b517ba777$exports;
$24b9dab4eebce549$exports = $24b9dab4eebce549$var$Stack;


var $ddcb57ea93e59e60$exports = {};
var $73c2bbddf05cdc83$exports = {};

var $1e0c8d992f8faf3a$exports = {};
var $0f6cd24e62a0006a$exports = {};

var $8dbf027ad95e8f23$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $8dbf027ad95e8f23$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $8dbf027ad95e8f23$var$setCacheAdd(value) {
    this.__data__.set(value, $8dbf027ad95e8f23$var$HASH_UNDEFINED);
    return this;
}
$8dbf027ad95e8f23$exports = $8dbf027ad95e8f23$var$setCacheAdd;


var $eb48169aaaf34b5c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $eb48169aaaf34b5c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$eb48169aaaf34b5c$exports = $eb48169aaaf34b5c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $0f6cd24e62a0006a$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $a3097376b2983dfe$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$0f6cd24e62a0006a$var$SetCache.prototype.add = $0f6cd24e62a0006a$var$SetCache.prototype.push = $8dbf027ad95e8f23$exports;
$0f6cd24e62a0006a$var$SetCache.prototype.has = $eb48169aaaf34b5c$exports;
$0f6cd24e62a0006a$exports = $0f6cd24e62a0006a$var$SetCache;


var $bc5234a832151b51$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $bc5234a832151b51$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$bc5234a832151b51$exports = $bc5234a832151b51$var$arraySome;


var $4df0723149b6448e$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4df0723149b6448e$var$cacheHas(cache, key) {
    return cache.has(key);
}
$4df0723149b6448e$exports = $4df0723149b6448e$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1e0c8d992f8faf3a$var$COMPARE_PARTIAL_FLAG = 1, $1e0c8d992f8faf3a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1e0c8d992f8faf3a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1e0c8d992f8faf3a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1e0c8d992f8faf3a$var$COMPARE_UNORDERED_FLAG ? new $0f6cd24e62a0006a$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$bc5234a832151b51$exports(other, function(othValue, othIndex) {
                if (!$4df0723149b6448e$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1e0c8d992f8faf3a$exports = $1e0c8d992f8faf3a$var$equalArrays;


var $d67f2325927a902d$exports = {};

var $173da7417fce8a3d$exports = {};

var $83nx1 = parcelRequire("83nx1");
/** Built-in value references. */ var $173da7417fce8a3d$var$Uint8Array = $83nx1.Uint8Array;
$173da7417fce8a3d$exports = $173da7417fce8a3d$var$Uint8Array;




var $09bacb38db54c07f$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $09bacb38db54c07f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$09bacb38db54c07f$exports = $09bacb38db54c07f$var$mapToArray;


var $b0242255ce20714a$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b0242255ce20714a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$b0242255ce20714a$exports = $b0242255ce20714a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d67f2325927a902d$var$COMPARE_PARTIAL_FLAG = 1, $d67f2325927a902d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d67f2325927a902d$var$boolTag = '[object Boolean]', $d67f2325927a902d$var$dateTag = '[object Date]', $d67f2325927a902d$var$errorTag = '[object Error]', $d67f2325927a902d$var$mapTag = '[object Map]', $d67f2325927a902d$var$numberTag = '[object Number]', $d67f2325927a902d$var$regexpTag = '[object RegExp]', $d67f2325927a902d$var$setTag = '[object Set]', $d67f2325927a902d$var$stringTag = '[object String]', $d67f2325927a902d$var$symbolTag = '[object Symbol]';
var $d67f2325927a902d$var$arrayBufferTag = '[object ArrayBuffer]', $d67f2325927a902d$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $d67f2325927a902d$var$symbolProto = $aa9ebce293fb2e09$exports ? $aa9ebce293fb2e09$exports.prototype : undefined, $d67f2325927a902d$var$symbolValueOf = $d67f2325927a902d$var$symbolProto ? $d67f2325927a902d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d67f2325927a902d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d67f2325927a902d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d67f2325927a902d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $173da7417fce8a3d$exports(object), new $173da7417fce8a3d$exports(other))) return false;
            return true;
        case $d67f2325927a902d$var$boolTag:
        case $d67f2325927a902d$var$dateTag:
        case $d67f2325927a902d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $40ef67da37ce76ef$exports(+object, +other);
        case $d67f2325927a902d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d67f2325927a902d$var$regexpTag:
        case $d67f2325927a902d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $d67f2325927a902d$var$mapTag:
            var convert = $09bacb38db54c07f$exports;
        case $d67f2325927a902d$var$setTag:
            var isPartial = bitmask & $d67f2325927a902d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $b0242255ce20714a$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d67f2325927a902d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1e0c8d992f8faf3a$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $d67f2325927a902d$var$symbolTag:
            if ($d67f2325927a902d$var$symbolValueOf) return $d67f2325927a902d$var$symbolValueOf.call(object) == $d67f2325927a902d$var$symbolValueOf.call(other);
    }
    return false;
}
$d67f2325927a902d$exports = $d67f2325927a902d$var$equalByTag;


var $f0e038b3e596b085$exports = {};
var $6161eee532d0d7f9$exports = {};
var $3d5867e2494fcd03$exports = {};
var $29d6e3ba59f65258$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $29d6e3ba59f65258$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$29d6e3ba59f65258$exports = $29d6e3ba59f65258$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3d5867e2494fcd03$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $e9f4eab8a3ba19aa$exports(object) ? result : $29d6e3ba59f65258$exports(result, symbolsFunc(object));
}
$3d5867e2494fcd03$exports = $3d5867e2494fcd03$var$baseGetAllKeys;


var $8f3c24fec9a6e08b$exports = {};
var $0b722f1d5fffe7ad$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $0b722f1d5fffe7ad$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$0b722f1d5fffe7ad$exports = $0b722f1d5fffe7ad$var$arrayFilter;


var $6a89fdd830bcb22c$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $6a89fdd830bcb22c$var$stubArray() {
    return [];
}
$6a89fdd830bcb22c$exports = $6a89fdd830bcb22c$var$stubArray;


/** Used for built-in method references. */ var $8f3c24fec9a6e08b$var$objectProto = Object.prototype;
/** Built-in value references. */ var $8f3c24fec9a6e08b$var$propertyIsEnumerable = $8f3c24fec9a6e08b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8f3c24fec9a6e08b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8f3c24fec9a6e08b$var$getSymbols = !$8f3c24fec9a6e08b$var$nativeGetSymbols ? $6a89fdd830bcb22c$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $0b722f1d5fffe7ad$exports($8f3c24fec9a6e08b$var$nativeGetSymbols(object), function(symbol) {
        return $8f3c24fec9a6e08b$var$propertyIsEnumerable.call(object, symbol);
    });
};
$8f3c24fec9a6e08b$exports = $8f3c24fec9a6e08b$var$getSymbols;


var $3cea58c3c3d6f086$exports = {};
var $bdadddeb1fd5bbdd$exports = {};
var $f6cb3a5434ac7d1c$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $f6cb3a5434ac7d1c$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$f6cb3a5434ac7d1c$exports = $f6cb3a5434ac7d1c$var$baseTimes;


var $58078857a51245fd$exports = {};
var $503a970bc031a225$exports = {};


/** `Object#toString` result references. */ var $503a970bc031a225$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $503a970bc031a225$var$baseIsArguments(value) {
    return $30ec207d7cd7a4f3$exports(value) && $bf759a7d004b6e9c$exports(value) == $503a970bc031a225$var$argsTag;
}
$503a970bc031a225$exports = $503a970bc031a225$var$baseIsArguments;



/** Used for built-in method references. */ var $58078857a51245fd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $58078857a51245fd$var$hasOwnProperty = $58078857a51245fd$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $58078857a51245fd$var$propertyIsEnumerable = $58078857a51245fd$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $58078857a51245fd$var$isArguments = $503a970bc031a225$exports(function() {
    return arguments;
}()) ? $503a970bc031a225$exports : function(value) {
    return $30ec207d7cd7a4f3$exports(value) && $58078857a51245fd$var$hasOwnProperty.call(value, 'callee') && !$58078857a51245fd$var$propertyIsEnumerable.call(value, 'callee');
};
$58078857a51245fd$exports = $58078857a51245fd$var$isArguments;




var $cGznn = parcelRequire("cGznn");
var $a8eb3b42bf304d25$exports = {};
/** Used as references for various `Number` constants. */ var $a8eb3b42bf304d25$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a8eb3b42bf304d25$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a8eb3b42bf304d25$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a8eb3b42bf304d25$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a8eb3b42bf304d25$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$a8eb3b42bf304d25$exports = $a8eb3b42bf304d25$var$isIndex;


var $57f54d4e463d404c$exports = {};
var $0cd50e2437277a11$exports = {};

var $6e14b98aed5ff77f$exports = {};
/** Used as references for various `Number` constants. */ var $6e14b98aed5ff77f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6e14b98aed5ff77f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $6e14b98aed5ff77f$var$MAX_SAFE_INTEGER;
}
$6e14b98aed5ff77f$exports = $6e14b98aed5ff77f$var$isLength;



/** `Object#toString` result references. */ var $0cd50e2437277a11$var$argsTag = '[object Arguments]', $0cd50e2437277a11$var$arrayTag = '[object Array]', $0cd50e2437277a11$var$boolTag = '[object Boolean]', $0cd50e2437277a11$var$dateTag = '[object Date]', $0cd50e2437277a11$var$errorTag = '[object Error]', $0cd50e2437277a11$var$funcTag = '[object Function]', $0cd50e2437277a11$var$mapTag = '[object Map]', $0cd50e2437277a11$var$numberTag = '[object Number]', $0cd50e2437277a11$var$objectTag = '[object Object]', $0cd50e2437277a11$var$regexpTag = '[object RegExp]', $0cd50e2437277a11$var$setTag = '[object Set]', $0cd50e2437277a11$var$stringTag = '[object String]', $0cd50e2437277a11$var$weakMapTag = '[object WeakMap]';
var $0cd50e2437277a11$var$arrayBufferTag = '[object ArrayBuffer]', $0cd50e2437277a11$var$dataViewTag = '[object DataView]', $0cd50e2437277a11$var$float32Tag = '[object Float32Array]', $0cd50e2437277a11$var$float64Tag = '[object Float64Array]', $0cd50e2437277a11$var$int8Tag = '[object Int8Array]', $0cd50e2437277a11$var$int16Tag = '[object Int16Array]', $0cd50e2437277a11$var$int32Tag = '[object Int32Array]', $0cd50e2437277a11$var$uint8Tag = '[object Uint8Array]', $0cd50e2437277a11$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0cd50e2437277a11$var$uint16Tag = '[object Uint16Array]', $0cd50e2437277a11$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $0cd50e2437277a11$var$typedArrayTags = {};
$0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$float32Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$float64Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$int8Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$int16Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$int32Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$uint8Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$uint8ClampedTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$uint16Tag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$uint32Tag] = true;
$0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$argsTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$arrayTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$arrayBufferTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$boolTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$dataViewTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$dateTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$errorTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$funcTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$mapTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$numberTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$objectTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$regexpTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$setTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$stringTag] = $0cd50e2437277a11$var$typedArrayTags[$0cd50e2437277a11$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $0cd50e2437277a11$var$baseIsTypedArray(value) {
    return $30ec207d7cd7a4f3$exports(value) && $6e14b98aed5ff77f$exports(value.length) && !!$0cd50e2437277a11$var$typedArrayTags[$bf759a7d004b6e9c$exports(value)];
}
$0cd50e2437277a11$exports = $0cd50e2437277a11$var$baseIsTypedArray;


var $1df420928aaaa4bf$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1df420928aaaa4bf$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$1df420928aaaa4bf$exports = $1df420928aaaa4bf$var$baseUnary;



var $6bKK7 = parcelRequire("6bKK7");
/* Node.js helper references. */ var $57f54d4e463d404c$var$nodeIsTypedArray = $6bKK7 && $6bKK7.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $57f54d4e463d404c$var$isTypedArray = $57f54d4e463d404c$var$nodeIsTypedArray ? $1df420928aaaa4bf$exports($57f54d4e463d404c$var$nodeIsTypedArray) : $0cd50e2437277a11$exports;
$57f54d4e463d404c$exports = $57f54d4e463d404c$var$isTypedArray;


/** Used for built-in method references. */ var $bdadddeb1fd5bbdd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdadddeb1fd5bbdd$var$hasOwnProperty = $bdadddeb1fd5bbdd$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $bdadddeb1fd5bbdd$var$arrayLikeKeys(value, inherited) {
    var isArr = $e9f4eab8a3ba19aa$exports(value), isArg = !isArr && $58078857a51245fd$exports(value), isBuff = !isArr && !isArg && $cGznn(value), isType = !isArr && !isArg && !isBuff && $57f54d4e463d404c$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $f6cb3a5434ac7d1c$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $bdadddeb1fd5bbdd$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $a8eb3b42bf304d25$exports(key, length)))) result.push(key);
    return result;
}
$bdadddeb1fd5bbdd$exports = $bdadddeb1fd5bbdd$var$arrayLikeKeys;


var $6ddfccb6eb424b12$exports = {};
var $96fee967d764e0a3$exports = {};
/** Used for built-in method references. */ var $96fee967d764e0a3$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $96fee967d764e0a3$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $96fee967d764e0a3$var$objectProto;
    return value === proto;
}
$96fee967d764e0a3$exports = $96fee967d764e0a3$var$isPrototype;


var $d1d46d625a4183d2$exports = {};
var $83811c48aacf8261$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $83811c48aacf8261$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$83811c48aacf8261$exports = $83811c48aacf8261$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d1d46d625a4183d2$var$nativeKeys = $83811c48aacf8261$exports(Object.keys, Object);
$d1d46d625a4183d2$exports = $d1d46d625a4183d2$var$nativeKeys;


/** Used for built-in method references. */ var $6ddfccb6eb424b12$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6ddfccb6eb424b12$var$hasOwnProperty = $6ddfccb6eb424b12$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6ddfccb6eb424b12$var$baseKeys(object) {
    if (!$96fee967d764e0a3$exports(object)) return $d1d46d625a4183d2$exports(object);
    var result = [];
    for(var key in Object(object))if ($6ddfccb6eb424b12$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$6ddfccb6eb424b12$exports = $6ddfccb6eb424b12$var$baseKeys;


var $b1b629d226020fad$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b1b629d226020fad$var$isArrayLike(value) {
    return value != null && $6e14b98aed5ff77f$exports(value.length) && !$3946d51b8802f963$exports(value);
}
$b1b629d226020fad$exports = $b1b629d226020fad$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3cea58c3c3d6f086$var$keys(object) {
    return $b1b629d226020fad$exports(object) ? $bdadddeb1fd5bbdd$exports(object) : $6ddfccb6eb424b12$exports(object);
}
$3cea58c3c3d6f086$exports = $3cea58c3c3d6f086$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6161eee532d0d7f9$var$getAllKeys(object) {
    return $3d5867e2494fcd03$exports(object, $3cea58c3c3d6f086$exports, $8f3c24fec9a6e08b$exports);
}
$6161eee532d0d7f9$exports = $6161eee532d0d7f9$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f0e038b3e596b085$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f0e038b3e596b085$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0e038b3e596b085$var$hasOwnProperty = $f0e038b3e596b085$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f0e038b3e596b085$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f0e038b3e596b085$var$COMPARE_PARTIAL_FLAG, objProps = $6161eee532d0d7f9$exports(object), objLength = objProps.length, othProps = $6161eee532d0d7f9$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f0e038b3e596b085$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$f0e038b3e596b085$exports = $f0e038b3e596b085$var$equalObjects;


var $c0a9e02288d6a01b$exports = {};
var $dbedf3d0bb217134$exports = {};


var $83nx1 = parcelRequire("83nx1");
/* Built-in method references that are verified to be native. */ var $dbedf3d0bb217134$var$DataView = $21ba99941d8ab1d0$exports($83nx1, 'DataView');
$dbedf3d0bb217134$exports = $dbedf3d0bb217134$var$DataView;



var $dec596c2fc4425db$exports = {};


var $83nx1 = parcelRequire("83nx1");
/* Built-in method references that are verified to be native. */ var $dec596c2fc4425db$var$Promise = $21ba99941d8ab1d0$exports($83nx1, 'Promise');
$dec596c2fc4425db$exports = $dec596c2fc4425db$var$Promise;


var $5dfe140a5315894d$exports = {};


var $83nx1 = parcelRequire("83nx1");
/* Built-in method references that are verified to be native. */ var $5dfe140a5315894d$var$Set = $21ba99941d8ab1d0$exports($83nx1, 'Set');
$5dfe140a5315894d$exports = $5dfe140a5315894d$var$Set;


var $8f6396965ed4a1bb$exports = {};


var $83nx1 = parcelRequire("83nx1");
/* Built-in method references that are verified to be native. */ var $8f6396965ed4a1bb$var$WeakMap = $21ba99941d8ab1d0$exports($83nx1, 'WeakMap');
$8f6396965ed4a1bb$exports = $8f6396965ed4a1bb$var$WeakMap;




/** `Object#toString` result references. */ var $c0a9e02288d6a01b$var$mapTag = '[object Map]', $c0a9e02288d6a01b$var$objectTag = '[object Object]', $c0a9e02288d6a01b$var$promiseTag = '[object Promise]', $c0a9e02288d6a01b$var$setTag = '[object Set]', $c0a9e02288d6a01b$var$weakMapTag = '[object WeakMap]';
var $c0a9e02288d6a01b$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c0a9e02288d6a01b$var$dataViewCtorString = $4f779702c2fe3a19$exports($dbedf3d0bb217134$exports), $c0a9e02288d6a01b$var$mapCtorString = $4f779702c2fe3a19$exports($478198d25e7d8609$exports), $c0a9e02288d6a01b$var$promiseCtorString = $4f779702c2fe3a19$exports($dec596c2fc4425db$exports), $c0a9e02288d6a01b$var$setCtorString = $4f779702c2fe3a19$exports($5dfe140a5315894d$exports), $c0a9e02288d6a01b$var$weakMapCtorString = $4f779702c2fe3a19$exports($8f6396965ed4a1bb$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c0a9e02288d6a01b$var$getTag = $bf759a7d004b6e9c$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($dbedf3d0bb217134$exports && $c0a9e02288d6a01b$var$getTag(new $dbedf3d0bb217134$exports(new ArrayBuffer(1))) != $c0a9e02288d6a01b$var$dataViewTag || $478198d25e7d8609$exports && $c0a9e02288d6a01b$var$getTag(new $478198d25e7d8609$exports) != $c0a9e02288d6a01b$var$mapTag || $dec596c2fc4425db$exports && $c0a9e02288d6a01b$var$getTag($dec596c2fc4425db$exports.resolve()) != $c0a9e02288d6a01b$var$promiseTag || $5dfe140a5315894d$exports && $c0a9e02288d6a01b$var$getTag(new $5dfe140a5315894d$exports) != $c0a9e02288d6a01b$var$setTag || $8f6396965ed4a1bb$exports && $c0a9e02288d6a01b$var$getTag(new $8f6396965ed4a1bb$exports) != $c0a9e02288d6a01b$var$weakMapTag) $c0a9e02288d6a01b$var$getTag = function(value) {
    var result = $bf759a7d004b6e9c$exports(value), Ctor = result == $c0a9e02288d6a01b$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $4f779702c2fe3a19$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c0a9e02288d6a01b$var$dataViewCtorString:
            return $c0a9e02288d6a01b$var$dataViewTag;
        case $c0a9e02288d6a01b$var$mapCtorString:
            return $c0a9e02288d6a01b$var$mapTag;
        case $c0a9e02288d6a01b$var$promiseCtorString:
            return $c0a9e02288d6a01b$var$promiseTag;
        case $c0a9e02288d6a01b$var$setCtorString:
            return $c0a9e02288d6a01b$var$setTag;
        case $c0a9e02288d6a01b$var$weakMapCtorString:
            return $c0a9e02288d6a01b$var$weakMapTag;
    }
    return result;
};
$c0a9e02288d6a01b$exports = $c0a9e02288d6a01b$var$getTag;




var $cGznn = parcelRequire("cGznn");

/** Used to compose bitmasks for value comparisons. */ var $73c2bbddf05cdc83$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $73c2bbddf05cdc83$var$argsTag = '[object Arguments]', $73c2bbddf05cdc83$var$arrayTag = '[object Array]', $73c2bbddf05cdc83$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $73c2bbddf05cdc83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $73c2bbddf05cdc83$var$hasOwnProperty = $73c2bbddf05cdc83$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $73c2bbddf05cdc83$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $e9f4eab8a3ba19aa$exports(object), othIsArr = $e9f4eab8a3ba19aa$exports(other), objTag = objIsArr ? $73c2bbddf05cdc83$var$arrayTag : $c0a9e02288d6a01b$exports(object), othTag = othIsArr ? $73c2bbddf05cdc83$var$arrayTag : $c0a9e02288d6a01b$exports(other);
    objTag = objTag == $73c2bbddf05cdc83$var$argsTag ? $73c2bbddf05cdc83$var$objectTag : objTag;
    othTag = othTag == $73c2bbddf05cdc83$var$argsTag ? $73c2bbddf05cdc83$var$objectTag : othTag;
    var objIsObj = objTag == $73c2bbddf05cdc83$var$objectTag, othIsObj = othTag == $73c2bbddf05cdc83$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $cGznn(object)) {
        if (!$cGznn(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $24b9dab4eebce549$exports);
        return objIsArr || $57f54d4e463d404c$exports(object) ? $1e0c8d992f8faf3a$exports(object, other, bitmask, customizer, equalFunc, stack) : $d67f2325927a902d$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $73c2bbddf05cdc83$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $73c2bbddf05cdc83$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $73c2bbddf05cdc83$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $24b9dab4eebce549$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $24b9dab4eebce549$exports);
    return $f0e038b3e596b085$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$73c2bbddf05cdc83$exports = $73c2bbddf05cdc83$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $ddcb57ea93e59e60$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$30ec207d7cd7a4f3$exports(value) && !$30ec207d7cd7a4f3$exports(other)) return value !== value && other !== other;
    return $73c2bbddf05cdc83$exports(value, other, bitmask, customizer, $ddcb57ea93e59e60$var$baseIsEqual, stack);
}
$ddcb57ea93e59e60$exports = $ddcb57ea93e59e60$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $0feaba80faf7ff59$var$COMPARE_PARTIAL_FLAG = 1, $0feaba80faf7ff59$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $0feaba80faf7ff59$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $24b9dab4eebce549$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $ddcb57ea93e59e60$exports(srcValue, objValue, $0feaba80faf7ff59$var$COMPARE_PARTIAL_FLAG | $0feaba80faf7ff59$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$0feaba80faf7ff59$exports = $0feaba80faf7ff59$var$baseIsMatch;


var $03af30f1a6b0f853$exports = {};
var $e35700fed828ccc3$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e35700fed828ccc3$var$isStrictComparable(value) {
    return value === value && !$3cf8bb2e7defbbff$exports(value);
}
$e35700fed828ccc3$exports = $e35700fed828ccc3$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $03af30f1a6b0f853$var$getMatchData(object) {
    var result = $3cea58c3c3d6f086$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $e35700fed828ccc3$exports(value)
        ];
    }
    return result;
}
$03af30f1a6b0f853$exports = $03af30f1a6b0f853$var$getMatchData;


var $2907b40bfb51481c$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $2907b40bfb51481c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$2907b40bfb51481c$exports = $2907b40bfb51481c$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $6e42a1b159f70c7d$var$baseMatches(source) {
    var matchData = $03af30f1a6b0f853$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $2907b40bfb51481c$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $0feaba80faf7ff59$exports(object, source, matchData);
    };
}
$6e42a1b159f70c7d$exports = $6e42a1b159f70c7d$var$baseMatches;


var $25ef17cd8bdd65c6$exports = {};


var $bcf235c69ce4f0e7$exports = {};
var $483d38439062713a$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $483d38439062713a$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$483d38439062713a$exports = $483d38439062713a$var$baseHasIn;


var $d391d21c38faf604$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $d391d21c38faf604$var$hasPath(object, path, hasFunc) {
    path = $231d0d199b5440f4$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $fb63eade37bbe6b1$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $6e14b98aed5ff77f$exports(length) && $a8eb3b42bf304d25$exports(key, length) && ($e9f4eab8a3ba19aa$exports(object) || $58078857a51245fd$exports(object));
}
$d391d21c38faf604$exports = $d391d21c38faf604$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $bcf235c69ce4f0e7$var$hasIn(object, path) {
    return object != null && $d391d21c38faf604$exports(object, path, $483d38439062713a$exports);
}
$bcf235c69ce4f0e7$exports = $bcf235c69ce4f0e7$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $25ef17cd8bdd65c6$var$COMPARE_PARTIAL_FLAG = 1, $25ef17cd8bdd65c6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $25ef17cd8bdd65c6$var$baseMatchesProperty(path, srcValue) {
    if ($3dbb9373dff9ef1d$exports(path) && $e35700fed828ccc3$exports(srcValue)) return $2907b40bfb51481c$exports($fb63eade37bbe6b1$exports(path), srcValue);
    return function(object) {
        var objValue = $d946048a435dc4a5$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $bcf235c69ce4f0e7$exports(object, path) : $ddcb57ea93e59e60$exports(srcValue, objValue, $25ef17cd8bdd65c6$var$COMPARE_PARTIAL_FLAG | $25ef17cd8bdd65c6$var$COMPARE_UNORDERED_FLAG);
    };
}
$25ef17cd8bdd65c6$exports = $25ef17cd8bdd65c6$var$baseMatchesProperty;


var $e88a261cf8244156$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e88a261cf8244156$var$identity(value) {
    return value;
}
$e88a261cf8244156$exports = $e88a261cf8244156$var$identity;



var $1f9bf00d0737e01a$exports = {};
var $9fb4c2db2611d58b$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9fb4c2db2611d58b$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$9fb4c2db2611d58b$exports = $9fb4c2db2611d58b$var$baseProperty;


var $45a5120c5a74eebc$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $45a5120c5a74eebc$var$basePropertyDeep(path) {
    return function(object) {
        return $ea39284deca3da9b$exports(object, path);
    };
}
$45a5120c5a74eebc$exports = $45a5120c5a74eebc$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $1f9bf00d0737e01a$var$property(path) {
    return $3dbb9373dff9ef1d$exports(path) ? $9fb4c2db2611d58b$exports($fb63eade37bbe6b1$exports(path)) : $45a5120c5a74eebc$exports(path);
}
$1f9bf00d0737e01a$exports = $1f9bf00d0737e01a$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $a3e1cb58c2a61f92$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $e88a261cf8244156$exports;
    if (typeof value == 'object') return $e9f4eab8a3ba19aa$exports(value) ? $25ef17cd8bdd65c6$exports(value[0], value[1]) : $6e42a1b159f70c7d$exports(value);
    return $1f9bf00d0737e01a$exports(value);
}
$a3e1cb58c2a61f92$exports = $a3e1cb58c2a61f92$var$baseIteratee;


var $30fcd967f4429de6$exports = {};

var $bf8aa64e7e6a9541$exports = {};
var $e929373faf5473f3$exports = {};
var $a3c2baca40020ed4$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a3c2baca40020ed4$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a3c2baca40020ed4$exports = $a3c2baca40020ed4$var$baseFindIndex;


var $9a9263ca11703c6e$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $9a9263ca11703c6e$var$baseIsNaN(value) {
    return value !== value;
}
$9a9263ca11703c6e$exports = $9a9263ca11703c6e$var$baseIsNaN;


var $2490f356eed472ff$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2490f356eed472ff$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$2490f356eed472ff$exports = $2490f356eed472ff$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e929373faf5473f3$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $2490f356eed472ff$exports(array, value, fromIndex) : $a3c2baca40020ed4$exports(array, $9a9263ca11703c6e$exports, fromIndex);
}
$e929373faf5473f3$exports = $e929373faf5473f3$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf8aa64e7e6a9541$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $e929373faf5473f3$exports(array, value, 0) > -1;
}
$bf8aa64e7e6a9541$exports = $bf8aa64e7e6a9541$var$arrayIncludes;


var $0fa4e498c03fa511$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $0fa4e498c03fa511$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$0fa4e498c03fa511$exports = $0fa4e498c03fa511$var$arrayIncludesWith;



var $ca705b01fe6ab3a5$exports = {};

var $5ed62c5d6493a418$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $5ed62c5d6493a418$var$noop() {
// No operation performed.
}
$5ed62c5d6493a418$exports = $5ed62c5d6493a418$var$noop;



/** Used as references for various `Number` constants. */ var $ca705b01fe6ab3a5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ca705b01fe6ab3a5$var$createSet = !($5dfe140a5315894d$exports && 1 / $b0242255ce20714a$exports(new $5dfe140a5315894d$exports([
    ,
    -0
]))[1] == $ca705b01fe6ab3a5$var$INFINITY) ? $5ed62c5d6493a418$exports : function(values) {
    return new $5dfe140a5315894d$exports(values);
};
$ca705b01fe6ab3a5$exports = $ca705b01fe6ab3a5$var$createSet;



/** Used as the size to enable large array optimizations. */ var $30fcd967f4429de6$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $30fcd967f4429de6$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $bf8aa64e7e6a9541$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $0fa4e498c03fa511$exports;
    } else if (length >= $30fcd967f4429de6$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $ca705b01fe6ab3a5$exports(array);
        if (set) return $b0242255ce20714a$exports(set);
        isCommon = false;
        includes = $4df0723149b6448e$exports;
        seen = new $0f6cd24e62a0006a$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$30fcd967f4429de6$exports = $30fcd967f4429de6$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $fead821d6e5c4378$var$uniqBy(array, iteratee) {
    return array && array.length ? $30fcd967f4429de6$exports(array, $a3e1cb58c2a61f92$exports(iteratee, 2)) : [];
}
$fead821d6e5c4378$exports = $fead821d6e5c4378$var$uniqBy;



var $b7Z9x = parcelRequire("b7Z9x");

var $b7Z9x = parcelRequire("b7Z9x");


var $b7Z9x = parcelRequire("b7Z9x");


var $80836ea8a08da7a7$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style"
];
function $80836ea8a08da7a7$var$_extends() {
    $80836ea8a08da7a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $80836ea8a08da7a7$var$_extends.apply(this, arguments);
}
function $80836ea8a08da7a7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $80836ea8a08da7a7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $80836ea8a08da7a7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $80836ea8a08da7a7$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $80836ea8a08da7a7$var$_objectWithoutProperties(props, $80836ea8a08da7a7$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("svg", $80836ea8a08da7a7$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("desc", null, props.desc), children);
}


var $b8a24ec1bb4853d9$exports = {};
var $9d0391832cd495ba$exports = {};
var $22a403da23f48340$exports = {};
var $c0ceb13c3b56691f$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $c0ceb13c3b56691f$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$c0ceb13c3b56691f$exports = $c0ceb13c3b56691f$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $22a403da23f48340$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $c0ceb13c3b56691f$exports(array, start, end);
}
$22a403da23f48340$exports = $22a403da23f48340$var$castSlice;


var $1c8807d1b9ef26ea$exports = {};
/** Used to compose unicode character classes. */ var $1c8807d1b9ef26ea$var$rsAstralRange = '\\ud800-\\udfff', $1c8807d1b9ef26ea$var$rsComboMarksRange = '\\u0300-\\u036f', $1c8807d1b9ef26ea$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1c8807d1b9ef26ea$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1c8807d1b9ef26ea$var$rsComboRange = $1c8807d1b9ef26ea$var$rsComboMarksRange + $1c8807d1b9ef26ea$var$reComboHalfMarksRange + $1c8807d1b9ef26ea$var$rsComboSymbolsRange, $1c8807d1b9ef26ea$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1c8807d1b9ef26ea$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1c8807d1b9ef26ea$var$reHasUnicode = RegExp('[' + $1c8807d1b9ef26ea$var$rsZWJ + $1c8807d1b9ef26ea$var$rsAstralRange + $1c8807d1b9ef26ea$var$rsComboRange + $1c8807d1b9ef26ea$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1c8807d1b9ef26ea$var$hasUnicode(string) {
    return $1c8807d1b9ef26ea$var$reHasUnicode.test(string);
}
$1c8807d1b9ef26ea$exports = $1c8807d1b9ef26ea$var$hasUnicode;


var $f234c4290566d16d$exports = {};
var $a7a673df172a0cfe$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a7a673df172a0cfe$var$asciiToArray(string) {
    return string.split('');
}
$a7a673df172a0cfe$exports = $a7a673df172a0cfe$var$asciiToArray;



var $117ea40814f9ad02$exports = {};
/** Used to compose unicode character classes. */ var $117ea40814f9ad02$var$rsAstralRange = '\\ud800-\\udfff', $117ea40814f9ad02$var$rsComboMarksRange = '\\u0300-\\u036f', $117ea40814f9ad02$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $117ea40814f9ad02$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $117ea40814f9ad02$var$rsComboRange = $117ea40814f9ad02$var$rsComboMarksRange + $117ea40814f9ad02$var$reComboHalfMarksRange + $117ea40814f9ad02$var$rsComboSymbolsRange, $117ea40814f9ad02$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $117ea40814f9ad02$var$rsAstral = '[' + $117ea40814f9ad02$var$rsAstralRange + ']', $117ea40814f9ad02$var$rsCombo = '[' + $117ea40814f9ad02$var$rsComboRange + ']', $117ea40814f9ad02$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $117ea40814f9ad02$var$rsModifier = '(?:' + $117ea40814f9ad02$var$rsCombo + '|' + $117ea40814f9ad02$var$rsFitz + ')', $117ea40814f9ad02$var$rsNonAstral = '[^' + $117ea40814f9ad02$var$rsAstralRange + ']', $117ea40814f9ad02$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $117ea40814f9ad02$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $117ea40814f9ad02$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $117ea40814f9ad02$var$reOptMod = $117ea40814f9ad02$var$rsModifier + '?', $117ea40814f9ad02$var$rsOptVar = '[' + $117ea40814f9ad02$var$rsVarRange + ']?', $117ea40814f9ad02$var$rsOptJoin = '(?:' + $117ea40814f9ad02$var$rsZWJ + '(?:' + [
    $117ea40814f9ad02$var$rsNonAstral,
    $117ea40814f9ad02$var$rsRegional,
    $117ea40814f9ad02$var$rsSurrPair
].join('|') + ')' + $117ea40814f9ad02$var$rsOptVar + $117ea40814f9ad02$var$reOptMod + ')*', $117ea40814f9ad02$var$rsSeq = $117ea40814f9ad02$var$rsOptVar + $117ea40814f9ad02$var$reOptMod + $117ea40814f9ad02$var$rsOptJoin, $117ea40814f9ad02$var$rsSymbol = '(?:' + [
    $117ea40814f9ad02$var$rsNonAstral + $117ea40814f9ad02$var$rsCombo + '?',
    $117ea40814f9ad02$var$rsCombo,
    $117ea40814f9ad02$var$rsRegional,
    $117ea40814f9ad02$var$rsSurrPair,
    $117ea40814f9ad02$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $117ea40814f9ad02$var$reUnicode = RegExp($117ea40814f9ad02$var$rsFitz + '(?=' + $117ea40814f9ad02$var$rsFitz + ')|' + $117ea40814f9ad02$var$rsSymbol + $117ea40814f9ad02$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $117ea40814f9ad02$var$unicodeToArray(string) {
    return string.match($117ea40814f9ad02$var$reUnicode) || [];
}
$117ea40814f9ad02$exports = $117ea40814f9ad02$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f234c4290566d16d$var$stringToArray(string) {
    return $1c8807d1b9ef26ea$exports(string) ? $117ea40814f9ad02$exports(string) : $a7a673df172a0cfe$exports(string);
}
$f234c4290566d16d$exports = $f234c4290566d16d$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $9d0391832cd495ba$var$createCaseFirst(methodName) {
    return function(string) {
        string = $d89e3302df84e87e$exports(string);
        var strSymbols = $1c8807d1b9ef26ea$exports(string) ? $f234c4290566d16d$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $22a403da23f48340$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$9d0391832cd495ba$exports = $9d0391832cd495ba$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $b8a24ec1bb4853d9$var$upperFirst = $9d0391832cd495ba$exports('toUpperCase');
$b8a24ec1bb4853d9$exports = $b8a24ec1bb4853d9$var$upperFirst;



var $b7Z9x = parcelRequire("b7Z9x");
var $6fa814273ae93f6c$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$6fa814273ae93f6c$exports = (parcelRequire("1zRNb"));




function $6382e2250f308631$var$_extends() {
    $6382e2250f308631$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6382e2250f308631$var$_extends.apply(this, arguments);
}
var $6382e2250f308631$var$symbolFactories = {
    symbolCircle: (0, $6fa814273ae93f6c$exports.symbolCircle),
    symbolCross: (0, $6fa814273ae93f6c$exports.symbolCross),
    symbolDiamond: (0, $6fa814273ae93f6c$exports.symbolDiamond),
    symbolSquare: (0, $6fa814273ae93f6c$exports.symbolSquare),
    symbolStar: (0, $6fa814273ae93f6c$exports.symbolStar),
    symbolTriangle: (0, $6fa814273ae93f6c$exports.symbolTriangle),
    symbolWye: (0, $6fa814273ae93f6c$exports.symbolWye)
};
var $6382e2250f308631$var$RADIAN = Math.PI / 180;
var $6382e2250f308631$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($b8a24ec1bb4853d9$exports)))(type));
    return $6382e2250f308631$var$symbolFactories[name] || (0, $6fa814273ae93f6c$exports.symbolCircle);
};
var $6382e2250f308631$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $6382e2250f308631$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $6382e2250f308631$var$symbolsDefaultProps = {
    type: 'circle',
    size: 64,
    sizeType: 'area'
};
var $6382e2250f308631$var$registerSymbol = function registerSymbol(key, factory) {
    $6382e2250f308631$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($b8a24ec1bb4853d9$exports)))(key))] = factory;
};
var $6382e2250f308631$export$fa456266707bf4e4 = function Symbols(props) {
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var size = props.size, sizeType = props.sizeType, type = props.type;
        var symbolFactory = $6382e2250f308631$var$getSymbolFactory(type);
        var symbol = (0, $6fa814273ae93f6c$exports.symbol)().type(symbolFactory).size($6382e2250f308631$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy, size = props.size;
    var filteredProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $6382e2250f308631$var$_extends({}, filteredProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$6382e2250f308631$export$fa456266707bf4e4.defaultProps = $6382e2250f308631$var$symbolsDefaultProps;
$6382e2250f308631$export$fa456266707bf4e4.registerSymbol = $6382e2250f308631$var$registerSymbol;



function $c405cce79b21161d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c405cce79b21161d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c405cce79b21161d$var$_typeof(obj);
}
function $c405cce79b21161d$var$_extends() {
    $c405cce79b21161d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c405cce79b21161d$var$_extends.apply(this, arguments);
}
function $c405cce79b21161d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c405cce79b21161d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c405cce79b21161d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c405cce79b21161d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c405cce79b21161d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c405cce79b21161d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c405cce79b21161d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c405cce79b21161d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c405cce79b21161d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c405cce79b21161d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c405cce79b21161d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c405cce79b21161d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c405cce79b21161d$var$_setPrototypeOf(subClass, superClass);
}
function $c405cce79b21161d$var$_setPrototypeOf(o, p) {
    $c405cce79b21161d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c405cce79b21161d$var$_setPrototypeOf(o, p);
}
function $c405cce79b21161d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c405cce79b21161d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c405cce79b21161d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c405cce79b21161d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c405cce79b21161d$var$_possibleConstructorReturn(this, result);
    };
}
function $c405cce79b21161d$var$_possibleConstructorReturn(self, call) {
    if (call && ($c405cce79b21161d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c405cce79b21161d$var$_assertThisInitialized(self);
}
function $c405cce79b21161d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c405cce79b21161d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c405cce79b21161d$var$_getPrototypeOf(o) {
    $c405cce79b21161d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c405cce79b21161d$var$_getPrototypeOf(o);
}
function $c405cce79b21161d$var$_defineProperty(obj, key, value) {
    key = $c405cce79b21161d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c405cce79b21161d$var$_toPropertyKey(arg) {
    var key = $c405cce79b21161d$var$_toPrimitive(arg, "string");
    return $c405cce79b21161d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c405cce79b21161d$var$_toPrimitive(input, hint) {
    if ($c405cce79b21161d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c405cce79b21161d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c405cce79b21161d$var$SIZE = 32;
var $c405cce79b21161d$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $c405cce79b21161d$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $c405cce79b21161d$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $c405cce79b21161d$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $c405cce79b21161d$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $c405cce79b21161d$var$SIZE / 2;
                var sixthSize = $c405cce79b21161d$var$SIZE / 6;
                var thirdSize = $c405cce79b21161d$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $c405cce79b21161d$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($c405cce79b21161d$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($c405cce79b21161d$var$SIZE / 8, "h").concat($c405cce79b21161d$var$SIZE, "v").concat($c405cce79b21161d$var$SIZE * 3 / 4, "h").concat(-$c405cce79b21161d$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(data.legendIcon)) {
                    var iconProps = $c405cce79b21161d$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $6382e2250f308631$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $c405cce79b21161d$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $c405cce79b21161d$var$SIZE,
                    height: $c405cce79b21161d$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))((_classNames = {
                        'recharts-legend-item': true
                    }, $c405cce79b21161d$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $c405cce79b21161d$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === 'none') return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("li", $c405cce79b21161d$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f321872aac18bbfb$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $80836ea8a08da7a7$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $b7Z9x.PureComponent));
$c405cce79b21161d$var$_defineProperty($c405cce79b21161d$export$99f8d96ed0cededa, "displayName", 'Legend');
$c405cce79b21161d$var$_defineProperty($c405cce79b21161d$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



function $4d6b5192df4a4236$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4d6b5192df4a4236$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4d6b5192df4a4236$var$_typeof(obj);
}
var $4d6b5192df4a4236$var$_excluded = [
    "ref"
];
function $4d6b5192df4a4236$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d6b5192df4a4236$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4d6b5192df4a4236$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4d6b5192df4a4236$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4d6b5192df4a4236$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4d6b5192df4a4236$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4d6b5192df4a4236$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4d6b5192df4a4236$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4d6b5192df4a4236$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4d6b5192df4a4236$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d6b5192df4a4236$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4d6b5192df4a4236$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4d6b5192df4a4236$var$_setPrototypeOf(subClass, superClass);
}
function $4d6b5192df4a4236$var$_setPrototypeOf(o, p) {
    $4d6b5192df4a4236$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4d6b5192df4a4236$var$_setPrototypeOf(o, p);
}
function $4d6b5192df4a4236$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4d6b5192df4a4236$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4d6b5192df4a4236$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4d6b5192df4a4236$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4d6b5192df4a4236$var$_possibleConstructorReturn(this, result);
    };
}
function $4d6b5192df4a4236$var$_possibleConstructorReturn(self, call) {
    if (call && ($4d6b5192df4a4236$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4d6b5192df4a4236$var$_assertThisInitialized(self);
}
function $4d6b5192df4a4236$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4d6b5192df4a4236$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4d6b5192df4a4236$var$_getPrototypeOf(o) {
    $4d6b5192df4a4236$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4d6b5192df4a4236$var$_getPrototypeOf(o);
}
function $4d6b5192df4a4236$var$_defineProperty(obj, key, value) {
    key = $4d6b5192df4a4236$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4d6b5192df4a4236$var$_toPropertyKey(arg) {
    var key = $4d6b5192df4a4236$var$_toPrimitive(arg, "string");
    return $4d6b5192df4a4236$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4d6b5192df4a4236$var$_toPrimitive(input, hint) {
    if ($4d6b5192df4a4236$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4d6b5192df4a4236$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4d6b5192df4a4236$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4d6b5192df4a4236$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4d6b5192df4a4236$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4d6b5192df4a4236$var$defaultUniqBy(entry) {
    return entry.value;
}
function $4d6b5192df4a4236$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($fead821d6e5c4378$exports)))(payload, $4d6b5192df4a4236$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($fead821d6e5c4378$exports)))(payload, option);
    return payload;
}
function $4d6b5192df4a4236$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(content, props);
    var ref = props.ref, otherProps = $4d6b5192df4a4236$var$_objectWithoutProperties(props, $4d6b5192df4a4236$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $c405cce79b21161d$export$99f8d96ed0cededa), otherProps);
}
var $4d6b5192df4a4236$var$EPS = 1;
var $4d6b5192df4a4236$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $4d6b5192df4a4236$var$_inherits(Legend, _PureComponent);
    var _super = $4d6b5192df4a4236$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $4d6b5192df4a4236$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $4d6b5192df4a4236$var$_defineProperty($4d6b5192df4a4236$var$_assertThisInitialized(_this), "state", {
            boxWidth: -1,
            boxHeight: -1
        });
        return _this;
    }
    $4d6b5192df4a4236$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $4d6b5192df4a4236$var$_objectSpread($4d6b5192df4a4236$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $4d6b5192df4a4236$var$EPS || Math.abs(_box3.height - boxHeight) > $4d6b5192df4a4236$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $4d6b5192df4a4236$var$_objectSpread($4d6b5192df4a4236$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $4d6b5192df4a4236$var$renderContent(content, $4d6b5192df4a4236$var$_objectSpread($4d6b5192df4a4236$var$_objectSpread({}, this.props), {}, {
                    payload: $4d6b5192df4a4236$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $b7Z9x.PureComponent));
$4d6b5192df4a4236$var$_defineProperty($4d6b5192df4a4236$export$ed247974535929c7, "displayName", 'Legend');
$4d6b5192df4a4236$var$_defineProperty($4d6b5192df4a4236$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});

var $a2615da14a6e744e$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $a2615da14a6e744e$var$isEqual(value, other) {
    return $ddcb57ea93e59e60$exports(value, other);
}
$a2615da14a6e744e$exports = $a2615da14a6e744e$var$isEqual;





var $b7Z9x = parcelRequire("b7Z9x");

var $b7Z9x = parcelRequire("b7Z9x");

var $ejhsZ = parcelRequire("ejhsZ");
var $4724a5ec92bd49bf$exports = {};
(function(global, factory) {
    factory($4724a5ec92bd49bf$exports);
})($4724a5ec92bd49bf$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $de339e9a2395004a$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $de339e9a2395004a$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $de339e9a2395004a$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $440bc28d9761a77e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $440bc28d9761a77e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $440bc28d9761a77e$var$_typeof(obj);
}
function $440bc28d9761a77e$var$_toArray(arr) {
    return $440bc28d9761a77e$var$_arrayWithHoles(arr) || $440bc28d9761a77e$var$_iterableToArray(arr) || $440bc28d9761a77e$var$_unsupportedIterableToArray(arr) || $440bc28d9761a77e$var$_nonIterableRest();
}
function $440bc28d9761a77e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $440bc28d9761a77e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $440bc28d9761a77e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $440bc28d9761a77e$var$_arrayLikeToArray(o, minLen);
}
function $440bc28d9761a77e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $440bc28d9761a77e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $440bc28d9761a77e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $440bc28d9761a77e$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $440bc28d9761a77e$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $de339e9a2395004a$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $de339e9a2395004a$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($440bc28d9761a77e$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $0a89a3b58486c782$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0a89a3b58486c782$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0a89a3b58486c782$var$_typeof(obj);
}
function $0a89a3b58486c782$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0a89a3b58486c782$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0a89a3b58486c782$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0a89a3b58486c782$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0a89a3b58486c782$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0a89a3b58486c782$var$_defineProperty(obj, key, value) {
    key = $0a89a3b58486c782$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a89a3b58486c782$var$_toPropertyKey(arg) {
    var key = $0a89a3b58486c782$var$_toPrimitive(arg, "string");
    return $0a89a3b58486c782$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0a89a3b58486c782$var$_toPrimitive(input, hint) {
    if ($0a89a3b58486c782$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0a89a3b58486c782$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $0a89a3b58486c782$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $0a89a3b58486c782$var$IN_LINE_PREFIX_LIST = [
    '-webkit-',
    '-moz-',
    '-o-',
    '-ms-'
];
var $0a89a3b58486c782$var$IN_COMPATIBLE_PROPERTY = [
    'transform',
    'transformOrigin',
    'transition'
];
var $0a89a3b58486c782$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $0a89a3b58486c782$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $0a89a3b58486c782$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $0a89a3b58486c782$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($0a89a3b58486c782$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $0a89a3b58486c782$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === 'transition';
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $0a89a3b58486c782$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($0a89a3b58486c782$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $0a89a3b58486c782$var$_objectSpread($0a89a3b58486c782$var$_objectSpread({}, result), {}, $0a89a3b58486c782$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $0a89a3b58486c782$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $0a89a3b58486c782$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $0a89a3b58486c782$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $0a89a3b58486c782$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $0a89a3b58486c782$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $0a89a3b58486c782$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $0a89a3b58486c782$var$_objectSpread($0a89a3b58486c782$var$_objectSpread({}, res), {}, $0a89a3b58486c782$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $0a89a3b58486c782$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $0a89a3b58486c782$var$_objectSpread($0a89a3b58486c782$var$_objectSpread({}, res), $0a89a3b58486c782$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $0a89a3b58486c782$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $0a89a3b58486c782$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $0a89a3b58486c782$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($0a89a3b58486c782$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $0a89a3b58486c782$var$isDev = false;
var $0a89a3b58486c782$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($0a89a3b58486c782$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $9c37125ce8e30c06$var$_slicedToArray(arr, i) {
    return $9c37125ce8e30c06$var$_arrayWithHoles(arr) || $9c37125ce8e30c06$var$_iterableToArrayLimit(arr, i) || $9c37125ce8e30c06$var$_unsupportedIterableToArray(arr, i) || $9c37125ce8e30c06$var$_nonIterableRest();
}
function $9c37125ce8e30c06$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9c37125ce8e30c06$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $9c37125ce8e30c06$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9c37125ce8e30c06$var$_toConsumableArray(arr) {
    return $9c37125ce8e30c06$var$_arrayWithoutHoles(arr) || $9c37125ce8e30c06$var$_iterableToArray(arr) || $9c37125ce8e30c06$var$_unsupportedIterableToArray(arr) || $9c37125ce8e30c06$var$_nonIterableSpread();
}
function $9c37125ce8e30c06$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9c37125ce8e30c06$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9c37125ce8e30c06$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9c37125ce8e30c06$var$_arrayLikeToArray(o, minLen);
}
function $9c37125ce8e30c06$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9c37125ce8e30c06$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9c37125ce8e30c06$var$_arrayLikeToArray(arr);
}
function $9c37125ce8e30c06$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9c37125ce8e30c06$var$ACCURACY = 1e-4;
var $9c37125ce8e30c06$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $9c37125ce8e30c06$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $9c37125ce8e30c06$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $9c37125ce8e30c06$var$cubicBezierFactor(c1, c2);
        return $9c37125ce8e30c06$var$multyTime(params, t);
    };
};
var $9c37125ce8e30c06$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $9c37125ce8e30c06$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($9c37125ce8e30c06$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $9c37125ce8e30c06$var$multyTime(newParams, t);
    };
};
var $9c37125ce8e30c06$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $9c37125ce8e30c06$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $0a89a3b58486c782$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $0a89a3b58486c782$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $9c37125ce8e30c06$var$cubicBezier(x1, x2);
    var curveY = $9c37125ce8e30c06$var$cubicBezier(y1, y2);
    var derCurveX = $9c37125ce8e30c06$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $9c37125ce8e30c06$var$ACCURACY || derVal < $9c37125ce8e30c06$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $9c37125ce8e30c06$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $9c37125ce8e30c06$var$ACCURACY && Math.abs(newV) < $9c37125ce8e30c06$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $9c37125ce8e30c06$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $9c37125ce8e30c06$export$56c51296f72f0592(easing);
        case 'spring':
            return $9c37125ce8e30c06$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $9c37125ce8e30c06$export$56c51296f72f0592(easing);
            (0, $0a89a3b58486c782$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $0a89a3b58486c782$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $70bdc243bd28c19d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $70bdc243bd28c19d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $70bdc243bd28c19d$var$_typeof(obj);
}
function $70bdc243bd28c19d$var$_toConsumableArray(arr) {
    return $70bdc243bd28c19d$var$_arrayWithoutHoles(arr) || $70bdc243bd28c19d$var$_iterableToArray(arr) || $70bdc243bd28c19d$var$_unsupportedIterableToArray(arr) || $70bdc243bd28c19d$var$_nonIterableSpread();
}
function $70bdc243bd28c19d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70bdc243bd28c19d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $70bdc243bd28c19d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $70bdc243bd28c19d$var$_arrayLikeToArray(arr);
}
function $70bdc243bd28c19d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70bdc243bd28c19d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $70bdc243bd28c19d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $70bdc243bd28c19d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $70bdc243bd28c19d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $70bdc243bd28c19d$var$_defineProperty(obj, key, value) {
    key = $70bdc243bd28c19d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $70bdc243bd28c19d$var$_toPropertyKey(arg) {
    var key = $70bdc243bd28c19d$var$_toPrimitive(arg, "string");
    return $70bdc243bd28c19d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $70bdc243bd28c19d$var$_toPrimitive(input, hint) {
    if ($70bdc243bd28c19d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($70bdc243bd28c19d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $70bdc243bd28c19d$var$_slicedToArray(arr, i) {
    return $70bdc243bd28c19d$var$_arrayWithHoles(arr) || $70bdc243bd28c19d$var$_iterableToArrayLimit(arr, i) || $70bdc243bd28c19d$var$_unsupportedIterableToArray(arr, i) || $70bdc243bd28c19d$var$_nonIterableRest();
}
function $70bdc243bd28c19d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70bdc243bd28c19d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70bdc243bd28c19d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70bdc243bd28c19d$var$_arrayLikeToArray(o, minLen);
}
function $70bdc243bd28c19d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $70bdc243bd28c19d$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $70bdc243bd28c19d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $70bdc243bd28c19d$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $70bdc243bd28c19d$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $70bdc243bd28c19d$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $0a89a3b58486c782$export$d6051a0f7a227332)(function(key, val) {
        if ($70bdc243bd28c19d$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $70bdc243bd28c19d$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $0a89a3b58486c782$export$d6051a0f7a227332)(function(key, val) {
        if ($70bdc243bd28c19d$var$needContinue(val)) return $70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, val), {}, {
            velocity: $70bdc243bd28c19d$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $70bdc243bd28c19d$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$70bdc243bd28c19d$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $0a89a3b58486c782$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, res), {}, $70bdc243bd28c19d$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, res), {}, $70bdc243bd28c19d$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $0a89a3b58486c782$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($70bdc243bd28c19d$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $70bdc243bd28c19d$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $0a89a3b58486c782$export$d6051a0f7a227332)(function(key, val) {
            return $70bdc243bd28c19d$var$alpha.apply(void 0, $70bdc243bd28c19d$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $0a89a3b58486c782$export$d6051a0f7a227332)(function(key, val) {
                return $70bdc243bd28c19d$var$alpha.apply(void 0, $70bdc243bd28c19d$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread($70bdc243bd28c19d$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $62c76cb9bca41d87$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $62c76cb9bca41d87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $62c76cb9bca41d87$var$_typeof(obj);
}
var $62c76cb9bca41d87$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $62c76cb9bca41d87$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $62c76cb9bca41d87$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $62c76cb9bca41d87$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $62c76cb9bca41d87$var$_toConsumableArray(arr) {
    return $62c76cb9bca41d87$var$_arrayWithoutHoles(arr) || $62c76cb9bca41d87$var$_iterableToArray(arr) || $62c76cb9bca41d87$var$_unsupportedIterableToArray(arr) || $62c76cb9bca41d87$var$_nonIterableSpread();
}
function $62c76cb9bca41d87$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $62c76cb9bca41d87$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $62c76cb9bca41d87$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $62c76cb9bca41d87$var$_arrayLikeToArray(o, minLen);
}
function $62c76cb9bca41d87$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $62c76cb9bca41d87$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $62c76cb9bca41d87$var$_arrayLikeToArray(arr);
}
function $62c76cb9bca41d87$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $62c76cb9bca41d87$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $62c76cb9bca41d87$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $62c76cb9bca41d87$var$ownKeys(Object(source), !0).forEach(function(key) {
            $62c76cb9bca41d87$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $62c76cb9bca41d87$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $62c76cb9bca41d87$var$_defineProperty(obj, key, value) {
    key = $62c76cb9bca41d87$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $62c76cb9bca41d87$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $62c76cb9bca41d87$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $62c76cb9bca41d87$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $62c76cb9bca41d87$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $62c76cb9bca41d87$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $62c76cb9bca41d87$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $62c76cb9bca41d87$var$_toPropertyKey(arg) {
    var key = $62c76cb9bca41d87$var$_toPrimitive(arg, "string");
    return $62c76cb9bca41d87$var$_typeof(key) === "symbol" ? key : String(key);
}
function $62c76cb9bca41d87$var$_toPrimitive(input, hint) {
    if ($62c76cb9bca41d87$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($62c76cb9bca41d87$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $62c76cb9bca41d87$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $62c76cb9bca41d87$var$_setPrototypeOf(subClass, superClass);
}
function $62c76cb9bca41d87$var$_setPrototypeOf(o, p) {
    $62c76cb9bca41d87$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $62c76cb9bca41d87$var$_setPrototypeOf(o, p);
}
function $62c76cb9bca41d87$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $62c76cb9bca41d87$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $62c76cb9bca41d87$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $62c76cb9bca41d87$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $62c76cb9bca41d87$var$_possibleConstructorReturn(this, result);
    };
}
function $62c76cb9bca41d87$var$_possibleConstructorReturn(self, call) {
    if (call && ($62c76cb9bca41d87$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $62c76cb9bca41d87$var$_assertThisInitialized(self);
}
function $62c76cb9bca41d87$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $62c76cb9bca41d87$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $62c76cb9bca41d87$var$_getPrototypeOf(o) {
    $62c76cb9bca41d87$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $62c76cb9bca41d87$var$_getPrototypeOf(o);
}
var $62c76cb9bca41d87$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $62c76cb9bca41d87$var$_inherits(Animate, _PureComponent);
    var _super = $62c76cb9bca41d87$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $62c76cb9bca41d87$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($62c76cb9bca41d87$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($62c76cb9bca41d87$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $62c76cb9bca41d87$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $62c76cb9bca41d87$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $62c76cb9bca41d87$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $62c76cb9bca41d87$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $62c76cb9bca41d87$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $4724a5ec92bd49bf$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $62c76cb9bca41d87$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $70bdc243bd28c19d$export$2e2bcd8739ae039)(from, to, (0, $9c37125ce8e30c06$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($62c76cb9bca41d87$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $0a89a3b58486c782$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($62c76cb9bca41d87$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $0a89a3b58486c782$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($62c76cb9bca41d87$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $440bc28d9761a77e$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $62c76cb9bca41d87$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $0a89a3b58486c782$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $62c76cb9bca41d87$var$_objectWithoutProperties(_this$props4, $62c76cb9bca41d87$var$_excluded);
                var count = (0, $b7Z9x.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $0a89a3b58486c782$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $b7Z9x.cloneElement)(container, $62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread({}, others), {}, {
                        style: $62c76cb9bca41d87$var$_objectSpread($62c76cb9bca41d87$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $b7Z9x.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", null, (0, $b7Z9x.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $b7Z9x.PureComponent));
$62c76cb9bca41d87$var$Animate.displayName = 'Animate';
$62c76cb9bca41d87$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$62c76cb9bca41d87$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).func
};
var $62c76cb9bca41d87$export$2e2bcd8739ae039 = $62c76cb9bca41d87$var$Animate;





var $b7Z9x = parcelRequire("b7Z9x");
var $8d47cbf140fa85cb$exports = {};
"use strict";

var $8d47cbf140fa85cb$var$_CSSTransition = $8d47cbf140fa85cb$var$_interopRequireDefault((parcelRequire("b38uU")));

var $8d47cbf140fa85cb$var$_ReplaceTransition = $8d47cbf140fa85cb$var$_interopRequireDefault((parcelRequire("c3wW1")));

var $8d47cbf140fa85cb$var$_TransitionGroup = $8d47cbf140fa85cb$var$_interopRequireDefault((parcelRequire("eqPBe")));

var $8d47cbf140fa85cb$var$_Transition = $8d47cbf140fa85cb$var$_interopRequireDefault((parcelRequire("bPfYh")));
function $8d47cbf140fa85cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$8d47cbf140fa85cb$exports = {
    Transition: $8d47cbf140fa85cb$var$_Transition.default,
    TransitionGroup: $8d47cbf140fa85cb$var$_TransitionGroup.default,
    ReplaceTransition: $8d47cbf140fa85cb$var$_ReplaceTransition.default,
    CSSTransition: $8d47cbf140fa85cb$var$_CSSTransition.default
};



var $ejhsZ = parcelRequire("ejhsZ");

var $b7Z9x = parcelRequire("b7Z9x");


var $ejhsZ = parcelRequire("ejhsZ");

var $5dc5824c0cd62500$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $5dc5824c0cd62500$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5dc5824c0cd62500$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5dc5824c0cd62500$var$_typeof(obj);
}
function $5dc5824c0cd62500$var$_extends() {
    $5dc5824c0cd62500$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5dc5824c0cd62500$var$_extends.apply(this, arguments);
}
function $5dc5824c0cd62500$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5dc5824c0cd62500$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5dc5824c0cd62500$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5dc5824c0cd62500$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5dc5824c0cd62500$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5dc5824c0cd62500$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5dc5824c0cd62500$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5dc5824c0cd62500$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5dc5824c0cd62500$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dc5824c0cd62500$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5dc5824c0cd62500$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5dc5824c0cd62500$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5dc5824c0cd62500$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5dc5824c0cd62500$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5dc5824c0cd62500$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5dc5824c0cd62500$var$_setPrototypeOf(subClass, superClass);
}
function $5dc5824c0cd62500$var$_setPrototypeOf(o, p) {
    $5dc5824c0cd62500$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5dc5824c0cd62500$var$_setPrototypeOf(o, p);
}
function $5dc5824c0cd62500$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5dc5824c0cd62500$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5dc5824c0cd62500$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5dc5824c0cd62500$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5dc5824c0cd62500$var$_possibleConstructorReturn(this, result);
    };
}
function $5dc5824c0cd62500$var$_possibleConstructorReturn(self, call) {
    if (call && ($5dc5824c0cd62500$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5dc5824c0cd62500$var$_assertThisInitialized(self);
}
function $5dc5824c0cd62500$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5dc5824c0cd62500$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5dc5824c0cd62500$var$_getPrototypeOf(o) {
    $5dc5824c0cd62500$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5dc5824c0cd62500$var$_getPrototypeOf(o);
}
function $5dc5824c0cd62500$var$_defineProperty(obj, key, value) {
    key = $5dc5824c0cd62500$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5dc5824c0cd62500$var$_toPropertyKey(arg) {
    var key = $5dc5824c0cd62500$var$_toPrimitive(arg, "string");
    return $5dc5824c0cd62500$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5dc5824c0cd62500$var$_toPrimitive(input, hint) {
    if ($5dc5824c0cd62500$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5dc5824c0cd62500$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $5dc5824c0cd62500$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $5dc5824c0cd62500$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $5dc5824c0cd62500$var$_inherits(AnimateGroupChild, _Component);
    var _super = $5dc5824c0cd62500$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $5dc5824c0cd62500$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $5dc5824c0cd62500$var$_defineProperty($5dc5824c0cd62500$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $5dc5824c0cd62500$var$_defineProperty($5dc5824c0cd62500$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $5dc5824c0cd62500$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($5dc5824c0cd62500$var$_objectSpread($5dc5824c0cd62500$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $5dc5824c0cd62500$var$parseDurationOfSingleTransition(appearOptions) + $5dc5824c0cd62500$var$parseDurationOfSingleTransition(enterOptions) + $5dc5824c0cd62500$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $5dc5824c0cd62500$var$_objectWithoutProperties(_this$props3, $5dc5824c0cd62500$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8d47cbf140fa85cb$exports.Transition), $5dc5824c0cd62500$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $62c76cb9bca41d87$export$2e2bcd8739ae039), _this2.state, (0, $b7Z9x.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $b7Z9x.Component));
$5dc5824c0cd62500$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).element
};
var $5dc5824c0cd62500$export$2e2bcd8739ae039 = $5dc5824c0cd62500$var$AnimateGroupChild;


function $f6360c112f10fe04$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8d47cbf140fa85cb$exports.TransitionGroup), {
        component: component
    }, (0, $b7Z9x.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $5dc5824c0cd62500$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$f6360c112f10fe04$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($ejhsZ))).any
};
$f6360c112f10fe04$var$AnimateGroup.defaultProps = {
    component: 'span'
};
var $f6360c112f10fe04$export$2e2bcd8739ae039 = $f6360c112f10fe04$var$AnimateGroup;


var $0a5c28282f32194f$export$2e2bcd8739ae039 = (0, $62c76cb9bca41d87$export$2e2bcd8739ae039);







var $b7Z9x = parcelRequire("b7Z9x");





function $8ee86b32b3d05985$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8ee86b32b3d05985$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8ee86b32b3d05985$var$_typeof(obj);
}
function $8ee86b32b3d05985$var$_extends() {
    $8ee86b32b3d05985$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ee86b32b3d05985$var$_extends.apply(this, arguments);
}
function $8ee86b32b3d05985$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ee86b32b3d05985$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8ee86b32b3d05985$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8ee86b32b3d05985$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8ee86b32b3d05985$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ee86b32b3d05985$var$_defineProperty(obj, key, value) {
    key = $8ee86b32b3d05985$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ee86b32b3d05985$var$_toPropertyKey(arg) {
    var key = $8ee86b32b3d05985$var$_toPrimitive(arg, "string");
    return $8ee86b32b3d05985$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8ee86b32b3d05985$var$_toPrimitive(input, hint) {
    if ($8ee86b32b3d05985$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8ee86b32b3d05985$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8ee86b32b3d05985$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $6fa814273ae93f6c$exports.curveBasisClosed),
    curveBasisOpen: (0, $6fa814273ae93f6c$exports.curveBasisOpen),
    curveBasis: (0, $6fa814273ae93f6c$exports.curveBasis),
    curveBumpX: (0, $6fa814273ae93f6c$exports.curveBumpX),
    curveBumpY: (0, $6fa814273ae93f6c$exports.curveBumpY),
    curveLinearClosed: (0, $6fa814273ae93f6c$exports.curveLinearClosed),
    curveLinear: (0, $6fa814273ae93f6c$exports.curveLinear),
    curveMonotoneX: (0, $6fa814273ae93f6c$exports.curveMonotoneX),
    curveMonotoneY: (0, $6fa814273ae93f6c$exports.curveMonotoneY),
    curveNatural: (0, $6fa814273ae93f6c$exports.curveNatural),
    curveStep: (0, $6fa814273ae93f6c$exports.curveStep),
    curveStepAfter: (0, $6fa814273ae93f6c$exports.curveStepAfter),
    curveStepBefore: (0, $6fa814273ae93f6c$exports.curveStepBefore)
};
var $8ee86b32b3d05985$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $8ee86b32b3d05985$var$getX = function getX(p) {
    return p.x;
};
var $8ee86b32b3d05985$var$getY = function getY(p) {
    return p.y;
};
var $8ee86b32b3d05985$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($b8a24ec1bb4853d9$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $8ee86b32b3d05985$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $8ee86b32b3d05985$var$CURVE_FACTORIES[name] || (0, $6fa814273ae93f6c$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $8ee86b32b3d05985$var$getPath = function getPath(_ref) {
    var type = _ref.type, points = _ref.points, baseLine = _ref.baseLine, layout = _ref.layout, connectNulls = _ref.connectNulls;
    var curveFactory = $8ee86b32b3d05985$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $8ee86b32b3d05985$var$defined(entry);
    }) : points;
    var lineFunction;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $8ee86b32b3d05985$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $8ee86b32b3d05985$var$_objectSpread($8ee86b32b3d05985$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $6fa814273ae93f6c$exports.area)().y($8ee86b32b3d05985$var$getY).x1($8ee86b32b3d05985$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $6fa814273ae93f6c$exports.area)().x($8ee86b32b3d05985$var$getX).y1($8ee86b32b3d05985$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($8ee86b32b3d05985$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $6fa814273ae93f6c$exports.area)().y($8ee86b32b3d05985$var$getY).x1($8ee86b32b3d05985$var$getX).x0(baseLine);
    else if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $6fa814273ae93f6c$exports.area)().x($8ee86b32b3d05985$var$getX).y1($8ee86b32b3d05985$var$getY).y0(baseLine);
    else lineFunction = (0, $6fa814273ae93f6c$exports.line)().x($8ee86b32b3d05985$var$getX).y($8ee86b32b3d05985$var$getY);
    lineFunction.defined($8ee86b32b3d05985$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $8ee86b32b3d05985$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $8ee86b32b3d05985$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $8ee86b32b3d05985$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props), (0, $f321872aac18bbfb$export$7c4c290a4a9c1b1e)(props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};
$8ee86b32b3d05985$export$b0e83c3ef8d2db1.defaultProps = {
    type: 'linear',
    points: [],
    connectNulls: false
};



var $b7Z9x = parcelRequire("b7Z9x");



function $91e8d465d4ebe72b$var$_extends() {
    $91e8d465d4ebe72b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91e8d465d4ebe72b$var$_extends.apply(this, arguments);
}
var $91e8d465d4ebe72b$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("circle", $91e8d465d4ebe72b$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props), (0, $f321872aac18bbfb$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};



var $b7Z9x = parcelRequire("b7Z9x");


var $fdd33d93262f23bd$var$_excluded = [
    "children",
    "className"
];
function $fdd33d93262f23bd$var$_extends() {
    $fdd33d93262f23bd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdd33d93262f23bd$var$_extends.apply(this, arguments);
}
function $fdd33d93262f23bd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fdd33d93262f23bd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fdd33d93262f23bd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fdd33d93262f23bd$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $fdd33d93262f23bd$var$_objectWithoutProperties(props, $fdd33d93262f23bd$var$_excluded);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", $fdd33d93262f23bd$var$_extends({
        className: layerClass
    }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});





var $14e1f3ed3f28d525$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $14e1f3ed3f28d525$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$14e1f3ed3f28d525$exports = $14e1f3ed3f28d525$var$last;




var $b7Z9x = parcelRequire("b7Z9x");




var $b7Z9x = parcelRequire("b7Z9x");



var $b7Z9x = parcelRequire("b7Z9x");
var $f688e31300eb5683$exports = {};
'use strict';
Object.defineProperty($f688e31300eb5683$exports, "__esModule", {
    value: true
});
var $6ead6031639915f0$exports = {};
var $e44150714eaf704d$exports = {};
var $e44150714eaf704d$var$openParentheses = "(".charCodeAt(0);
var $e44150714eaf704d$var$closeParentheses = ")".charCodeAt(0);
var $e44150714eaf704d$var$singleQuote = "'".charCodeAt(0);
var $e44150714eaf704d$var$doubleQuote = '"'.charCodeAt(0);
var $e44150714eaf704d$var$backslash = "\\".charCodeAt(0);
var $e44150714eaf704d$var$slash = "/".charCodeAt(0);
var $e44150714eaf704d$var$comma = ",".charCodeAt(0);
var $e44150714eaf704d$var$colon = ":".charCodeAt(0);
var $e44150714eaf704d$var$star = "*".charCodeAt(0);
$e44150714eaf704d$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $e44150714eaf704d$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $e44150714eaf704d$var$comma || code === $e44150714eaf704d$var$colon || code === $e44150714eaf704d$var$slash && value.charCodeAt(next + 1) !== $e44150714eaf704d$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $e44150714eaf704d$var$singleQuote || code === $e44150714eaf704d$var$doubleQuote) {
            next = pos;
            quote = code === $e44150714eaf704d$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $e44150714eaf704d$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $e44150714eaf704d$var$slash && value.charCodeAt(pos + 1) === $e44150714eaf704d$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $e44150714eaf704d$var$slash || code === $e44150714eaf704d$var$comma || code === $e44150714eaf704d$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($e44150714eaf704d$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $e44150714eaf704d$var$singleQuote && code !== $e44150714eaf704d$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $e44150714eaf704d$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($e44150714eaf704d$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $e44150714eaf704d$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $e44150714eaf704d$var$singleQuote || code === $e44150714eaf704d$var$doubleQuote || code === $e44150714eaf704d$var$comma || code === $e44150714eaf704d$var$colon || code === $e44150714eaf704d$var$slash || code === $e44150714eaf704d$var$openParentheses || code === $e44150714eaf704d$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($e44150714eaf704d$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $1834e4e753bb383b$exports = {};
$1834e4e753bb383b$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $8c1cb793926cb9d6$exports = {};
function $8c1cb793926cb9d6$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $8c1cb793926cb9d6$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $8c1cb793926cb9d6$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $8c1cb793926cb9d6$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $8c1cb793926cb9d6$var$stringifyNode(nodes, custom);
}
$8c1cb793926cb9d6$exports = $8c1cb793926cb9d6$var$stringify;


function $6ead6031639915f0$var$ValueParser(value) {
    if (this instanceof $6ead6031639915f0$var$ValueParser) {
        this.nodes = $e44150714eaf704d$exports(value);
        return this;
    }
    return new $6ead6031639915f0$var$ValueParser(value);
}
$6ead6031639915f0$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $8c1cb793926cb9d6$exports(this.nodes) : "";
};
$6ead6031639915f0$var$ValueParser.prototype.walk = function(cb, bubble) {
    $1834e4e753bb383b$exports(this.nodes, cb, bubble);
    return this;
};

$6ead6031639915f0$var$ValueParser.unit = (parcelRequire("7kayC"));
$6ead6031639915f0$var$ValueParser.walk = $1834e4e753bb383b$exports;
$6ead6031639915f0$var$ValueParser.stringify = $8c1cb793926cb9d6$exports;
$6ead6031639915f0$exports = $6ead6031639915f0$var$ValueParser;


var $f688e31300eb5683$var$_postcssValueParser2 = $f688e31300eb5683$var$_interopRequireDefault($6ead6031639915f0$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $495e966b099afba0$export$8f49e4af10703ce3;
var $495e966b099afba0$export$7acfa6ed01010e37;
var $495e966b099afba0$export$98e6a39c04603d36;
var $495e966b099afba0$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: 'JisonParserError'
        });
        if (msg == null) msg = '???';
        Object.defineProperty(this, 'message', {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === 'function') {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return 'end of input';
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: 'MathExpression',
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: 'LengthValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: 'AngleValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: 'TimeValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: 'FrequencyValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: 'ResolutionValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: 'EmValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'em'
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: 'ExValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ex'
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: 'ChValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ch'
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: 'RemValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'rem'
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: 'VhValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vh'
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: 'VwValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vw'
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: 'VminValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmin'
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: 'VmaxValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmax'
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: 'PercentageValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: '%'
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === 'function') this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === 'function') this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === 'function') {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                            else errStr = 'Parse error: ';
                            if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                            if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                            else errStr += 'Unexpected ' + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== 'undefined') {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonLexerError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = 'JisonLexerError';
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: '',
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: '',
            matched: '',
            matches: false,
            yytext: '',
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = '' + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === 'function') {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += '\n';
                        msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === 'function') {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = '';
                if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput('', {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = '';
                this.yyleng = 0;
                this.match = '';
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || '';
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== 'string') {
                    if (rv) this._input = '' + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === '\n') lines = true;
                else if (ch === '\r') {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === '\n') {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(-maxLines);
                past = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(0, maxLines);
                next = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split('\n');
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(' ');
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ': ' + line;
                    var errpfx = new Array(lineno_display_width + 1).join('^');
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join('.');
                        var mark = new Array(len).join('^');
                        rv += '\n' + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, ' ');
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                    intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join('\n');
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = 'line ' + l1 + ', ';
                    if (dc <= 1) rv += 'column ' + c1;
                    else rv += 'columns ' + c1 + ' .. ' + c2;
                } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                    else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = '';
                    if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions['INITIAL'];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                'INITIAL': {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$495e966b099afba0$export$8f49e4af10703ce3 = $495e966b099afba0$var$parser;
$495e966b099afba0$export$7acfa6ed01010e37 = $495e966b099afba0$var$parser.Parser;
$495e966b099afba0$export$98e6a39c04603d36 = function() {
    return $495e966b099afba0$var$parser.parse.apply($495e966b099afba0$var$parser, arguments);
};


var $d93a2c0733efc6f6$exports = {};
"use strict";
Object.defineProperty($d93a2c0733efc6f6$exports, "__esModule", {
    value: true
});
$d93a2c0733efc6f6$exports.flip = $d93a2c0733efc6f6$var$flip;
var $2ce45bec3b3f0167$exports = {};
'use strict';
Object.defineProperty($2ce45bec3b3f0167$exports, "__esModule", {
    value: true
});
var $e51c5398e5f3e64a$exports = {};
var $e51c5398e5f3e64a$var$conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0 / 2.54,
        'mm': 96.0 / 25.4,
        'in': 96,
        'pt': 96.0 / 72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54 / 96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54 / 72.0,
        'pc': 2.54 / 6.0
    },
    'mm': {
        'px': 25.4 / 96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4 / 72.0,
        'pc': 25.4 / 6.0
    },
    'in': {
        'px': 1.0 / 96.0,
        'cm': 1.0 / 2.54,
        'mm': 1.0 / 25.4,
        'in': 1,
        'pt': 1.0 / 72.0,
        'pc': 1.0 / 6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0 / 2.54,
        'mm': 72.0 / 25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 0.0625,
        'cm': 6.0 / 2.54,
        'mm': 6.0 / 25.4,
        'in': 6,
        'pt': 6.0 / 72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180 / Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400 / 360,
        'grad': 1,
        'rad': 200 / Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI / 180,
        'grad': Math.PI / 200,
        'rad': 1,
        'turn': Math.PI * 2
    },
    'turn': {
        'deg': 1 / 360,
        'grad': 1 / 400,
        'rad': 0.5 / Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 0.001
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 0.001,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0 / 2.54,
        'dppx': 1 / 96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54 / 96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0 / 2.54,
        'dppx': 1
    }
};
$e51c5398e5f3e64a$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$e51c5398e5f3e64a$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$e51c5398e5f3e64a$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $e51c5398e5f3e64a$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $2ce45bec3b3f0167$var$_cssUnitConverter2 = $2ce45bec3b3f0167$var$_interopRequireDefault($e51c5398e5f3e64a$exports);
function $2ce45bec3b3f0167$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2ce45bec3b3f0167$var$convertNodes(left, right, precision) {
    switch(left.type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
            return $2ce45bec3b3f0167$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $2ce45bec3b3f0167$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $2ce45bec3b3f0167$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$2ce45bec3b3f0167$exports.default = $2ce45bec3b3f0167$var$convertNodes;
$2ce45bec3b3f0167$exports = $2ce45bec3b3f0167$exports['default'];


var $d93a2c0733efc6f6$var$_convert2 = $d93a2c0733efc6f6$var$_interopRequireDefault($2ce45bec3b3f0167$exports);
function $d93a2c0733efc6f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d93a2c0733efc6f6$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $d93a2c0733efc6f6$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $d93a2c0733efc6f6$var$reduce(node.value, precision);
    return node;
}
function $d93a2c0733efc6f6$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $d93a2c0733efc6f6$var$isValueType(type) {
    switch(type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
        case 'EmValue':
        case 'ExValue':
        case 'ChValue':
        case 'RemValue':
        case 'VhValue':
        case 'VwValue':
        case 'VminValue':
        case 'VmaxValue':
        case 'PercentageValue':
        case 'Value':
            return true;
    }
    return false;
}
function $d93a2c0733efc6f6$var$convertMathExpression(node, precision) {
    var nodes = (0, $d93a2c0733efc6f6$var$_convert2.default)(node.left, node.right, precision);
    var left = $d93a2c0733efc6f6$var$reduce(nodes.left, precision);
    var right = $d93a2c0733efc6f6$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
            if ($d93a2c0733efc6f6$var$isEqual(left.right, right.right)) nodes = (0, $d93a2c0733efc6f6$var$_convert2.default)(left.left, right.left, precision);
            else if ($d93a2c0733efc6f6$var$isEqual(left.right, right.left)) nodes = (0, $d93a2c0733efc6f6$var$_convert2.default)(left.left, right.right, precision);
            left = $d93a2c0733efc6f6$var$reduce(nodes.left, precision);
            right = $d93a2c0733efc6f6$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $d93a2c0733efc6f6$var$flip(operator) {
    return operator === '+' ? '-' : '+';
}
function $d93a2c0733efc6f6$var$flipValue(node) {
    if ($d93a2c0733efc6f6$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == 'MathExpression') {
        node.left = $d93a2c0733efc6f6$var$flipValue(node.left);
        node.right = $d93a2c0733efc6f6$var$flipValue(node.right);
    }
    return node;
}
function $d93a2c0733efc6f6$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $d93a2c0733efc6f6$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $d93a2c0733efc6f6$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($d93a2c0733efc6f6$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $d93a2c0733efc6f6$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === '-' ? $d93a2c0733efc6f6$var$flip(right.operator) : right.operator;
            return $d93a2c0733efc6f6$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $d93a2c0733efc6f6$var$reduce({
                type: 'MathExpression',
                operator: op === '-' ? $d93a2c0733efc6f6$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $d93a2c0733efc6f6$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $d93a2c0733efc6f6$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $d93a2c0733efc6f6$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $d93a2c0733efc6f6$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === '-') {
                node.right = $d93a2c0733efc6f6$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? '+' : '-',
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === '-' ? '-' : '+';
            } else node.right = $d93a2c0733efc6f6$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === '-' ? '+' : '-';
            }
            return $d93a2c0733efc6f6$var$reduce(node, precision);
        }
    }
    return node;
}
function $d93a2c0733efc6f6$var$reduceDivisionExpression(node, precision) {
    if (!$d93a2c0733efc6f6$var$isValueType(node.right.type)) return node;
    if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
    if (node.right.value === 0) throw new Error('Cannot divide by zero');
    // (expr) / value
    if (node.left.type === 'MathExpression') {
        if ($d93a2c0733efc6f6$var$isValueType(node.left.left.type) && $d93a2c0733efc6f6$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $d93a2c0733efc6f6$var$reduce(node.left, precision);
        }
        return node;
    } else if ($d93a2c0733efc6f6$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $d93a2c0733efc6f6$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
        if ($d93a2c0733efc6f6$var$isValueType(node.left.left.type) && $d93a2c0733efc6f6$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($d93a2c0733efc6f6$var$isValueType(node.left.type) && node.right.type === 'Value') {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if ($d93a2c0733efc6f6$var$isValueType(node.right.left.type) && $d93a2c0733efc6f6$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === 'Value' && $d93a2c0733efc6f6$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $d93a2c0733efc6f6$var$reduceMathExpression(node, precision) {
    node = $d93a2c0733efc6f6$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $d93a2c0733efc6f6$var$reduceAddSubExpression(node, precision);
        case "/":
            return $d93a2c0733efc6f6$var$reduceDivisionExpression(node, precision);
        case "*":
            return $d93a2c0733efc6f6$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$d93a2c0733efc6f6$exports.default = $d93a2c0733efc6f6$var$reduce;


var $f688e31300eb5683$var$_reducer2 = $f688e31300eb5683$var$_interopRequireDefault($d93a2c0733efc6f6$exports);
var $6695e32c02f9e6dd$exports = {};
"use strict";
Object.defineProperty($6695e32c02f9e6dd$exports, "__esModule", {
    value: true
});
$6695e32c02f9e6dd$exports.default = function(calc, node, precision) {
    var str = $6695e32c02f9e6dd$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $6695e32c02f9e6dd$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $6695e32c02f9e6dd$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $6695e32c02f9e6dd$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === 'MathExpression' && $6695e32c02f9e6dd$var$order[op] < $6695e32c02f9e6dd$var$order[left.operator]) str += "(" + $6695e32c02f9e6dd$var$stringify(left, prec) + ")";
            else str += $6695e32c02f9e6dd$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === 'MathExpression' && $6695e32c02f9e6dd$var$order[op] < $6695e32c02f9e6dd$var$order[right.operator]) str += "(" + $6695e32c02f9e6dd$var$stringify(right, prec) + ")";
            else if (right.type === 'MathExpression' && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $d93a2c0733efc6f6$exports.flip)(right.operator);
                str += $6695e32c02f9e6dd$var$stringify(right, prec);
            } else str += $6695e32c02f9e6dd$var$stringify(right, prec);
            return str;
        case "Value":
            return $6695e32c02f9e6dd$var$round(node.value, prec);
        case 'CssVariable':
            if (node.fallback) return "var(" + node.value + ", " + $6695e32c02f9e6dd$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case 'Calc':
            if (node.prefix) return "-" + node.prefix + "-calc(" + $6695e32c02f9e6dd$var$stringify(node.value, prec) + ")";
            return "calc(" + $6695e32c02f9e6dd$var$stringify(node.value, prec) + ")";
        default:
            return $6695e32c02f9e6dd$var$round(node.value, prec) + node.unit;
    }
}
$6695e32c02f9e6dd$exports = $6695e32c02f9e6dd$exports["default"];


var $f688e31300eb5683$var$_stringifier2 = $f688e31300eb5683$var$_interopRequireDefault($6695e32c02f9e6dd$exports);
function $f688e31300eb5683$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $f688e31300eb5683$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$f688e31300eb5683$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $f688e31300eb5683$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !$f688e31300eb5683$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $f688e31300eb5683$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
        var ast = $495e966b099afba0$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $f688e31300eb5683$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, $f688e31300eb5683$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$f688e31300eb5683$exports = $f688e31300eb5683$exports['default'];




var $51c8fb4726a2e81c$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $51c8fb4726a2e81c$export$98f03c5d19621d70 = {
    isSsr: $51c8fb4726a2e81c$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $51c8fb4726a2e81c$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $51c8fb4726a2e81c$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $51c8fb4726a2e81c$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $5693eee73e492f24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5693eee73e492f24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5693eee73e492f24$var$_typeof(obj);
}
function $5693eee73e492f24$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5693eee73e492f24$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5693eee73e492f24$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5693eee73e492f24$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5693eee73e492f24$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5693eee73e492f24$var$_defineProperty(obj, key, value) {
    key = $5693eee73e492f24$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5693eee73e492f24$var$_toPropertyKey(arg) {
    var key = $5693eee73e492f24$var$_toPrimitive(arg, "string");
    return $5693eee73e492f24$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5693eee73e492f24$var$_toPrimitive(input, hint) {
    if ($5693eee73e492f24$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5693eee73e492f24$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5693eee73e492f24$var$_toConsumableArray(arr) {
    return $5693eee73e492f24$var$_arrayWithoutHoles(arr) || $5693eee73e492f24$var$_iterableToArray(arr) || $5693eee73e492f24$var$_unsupportedIterableToArray(arr) || $5693eee73e492f24$var$_nonIterableSpread();
}
function $5693eee73e492f24$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5693eee73e492f24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5693eee73e492f24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5693eee73e492f24$var$_arrayLikeToArray(o, minLen);
}
function $5693eee73e492f24$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5693eee73e492f24$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5693eee73e492f24$var$_arrayLikeToArray(arr);
}
function $5693eee73e492f24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5693eee73e492f24$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $5693eee73e492f24$var$MAX_CACHE_NUM = 2000;
var $5693eee73e492f24$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $5693eee73e492f24$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $5693eee73e492f24$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $5693eee73e492f24$var$autoCompleteStyle(name, value) {
    if ($5693eee73e492f24$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $5693eee73e492f24$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($5693eee73e492f24$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($5693eee73e492f24$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $5693eee73e492f24$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($5693eee73e492f24$var$camelToMiddleLine(s), ":").concat($5693eee73e492f24$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
var $5693eee73e492f24$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $5693eee73e492f24$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($5693eee73e492f24$var$stringCache.widthCache[cacheKey]) return $5693eee73e492f24$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($5693eee73e492f24$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $5693eee73e492f24$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $5693eee73e492f24$var$_objectSpread($5693eee73e492f24$var$_objectSpread({}, $5693eee73e492f24$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $5693eee73e492f24$var$stringCache.widthCache[cacheKey] = result;
        if (++$5693eee73e492f24$var$stringCache.cacheCount > $5693eee73e492f24$var$MAX_CACHE_NUM) {
            $5693eee73e492f24$var$stringCache.cacheCount = 0;
            $5693eee73e492f24$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $5693eee73e492f24$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    };
    // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== 'undefined') box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $5693eee73e492f24$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


var $b68d75c627cc2644$var$_excluded = [
    "dx",
    "dy",
    "textAnchor",
    "verticalAnchor",
    "scaleToFit",
    "angle",
    "lineHeight",
    "capHeight",
    "className",
    "breakAll"
];
function $b68d75c627cc2644$var$_extends() {
    $b68d75c627cc2644$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b68d75c627cc2644$var$_extends.apply(this, arguments);
}
function $b68d75c627cc2644$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b68d75c627cc2644$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b68d75c627cc2644$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b68d75c627cc2644$var$_slicedToArray(arr, i) {
    return $b68d75c627cc2644$var$_arrayWithHoles(arr) || $b68d75c627cc2644$var$_iterableToArrayLimit(arr, i) || $b68d75c627cc2644$var$_unsupportedIterableToArray(arr, i) || $b68d75c627cc2644$var$_nonIterableRest();
}
function $b68d75c627cc2644$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b68d75c627cc2644$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b68d75c627cc2644$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b68d75c627cc2644$var$_arrayLikeToArray(o, minLen);
}
function $b68d75c627cc2644$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b68d75c627cc2644$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $b68d75c627cc2644$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b68d75c627cc2644$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $b68d75c627cc2644$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($b68d75c627cc2644$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $5693eee73e492f24$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $5693eee73e492f24$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $b68d75c627cc2644$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $b68d75c627cc2644$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $b68d75c627cc2644$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $b68d75c627cc2644$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $b68d75c627cc2644$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(children) ? children.toString().split($b68d75c627cc2644$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $b68d75c627cc2644$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $b68d75c627cc2644$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $b68d75c627cc2644$var$getWordsWithoutCalculate(children);
        return $b68d75c627cc2644$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $b68d75c627cc2644$var$getWordsWithoutCalculate(children);
};
var $b68d75c627cc2644$var$textDefaultProps = {
    x: 0,
    y: 0,
    lineHeight: '1em',
    capHeight: '0.71em',
    // Magic number from d3
    scaleToFit: false,
    textAnchor: 'start',
    verticalAnchor: 'end',
    // Maintain compat with existing charts / default SVG behavior
    fill: '#808080'
};
var $b68d75c627cc2644$export$5f1af8db9871e1d6 = function Text(props) {
    var wordsByLines = (0, $b7Z9x.useMemo)(function() {
        return $b68d75c627cc2644$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: props.scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        props.scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, textAnchor = props.textAnchor, verticalAnchor = props.verticalAnchor, scaleToFit = props.scaleToFit, angle = props.angle, lineHeight = props.lineHeight, capHeight = props.capHeight, className = props.className, breakAll = props.breakAll, textProps = $b68d75c627cc2644$var$_objectWithoutProperties(props, $b68d75c627cc2644$var$_excluded);
    if (!(0, $201aa8e07b0747a2$export$402a499e1ea44294)(textProps.x) || !(0, $201aa8e07b0747a2$export$402a499e1ea44294)(textProps.y)) return null;
    var x = textProps.x + ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = textProps.y + ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f688e31300eb5683$exports)))("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f688e31300eb5683$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f688e31300eb5683$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("text", $b68d75c627cc2644$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-text', className),
        textAnchor: textAnchor,
        fill: textProps.fill.includes('url') ? $b68d75c627cc2644$var$textDefaultProps.fill : textProps.fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? '' : ' ')));
    }));
};
$b68d75c627cc2644$export$5f1af8db9871e1d6.defaultProps = $b68d75c627cc2644$var$textDefaultProps;







var $e20cd8069ccd8bf4$exports = {};
var $f2b4c8c6cd3ce85a$exports = {};

var $b4967c1c6b89d66e$exports = {};



/** Built-in value references. */ var $b4967c1c6b89d66e$var$spreadableSymbol = $aa9ebce293fb2e09$exports ? $aa9ebce293fb2e09$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $b4967c1c6b89d66e$var$isFlattenable(value) {
    return $e9f4eab8a3ba19aa$exports(value) || $58078857a51245fd$exports(value) || !!($b4967c1c6b89d66e$var$spreadableSymbol && value && value[$b4967c1c6b89d66e$var$spreadableSymbol]);
}
$b4967c1c6b89d66e$exports = $b4967c1c6b89d66e$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f2b4c8c6cd3ce85a$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $b4967c1c6b89d66e$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f2b4c8c6cd3ce85a$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $29d6e3ba59f65258$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f2b4c8c6cd3ce85a$exports = $f2b4c8c6cd3ce85a$var$baseFlatten;


var $f1e34f8dc380af0c$exports = {};



var $e3e798850518a656$exports = {};
var $72d146bf2da273f9$exports = {};
var $7739bf3b206d90b7$exports = {};
var $94b1c4f5cdf12f23$exports = {};
var $ec9b0520d262b90e$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ec9b0520d262b90e$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$ec9b0520d262b90e$exports = $ec9b0520d262b90e$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $94b1c4f5cdf12f23$var$baseFor = $ec9b0520d262b90e$exports();
$94b1c4f5cdf12f23$exports = $94b1c4f5cdf12f23$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7739bf3b206d90b7$var$baseForOwn(object, iteratee) {
    return object && $94b1c4f5cdf12f23$exports(object, iteratee, $3cea58c3c3d6f086$exports);
}
$7739bf3b206d90b7$exports = $7739bf3b206d90b7$var$baseForOwn;


var $cd0b875ab7b9fe9d$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $cd0b875ab7b9fe9d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$b1b629d226020fad$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$cd0b875ab7b9fe9d$exports = $cd0b875ab7b9fe9d$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $72d146bf2da273f9$var$baseEach = $cd0b875ab7b9fe9d$exports($7739bf3b206d90b7$exports);
$72d146bf2da273f9$exports = $72d146bf2da273f9$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e3e798850518a656$var$baseMap(collection, iteratee) {
    var index = -1, result = $b1b629d226020fad$exports(collection) ? Array(collection.length) : [];
    $72d146bf2da273f9$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$e3e798850518a656$exports = $e3e798850518a656$var$baseMap;


var $9aabc477fdca63a0$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9aabc477fdca63a0$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9aabc477fdca63a0$exports = $9aabc477fdca63a0$var$baseSortBy;



var $23b24dbc9364a863$exports = {};
var $59adaadbc7d6e0c7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $59adaadbc7d6e0c7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $df0bd783b3fde9a7$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $df0bd783b3fde9a7$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$59adaadbc7d6e0c7$exports = $59adaadbc7d6e0c7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $23b24dbc9364a863$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $59adaadbc7d6e0c7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$23b24dbc9364a863$exports = $23b24dbc9364a863$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f1e34f8dc380af0c$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $a39ed7a356e41a02$exports(iteratees, function(iteratee) {
        if ($e9f4eab8a3ba19aa$exports(iteratee)) return function(value) {
            return $ea39284deca3da9b$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $e88a261cf8244156$exports
    ];
    var index = -1;
    iteratees = $a39ed7a356e41a02$exports(iteratees, $1df420928aaaa4bf$exports($a3e1cb58c2a61f92$exports));
    var result = $e3e798850518a656$exports(collection, function(value, key, collection) {
        var criteria = $a39ed7a356e41a02$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9aabc477fdca63a0$exports(result, function(object, other) {
        return $23b24dbc9364a863$exports(object, other, orders);
    });
}
$f1e34f8dc380af0c$exports = $f1e34f8dc380af0c$var$baseOrderBy;


var $449cf1b2ca461787$exports = {};

var $3cb44802af738e78$exports = {};
var $a2d6462b60cf5ded$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $a2d6462b60cf5ded$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$a2d6462b60cf5ded$exports = $a2d6462b60cf5ded$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $3cb44802af738e78$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3cb44802af738e78$var$overRest(func, start, transform) {
    start = $3cb44802af738e78$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3cb44802af738e78$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $a2d6462b60cf5ded$exports(func, this, otherArgs);
    };
}
$3cb44802af738e78$exports = $3cb44802af738e78$var$overRest;


var $391262b49bb1c7a4$exports = {};
var $f3ecf23baa544145$exports = {};
var $0cec6e8eda19cf3f$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $0cec6e8eda19cf3f$var$constant(value) {
    return function() {
        return value;
    };
}
$0cec6e8eda19cf3f$exports = $0cec6e8eda19cf3f$var$constant;


var $c8438589f608e50e$exports = {};

var $c8438589f608e50e$var$defineProperty = function() {
    try {
        var func = $21ba99941d8ab1d0$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$c8438589f608e50e$exports = $c8438589f608e50e$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $f3ecf23baa544145$var$baseSetToString = !$c8438589f608e50e$exports ? $e88a261cf8244156$exports : function(func, string) {
    return $c8438589f608e50e$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $0cec6e8eda19cf3f$exports(string),
        'writable': true
    });
};
$f3ecf23baa544145$exports = $f3ecf23baa544145$var$baseSetToString;


var $de7abe14014897a6$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $de7abe14014897a6$var$HOT_COUNT = 800, $de7abe14014897a6$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $de7abe14014897a6$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $de7abe14014897a6$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $de7abe14014897a6$var$nativeNow(), remaining = $de7abe14014897a6$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $de7abe14014897a6$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$de7abe14014897a6$exports = $de7abe14014897a6$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $391262b49bb1c7a4$var$setToString = $de7abe14014897a6$exports($f3ecf23baa544145$exports);
$391262b49bb1c7a4$exports = $391262b49bb1c7a4$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $449cf1b2ca461787$var$baseRest(func, start) {
    return $391262b49bb1c7a4$exports($3cb44802af738e78$exports(func, start, $e88a261cf8244156$exports), func + '');
}
$449cf1b2ca461787$exports = $449cf1b2ca461787$var$baseRest;


var $89342db7e4beb4e5$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $89342db7e4beb4e5$var$isIterateeCall(value, index, object) {
    if (!$3cf8bb2e7defbbff$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $b1b629d226020fad$exports(object) && $a8eb3b42bf304d25$exports(index, object.length) : type == 'string' && index in object) return $40ef67da37ce76ef$exports(object[index], value);
    return false;
}
$89342db7e4beb4e5$exports = $89342db7e4beb4e5$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $e20cd8069ccd8bf4$var$sortBy = $449cf1b2ca461787$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $89342db7e4beb4e5$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $89342db7e4beb4e5$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $f1e34f8dc380af0c$exports(collection, $f2b4c8c6cd3ce85a$exports(iteratees, 1), []);
});
$e20cd8069ccd8bf4$exports = $e20cd8069ccd8bf4$var$sortBy;






var $fad4eca9fe13ba8f$exports = {};
var $291f8c248398ed4e$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $291f8c248398ed4e$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$df0bd783b3fde9a7$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$291f8c248398ed4e$exports = $291f8c248398ed4e$var$baseExtremum;


var $88e875759bb30032$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $88e875759bb30032$var$baseGt(value, other) {
    return value > other;
}
$88e875759bb30032$exports = $88e875759bb30032$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $fad4eca9fe13ba8f$var$max(array) {
    return array && array.length ? $291f8c248398ed4e$exports(array, $e88a261cf8244156$exports, $88e875759bb30032$exports) : undefined;
}
$fad4eca9fe13ba8f$exports = $fad4eca9fe13ba8f$var$max;


var $96e03318e85fb2a8$exports = {};

var $acd1488bdf5a03ce$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $acd1488bdf5a03ce$var$baseLt(value, other) {
    return value < other;
}
$acd1488bdf5a03ce$exports = $acd1488bdf5a03ce$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $96e03318e85fb2a8$var$min(array) {
    return array && array.length ? $291f8c248398ed4e$exports(array, $e88a261cf8244156$exports, $acd1488bdf5a03ce$exports) : undefined;
}
$96e03318e85fb2a8$exports = $96e03318e85fb2a8$var$min;


var $30960d86d5d3631c$exports = {};

var $a6f2d3d85d80663b$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a6f2d3d85d80663b$var$map(collection, iteratee) {
    var func = $e9f4eab8a3ba19aa$exports(collection) ? $a39ed7a356e41a02$exports : $e3e798850518a656$exports;
    return func(collection, $a3e1cb58c2a61f92$exports(iteratee, 3));
}
$a6f2d3d85d80663b$exports = $a6f2d3d85d80663b$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $30960d86d5d3631c$var$flatMap(collection, iteratee) {
    return $f2b4c8c6cd3ce85a$exports($a6f2d3d85d80663b$exports(collection, iteratee), 1);
}
$30960d86d5d3631c$exports = $30960d86d5d3631c$var$flatMap;





var $2903d33098abf7e3$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$2903d33098abf7e3$exports = (parcelRequire("fH8Mx"));



var $068d20ea68d7a3b4$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $068d20ea68d7a3b4$exports) $068d20ea68d7a3b4$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($068d20ea68d7a3b4$exports);


function $0c04c5fc909e9716$var$_toConsumableArray(arr) {
    return $0c04c5fc909e9716$var$_arrayWithoutHoles(arr) || $0c04c5fc909e9716$var$_iterableToArray(arr) || $0c04c5fc909e9716$var$_unsupportedIterableToArray(arr) || $0c04c5fc909e9716$var$_nonIterableSpread();
}
function $0c04c5fc909e9716$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c04c5fc909e9716$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c04c5fc909e9716$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c04c5fc909e9716$var$_arrayLikeToArray(o, minLen);
}
function $0c04c5fc909e9716$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $0c04c5fc909e9716$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0c04c5fc909e9716$var$_arrayLikeToArray(arr);
}
function $0c04c5fc909e9716$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0c04c5fc909e9716$var$identity = function identity(i) {
    return i;
};
var $0c04c5fc909e9716$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $0c04c5fc909e9716$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $0c04c5fc909e9716$export$ca73b6d700d0505;
};
var $0c04c5fc909e9716$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $0c04c5fc909e9716$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $0c04c5fc909e9716$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $0c04c5fc909e9716$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $0c04c5fc909e9716$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $0c04c5fc909e9716$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $0c04c5fc909e9716$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $0c04c5fc909e9716$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $0c04c5fc909e9716$export$c3095a23b368d1f2 = function curry(fn) {
    return $0c04c5fc909e9716$var$curryN(fn.length, fn);
};
var $0c04c5fc909e9716$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $0c04c5fc909e9716$export$871de8747c9eaa88 = $0c04c5fc909e9716$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $0c04c5fc909e9716$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $0c04c5fc909e9716$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $0c04c5fc909e9716$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $0c04c5fc909e9716$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $976a58df46781887$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $976a58df46781887$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $976a58df46781887$var$interpolateNumber = (0, $0c04c5fc909e9716$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $976a58df46781887$var$uninterpolateNumber = (0, $0c04c5fc909e9716$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $976a58df46781887$var$uninterpolateTruncation = (0, $0c04c5fc909e9716$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $976a58df46781887$export$2e2bcd8739ae039 = {
    rangeStep: $976a58df46781887$var$rangeStep,
    getDigitCount: $976a58df46781887$var$getDigitCount,
    interpolateNumber: $976a58df46781887$var$interpolateNumber,
    uninterpolateNumber: $976a58df46781887$var$uninterpolateNumber,
    uninterpolateTruncation: $976a58df46781887$var$uninterpolateTruncation
};


function $8709fe7ff9e21bf2$var$_toConsumableArray(arr) {
    return $8709fe7ff9e21bf2$var$_arrayWithoutHoles(arr) || $8709fe7ff9e21bf2$var$_iterableToArray(arr) || $8709fe7ff9e21bf2$var$_unsupportedIterableToArray(arr) || $8709fe7ff9e21bf2$var$_nonIterableSpread();
}
function $8709fe7ff9e21bf2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8709fe7ff9e21bf2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $8709fe7ff9e21bf2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8709fe7ff9e21bf2$var$_arrayLikeToArray(arr);
}
function $8709fe7ff9e21bf2$var$_slicedToArray(arr, i) {
    return $8709fe7ff9e21bf2$var$_arrayWithHoles(arr) || $8709fe7ff9e21bf2$var$_iterableToArrayLimit(arr, i) || $8709fe7ff9e21bf2$var$_unsupportedIterableToArray(arr, i) || $8709fe7ff9e21bf2$var$_nonIterableRest();
}
function $8709fe7ff9e21bf2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8709fe7ff9e21bf2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8709fe7ff9e21bf2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8709fe7ff9e21bf2$var$_arrayLikeToArray(o, minLen);
}
function $8709fe7ff9e21bf2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8709fe7ff9e21bf2$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8709fe7ff9e21bf2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $8709fe7ff9e21bf2$var$getValidInterval(_ref) {
    var _ref2 = $8709fe7ff9e21bf2$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $8709fe7ff9e21bf2$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0);
    var digitCount = (0, $976a58df46781887$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $8709fe7ff9e21bf2$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(10).pow((0, $976a58df46781887$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $0c04c5fc909e9716$export$f672e0b6f7222cd7)((0, $0c04c5fc909e9716$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $0c04c5fc909e9716$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $8709fe7ff9e21bf2$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $8709fe7ff9e21bf2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $8709fe7ff9e21bf2$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $8709fe7ff9e21bf2$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $8709fe7ff9e21bf2$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $8709fe7ff9e21bf2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $8709fe7ff9e21bf2$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($8709fe7ff9e21bf2$var$_toConsumableArray((0, $0c04c5fc909e9716$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($8709fe7ff9e21bf2$var$_toConsumableArray((0, $0c04c5fc909e9716$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $0c04c5fc909e9716$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $8709fe7ff9e21bf2$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $8709fe7ff9e21bf2$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $976a58df46781887$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $0c04c5fc909e9716$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $8709fe7ff9e21bf2$var$getTickValuesFn(_ref5) {
    var _ref6 = $8709fe7ff9e21bf2$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $8709fe7ff9e21bf2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $8709fe7ff9e21bf2$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $8709fe7ff9e21bf2$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $8709fe7ff9e21bf2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $0c04c5fc909e9716$export$f672e0b6f7222cd7)((0, $0c04c5fc909e9716$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(n).mul(step)).toNumber();
    }), (0, $0c04c5fc909e9716$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $0c04c5fc909e9716$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $8709fe7ff9e21bf2$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $8709fe7ff9e21bf2$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $8709fe7ff9e21bf2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $8709fe7ff9e21bf2$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $8709fe7ff9e21bf2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($8709fe7ff9e21bf2$var$_toConsumableArray((0, $976a58df46781887$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($068d20ea68d7a3b4$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $0c04c5fc909e9716$export$66c1ae025e96b4bc)(values) : values;
}
var $8709fe7ff9e21bf2$export$b84e75ccbfe6a612 = (0, $0c04c5fc909e9716$export$fc10aeed3a532e2a)($8709fe7ff9e21bf2$var$getNiceTickValuesFn);
var $8709fe7ff9e21bf2$export$4cc7a216492b1f53 = (0, $0c04c5fc909e9716$export$fc10aeed3a532e2a)($8709fe7ff9e21bf2$var$getTickValuesFn);
var $8709fe7ff9e21bf2$export$e9d28da780436e98 = (0, $0c04c5fc909e9716$export$fc10aeed3a532e2a)($8709fe7ff9e21bf2$var$getTickValuesFixedDomainFn);





var $b7Z9x = parcelRequire("b7Z9x");


var $234881ad2855ab77$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $234881ad2855ab77$var$_extends() {
    $234881ad2855ab77$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $234881ad2855ab77$var$_extends.apply(this, arguments);
}
function $234881ad2855ab77$var$_slicedToArray(arr, i) {
    return $234881ad2855ab77$var$_arrayWithHoles(arr) || $234881ad2855ab77$var$_iterableToArrayLimit(arr, i) || $234881ad2855ab77$var$_unsupportedIterableToArray(arr, i) || $234881ad2855ab77$var$_nonIterableRest();
}
function $234881ad2855ab77$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $234881ad2855ab77$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $234881ad2855ab77$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $234881ad2855ab77$var$_arrayLikeToArray(o, minLen);
}
function $234881ad2855ab77$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $234881ad2855ab77$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $234881ad2855ab77$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $234881ad2855ab77$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $234881ad2855ab77$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $234881ad2855ab77$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $234881ad2855ab77$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $234881ad2855ab77$var$_objectWithoutProperties(props, $234881ad2855ab77$var$_excluded);
    var svgProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $234881ad2855ab77$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $234881ad2855ab77$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", $234881ad2855ab77$var$_extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$234881ad2855ab77$export$4f4d7676bdf949e5.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
$234881ad2855ab77$export$4f4d7676bdf949e5.displayName = 'ErrorBar';





function $3bb158ee6cd3f1ec$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3bb158ee6cd3f1ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3bb158ee6cd3f1ec$var$_typeof(obj);
}
function $3bb158ee6cd3f1ec$var$_toConsumableArray(arr) {
    return $3bb158ee6cd3f1ec$var$_arrayWithoutHoles(arr) || $3bb158ee6cd3f1ec$var$_iterableToArray(arr) || $3bb158ee6cd3f1ec$var$_unsupportedIterableToArray(arr) || $3bb158ee6cd3f1ec$var$_nonIterableSpread();
}
function $3bb158ee6cd3f1ec$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3bb158ee6cd3f1ec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3bb158ee6cd3f1ec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3bb158ee6cd3f1ec$var$_arrayLikeToArray(o, minLen);
}
function $3bb158ee6cd3f1ec$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3bb158ee6cd3f1ec$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3bb158ee6cd3f1ec$var$_arrayLikeToArray(arr);
}
function $3bb158ee6cd3f1ec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3bb158ee6cd3f1ec$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3bb158ee6cd3f1ec$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3bb158ee6cd3f1ec$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3bb158ee6cd3f1ec$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3bb158ee6cd3f1ec$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3bb158ee6cd3f1ec$var$_defineProperty(obj, key, value) {
    key = $3bb158ee6cd3f1ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3bb158ee6cd3f1ec$var$_toPropertyKey(arg) {
    var key = $3bb158ee6cd3f1ec$var$_toPrimitive(arg, "string");
    return $3bb158ee6cd3f1ec$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3bb158ee6cd3f1ec$var$_toPrimitive(input, hint) {
    if ($3bb158ee6cd3f1ec$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3bb158ee6cd3f1ec$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3bb158ee6cd3f1ec$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(dataKey)) return defaultValue;
    if ((0, $201aa8e07b0747a2$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $3bb158ee6cd3f1ec$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($30960d86d5d3631c$exports)))(data, function(entry) {
        return $3bb158ee6cd3f1ec$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        var domain = flattenData.filter(function(entry) {
            return (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($96e03318e85fb2a8$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry);
    }) : flattenData;
    // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $201aa8e07b0747a2$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $3bb158ee6cd3f1ec$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $201aa8e07b0747a2$export$9d334328eb75e624)(cur - before) !== (0, $201aa8e07b0747a2$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $201aa8e07b0747a2$export$9d334328eb75e624)(after - cur) === (0, $201aa8e07b0747a2$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var min = Math.min(before, after);
                var max = Math.max(before, after);
                if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $3bb158ee6cd3f1ec$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $3bb158ee6cd3f1ec$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $4d6b5192df4a4236$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: $3bb158ee6cd3f1ec$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, legendItem.props), (0, $4d6b5192df4a4236$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $3bb158ee6cd3f1ec$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $423c5b3e35d96d0c$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $3bb158ee6cd3f1ec$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($3bb158ee6cd3f1ec$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($3bb158ee6cd3f1ec$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $3bb158ee6cd3f1ec$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $3bb158ee6cd3f1ec$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(offset[align])) newOffset = $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, offset), {}, $3bb158ee6cd3f1ec$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, offset), {}, $3bb158ee6cd3f1ec$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $3bb158ee6cd3f1ec$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $3bb158ee6cd3f1ec$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $234881ad2855ab77$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $3bb158ee6cd3f1ec$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $3bb158ee6cd3f1ec$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($96e03318e85fb2a8$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $3bb158ee6cd3f1ec$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $3bb158ee6cd3f1ec$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $3bb158ee6cd3f1ec$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $3bb158ee6cd3f1ec$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $3bb158ee6cd3f1ec$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $3bb158ee6cd3f1ec$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $3bb158ee6cd3f1ec$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $3bb158ee6cd3f1ec$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $3bb158ee6cd3f1ec$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $3bb158ee6cd3f1ec$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $201aa8e07b0747a2$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $3bb158ee6cd3f1ec$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $3bb158ee6cd3f1ec$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $2903d33098abf7e3$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $2903d33098abf7e3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $2903d33098abf7e3$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $2903d33098abf7e3$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $2903d33098abf7e3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4599bb014160114d$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($b8a24ec1bb4853d9$exports)))(scale));
        return {
            scale: ($2903d33098abf7e3$exports[name] || $2903d33098abf7e3$exports.scalePoint)(),
            realScaleType: $2903d33098abf7e3$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $2903d33098abf7e3$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $3bb158ee6cd3f1ec$var$EPS = 1e-4;
var $3bb158ee6cd3f1ec$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $3bb158ee6cd3f1ec$var$EPS;
    var max = Math.max(range[0], range[1]) + $3bb158ee6cd3f1ec$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $3bb158ee6cd3f1ec$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $3bb158ee6cd3f1ec$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(domain[0]) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $3bb158ee6cd3f1ec$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $3bb158ee6cd3f1ec$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $3bb158ee6cd3f1ec$var$STACK_OFFSET_MAP = {
    sign: $3bb158ee6cd3f1ec$export$3104c513558164c1,
    expand: (0, $6fa814273ae93f6c$exports.stackOffsetExpand),
    none: (0, $6fa814273ae93f6c$exports.stackOffsetNone),
    silhouette: (0, $6fa814273ae93f6c$exports.stackOffsetSilhouette),
    wiggle: (0, $6fa814273ae93f6c$exports.stackOffsetWiggle),
    positive: $3bb158ee6cd3f1ec$export$9f2c6ead70935022
};
var $3bb158ee6cd3f1ec$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $6fa814273ae93f6c$exports.stack)().keys(dataKeys).value(function(d, key) {
        return +$3bb158ee6cd3f1ec$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $6fa814273ae93f6c$exports.stackOrderNone)).offset($3bb158ee6cd3f1ec$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $3bb158ee6cd3f1ec$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $201aa8e07b0747a2$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, result), {}, $3bb158ee6cd3f1ec$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, res), {}, $3bb158ee6cd3f1ec$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $3bb158ee6cd3f1ec$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, result), {}, $3bb158ee6cd3f1ec$var$_defineProperty({}, axisId, group));
    }, {});
};
var $3bb158ee6cd3f1ec$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $8709fe7ff9e21bf2$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($96e03318e85fb2a8$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $8709fe7ff9e21bf2$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $3bb158ee6cd3f1ec$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $201aa8e07b0747a2$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $3bb158ee6cd3f1ec$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value) ? axis.scale(value) : null;
};
var $3bb158ee6cd3f1ec$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $3bb158ee6cd3f1ec$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $3bb158ee6cd3f1ec$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $3bb158ee6cd3f1ec$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $201aa8e07b0747a2$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $3bb158ee6cd3f1ec$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($96e03318e85fb2a8$exports)))(entry.concat([
                result[0]
            ]).filter((0, $201aa8e07b0747a2$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(entry.concat([
                result[1]
            ]).filter((0, $201aa8e07b0747a2$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $3bb158ee6cd3f1ec$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $3bb158ee6cd3f1ec$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $3bb158ee6cd3f1ec$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3bb158ee6cd3f1ec$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $3bb158ee6cd3f1ec$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($3bb158ee6cd3f1ec$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$3bb158ee6cd3f1ec$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($3bb158ee6cd3f1ec$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$3bb158ee6cd3f1ec$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $3bb158ee6cd3f1ec$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($e20cd8069ccd8bf4$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $3bb158ee6cd3f1ec$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $3bb158ee6cd3f1ec$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $3bb158ee6cd3f1ec$var$_objectSpread($3bb158ee6cd3f1ec$var$_objectSpread({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $3bb158ee6cd3f1ec$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $3bb158ee6cd3f1ec$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $43467ad7b884b88a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $43467ad7b884b88a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $43467ad7b884b88a$var$_typeof(obj);
}
function $43467ad7b884b88a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $43467ad7b884b88a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $43467ad7b884b88a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $43467ad7b884b88a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $43467ad7b884b88a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $43467ad7b884b88a$var$_defineProperty(obj, key, value) {
    key = $43467ad7b884b88a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $43467ad7b884b88a$var$_toPropertyKey(arg) {
    var key = $43467ad7b884b88a$var$_toPrimitive(arg, "string");
    return $43467ad7b884b88a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $43467ad7b884b88a$var$_toPrimitive(input, hint) {
    if ($43467ad7b884b88a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($43467ad7b884b88a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $43467ad7b884b88a$var$_slicedToArray(arr, i) {
    return $43467ad7b884b88a$var$_arrayWithHoles(arr) || $43467ad7b884b88a$var$_iterableToArrayLimit(arr, i) || $43467ad7b884b88a$var$_unsupportedIterableToArray(arr, i) || $43467ad7b884b88a$var$_nonIterableRest();
}
function $43467ad7b884b88a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $43467ad7b884b88a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $43467ad7b884b88a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $43467ad7b884b88a$var$_arrayLikeToArray(o, minLen);
}
function $43467ad7b884b88a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $43467ad7b884b88a$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $43467ad7b884b88a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $43467ad7b884b88a$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $43467ad7b884b88a$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $43467ad7b884b88a$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $43467ad7b884b88a$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$43467ad7b884b88a$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$43467ad7b884b88a$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $43467ad7b884b88a$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $43467ad7b884b88a$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $43467ad7b884b88a$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $43467ad7b884b88a$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $3bb158ee6cd3f1ec$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $3bb158ee6cd3f1ec$export$9d80152e23bae434)(scale);
        var ticks = (0, $3bb158ee6cd3f1ec$export$ac086aaa4358d590)(scale, $43467ad7b884b88a$var$_objectSpread($43467ad7b884b88a$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $43467ad7b884b88a$var$_objectSpread($43467ad7b884b88a$var$_objectSpread($43467ad7b884b88a$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $43467ad7b884b88a$var$_objectSpread($43467ad7b884b88a$var$_objectSpread({}, result), {}, $43467ad7b884b88a$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $43467ad7b884b88a$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $43467ad7b884b88a$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $43467ad7b884b88a$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $43467ad7b884b88a$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $43467ad7b884b88a$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $43467ad7b884b88a$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $43467ad7b884b88a$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $43467ad7b884b88a$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $43467ad7b884b88a$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $43467ad7b884b88a$var$_objectSpread($43467ad7b884b88a$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $43467ad7b884b88a$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $09aeb20c59d33797$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $09aeb20c59d33797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $09aeb20c59d33797$var$_typeof(obj);
}
function $09aeb20c59d33797$var$_toConsumableArray(arr) {
    return $09aeb20c59d33797$var$_arrayWithoutHoles(arr) || $09aeb20c59d33797$var$_iterableToArray(arr) || $09aeb20c59d33797$var$_unsupportedIterableToArray(arr) || $09aeb20c59d33797$var$_nonIterableSpread();
}
function $09aeb20c59d33797$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $09aeb20c59d33797$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $09aeb20c59d33797$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $09aeb20c59d33797$var$_arrayLikeToArray(o, minLen);
}
function $09aeb20c59d33797$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $09aeb20c59d33797$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $09aeb20c59d33797$var$_arrayLikeToArray(arr);
}
function $09aeb20c59d33797$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $09aeb20c59d33797$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $09aeb20c59d33797$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $09aeb20c59d33797$var$ownKeys(Object(source), !0).forEach(function(key) {
            $09aeb20c59d33797$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $09aeb20c59d33797$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $09aeb20c59d33797$var$_defineProperty(obj, key, value) {
    key = $09aeb20c59d33797$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $09aeb20c59d33797$var$_toPropertyKey(arg) {
    var key = $09aeb20c59d33797$var$_toPrimitive(arg, "string");
    return $09aeb20c59d33797$var$_typeof(key) === "symbol" ? key : String(key);
}
function $09aeb20c59d33797$var$_toPrimitive(input, hint) {
    if ($09aeb20c59d33797$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($09aeb20c59d33797$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $09aeb20c59d33797$var$_extends() {
    $09aeb20c59d33797$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09aeb20c59d33797$var$_extends.apply(this, arguments);
}
var $09aeb20c59d33797$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(formatter)) return formatter(label);
    return label;
};
var $09aeb20c59d33797$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $201aa8e07b0747a2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $09aeb20c59d33797$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $09aeb20c59d33797$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(labelProps.id) ? (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("text", $09aeb20c59d33797$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $09aeb20c59d33797$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $09aeb20c59d33797$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $09aeb20c59d33797$var$_objectSpread($09aeb20c59d33797$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $09aeb20c59d33797$var$_objectSpread($09aeb20c59d33797$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $09aeb20c59d33797$var$_objectSpread($09aeb20c59d33797$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $09aeb20c59d33797$var$_objectSpread($09aeb20c59d33797$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $09aeb20c59d33797$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $09aeb20c59d33797$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $09aeb20c59d33797$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $09aeb20c59d33797$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $09aeb20c59d33797$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $09aeb20c59d33797$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $09aeb20c59d33797$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $09aeb20c59d33797$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(position) && ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(position.x) || (0, $201aa8e07b0747a2$export$e50269385c77c348)(position.x)) && ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(position.y) || (0, $201aa8e07b0747a2$export$e50269385c77c348)(position.y))) return $09aeb20c59d33797$var$_objectSpread({
        x: x + (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $09aeb20c59d33797$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $09aeb20c59d33797$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(viewBox.cx);
};
function $09aeb20c59d33797$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(children) && !/*#__PURE__*/ (0, $b7Z9x.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(content)) return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(content)) {
        label = /*#__PURE__*/ (0, $b7Z9x.createElement)(content, props);
        if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(label)) return label;
    } else label = $09aeb20c59d33797$var$getLabel(props);
    var isPolarLabel = $09aeb20c59d33797$var$isPolar(viewBox);
    var attrs = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $09aeb20c59d33797$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $09aeb20c59d33797$var$getAttrsOfPolarLabel(props) : $09aeb20c59d33797$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $b68d75c627cc2644$export$5f1af8db9871e1d6), $09aeb20c59d33797$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$09aeb20c59d33797$export$b04be29aa201d4f5.displayName = 'Label';
$09aeb20c59d33797$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $09aeb20c59d33797$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(height)) {
        if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(x) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(top) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(x) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(cx) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $09aeb20c59d33797$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($09aeb20c59d33797$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $201aa8e07b0747a2$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($09aeb20c59d33797$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(label)) {
        if (label.type === $09aeb20c59d33797$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($09aeb20c59d33797$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($09aeb20c59d33797$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($09aeb20c59d33797$export$b04be29aa201d4f5, $09aeb20c59d33797$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $09aeb20c59d33797$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $09aeb20c59d33797$var$parseViewBox(parentProps);
    var explicitChildren = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, $09aeb20c59d33797$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $09aeb20c59d33797$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($09aeb20c59d33797$var$_toConsumableArray(explicitChildren));
};
$09aeb20c59d33797$export$b04be29aa201d4f5.parseViewBox = $09aeb20c59d33797$var$parseViewBox;
$09aeb20c59d33797$export$b04be29aa201d4f5.renderCallByParent = $09aeb20c59d33797$var$renderCallByParent;





function $761130a126329e24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $761130a126329e24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $761130a126329e24$var$_typeof(obj);
}
var $761130a126329e24$var$_excluded = [
    "data",
    "valueAccessor",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $761130a126329e24$var$_toConsumableArray(arr) {
    return $761130a126329e24$var$_arrayWithoutHoles(arr) || $761130a126329e24$var$_iterableToArray(arr) || $761130a126329e24$var$_unsupportedIterableToArray(arr) || $761130a126329e24$var$_nonIterableSpread();
}
function $761130a126329e24$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $761130a126329e24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $761130a126329e24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $761130a126329e24$var$_arrayLikeToArray(o, minLen);
}
function $761130a126329e24$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $761130a126329e24$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $761130a126329e24$var$_arrayLikeToArray(arr);
}
function $761130a126329e24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $761130a126329e24$var$_extends() {
    $761130a126329e24$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $761130a126329e24$var$_extends.apply(this, arguments);
}
function $761130a126329e24$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $761130a126329e24$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $761130a126329e24$var$ownKeys(Object(source), !0).forEach(function(key) {
            $761130a126329e24$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $761130a126329e24$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $761130a126329e24$var$_defineProperty(obj, key, value) {
    key = $761130a126329e24$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $761130a126329e24$var$_toPropertyKey(arg) {
    var key = $761130a126329e24$var$_toPrimitive(arg, "string");
    return $761130a126329e24$var$_typeof(key) === "symbol" ? key : String(key);
}
function $761130a126329e24$var$_toPrimitive(input, hint) {
    if ($761130a126329e24$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($761130a126329e24$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $761130a126329e24$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $761130a126329e24$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $761130a126329e24$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $761130a126329e24$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($14e1f3ed3f28d525$exports)))(entry.value) : entry.value;
    }
};
function $761130a126329e24$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $761130a126329e24$var$_objectWithoutProperties(props, $761130a126329e24$var$_excluded);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $09aeb20c59d33797$export$b04be29aa201d4f5), $761130a126329e24$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $09aeb20c59d33797$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(clockWise) ? entry : $761130a126329e24$var$_objectSpread($761130a126329e24$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$761130a126329e24$export$835fcf23ab7bf88.displayName = 'LabelList';
function $761130a126329e24$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($761130a126329e24$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($761130a126329e24$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3cf8bb2e7defbbff$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($761130a126329e24$export$835fcf23ab7bf88, $761130a126329e24$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $761130a126329e24$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, $761130a126329e24$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $761130a126329e24$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($761130a126329e24$var$_toConsumableArray(explicitChildren));
}
$761130a126329e24$export$835fcf23ab7bf88.renderCallByParent = $761130a126329e24$var$renderCallByParent;
$761130a126329e24$export$835fcf23ab7bf88.defaultProps = $761130a126329e24$var$defaultProps;







var $079ac3c80abbf2ba$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $079ac3c80abbf2ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $079ac3c80abbf2ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $079ac3c80abbf2ba$var$_typeof(obj);
}
function $079ac3c80abbf2ba$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $079ac3c80abbf2ba$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $079ac3c80abbf2ba$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $079ac3c80abbf2ba$var$_extends() {
    $079ac3c80abbf2ba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $079ac3c80abbf2ba$var$_extends.apply(this, arguments);
}
function $079ac3c80abbf2ba$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $079ac3c80abbf2ba$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $079ac3c80abbf2ba$var$ownKeys(Object(source), !0).forEach(function(key) {
            $079ac3c80abbf2ba$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $079ac3c80abbf2ba$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $079ac3c80abbf2ba$var$_toConsumableArray(arr) {
    return $079ac3c80abbf2ba$var$_arrayWithoutHoles(arr) || $079ac3c80abbf2ba$var$_iterableToArray(arr) || $079ac3c80abbf2ba$var$_unsupportedIterableToArray(arr) || $079ac3c80abbf2ba$var$_nonIterableSpread();
}
function $079ac3c80abbf2ba$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $079ac3c80abbf2ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $079ac3c80abbf2ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $079ac3c80abbf2ba$var$_arrayLikeToArray(o, minLen);
}
function $079ac3c80abbf2ba$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $079ac3c80abbf2ba$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $079ac3c80abbf2ba$var$_arrayLikeToArray(arr);
}
function $079ac3c80abbf2ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $079ac3c80abbf2ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $079ac3c80abbf2ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $079ac3c80abbf2ba$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $079ac3c80abbf2ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $079ac3c80abbf2ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $079ac3c80abbf2ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $079ac3c80abbf2ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $079ac3c80abbf2ba$var$_setPrototypeOf(subClass, superClass);
}
function $079ac3c80abbf2ba$var$_setPrototypeOf(o, p) {
    $079ac3c80abbf2ba$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $079ac3c80abbf2ba$var$_setPrototypeOf(o, p);
}
function $079ac3c80abbf2ba$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $079ac3c80abbf2ba$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $079ac3c80abbf2ba$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $079ac3c80abbf2ba$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $079ac3c80abbf2ba$var$_possibleConstructorReturn(this, result);
    };
}
function $079ac3c80abbf2ba$var$_possibleConstructorReturn(self, call) {
    if (call && ($079ac3c80abbf2ba$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $079ac3c80abbf2ba$var$_assertThisInitialized(self);
}
function $079ac3c80abbf2ba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $079ac3c80abbf2ba$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $079ac3c80abbf2ba$var$_getPrototypeOf(o) {
    $079ac3c80abbf2ba$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $079ac3c80abbf2ba$var$_getPrototypeOf(o);
}
function $079ac3c80abbf2ba$var$_defineProperty(obj, key, value) {
    key = $079ac3c80abbf2ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $079ac3c80abbf2ba$var$_toPropertyKey(arg) {
    var key = $079ac3c80abbf2ba$var$_toPrimitive(arg, "string");
    return $079ac3c80abbf2ba$var$_typeof(key) === "symbol" ? key : String(key);
}
function $079ac3c80abbf2ba$var$_toPrimitive(input, hint) {
    if ($079ac3c80abbf2ba$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($079ac3c80abbf2ba$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $079ac3c80abbf2ba$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $079ac3c80abbf2ba$var$_inherits(Line, _PureComponent);
    var _super = $079ac3c80abbf2ba$var$_createSuper(Line);
    function Line() {
        var _this;
        $079ac3c80abbf2ba$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0;; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($079ac3c80abbf2ba$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($079ac3c80abbf2ba$var$_toConsumableArray(Line.repeat(lines, count)), $079ac3c80abbf2ba$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "id", (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts-line-'));
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $079ac3c80abbf2ba$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $234881ad2855ab77$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(item, {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "bar-".concat(i),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $079ac3c80abbf2ba$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $079ac3c80abbf2ba$var$_objectWithoutProperties(_this$props3, $079ac3c80abbf2ba$var$_excluded);
                var curveProps = $079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1), $079ac3c80abbf2ba$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $079ac3c80abbf2ba$var$_objectSpread($079ac3c80abbf2ba$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $423c5b3e35d96d0c$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $761130a126329e24$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($079ac3c80abbf2ba$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($079ac3c80abbf2ba$var$_toConsumableArray(result), $079ac3c80abbf2ba$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-line-dot', option ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $91e8d465d4ebe72b$export$d046b3c4a416f60d), $079ac3c80abbf2ba$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $b7Z9x.PureComponent));
$079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$export$17d680238e50603e, "displayName", 'Line');
$079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $079ac3c80abbf2ba$var$_defineProperty($079ac3c80abbf2ba$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $079ac3c80abbf2ba$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ var $fcd7e08b06d8d7c6$exports = {};
var $966de9e21257bb79$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $966de9e21257bb79$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$966de9e21257bb79$exports = $966de9e21257bb79$var$arrayEvery;


var $d92151fb55cc37a2$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $d92151fb55cc37a2$var$baseEvery(collection, predicate) {
    var result = true;
    $72d146bf2da273f9$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$d92151fb55cc37a2$exports = $d92151fb55cc37a2$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $fcd7e08b06d8d7c6$var$every(collection, predicate, guard) {
    var func = $e9f4eab8a3ba19aa$exports(collection) ? $966de9e21257bb79$exports : $d92151fb55cc37a2$exports;
    if (guard && $89342db7e4beb4e5$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $a3e1cb58c2a61f92$exports(predicate, 3));
}
$fcd7e08b06d8d7c6$exports = $fcd7e08b06d8d7c6$var$every;


var $807f13c6658a121e$exports = {};
var $daa44be57df56f6c$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $daa44be57df56f6c$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$b1b629d226020fad$exports(collection)) {
            var iteratee = $a3e1cb58c2a61f92$exports(predicate, 3);
            collection = $3cea58c3c3d6f086$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$daa44be57df56f6c$exports = $daa44be57df56f6c$var$createFind;


var $902210f189c3d640$exports = {};


var $5e6c653d2b57ec1b$exports = {};
var $eb7fc883acaaf89c$exports = {};
var $9eeacf7bd5854d0a$exports = {};
var $f1fd0294c3f2d96b$exports = {};
var $eeb872a4176aa2c0$exports = {};
/** Used to match a single whitespace character. */ var $eeb872a4176aa2c0$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $eeb872a4176aa2c0$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $eeb872a4176aa2c0$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$eeb872a4176aa2c0$exports = $eeb872a4176aa2c0$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $f1fd0294c3f2d96b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $f1fd0294c3f2d96b$var$baseTrim(string) {
    return string ? string.slice(0, $eeb872a4176aa2c0$exports(string) + 1).replace($f1fd0294c3f2d96b$var$reTrimStart, '') : string;
}
$f1fd0294c3f2d96b$exports = $f1fd0294c3f2d96b$var$baseTrim;




/** Used as references for various `Number` constants. */ var $9eeacf7bd5854d0a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $9eeacf7bd5854d0a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $9eeacf7bd5854d0a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $9eeacf7bd5854d0a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $9eeacf7bd5854d0a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $9eeacf7bd5854d0a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($df0bd783b3fde9a7$exports(value)) return $9eeacf7bd5854d0a$var$NAN;
    if ($3cf8bb2e7defbbff$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $3cf8bb2e7defbbff$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $f1fd0294c3f2d96b$exports(value);
    var isBinary = $9eeacf7bd5854d0a$var$reIsBinary.test(value);
    return isBinary || $9eeacf7bd5854d0a$var$reIsOctal.test(value) ? $9eeacf7bd5854d0a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $9eeacf7bd5854d0a$var$reIsBadHex.test(value) ? $9eeacf7bd5854d0a$var$NAN : +value;
}
$9eeacf7bd5854d0a$exports = $9eeacf7bd5854d0a$var$toNumber;


/** Used as references for various `Number` constants. */ var $eb7fc883acaaf89c$var$INFINITY = 1 / 0, $eb7fc883acaaf89c$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $eb7fc883acaaf89c$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $9eeacf7bd5854d0a$exports(value);
    if (value === $eb7fc883acaaf89c$var$INFINITY || value === -$eb7fc883acaaf89c$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $eb7fc883acaaf89c$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$eb7fc883acaaf89c$exports = $eb7fc883acaaf89c$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $5e6c653d2b57ec1b$var$toInteger(value) {
    var result = $eb7fc883acaaf89c$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$5e6c653d2b57ec1b$exports = $5e6c653d2b57ec1b$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $902210f189c3d640$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $902210f189c3d640$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $5e6c653d2b57ec1b$exports(fromIndex);
    if (index < 0) index = $902210f189c3d640$var$nativeMax(length + index, 0);
    return $a3c2baca40020ed4$exports(array, $a3e1cb58c2a61f92$exports(predicate, 3), index);
}
$902210f189c3d640$exports = $902210f189c3d640$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $807f13c6658a121e$var$find = $daa44be57df56f6c$exports($902210f189c3d640$exports);
$807f13c6658a121e$exports = $807f13c6658a121e$var$find;



var $91f710ccfab96e63$exports = {};
var $bb97fb2cb8055912$exports = {};

var $28444bade0018253$exports = {};

var $83nx1 = parcelRequire("83nx1");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $28444bade0018253$var$now = function() {
    return $83nx1.Date.now();
};
$28444bade0018253$exports = $28444bade0018253$var$now;



/** Error message constants. */ var $bb97fb2cb8055912$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb97fb2cb8055912$var$nativeMax = Math.max, $bb97fb2cb8055912$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $bb97fb2cb8055912$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($bb97fb2cb8055912$var$FUNC_ERROR_TEXT);
    wait = $9eeacf7bd5854d0a$exports(wait) || 0;
    if ($3cf8bb2e7defbbff$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $bb97fb2cb8055912$var$nativeMax($9eeacf7bd5854d0a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $bb97fb2cb8055912$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $28444bade0018253$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($28444bade0018253$exports());
    }
    function debounced() {
        var time = $28444bade0018253$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$bb97fb2cb8055912$exports = $bb97fb2cb8055912$var$debounce;



/** Error message constants. */ var $91f710ccfab96e63$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $91f710ccfab96e63$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($91f710ccfab96e63$var$FUNC_ERROR_TEXT);
    if ($3cf8bb2e7defbbff$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $bb97fb2cb8055912$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$91f710ccfab96e63$exports = $91f710ccfab96e63$var$throttle;




var $9243674fe89e2a08$exports = {};
var $7c576dc30a2a05b7$exports = {};
var $3f391047c29f8823$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3f391047c29f8823$var$nativeCeil = Math.ceil, $3f391047c29f8823$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $3f391047c29f8823$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $3f391047c29f8823$var$nativeMax($3f391047c29f8823$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$3f391047c29f8823$exports = $3f391047c29f8823$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $7c576dc30a2a05b7$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $89342db7e4beb4e5$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $eb7fc883acaaf89c$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $eb7fc883acaaf89c$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $eb7fc883acaaf89c$exports(step);
        return $3f391047c29f8823$exports(start, end, step, fromRight);
    };
}
$7c576dc30a2a05b7$exports = $7c576dc30a2a05b7$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $9243674fe89e2a08$var$range = $7c576dc30a2a05b7$exports();
$9243674fe89e2a08$exports = $9243674fe89e2a08$var$range;



var $20ade4e8ba3f58a7$exports = {};


/** `Object#toString` result references. */ var $20ade4e8ba3f58a7$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $20ade4e8ba3f58a7$var$isBoolean(value) {
    return value === true || value === false || $30ec207d7cd7a4f3$exports(value) && $bf759a7d004b6e9c$exports(value) == $20ade4e8ba3f58a7$var$boolTag;
}
$20ade4e8ba3f58a7$exports = $20ade4e8ba3f58a7$var$isBoolean;




var $b7Z9x = parcelRequire("b7Z9x");





/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $49954040ab87d788$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}



var $114be58e6a32d8bf$exports = {};
var $23b5c720065a440a$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $23b5c720065a440a$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $c8438589f608e50e$exports) $c8438589f608e50e$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$23b5c720065a440a$exports = $23b5c720065a440a$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $114be58e6a32d8bf$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $a3e1cb58c2a61f92$exports(iteratee, 3);
    $7739bf3b206d90b7$exports(object, function(value, key, object) {
        $23b5c720065a440a$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$114be58e6a32d8bf$exports = $114be58e6a32d8bf$var$mapValues;










var $b7Z9x = parcelRequire("b7Z9x");



var $b7Z9x = parcelRequire("b7Z9x");



function $a3a55738a2f00209$var$_extends() {
    $a3a55738a2f00209$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3a55738a2f00209$var$_extends.apply(this, arguments);
}
function $a3a55738a2f00209$var$_slicedToArray(arr, i) {
    return $a3a55738a2f00209$var$_arrayWithHoles(arr) || $a3a55738a2f00209$var$_iterableToArrayLimit(arr, i) || $a3a55738a2f00209$var$_unsupportedIterableToArray(arr, i) || $a3a55738a2f00209$var$_nonIterableRest();
}
function $a3a55738a2f00209$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3a55738a2f00209$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a3a55738a2f00209$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3a55738a2f00209$var$_arrayLikeToArray(o, minLen);
}
function $a3a55738a2f00209$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3a55738a2f00209$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $a3a55738a2f00209$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a3a55738a2f00209$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $a3a55738a2f00209$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $a3a55738a2f00209$export$4617fb02663045ef = function Rectangle(props) {
    var pathRef = (0, $b7Z9x.useRef)();
    var _useState = (0, $b7Z9x.useState)(-1), _useState2 = $a3a55738a2f00209$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $b7Z9x.useLayoutEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $a3a55738a2f00209$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $a3a55738a2f00209$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $a3a55738a2f00209$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $a3a55738a2f00209$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};
$a3a55738a2f00209$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};




/**
 * @fileOverview Cross
 */ var $f8f3ac98b98deceb$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$f8f3ac98b98deceb$export$f6f0c3fe4ec306ea.displayName = 'Cell';








var $a9b5532e74641027$var$_excluded = [
    "value",
    "background"
];
function $a9b5532e74641027$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a9b5532e74641027$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a9b5532e74641027$var$_typeof(obj);
}
function $a9b5532e74641027$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9b5532e74641027$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a9b5532e74641027$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a9b5532e74641027$var$_extends() {
    $a9b5532e74641027$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9b5532e74641027$var$_extends.apply(this, arguments);
}
function $a9b5532e74641027$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a9b5532e74641027$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a9b5532e74641027$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a9b5532e74641027$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a9b5532e74641027$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a9b5532e74641027$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9b5532e74641027$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a9b5532e74641027$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a9b5532e74641027$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a9b5532e74641027$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a9b5532e74641027$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a9b5532e74641027$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a9b5532e74641027$var$_setPrototypeOf(subClass, superClass);
}
function $a9b5532e74641027$var$_setPrototypeOf(o, p) {
    $a9b5532e74641027$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a9b5532e74641027$var$_setPrototypeOf(o, p);
}
function $a9b5532e74641027$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a9b5532e74641027$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a9b5532e74641027$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a9b5532e74641027$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a9b5532e74641027$var$_possibleConstructorReturn(this, result);
    };
}
function $a9b5532e74641027$var$_possibleConstructorReturn(self, call) {
    if (call && ($a9b5532e74641027$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a9b5532e74641027$var$_assertThisInitialized(self);
}
function $a9b5532e74641027$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a9b5532e74641027$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a9b5532e74641027$var$_getPrototypeOf(o) {
    $a9b5532e74641027$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a9b5532e74641027$var$_getPrototypeOf(o);
}
function $a9b5532e74641027$var$_defineProperty(obj, key, value) {
    key = $a9b5532e74641027$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9b5532e74641027$var$_toPropertyKey(arg) {
    var key = $a9b5532e74641027$var$_toPrimitive(arg, "string");
    return $a9b5532e74641027$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a9b5532e74641027$var$_toPrimitive(input, hint) {
    if ($a9b5532e74641027$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a9b5532e74641027$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a9b5532e74641027$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $a9b5532e74641027$var$_inherits(Bar, _PureComponent);
    var _super = $a9b5532e74641027$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $a9b5532e74641027$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a9b5532e74641027$var$_defineProperty($a9b5532e74641027$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $a9b5532e74641027$var$_defineProperty($a9b5532e74641027$var$_assertThisInitialized(_this), "id", (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts-bar-'));
        $a9b5532e74641027$var$_defineProperty($a9b5532e74641027$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $a9b5532e74641027$var$_defineProperty($a9b5532e74641027$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $a9b5532e74641027$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var shape = this.props.shape;
                var baseProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var props = $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, baseProps), entry), {}, {
                        index: i
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $a9b5532e74641027$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $f321872aac18bbfb$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), Bar.renderRectangle(shape, props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props = this.props, data = _this$props.data, layout = _this$props.layout, isAnimationActive = _this$props.isAnimationActive, animationBegin = _this$props.animationBegin, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, animationId = _this$props.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props2 = this.props, data = _this$props2.data, isAnimationActive = _this$props2.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var data = this.props.data;
                var backgroundProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $a9b5532e74641027$var$_objectWithoutProperties(entry, $a9b5532e74641027$var$_excluded);
                    if (!background) return null;
                    var props = $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $f321872aac18bbfb$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return Bar.renderRectangle(_this4.props.background, props);
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props3 = this.props, data = _this$props3.data, xAxis = _this$props3.xAxis, yAxis = _this$props3.yAxis, layout = _this$props3.layout, children = _this$props3.children;
                var errorBarItems = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $234881ad2855ab77$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, hide = _this$props4.hide, data = _this$props4.data, className = _this$props4.className, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, left = _this$props4.left, top = _this$props4.top, width = _this$props4.width, height = _this$props4.height, isAnimationActive = _this$props4.isAnimationActive, background = _this$props4.background, id = _this$props4.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $761130a126329e24$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        },
        {
            key: "renderRectangle",
            value: function renderRectangle(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) rectangle = option(props);
                else rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $a3a55738a2f00209$export$4617fb02663045ef), props);
                return rectangle;
            }
        }
    ]);
    return Bar;
}((0, $b7Z9x.PureComponent));
$a9b5532e74641027$var$_defineProperty($a9b5532e74641027$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$a9b5532e74641027$var$_defineProperty($a9b5532e74641027$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    // data of bar
    data: [],
    layout: 'vertical',
    isAnimationActive: !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $a9b5532e74641027$var$_defineProperty($a9b5532e74641027$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $3bb158ee6cd3f1ec$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $3bb158ee6cd3f1ec$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $f8f3ac98b98deceb$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $3bb158ee6cd3f1ec$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, dataKey);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $3bb158ee6cd3f1ec$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $201aa8e07b0747a2$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $3bb158ee6cd3f1ec$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $201aa8e07b0747a2$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread($a9b5532e74641027$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $3bb158ee6cd3f1ec$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $a9b5532e74641027$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $d709a5412861b060$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d709a5412861b060$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d709a5412861b060$var$_typeof(obj);
}
function $d709a5412861b060$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d709a5412861b060$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d709a5412861b060$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d709a5412861b060$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d709a5412861b060$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d709a5412861b060$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d709a5412861b060$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d709a5412861b060$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d709a5412861b060$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d709a5412861b060$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d709a5412861b060$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d709a5412861b060$var$_defineProperty(obj, key, value) {
    key = $d709a5412861b060$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d709a5412861b060$var$_toPropertyKey(arg) {
    var key = $d709a5412861b060$var$_toPrimitive(arg, "string");
    return $d709a5412861b060$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d709a5412861b060$var$_toPrimitive(input, hint) {
    if ($d709a5412861b060$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d709a5412861b060$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d709a5412861b060$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $a9b5532e74641027$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
            if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === 'no-gap') {
                var gap = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $3bb158ee6cd3f1ec$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $3bb158ee6cd3f1ec$export$9d80152e23bae434)(scale);
        var ticks = (0, $3bb158ee6cd3f1ec$export$ac086aaa4358d590)(scale, $d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $3bb158ee6cd3f1ec$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread({}, result), {}, $d709a5412861b060$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $d709a5412861b060$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $d709a5412861b060$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $d709a5412861b060$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $d709a5412861b060$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $d709a5412861b060$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $d709a5412861b060$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$d709a5412861b060$var$_defineProperty($d709a5412861b060$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $d709a5412861b060$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread({}, res), {}, $d709a5412861b060$var$_defineProperty({}, key, $d709a5412861b060$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $d709a5412861b060$var$_objectSpread($d709a5412861b060$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($114be58e6a32d8bf$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fcd7e08b06d8d7c6$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $d709a5412861b060$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $d709a5412861b060$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $d709a5412861b060$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


function $38ad82b150a25707$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $38ad82b150a25707$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $38ad82b150a25707$var$_typeof(obj);
}
function $38ad82b150a25707$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $38ad82b150a25707$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $38ad82b150a25707$var$ownKeys(Object(source), !0).forEach(function(key) {
            $38ad82b150a25707$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $38ad82b150a25707$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $38ad82b150a25707$var$_defineProperty(obj, key, value) {
    key = $38ad82b150a25707$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $38ad82b150a25707$var$_toPropertyKey(arg) {
    var key = $38ad82b150a25707$var$_toPrimitive(arg, "string");
    return $38ad82b150a25707$var$_typeof(key) === "symbol" ? key : String(key);
}
function $38ad82b150a25707$var$_toPrimitive(input, hint) {
    if ($38ad82b150a25707$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($38ad82b150a25707$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $38ad82b150a25707$export$8d7cd2cadfe08ccd(ticks) {
    var N = 1;
    var previous = (0, $49954040ab87d788$export$41514b9f058a6886)(ticks, N, function(tickItem) {
        return tickItem.isShow;
    });
    while(N <= ticks.length){
        if (previous !== undefined) return previous;
        N++;
        previous = (0, $49954040ab87d788$export$41514b9f058a6886)(ticks, N, function(tickItem) {
            return tickItem.isShow;
        });
    }
    return ticks.slice(0, 1);
}
function $38ad82b150a25707$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $49954040ab87d788$export$41514b9f058a6886)(ticks, interval + 1);
}
function $38ad82b150a25707$var$getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $d709a5412861b060$export$3ee78d51cffc2b68)(size, angle);
}
function $38ad82b150a25707$var$getTicksEnd(_ref) {
    var angle = _ref.angle, ticks = _ref.ticks, tickFormatter = _ref.tickFormatter, viewBox = _ref.viewBox, orientation = _ref.orientation, minTickGap = _ref.minTickGap, unit = _ref.unit, fontSize = _ref.fontSize, letterSpacing = _ref.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === 'width' ? (0, $5693eee73e492f24$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? (0, $201aa8e07b0747a2$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
    } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
    }
    for(var i = len - 1; i >= 0; i--){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
        // Recharts only supports angles when sizeKey === 'width'
        var size = sizeKey === 'width' ? $38ad82b150a25707$var$getAngledTickWidth((0, $5693eee73e492f24$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5693eee73e492f24$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * size / 2 - end);
            result[i] = entry = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            end = entry.tickCoord - sign * (size / 2 + minTickGap);
            result[i] = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $38ad82b150a25707$var$getTicksStart(_ref2, preserveEnd) {
    var angle = _ref2.angle, ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit, fontSize = _ref2.fontSize, letterSpacing = _ref2.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var result = (ticks || []).slice();
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === 'width' ? (0, $5693eee73e492f24$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var len = result.length;
    var sign = len >= 2 ? (0, $201aa8e07b0747a2$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
    } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
    }
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
        // Recharts only supports angles when sizeKey === 'width'
        var tailSize = sizeKey === 'width' ? $38ad82b150a25707$var$getAngledTickWidth((0, $5693eee73e492f24$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5693eee73e492f24$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    for(var i = 0; i < count; i++){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
        var size = sizeKey === 'width' ? $38ad82b150a25707$var$getAngledTickWidth((0, $5693eee73e492f24$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5693eee73e492f24$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * size / 2 - start);
            result[i] = entry = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            start = entry.tickCoord + sign * (size / 2 + minTickGap);
            result[i] = $38ad82b150a25707$var$_objectSpread($38ad82b150a25707$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $38ad82b150a25707$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(interval) || (0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr) return $38ad82b150a25707$export$beeebbe3ff1b306b(ticks, typeof interval === 'number' && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    if (interval === 'equidistantPreserveStart') {
        candidates = $38ad82b150a25707$var$getTicksStart({
            angle: angle,
            ticks: ticks,
            tickFormatter: tickFormatter,
            viewBox: viewBox,
            orientation: orientation,
            minTickGap: minTickGap,
            unit: unit,
            fontSize: fontSize,
            letterSpacing: letterSpacing
        });
        return $38ad82b150a25707$export$8d7cd2cadfe08ccd(candidates);
    }
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $38ad82b150a25707$var$getTicksStart({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }, interval === 'preserveStartEnd');
    else candidates = $38ad82b150a25707$var$getTicksEnd({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    });
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}








var $b7Z9x = parcelRequire("b7Z9x");






var $b7Z9x = parcelRequire("b7Z9x");


/**
 * @fileOverview Default Tooltip Content
 */ function $8aee9e18f9655cd0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8aee9e18f9655cd0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8aee9e18f9655cd0$var$_typeof(obj);
}
function $8aee9e18f9655cd0$var$_slicedToArray(arr, i) {
    return $8aee9e18f9655cd0$var$_arrayWithHoles(arr) || $8aee9e18f9655cd0$var$_iterableToArrayLimit(arr, i) || $8aee9e18f9655cd0$var$_unsupportedIterableToArray(arr, i) || $8aee9e18f9655cd0$var$_nonIterableRest();
}
function $8aee9e18f9655cd0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8aee9e18f9655cd0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8aee9e18f9655cd0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8aee9e18f9655cd0$var$_arrayLikeToArray(o, minLen);
}
function $8aee9e18f9655cd0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8aee9e18f9655cd0$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8aee9e18f9655cd0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8aee9e18f9655cd0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8aee9e18f9655cd0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8aee9e18f9655cd0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8aee9e18f9655cd0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8aee9e18f9655cd0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8aee9e18f9655cd0$var$_defineProperty(obj, key, value) {
    key = $8aee9e18f9655cd0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8aee9e18f9655cd0$var$_toPropertyKey(arg) {
    var key = $8aee9e18f9655cd0$var$_toPrimitive(arg, "string");
    return $8aee9e18f9655cd0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8aee9e18f9655cd0$var$_toPrimitive(input, hint) {
    if ($8aee9e18f9655cd0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8aee9e18f9655cd0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8aee9e18f9655cd0$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(value) && (0, $201aa8e07b0747a2$export$402a499e1ea44294)(value[0]) && (0, $201aa8e07b0747a2$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $8aee9e18f9655cd0$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($e20cd8069ccd8bf4$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $8aee9e18f9655cd0$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $8aee9e18f9655cd0$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $8aee9e18f9655cd0$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $201aa8e07b0747a2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $201aa8e07b0747a2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $8aee9e18f9655cd0$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $8aee9e18f9655cd0$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};




function $eb1d3fe36ab16514$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $eb1d3fe36ab16514$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $eb1d3fe36ab16514$var$_typeof(obj);
}
function $eb1d3fe36ab16514$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb1d3fe36ab16514$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb1d3fe36ab16514$var$ownKeys(Object(source), !0).forEach(function(key) {
            $eb1d3fe36ab16514$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb1d3fe36ab16514$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eb1d3fe36ab16514$var$_defineProperty(obj, key, value) {
    key = $eb1d3fe36ab16514$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb1d3fe36ab16514$var$_toPropertyKey(arg) {
    var key = $eb1d3fe36ab16514$var$_toPrimitive(arg, "string");
    return $eb1d3fe36ab16514$var$_typeof(key) === "symbol" ? key : String(key);
}
function $eb1d3fe36ab16514$var$_toPrimitive(input, hint) {
    if ($eb1d3fe36ab16514$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($eb1d3fe36ab16514$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $eb1d3fe36ab16514$var$_slicedToArray(arr, i) {
    return $eb1d3fe36ab16514$var$_arrayWithHoles(arr) || $eb1d3fe36ab16514$var$_iterableToArrayLimit(arr, i) || $eb1d3fe36ab16514$var$_unsupportedIterableToArray(arr, i) || $eb1d3fe36ab16514$var$_nonIterableRest();
}
function $eb1d3fe36ab16514$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb1d3fe36ab16514$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eb1d3fe36ab16514$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eb1d3fe36ab16514$var$_arrayLikeToArray(o, minLen);
}
function $eb1d3fe36ab16514$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eb1d3fe36ab16514$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $eb1d3fe36ab16514$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $eb1d3fe36ab16514$var$CLS_PREFIX = 'recharts-tooltip-wrapper';
var $eb1d3fe36ab16514$var$EPS = 1;
function $eb1d3fe36ab16514$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $eb1d3fe36ab16514$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($fead821d6e5c4378$exports)))(payload, $eb1d3fe36ab16514$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($fead821d6e5c4378$exports)))(payload, option);
    return payload;
}
function $eb1d3fe36ab16514$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8aee9e18f9655cd0$export$6fe33945eebf9ac8), props);
}
var $eb1d3fe36ab16514$var$tooltipDefaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    reverseDirection: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    // this doesn't exist on TooltipProps
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cursorStyle: {},
    separator: ' : ',
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: 'hover',
    isAnimationActive: !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr,
    animationEasing: 'ease',
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};
var $eb1d3fe36ab16514$export$28c660c63b792dea = function Tooltip(props) {
    var _classNames;
    var _useState = (0, $b7Z9x.useState)(-1), _useState2 = $eb1d3fe36ab16514$var$_slicedToArray(_useState, 2), boxWidth = _useState2[0], setBoxWidth = _useState2[1];
    var _useState3 = (0, $b7Z9x.useState)(-1), _useState4 = $eb1d3fe36ab16514$var$_slicedToArray(_useState3, 2), boxHeight = _useState4[0], setBoxHeight = _useState4[1];
    var _useState5 = (0, $b7Z9x.useState)(false), _useState6 = $eb1d3fe36ab16514$var$_slicedToArray(_useState5, 2), dismissed = _useState6[0], setDismissed = _useState6[1];
    var _useState7 = (0, $b7Z9x.useState)({
        x: 0,
        y: 0
    }), _useState8 = $eb1d3fe36ab16514$var$_slicedToArray(_useState7, 2), dismissedAtCoordinate = _useState8[0], setDismissedAtCoordinate = _useState8[1];
    var wrapperNode = (0, $b7Z9x.useRef)();
    var allowEscapeViewBox = props.allowEscapeViewBox, reverseDirection = props.reverseDirection, coordinate = props.coordinate, offset = props.offset, position = props.position, viewBox = props.viewBox;
    var handleKeyDown = (0, $b7Z9x.useCallback)(function(event) {
        if (event.key === 'Escape') {
            setDismissed(true);
            setDismissedAtCoordinate(function(prev) {
                return $eb1d3fe36ab16514$var$_objectSpread($eb1d3fe36ab16514$var$_objectSpread({}, prev), {}, {
                    x: coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
                    y: coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
                });
            });
        }
    }, [
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
    ]);
    (0, $b7Z9x.useEffect)(function() {
        var updateBBox = function updateBBox() {
            if (dismissed) {
                document.removeEventListener('keydown', handleKeyDown);
                if ((coordinate === null || coordinate === void 0 ? void 0 : coordinate.x) !== dismissedAtCoordinate.x || (coordinate === null || coordinate === void 0 ? void 0 : coordinate.y) !== dismissedAtCoordinate.y) setDismissed(false);
            } else document.addEventListener('keydown', handleKeyDown);
            if (wrapperNode.current && wrapperNode.current.getBoundingClientRect) {
                var box = wrapperNode.current.getBoundingClientRect();
                if (Math.abs(box.width - boxWidth) > $eb1d3fe36ab16514$var$EPS || Math.abs(box.height - boxHeight) > $eb1d3fe36ab16514$var$EPS) {
                    setBoxWidth(box.width);
                    setBoxHeight(box.height);
                }
            } else if (boxWidth !== -1 || boxHeight !== -1) {
                setBoxWidth(-1);
                setBoxHeight(-1);
            }
        };
        updateBBox();
        return function() {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        boxHeight,
        boxWidth,
        coordinate,
        dismissed,
        dismissedAtCoordinate.x,
        dismissedAtCoordinate.y,
        handleKeyDown
    ]);
    var getTranslate = function getTranslate(_ref) {
        var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
        if (position && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(position[key])) return position[key];
        var negative = coordinate[key] - tooltipDimension - offset;
        var positive = coordinate[key] + offset;
        if (allowEscapeViewBox !== null && allowEscapeViewBox !== void 0 && allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
        if (reverseDirection !== null && reverseDirection !== void 0 && reverseDirection[key]) {
            var _tooltipBoundary = negative;
            var _viewBoxBoundary = viewBox[key];
            if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
            return Math.max(negative, viewBox[key]);
        }
        var tooltipBoundary = positive + tooltipDimension;
        var viewBoxBoundary = viewBox[key] + viewBoxDimension;
        if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
        return Math.max(positive, viewBox[key]);
    };
    var payload = props.payload, payloadUniqBy = props.payloadUniqBy, filterNull = props.filterNull, active = props.active, wrapperStyle = props.wrapperStyle, useTranslate3d = props.useTranslate3d, isAnimationActive = props.isAnimationActive, animationDuration = props.animationDuration, animationEasing = props.animationEasing;
    var finalPayload = $eb1d3fe36ab16514$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry.value);
    }) : payload);
    var hasPayload = finalPayload && finalPayload.length;
    var content = props.content;
    var outerStyle = $eb1d3fe36ab16514$var$_objectSpread({
        pointerEvents: 'none',
        visibility: !dismissed && active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
    }, wrapperStyle);
    var translateX, translateY;
    if (position && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(position.x) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(position.y)) {
        translateX = position.x;
        translateY = position.y;
    } else if (boxWidth > 0 && boxHeight > 0 && coordinate) {
        translateX = getTranslate({
            key: 'x',
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
        });
        translateY = getTranslate({
            key: 'y',
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
        });
    } else outerStyle.visibility = 'hidden';
    outerStyle = $eb1d3fe36ab16514$var$_objectSpread($eb1d3fe36ab16514$var$_objectSpread({}, (0, $0a89a3b58486c782$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    })), outerStyle);
    if (isAnimationActive && active) outerStyle = $eb1d3fe36ab16514$var$_objectSpread($eb1d3fe36ab16514$var$_objectSpread({}, (0, $0a89a3b58486c782$export$ff9926a5d1daa67c)({
        transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
    })), outerStyle);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))($eb1d3fe36ab16514$var$CLS_PREFIX, (_classNames = {}, $eb1d3fe36ab16514$var$_defineProperty(_classNames, "".concat($eb1d3fe36ab16514$var$CLS_PREFIX, "-right"), (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $eb1d3fe36ab16514$var$_defineProperty(_classNames, "".concat($eb1d3fe36ab16514$var$CLS_PREFIX, "-left"), (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $eb1d3fe36ab16514$var$_defineProperty(_classNames, "".concat($eb1d3fe36ab16514$var$CLS_PREFIX, "-bottom"), (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $eb1d3fe36ab16514$var$_defineProperty(_classNames, "".concat($eb1d3fe36ab16514$var$CLS_PREFIX, "-top"), (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
    return(/*#__PURE__*/ // ESLint is disabled to allow listening to the `Escape` key. Refer to
    // https://github.com/recharts/recharts/pull/2925
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", {
        tabIndex: -1,
        role: "dialog",
        className: cls,
        style: outerStyle,
        ref: wrapperNode
    }, $eb1d3fe36ab16514$var$renderContent(content, $eb1d3fe36ab16514$var$_objectSpread($eb1d3fe36ab16514$var$_objectSpread({}, props), {}, {
        payload: finalPayload
    }))));
};
// needs to be set so that renderByOrder can find the correct handler function
$eb1d3fe36ab16514$export$28c660c63b792dea.displayName = 'Tooltip';
/**
 * needs to be set so that renderByOrder can access an have default values for
 * children.props when there are no props set by the consumer
 * doesn't work if using default parameters
 */ $eb1d3fe36ab16514$export$28c660c63b792dea.defaultProps = $eb1d3fe36ab16514$var$tooltipDefaultProps;





var $b7Z9x = parcelRequire("b7Z9x");



function $8e502fa2380939f7$var$_extends() {
    $8e502fa2380939f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e502fa2380939f7$var$_extends.apply(this, arguments);
}
var $8e502fa2380939f7$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $8e502fa2380939f7$export$3c877bb842c36952 = function Cross(props) {
    var x = props.x, y = props.y, width = props.width, height = props.height, top = props.top, left = props.left, className = props.className;
    if (!(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(x) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(y) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(height) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(top) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $8e502fa2380939f7$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-cross', className),
        d: $8e502fa2380939f7$var$getPath(x, y, width, height, top, left)
    }));
};
$8e502fa2380939f7$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};



var $b7Z9x = parcelRequire("b7Z9x");




function $f57f447fc0ea6b4e$var$_extends() {
    $f57f447fc0ea6b4e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f57f447fc0ea6b4e$var$_extends.apply(this, arguments);
}
var $f57f447fc0ea6b4e$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $201aa8e07b0747a2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $f57f447fc0ea6b4e$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $43467ad7b884b88a$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $43467ad7b884b88a$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $f57f447fc0ea6b4e$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $f57f447fc0ea6b4e$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $f57f447fc0ea6b4e$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $201aa8e07b0747a2$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $f57f447fc0ea6b4e$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $f57f447fc0ea6b4e$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $f57f447fc0ea6b4e$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $f57f447fc0ea6b4e$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $f57f447fc0ea6b4e$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $f57f447fc0ea6b4e$export$e98c2c7eb2b14f45 = function Sector(props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $201aa8e07b0747a2$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $f57f447fc0ea6b4e$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $f57f447fc0ea6b4e$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("path", $f57f447fc0ea6b4e$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};
$f57f447fc0ea6b4e$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};








var $b7Z9x = parcelRequire("b7Z9x");









var $75a0254afa97c64a$var$_excluded = [
    "viewBox"
], $75a0254afa97c64a$var$_excluded2 = [
    "viewBox"
], $75a0254afa97c64a$var$_excluded3 = [
    "ticks"
];
function $75a0254afa97c64a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $75a0254afa97c64a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $75a0254afa97c64a$var$_typeof(obj);
}
function $75a0254afa97c64a$var$_extends() {
    $75a0254afa97c64a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75a0254afa97c64a$var$_extends.apply(this, arguments);
}
function $75a0254afa97c64a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75a0254afa97c64a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $75a0254afa97c64a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $75a0254afa97c64a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $75a0254afa97c64a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $75a0254afa97c64a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $75a0254afa97c64a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $75a0254afa97c64a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $75a0254afa97c64a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75a0254afa97c64a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $75a0254afa97c64a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $75a0254afa97c64a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $75a0254afa97c64a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $75a0254afa97c64a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $75a0254afa97c64a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $75a0254afa97c64a$var$_setPrototypeOf(subClass, superClass);
}
function $75a0254afa97c64a$var$_setPrototypeOf(o, p) {
    $75a0254afa97c64a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $75a0254afa97c64a$var$_setPrototypeOf(o, p);
}
function $75a0254afa97c64a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75a0254afa97c64a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $75a0254afa97c64a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $75a0254afa97c64a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $75a0254afa97c64a$var$_possibleConstructorReturn(this, result);
    };
}
function $75a0254afa97c64a$var$_possibleConstructorReturn(self, call) {
    if (call && ($75a0254afa97c64a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $75a0254afa97c64a$var$_assertThisInitialized(self);
}
function $75a0254afa97c64a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $75a0254afa97c64a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $75a0254afa97c64a$var$_getPrototypeOf(o) {
    $75a0254afa97c64a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $75a0254afa97c64a$var$_getPrototypeOf(o);
}
function $75a0254afa97c64a$var$_defineProperty(obj, key, value) {
    key = $75a0254afa97c64a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75a0254afa97c64a$var$_toPropertyKey(arg) {
    var key = $75a0254afa97c64a$var$_toPrimitive(arg, "string");
    return $75a0254afa97c64a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $75a0254afa97c64a$var$_toPrimitive(input, hint) {
    if ($75a0254afa97c64a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($75a0254afa97c64a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $75a0254afa97c64a$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $75a0254afa97c64a$var$_inherits(CartesianAxis, _Component);
    var _super = $75a0254afa97c64a$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $75a0254afa97c64a$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $75a0254afa97c64a$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $75a0254afa97c64a$var$_objectWithoutProperties(_ref, $75a0254afa97c64a$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $75a0254afa97c64a$var$_objectWithoutProperties(_this$props, $75a0254afa97c64a$var$_excluded2);
                return !(0, $c84fad9052295dcc$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $c84fad9052295dcc$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $c84fad9052295dcc$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props)), (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", $75a0254afa97c64a$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $38ad82b150a25707$export$3d27d42b1034de5c)($75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(tick);
                var tickLineProps = $75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread($75a0254afa97c64a$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $75a0254afa97c64a$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f321872aac18bbfb$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", $75a0254afa97c64a$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $75a0254afa97c64a$var$_objectWithoutProperties(_this$props8, $75a0254afa97c64a$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $09aeb20c59d33797$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $b68d75c627cc2644$export$5f1af8db9871e1d6), $75a0254afa97c64a$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $b7Z9x.Component));
$75a0254afa97c64a$var$_defineProperty($75a0254afa97c64a$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$75a0254afa97c64a$var$_defineProperty($75a0254afa97c64a$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});





var $b7Z9x = parcelRequire("b7Z9x");






function $16ac6e2c28ed3585$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $16ac6e2c28ed3585$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $16ac6e2c28ed3585$var$_typeof(obj);
}
function $16ac6e2c28ed3585$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16ac6e2c28ed3585$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $16ac6e2c28ed3585$var$ownKeys(Object(source), !0).forEach(function(key) {
            $16ac6e2c28ed3585$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $16ac6e2c28ed3585$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16ac6e2c28ed3585$var$_defineProperty(obj, key, value) {
    key = $16ac6e2c28ed3585$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16ac6e2c28ed3585$var$_toPropertyKey(arg) {
    var key = $16ac6e2c28ed3585$var$_toPrimitive(arg, "string");
    return $16ac6e2c28ed3585$var$_typeof(key) === "symbol" ? key : String(key);
}
function $16ac6e2c28ed3585$var$_toPrimitive(input, hint) {
    if ($16ac6e2c28ed3585$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($16ac6e2c28ed3585$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $16ac6e2c28ed3585$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $16ac6e2c28ed3585$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $16ac6e2c28ed3585$var$PREFIX_LIST.reduce(function(res, entry) {
        return $16ac6e2c28ed3585$var$_objectSpread($16ac6e2c28ed3585$var$_objectSpread({}, res), {}, $16ac6e2c28ed3585$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $79872f49d027614b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $79872f49d027614b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $79872f49d027614b$var$_typeof(obj);
}
function $79872f49d027614b$var$_extends() {
    $79872f49d027614b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $79872f49d027614b$var$_extends.apply(this, arguments);
}
function $79872f49d027614b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $79872f49d027614b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $79872f49d027614b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $79872f49d027614b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $79872f49d027614b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $79872f49d027614b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $79872f49d027614b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $79872f49d027614b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $79872f49d027614b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $79872f49d027614b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $79872f49d027614b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $79872f49d027614b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $79872f49d027614b$var$_setPrototypeOf(subClass, superClass);
}
function $79872f49d027614b$var$_setPrototypeOf(o, p) {
    $79872f49d027614b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $79872f49d027614b$var$_setPrototypeOf(o, p);
}
function $79872f49d027614b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $79872f49d027614b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $79872f49d027614b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $79872f49d027614b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $79872f49d027614b$var$_possibleConstructorReturn(this, result);
    };
}
function $79872f49d027614b$var$_possibleConstructorReturn(self, call) {
    if (call && ($79872f49d027614b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $79872f49d027614b$var$_assertThisInitialized(self);
}
function $79872f49d027614b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $79872f49d027614b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $79872f49d027614b$var$_getPrototypeOf(o) {
    $79872f49d027614b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $79872f49d027614b$var$_getPrototypeOf(o);
}
function $79872f49d027614b$var$_defineProperty(obj, key, value) {
    key = $79872f49d027614b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $79872f49d027614b$var$_toPropertyKey(arg) {
    var key = $79872f49d027614b$var$_toPrimitive(arg, "string");
    return $79872f49d027614b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $79872f49d027614b$var$_toPrimitive(input, hint) {
    if ($79872f49d027614b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($79872f49d027614b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $79872f49d027614b$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $2903d33098abf7e3$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($9243674fe89e2a08$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $79872f49d027614b$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $79872f49d027614b$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $79872f49d027614b$var$_inherits(Brush, _PureComponent);
    var _super = $79872f49d027614b$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $79872f49d027614b$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $79872f49d027614b$var$_defineProperty($79872f49d027614b$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $79872f49d027614b$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($79872f49d027614b$var$_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind($79872f49d027614b$var$_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    $79872f49d027614b$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $79872f49d027614b$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $79872f49d027614b$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $79872f49d027614b$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $b7Z9x.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $79872f49d027614b$var$_objectSpread($79872f49d027614b$var$_objectSpread({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $b68d75c627cc2644$export$5f1af8db9871e1d6), $79872f49d027614b$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $b68d75c627cc2644$export$5f1af8db9871e1d6), $79872f49d027614b$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(x) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(y) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(width) || !(0, $201aa8e07b0747a2$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).Children.count(children) === 1;
                var style = (0, $16ac6e2c28ed3585$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $79872f49d027614b$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $79872f49d027614b$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $b7Z9x.PureComponent));
$79872f49d027614b$var$_defineProperty($79872f49d027614b$export$59bc2e3533b384a0, "displayName", 'Brush');
$79872f49d027614b$var$_defineProperty($79872f49d027614b$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});







var $b7Z9x = parcelRequire("b7Z9x");





var $7a45ea22f8fcd3e1$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};



/* eslint no-console: 0 */ var $aa92fa366686ac72$var$isDev = false;
var $aa92fa366686ac72$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($aa92fa366686ac72$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $26315adef90a8c0e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $26315adef90a8c0e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $26315adef90a8c0e$var$_typeof(obj);
}
function $26315adef90a8c0e$var$_extends() {
    $26315adef90a8c0e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $26315adef90a8c0e$var$_extends.apply(this, arguments);
}
function $26315adef90a8c0e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $26315adef90a8c0e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $26315adef90a8c0e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $26315adef90a8c0e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $26315adef90a8c0e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $26315adef90a8c0e$var$_defineProperty(obj, key, value) {
    key = $26315adef90a8c0e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $26315adef90a8c0e$var$_toPropertyKey(arg) {
    var key = $26315adef90a8c0e$var$_toPrimitive(arg, "string");
    return $26315adef90a8c0e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $26315adef90a8c0e$var$_toPrimitive(input, hint) {
    if ($26315adef90a8c0e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($26315adef90a8c0e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $26315adef90a8c0e$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $d709a5412861b060$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function $26315adef90a8c0e$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(x);
    var isY = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(y);
    (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $26315adef90a8c0e$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $26315adef90a8c0e$var$_objectSpread($26315adef90a8c0e$var$_objectSpread({
        clipPath: clipPath
    }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-reference-dot', className)
    }, $26315adef90a8c0e$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $09aeb20c59d33797$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$26315adef90a8c0e$export$aa7f0b0106bff39.displayName = 'ReferenceDot';
$26315adef90a8c0e$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
$26315adef90a8c0e$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $91e8d465d4ebe72b$export$d046b3c4a416f60d), $26315adef90a8c0e$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $7ff868e5d6b71ab0$exports = {};


var $fb32c04d009be5c5$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $fb32c04d009be5c5$var$baseSome(collection, predicate) {
    var result;
    $72d146bf2da273f9$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$fb32c04d009be5c5$exports = $fb32c04d009be5c5$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $7ff868e5d6b71ab0$var$some(collection, predicate, guard) {
    var func = $e9f4eab8a3ba19aa$exports(collection) ? $bc5234a832151b51$exports : $fb32c04d009be5c5$exports;
    if (guard && $89342db7e4beb4e5$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $a3e1cb58c2a61f92$exports(predicate, 3));
}
$7ff868e5d6b71ab0$exports = $7ff868e5d6b71ab0$var$some;




var $b7Z9x = parcelRequire("b7Z9x");








function $bdfd78e0730e9c70$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bdfd78e0730e9c70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bdfd78e0730e9c70$var$_typeof(obj);
}
function $bdfd78e0730e9c70$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bdfd78e0730e9c70$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bdfd78e0730e9c70$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bdfd78e0730e9c70$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bdfd78e0730e9c70$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bdfd78e0730e9c70$var$_defineProperty(obj, key, value) {
    key = $bdfd78e0730e9c70$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bdfd78e0730e9c70$var$_toPropertyKey(arg) {
    var key = $bdfd78e0730e9c70$var$_toPrimitive(arg, "string");
    return $bdfd78e0730e9c70$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bdfd78e0730e9c70$var$_toPrimitive(input, hint) {
    if ($bdfd78e0730e9c70$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bdfd78e0730e9c70$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bdfd78e0730e9c70$var$_slicedToArray(arr, i) {
    return $bdfd78e0730e9c70$var$_arrayWithHoles(arr) || $bdfd78e0730e9c70$var$_iterableToArrayLimit(arr, i) || $bdfd78e0730e9c70$var$_unsupportedIterableToArray(arr, i) || $bdfd78e0730e9c70$var$_nonIterableRest();
}
function $bdfd78e0730e9c70$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bdfd78e0730e9c70$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bdfd78e0730e9c70$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bdfd78e0730e9c70$var$_arrayLikeToArray(o, minLen);
}
function $bdfd78e0730e9c70$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bdfd78e0730e9c70$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $bdfd78e0730e9c70$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bdfd78e0730e9c70$var$_extends() {
    $bdfd78e0730e9c70$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdfd78e0730e9c70$var$_extends.apply(this, arguments);
}
var $bdfd78e0730e9c70$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("line", $bdfd78e0730e9c70$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $bdfd78e0730e9c70$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($7ff868e5d6b71ab0$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $bdfd78e0730e9c70$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $d709a5412861b060$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(fixedX);
    var isY = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $bdfd78e0730e9c70$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $bdfd78e0730e9c70$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $bdfd78e0730e9c70$var$_objectSpread($bdfd78e0730e9c70$var$_objectSpread({
        clipPath: clipPath
    }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-reference-line', className)
    }, $bdfd78e0730e9c70$var$renderLine(shape, lineProps), (0, $09aeb20c59d33797$export$b04be29aa201d4f5).renderCallByParent(props, (0, $d709a5412861b060$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$bdfd78e0730e9c70$export$b2f28e248e7838eb.displayName = 'ReferenceLine';
$bdfd78e0730e9c70$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};




var $b7Z9x = parcelRequire("b7Z9x");









function $b76311d184f58399$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b76311d184f58399$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b76311d184f58399$var$_typeof(obj);
}
function $b76311d184f58399$var$_extends() {
    $b76311d184f58399$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b76311d184f58399$var$_extends.apply(this, arguments);
}
function $b76311d184f58399$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b76311d184f58399$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b76311d184f58399$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b76311d184f58399$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b76311d184f58399$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b76311d184f58399$var$_defineProperty(obj, key, value) {
    key = $b76311d184f58399$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b76311d184f58399$var$_toPropertyKey(arg) {
    var key = $b76311d184f58399$var$_toPrimitive(arg, "string");
    return $b76311d184f58399$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b76311d184f58399$var$_toPrimitive(input, hint) {
    if ($b76311d184f58399$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b76311d184f58399$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b76311d184f58399$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $d709a5412861b060$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $d709a5412861b060$export$c7964a5b9439ae62)(p1, p2);
};
function $b76311d184f58399$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $201aa8e07b0747a2$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $b76311d184f58399$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-reference-area', className)
    }, $b76311d184f58399$export$b4ec4f050ce240b9.renderRect(shape, $b76311d184f58399$var$_objectSpread($b76311d184f58399$var$_objectSpread({
        clipPath: clipPath
    }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(props, true)), rect)), (0, $09aeb20c59d33797$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$b76311d184f58399$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';
$b76311d184f58399$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
$b76311d184f58399$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $a3a55738a2f00209$export$4617fb02663045ef), $b76311d184f58399$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $601404c2810871b9$var$_toConsumableArray(arr) {
    return $601404c2810871b9$var$_arrayWithoutHoles(arr) || $601404c2810871b9$var$_iterableToArray(arr) || $601404c2810871b9$var$_unsupportedIterableToArray(arr) || $601404c2810871b9$var$_nonIterableSpread();
}
function $601404c2810871b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $601404c2810871b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $601404c2810871b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $601404c2810871b9$var$_arrayLikeToArray(o, minLen);
}
function $601404c2810871b9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $601404c2810871b9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $601404c2810871b9$var$_arrayLikeToArray(arr);
}
function $601404c2810871b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $601404c2810871b9$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $bdfd78e0730e9c70$export$b2f28e248e7838eb));
    var dots = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $26315adef90a8c0e$export$aa7f0b0106bff39));
    var elements = [].concat($601404c2810871b9$var$_toConsumableArray(lines), $601404c2810871b9$var$_toConsumableArray(dots));
    var areas = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $b76311d184f58399$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $7a45ea22f8fcd3e1$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(el.props[key1]) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $cf9429b6a27dd5bb$exports = {};
'use strict';
var $cf9429b6a27dd5bb$var$has = Object.prototype.hasOwnProperty, $cf9429b6a27dd5bb$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cf9429b6a27dd5bb$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cf9429b6a27dd5bb$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cf9429b6a27dd5bb$var$Events().__proto__) $cf9429b6a27dd5bb$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cf9429b6a27dd5bb$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cf9429b6a27dd5bb$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cf9429b6a27dd5bb$var$EE(fn, context || emitter, once), evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cf9429b6a27dd5bb$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cf9429b6a27dd5bb$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cf9429b6a27dd5bb$var$EventEmitter() {
    this._events = new $cf9429b6a27dd5bb$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cf9429b6a27dd5bb$var$has.call(events, name)) names.push($cf9429b6a27dd5bb$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cf9429b6a27dd5bb$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cf9429b6a27dd5bb$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cf9429b6a27dd5bb$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cf9429b6a27dd5bb$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cf9429b6a27dd5bb$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cf9429b6a27dd5bb$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cf9429b6a27dd5bb$var$prefix ? $cf9429b6a27dd5bb$var$prefix + event : event;
        if (this._events[evt]) $cf9429b6a27dd5bb$var$clearEvent(this, evt);
    } else {
        this._events = new $cf9429b6a27dd5bb$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cf9429b6a27dd5bb$var$EventEmitter.prototype.off = $cf9429b6a27dd5bb$var$EventEmitter.prototype.removeListener;
$cf9429b6a27dd5bb$var$EventEmitter.prototype.addListener = $cf9429b6a27dd5bb$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cf9429b6a27dd5bb$var$EventEmitter.prefixed = $cf9429b6a27dd5bb$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cf9429b6a27dd5bb$var$EventEmitter.EventEmitter = $cf9429b6a27dd5bb$var$EventEmitter;
$cf9429b6a27dd5bb$exports = $cf9429b6a27dd5bb$var$EventEmitter;


var $4774d8afe029cf64$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($cf9429b6a27dd5bb$exports)))();
if ($4774d8afe029cf64$export$9bcdfe5f29bb33.setMaxListeners) $4774d8afe029cf64$export$9bcdfe5f29bb33.setMaxListeners(10);
var $4774d8afe029cf64$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $a2cf04b78f8e775c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a2cf04b78f8e775c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a2cf04b78f8e775c$var$_typeof(obj);
}
function $a2cf04b78f8e775c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a2cf04b78f8e775c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a2cf04b78f8e775c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a2cf04b78f8e775c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a2cf04b78f8e775c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a2cf04b78f8e775c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a2cf04b78f8e775c$var$_defineProperty(obj, key, value) {
    key = $a2cf04b78f8e775c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a2cf04b78f8e775c$var$_toPropertyKey(arg) {
    var key = $a2cf04b78f8e775c$var$_toPrimitive(arg, "string");
    return $a2cf04b78f8e775c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a2cf04b78f8e775c$var$_toPrimitive(input, hint) {
    if ($a2cf04b78f8e775c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a2cf04b78f8e775c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a2cf04b78f8e775c$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $a2cf04b78f8e775c$var$_classCallCheck(this, AccessibilityManager);
        $a2cf04b78f8e775c$var$_defineProperty(this, "activeIndex", 0);
        $a2cf04b78f8e775c$var$_defineProperty(this, "coordinateList", []);
        $a2cf04b78f8e775c$var$_defineProperty(this, "layout", 'horizontal');
    }
    $a2cf04b78f8e775c$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var pageX = x + coordinate;
                var pageY = y + this.offset.top;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();


var $451a5e3ff2cbaa23$var$_excluded = [
    "item"
], $451a5e3ff2cbaa23$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $451a5e3ff2cbaa23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $451a5e3ff2cbaa23$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $451a5e3ff2cbaa23$var$_typeof(obj);
}
function $451a5e3ff2cbaa23$var$_slicedToArray(arr, i) {
    return $451a5e3ff2cbaa23$var$_arrayWithHoles(arr) || $451a5e3ff2cbaa23$var$_iterableToArrayLimit(arr, i) || $451a5e3ff2cbaa23$var$_unsupportedIterableToArray(arr, i) || $451a5e3ff2cbaa23$var$_nonIterableRest();
}
function $451a5e3ff2cbaa23$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $451a5e3ff2cbaa23$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $451a5e3ff2cbaa23$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $451a5e3ff2cbaa23$var$_extends() {
    $451a5e3ff2cbaa23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $451a5e3ff2cbaa23$var$_extends.apply(this, arguments);
}
function $451a5e3ff2cbaa23$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $451a5e3ff2cbaa23$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $451a5e3ff2cbaa23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $451a5e3ff2cbaa23$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $451a5e3ff2cbaa23$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $451a5e3ff2cbaa23$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $451a5e3ff2cbaa23$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $451a5e3ff2cbaa23$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $451a5e3ff2cbaa23$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $451a5e3ff2cbaa23$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $451a5e3ff2cbaa23$var$_setPrototypeOf(subClass, superClass);
}
function $451a5e3ff2cbaa23$var$_setPrototypeOf(o, p) {
    $451a5e3ff2cbaa23$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $451a5e3ff2cbaa23$var$_setPrototypeOf(o, p);
}
function $451a5e3ff2cbaa23$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $451a5e3ff2cbaa23$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $451a5e3ff2cbaa23$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $451a5e3ff2cbaa23$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $451a5e3ff2cbaa23$var$_possibleConstructorReturn(this, result);
    };
}
function $451a5e3ff2cbaa23$var$_possibleConstructorReturn(self, call) {
    if (call && ($451a5e3ff2cbaa23$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $451a5e3ff2cbaa23$var$_assertThisInitialized(self);
}
function $451a5e3ff2cbaa23$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $451a5e3ff2cbaa23$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $451a5e3ff2cbaa23$var$_getPrototypeOf(o) {
    $451a5e3ff2cbaa23$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $451a5e3ff2cbaa23$var$_getPrototypeOf(o);
}
function $451a5e3ff2cbaa23$var$_toConsumableArray(arr) {
    return $451a5e3ff2cbaa23$var$_arrayWithoutHoles(arr) || $451a5e3ff2cbaa23$var$_iterableToArray(arr) || $451a5e3ff2cbaa23$var$_unsupportedIterableToArray(arr) || $451a5e3ff2cbaa23$var$_nonIterableSpread();
}
function $451a5e3ff2cbaa23$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $451a5e3ff2cbaa23$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $451a5e3ff2cbaa23$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $451a5e3ff2cbaa23$var$_arrayLikeToArray(o, minLen);
}
function $451a5e3ff2cbaa23$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $451a5e3ff2cbaa23$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $451a5e3ff2cbaa23$var$_arrayLikeToArray(arr);
}
function $451a5e3ff2cbaa23$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $451a5e3ff2cbaa23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $451a5e3ff2cbaa23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $451a5e3ff2cbaa23$var$ownKeys(Object(source), !0).forEach(function(key) {
            $451a5e3ff2cbaa23$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $451a5e3ff2cbaa23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $451a5e3ff2cbaa23$var$_defineProperty(obj, key, value) {
    key = $451a5e3ff2cbaa23$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $451a5e3ff2cbaa23$var$_toPropertyKey(arg) {
    var key = $451a5e3ff2cbaa23$var$_toPrimitive(arg, "string");
    return $451a5e3ff2cbaa23$var$_typeof(key) === "symbol" ? key : String(key);
}
function $451a5e3ff2cbaa23$var$_toPrimitive(input, hint) {
    if ($451a5e3ff2cbaa23$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($451a5e3ff2cbaa23$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $451a5e3ff2cbaa23$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $451a5e3ff2cbaa23$var$originCoordinate = {
    x: 0,
    y: 0
};
// use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $451a5e3ff2cbaa23$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $451a5e3ff2cbaa23$var$defer = // eslint-disable-next-line no-nested-ternary
typeof requestAnimationFrame === 'function' ? requestAnimationFrame : typeof setImmediate === 'function' ? setImmediate : setTimeout;
var $451a5e3ff2cbaa23$var$deferClear = // eslint-disable-next-line no-nested-ternary
typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame : typeof clearImmediate === 'function' ? clearImmediate : clearTimeout;
var $451a5e3ff2cbaa23$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $451a5e3ff2cbaa23$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, rangeObj), (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, rangeObj), (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $451a5e3ff2cbaa23$var$originCoordinate;
};
var $451a5e3ff2cbaa23$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($451a5e3ff2cbaa23$var$_toConsumableArray(result), $451a5e3ff2cbaa23$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(dataStartIndex) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ function $451a5e3ff2cbaa23$var$isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(domainStart) && (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}
function $451a5e3ff2cbaa23$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $451a5e3ff2cbaa23$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $451a5e3ff2cbaa23$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $201aa8e07b0747a2$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($451a5e3ff2cbaa23$var$_toConsumableArray(result), [
            (0, $3bb158ee6cd3f1ec$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $451a5e3ff2cbaa23$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $451a5e3ff2cbaa23$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $3bb158ee6cd3f1ec$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $451a5e3ff2cbaa23$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $451a5e3ff2cbaa23$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $451a5e3ff2cbaa23$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $3bb158ee6cd3f1ec$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $451a5e3ff2cbaa23$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ($451a5e3ff2cbaa23$var$isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $3bb158ee6cd3f1ec$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3bb158ee6cd3f1ec$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $451a5e3ff2cbaa23$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $3bb158ee6cd3f1ec$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $201aa8e07b0747a2$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($9243674fe89e2a08$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $3bb158ee6cd3f1ec$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($451a5e3ff2cbaa23$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $3bb158ee6cd3f1ec$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry) ? finalDomain : [].concat($451a5e3ff2cbaa23$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $3bb158ee6cd3f1ec$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $3bb158ee6cd3f1ec$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($9243674fe89e2a08$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $3bb158ee6cd3f1ec$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $3bb158ee6cd3f1ec$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $601404c2810871b9$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $3bb158ee6cd3f1ec$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, axisId, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $451a5e3ff2cbaa23$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $451a5e3ff2cbaa23$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $3bb158ee6cd3f1ec$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $451a5e3ff2cbaa23$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($9243674fe89e2a08$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $3bb158ee6cd3f1ec$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $601404c2810871b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $3bb158ee6cd3f1ec$export$a0bc8660980558a0)(originalDomain, (0, $3bb158ee6cd3f1ec$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $601404c2810871b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, axisId, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))($451a5e3ff2cbaa23$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $451a5e3ff2cbaa23$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $451a5e3ff2cbaa23$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $451a5e3ff2cbaa23$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $451a5e3ff2cbaa23$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($e20cd8069ccd8bf4$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $3bb158ee6cd3f1ec$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $451a5e3ff2cbaa23$var$createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $79872f49d027614b$export$59bc2e3533b384a0));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $451a5e3ff2cbaa23$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $423c5b3e35d96d0c$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $451a5e3ff2cbaa23$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $451a5e3ff2cbaa23$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $79872f49d027614b$export$59bc2e3533b384a0));
    var legendItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $4d6b5192df4a4236$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $79872f49d027614b$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $3bb158ee6cd3f1ec$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $451a5e3ff2cbaa23$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $451a5e3ff2cbaa23$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $451a5e3ff2cbaa23$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $3bb158ee6cd3f1ec$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $451a5e3ff2cbaa23$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $451a5e3ff2cbaa23$var$_defineProperty(_objectSpread6, entry.axisType, axis), $451a5e3ff2cbaa23$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $3bb158ee6cd3f1ec$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $423c5b3e35d96d0c$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $3bb158ee6cd3f1ec$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $3bb158ee6cd3f1ec$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $3bb158ee6cd3f1ec$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, pos), {}, {
                        position: $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, composedFn($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $451a5e3ff2cbaa23$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $451a5e3ff2cbaa23$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $451a5e3ff2cbaa23$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $423c5b3e35d96d0c$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $423c5b3e35d96d0c$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $451a5e3ff2cbaa23$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $3bb158ee6cd3f1ec$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, result), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, name, $451a5e3ff2cbaa23$var$getAxisMap(props, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $451a5e3ff2cbaa23$var$calculateOffset($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $451a5e3ff2cbaa23$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $451a5e3ff2cbaa23$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $451a5e3ff2cbaa23$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _this;
            $451a5e3ff2cbaa23$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $a2cf04b78f8e775c$export$a2c2de1efa8671eb)());
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "clearDeferId", function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(_this.deferId) && $451a5e3ff2cbaa23$var$deferClear) $451a5e3ff2cbaa23$var$deferClear(_this.deferId);
                _this.deferId = null;
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($451a5e3ff2cbaa23$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $451a5e3ff2cbaa23$var$defer && $451a5e3ff2cbaa23$var$defer(_this.applySyncEvent.bind($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), data));
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $451a5e3ff2cbaa23$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $423c5b3e35d96d0c$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    handler(mouse, e);
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $3bb158ee6cd3f1ec$export$846dc5ac5fecff74)((0, $38ad82b150a25707$export$3d27d42b1034de5c)($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, (0, $75a0254afa97c64a$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $3bb158ee6cd3f1ec$export$846dc5ac5fecff74)((0, $38ad82b150a25707$export$3d27d42b1034de5c)($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, (0, $75a0254afa97c64a$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(axis, true);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1);
                if (chartName === 'ScatterChart') {
                    restProps = activeCoordinate;
                    cursorComp = (0, $8e502fa2380939f7$export$3c877bb842c36952);
                } else if (chartName === 'BarChart') {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $a3a55738a2f00209$export$4617fb02663045ef);
                } else if (layout === 'radial') {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $f57f447fc0ea6b4e$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1);
                }
                var key = element.key || '_recharts-cursor';
                var cursorProps = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                    stroke: '#ccc',
                    pointerEvents: 'none'
                }, offset), restProps), (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: 'recharts-tooltip-cursor'
                });
                return /*#__PURE__*/ (0, $b7Z9x.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $b7Z9x.createElement)(cursorComp, cursorProps);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($807f13c6658a121e$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fcd7e08b06d8d7c6$exports)))(axis.domain, $451a5e3ff2cbaa23$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, {
                    key: element.key || 'grid',
                    x: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(polarAngles) ? polarAngles : (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(polarRadius) ? polarRadius : (0, $3bb158ee6cd3f1ec$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $3bb158ee6cd3f1ec$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $451a5e3ff2cbaa23$var$_objectWithoutProperties(props, $451a5e3ff2cbaa23$var$_excluded);
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(item, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var children = _this.props.children;
                var tooltipItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $eb1d3fe36ab16514$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(tooltipItem, {
                    viewBox: $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $3bb158ee6cd3f1ec$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $201aa8e07b0747a2$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $451a5e3ff2cbaa23$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $3bb158ee6cd3f1ec$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(activeDot)), (0, $f321872aac18bbfb$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $eb1d3fe36ab16514$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $3bb158ee6cd3f1ec$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $3bb158ee6cd3f1ec$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $3bb158ee6cd3f1ec$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $201aa8e07b0747a2$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $201aa8e07b0747a2$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($451a5e3ff2cbaa23$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $451a5e3ff2cbaa23$var$_defineProperty($451a5e3ff2cbaa23$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(element, $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(_props.id) ? (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts') : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($91f710ccfab96e63$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        $451a5e3ff2cbaa23$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(this.props.syncId)) this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.handleMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(this.props.syncId)) this.addListener();
                    // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === 'function') this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(this.props.children, (0, $eb1d3fe36ab16514$export$28c660c63b792dea));
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($20ade4e8ba3f58a7$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $5693eee73e492f24$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $5693eee73e492f24$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $451a5e3ff2cbaa23$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: 'none',
                        fill: '#ccc',
                        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === 'horizontal') {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === 'vertical') {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(activeCoordinate.cy)) {
                        if (layout === 'centric') {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $43467ad7b884b88a$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $201aa8e07b0747a2$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $43467ad7b884b88a$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $423c5b3e35d96d0c$export$64c61536a2b72e0f)(children, (0, $eb1d3fe36ab16514$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $f321872aac18bbfb$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $4774d8afe029cf64$export$9bcdfe5f29bb33).on((0, $4774d8afe029cf64$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $4774d8afe029cf64$export$9bcdfe5f29bb33).setMaxListeners && (0, $4774d8afe029cf64$export$9bcdfe5f29bb33)._maxListeners) (0, $4774d8afe029cf64$export$9bcdfe5f29bb33).setMaxListeners((0, $4774d8afe029cf64$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $4774d8afe029cf64$export$9bcdfe5f29bb33).removeListener((0, $4774d8afe029cf64$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $4774d8afe029cf64$export$9bcdfe5f29bb33).setMaxListeners && (0, $4774d8afe029cf64$export$9bcdfe5f29bb33)._maxListeners) (0, $4774d8afe029cf64$export$9bcdfe5f29bb33).setMaxListeners((0, $4774d8afe029cf64$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(syncId)) (0, $4774d8afe029cf64$export$9bcdfe5f29bb33).emit((0, $4774d8afe029cf64$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(data.dataEndIndex)) this.setState($451a5e3ff2cbaa23$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === 'value') {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        });
                        // When a categorical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $451a5e3ff2cbaa23$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $451a5e3ff2cbaa23$var$originCoordinate;
                        this.setState($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $423c5b3e35d96d0c$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $75a0254afa97c64a$export$bdd99f2cdf352bae), $451a5e3ff2cbaa23$var$_extends({}, axisOptions, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $451a5e3ff2cbaa23$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, res), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $451a5e3ff2cbaa23$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, res), {}, $451a5e3ff2cbaa23$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $423c5b3e35d96d0c$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $a3a55738a2f00209$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $43467ad7b884b88a$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $423c5b3e35d96d0c$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $451a5e3ff2cbaa23$var$_objectWithoutProperties(_this$props6, $451a5e3ff2cbaa23$var$_excluded2);
                    var attrs = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    };
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $80836ea8a08da7a7$export$7b92b459e668cb21), $451a5e3ff2cbaa23$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $423c5b3e35d96d0c$export$a98d6da55570cb82)(children, map));
                    if (this.props.accessibilityLayer) {
                        var _2, _img;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_2 = 0, _2 !== void 0) ? _2 : this.props.tabIndex;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_img = 'img', _img !== void 0) ? _img : this.props.role;
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", $451a5e3ff2cbaa23$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-wrapper', className),
                        style: $451a5e3ff2cbaa23$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $80836ea8a08da7a7$export$7b92b459e668cb21), $451a5e3ff2cbaa23$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $423c5b3e35d96d0c$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $b7Z9x.Component)), $451a5e3ff2cbaa23$var$_defineProperty(_class, "displayName", chartName), $451a5e3ff2cbaa23$var$_defineProperty(_class, "defaultProps", $451a5e3ff2cbaa23$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), $451a5e3ff2cbaa23$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(prevState.updateId)) {
            var defaultState = $451a5e3ff2cbaa23$var$createDefaultState(nextProps);
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $c84fad9052295dcc$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $451a5e3ff2cbaa23$var$createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, $451a5e3ff2cbaa23$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($451a5e3ff2cbaa23$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $423c5b3e35d96d0c$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($451a5e3ff2cbaa23$var$_objectSpread($451a5e3ff2cbaa23$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $451a5e3ff2cbaa23$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $b7Z9x.isValidElement)(option)) dot = /*#__PURE__*/ (0, $b7Z9x.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $91e8d465d4ebe72b$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $5a089bb377232adf$export$ea77231de273b52d = function XAxis() {
    return null;
};
$5a089bb377232adf$export$ea77231de273b52d.displayName = 'XAxis';
$5a089bb377232adf$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $9b81e5e543052ce8$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$9b81e5e543052ce8$export$f96c4024c52de8f4.displayName = 'YAxis';
$9b81e5e543052ce8$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};



var $4d82a1207fcb1b48$export$54d0e8420ac838ac = (0, $451a5e3ff2cbaa23$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $079ac3c80abbf2ba$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $5a089bb377232adf$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $9b81e5e543052ce8$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $d709a5412861b060$export$ece7de1383db5ac)
});



var $b7Z9x = parcelRequire("b7Z9x");

var $b7Z9x = parcelRequire("b7Z9x");

var $a2nZt = parcelRequire("a2nZt");


/* global Reflect, Promise */ var $efe37893e0473be3$var$extendStatics = function(d, b) {
    $efe37893e0473be3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $efe37893e0473be3$var$extendStatics(d, b);
};
function $efe37893e0473be3$var$__extends(d, b) {
    $efe37893e0473be3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $efe37893e0473be3$var$__assign = function() {
    $efe37893e0473be3$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efe37893e0473be3$var$__assign.apply(this, arguments);
};
function $efe37893e0473be3$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $efe37893e0473be3$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case 'debounce':
            return (0, (/*@__PURE__*/$parcel$interopDefault($bb97fb2cb8055912$exports)))(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return (0, (/*@__PURE__*/$parcel$interopDefault($91f710ccfab96e63$exports)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $efe37893e0473be3$var$isFunction = function(fn) {
    return typeof fn === 'function';
};
var $efe37893e0473be3$var$isSSR = function() {
    return typeof window === 'undefined';
};
var $efe37893e0473be3$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $efe37893e0473be3$var$createNotifier = function(setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            return {
                width: width,
                height: height
            };
        });
    };
};
var $efe37893e0473be3$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $efe37893e0473be3$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($efe37893e0473be3$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($efe37893e0473be3$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $efe37893e0473be3$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $efe37893e0473be3$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $a2nZt.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $efe37893e0473be3$var$createNotifier(function(setStateFunc) {
                return _this.setState(setStateFunc, function() {
                    return onResize === null || onResize === void 0 ? void 0 : onResize(_this.state.width, _this.state.height);
                });
            }, handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$efe37893e0473be3$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($efe37893e0473be3$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return 'renderProp';
            if ($efe37893e0473be3$var$isFunction(children)) return 'childFunction';
            if ((0, $b7Z9x.isValidElement)(children)) return 'child';
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return 'childArray';
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $b7Z9x.createRef)();
        _this.observableElement = null;
        if ($efe37893e0473be3$var$isSSR()) return _this;
        _this.resizeHandler = $efe37893e0473be3$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($efe37893e0473be3$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        switch(renderType){
            case 'renderProp':
                return render === null || render === void 0 ? void 0 : render(childProps);
            case 'childFunction':
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            case 'child':
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef;
                    var nativeProps = $efe37893e0473be3$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $b7Z9x.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0, $b7Z9x.cloneElement)(child, childProps);
            case 'childArray':
                var childArray = children;
                return childArray.map(function(el) {
                    return !!el && (0, $b7Z9x.cloneElement)(el, childProps);
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $b7Z9x.PureComponent));
function $efe37893e0473be3$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $efe37893e0473be3$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $b7Z9x.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $efe37893e0473be3$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement($efe37893e0473be3$export$2e2bcd8739ae039, $efe37893e0473be3$var$__assign({}, options, {
                targetRef: targetRef
            }), (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(ComponentInner, $efe37893e0473be3$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $b7Z9x.Component));
    function forwardRefWrapper(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement(ResizeDetectorHOC, $efe37893e0473be3$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $b7Z9x.forwardRef)(forwardRefWrapper);
}
var $efe37893e0473be3$var$useEnhancedEffect = $efe37893e0473be3$var$isSSR() ? (0, $b7Z9x.useEffect) : (0, $b7Z9x.useLayoutEffect);
function $efe37893e0473be3$export$453c3d1cba18d800(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = (0, $b7Z9x.useRef)(skipOnMount);
    var localRef = (0, $b7Z9x.useRef)(null);
    var resizeHandler = (0, $b7Z9x.useRef)();
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var _g = (0, $b7Z9x.useState)({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    $efe37893e0473be3$var$useEnhancedEffect(function() {
        if (!handleWidth && !handleHeight) return;
        var notifyResize = $efe37893e0473be3$var$createNotifier(setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current;
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $efe37893e0473be3$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) resizeObserver.observe(ref.current, observerOptions);
        return function() {
            var _a, _b;
            resizeObserver.disconnect();
            (_b = (_a = resizeHandler.current).cancel) === null || _b === void 0 || _b.call(_a);
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        observerOptions,
        ref.current
    ]);
    (0, $b7Z9x.useEffect)(function() {
        onResize === null || onResize === void 0 || onResize(size.width, size.height);
    }, [
        size
    ]);
    return $efe37893e0473be3$var$__assign({
        ref: ref
    }, size);
}




function $c31ab2f543d48c8b$var$_extends() {
    $c31ab2f543d48c8b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c31ab2f543d48c8b$var$_extends.apply(this, arguments);
}
function $c31ab2f543d48c8b$var$_slicedToArray(arr, i) {
    return $c31ab2f543d48c8b$var$_arrayWithHoles(arr) || $c31ab2f543d48c8b$var$_iterableToArrayLimit(arr, i) || $c31ab2f543d48c8b$var$_unsupportedIterableToArray(arr, i) || $c31ab2f543d48c8b$var$_nonIterableRest();
}
function $c31ab2f543d48c8b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c31ab2f543d48c8b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c31ab2f543d48c8b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c31ab2f543d48c8b$var$_arrayLikeToArray(o, minLen);
}
function $c31ab2f543d48c8b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c31ab2f543d48c8b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c31ab2f543d48c8b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c31ab2f543d48c8b$export$e60a4704009a0009 = /*#__PURE__*/ (0, $b7Z9x.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize;
    var _useState = (0, $b7Z9x.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $c31ab2f543d48c8b$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $b7Z9x.useRef)(null);
    (0, $b7Z9x.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var getContainerSize = (0, $b7Z9x.useCallback)(function() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    }, []);
    var updateDimensionsImmediate = (0, $b7Z9x.useCallback)(function() {
        var newSize = getContainerSize();
        if (newSize) {
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (onResize) onResize(containerWidth, containerHeight);
            setSizes(function(currentSizes) {
                var oldWidth = currentSizes.containerWidth, oldHeight = currentSizes.containerHeight;
                if (containerWidth !== oldWidth || containerHeight !== oldHeight) return {
                    containerWidth: containerWidth,
                    containerHeight: containerHeight
                };
                return currentSizes;
            });
        }
    }, [
        getContainerSize,
        onResize
    ]);
    var chartContent = (0, $b7Z9x.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)((0, $201aa8e07b0747a2$export$e50269385c77c348)(width) || (0, $201aa8e07b0747a2$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $201aa8e07b0747a2$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $201aa8e07b0747a2$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $aa92fa366686ac72$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $b7Z9x.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    (0, $b7Z9x.useEffect)(function() {
        var size = getContainerSize();
        if (size) setSizes(size);
    }, [
        getContainerSize
    ]);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $efe37893e0473be3$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: updateDimensionsImmediate,
        targetRef: containerRef,
        refreshMode: debounce > 0 ? 'debounce' : undefined,
        refreshRate: debounce
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("div", $c31ab2f543d48c8b$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-responsive-container', className),
        style: style,
        ref: containerRef
    }), chartContent));
});



const $c48726348e80dbc5$var$NBSP = "\u00a0";
const $c48726348e80dbc5$var$GameStats = ({ game: game })=>{
    const scoreData = (0, $b7Z9x.useMemo)(()=>game.frames.map(({ score: score, outcome: outcome }, i)=>({
                name: i + 1,
                score: score,
                pins: (0, $a6962441c258f009$export$2fc09de897439556)(outcome, i === 9)
            })), [
        game
    ]);
    const stats = (0, $b7Z9x.useMemo)(()=>{
        const results = {
            Pins: game.pins,
            Strikes: game.stats.strikes,
            Spares: {
                total: game.stats.spares.total,
                "single pin": game.stats.spares.single,
                "multiple pins": game.stats.spares.multiple
            }
        };
        if (game.stats.splits.total) results.Splits = `${game.stats.splits.total} ${game.stats.splits.converted ? `(${game.stats.splits.converted} converted)` : ""}`;
        if (game.stats.fouls) results.Fouls = game.stats.fouls;
        results.Misses = game.stats.misses;
        results["Avg First Ball Pinfall"] = game.stats.avgFirstBallPinfall;
        return results;
    }, [
        game
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("columns", "is-fluid"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                    children: Object.entries(stats).map(([key, value])=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                    children: `${key}:`
                                }),
                                $c48726348e80dbc5$var$NBSP,
                                [
                                    "number",
                                    "string"
                                ].includes(typeof value) ? /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                    children: value
                                }) : /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                            children: value.total
                                        }),
                                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("ml-3", "is-size-7"),
                                            children: Object.entries(value).filter(([k])=>k !== "total").map(([k, v])=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-grey"),
                                                            children: `${k}:`
                                                        }),
                                                        $c48726348e80dbc5$var$NBSP,
                                                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                                            children: v
                                                        })
                                                    ]
                                                }, k))
                                        })
                                    ]
                                })
                            ]
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column", "is-three-fifths"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $c31ab2f543d48c8b$export$e60a4704009a0009), {
                    height: 175,
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $4d82a1207fcb1b48$export$54d0e8420ac838ac), {
                        data: scoreData,
                        margin: {
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $6774215ffc20680c$export$6440e27b9f186856), {
                                strokeDasharray: "2 2"
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $5a089bb377232adf$export$ea77231de273b52d), {
                                dataKey: "name",
                                padding: {
                                    left: 10,
                                    right: 10
                                }
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9b81e5e543052ce8$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Pins",
                                yAxisId: "pins",
                                orientation: "left",
                                domain: [
                                    0,
                                    10
                                ]
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9b81e5e543052ce8$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Score",
                                yAxisId: "score",
                                orientation: "right",
                                domain: [
                                    0,
                                    30
                                ]
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $4d6b5192df4a4236$export$ed247974535929c7), {}),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $079ac3c80abbf2ba$export$17d680238e50603e), {
                                name: "Pins per frame",
                                type: "monotone",
                                yAxisId: "pins",
                                dataKey: "pins",
                                stroke: "#209cee"
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $079ac3c80abbf2ba$export$17d680238e50603e), {
                                name: "Score per frame",
                                type: "monotone",
                                yAxisId: "score",
                                dataKey: "score",
                                stroke: "#23d160"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $c48726348e80dbc5$export$2e2bcd8739ae039 = $c48726348e80dbc5$var$GameStats;


/* @leny/bowlstats
 *
 * /src/components/game-date.tsx
 */ 

const $f3293be3ff66996f$var$NBSP = "\u00a0";
const $f3293be3ff66996f$var$GameDate = ({ date: date, showYear: showYear = false })=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mr-2"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-block", "has-background-danger", "has-text-white", "is-size-7", "px-2", "has-text-centered", "has-text-weight-semibold", "is-uppercase"),
                children: date.format("MMM")
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-block", "has-text-centered", "has-text-black", "has-text-weight-bold", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.date()
            }),
            showYear && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-block", "has-text-black", "is-size-8", "px-2", "has-text-weight-semibold", "is-uppercase", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.format("YYYY")
            })
        ]
    });
var $f3293be3ff66996f$export$2e2bcd8739ae039 = $f3293be3ff66996f$var$GameDate;



const $feb21048dd71ecac$var$NBSP = "\u00a0";
const $feb21048dd71ecac$var$getBallColor = (ball)=>{
    switch(ball.slice(ball.startsWith("H") ? 1 : 0)){
        case "6":
            return "#f8362f";
        case "7":
            return "#c6c20d";
        case "8":
            return "#c81108";
        case "9":
            return "#46435a";
        case "10":
            return "#9b2527";
        case "11":
            return "#1b417d";
        case "12":
            return "#1b6626";
        case "13":
            return "#1f3c7c";
        case "14":
            return "#0aa025";
        case "15":
            return "#262b4b";
        case "16":
            return "#983d28";
        default:
            return "black";
    }
};
const $feb21048dd71ecac$var$Game = ({ game: game, isBest: isBest, isWorst: isWorst, showYear: showYear = false })=>{
    const [showDetails, setShowDetails] = (0, $b7Z9x.useState)(false);
    const date = (0, $b7Z9x.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a256cbbcc8ae3716$exports)))(new Date(game.date.year, game.date.month - 1, game.date.day)), [
        game
    ]);
    const toggleDetails = (0, $b7Z9x.useCallback)(()=>{
        setShowDetails(!showDetails);
    }, [
        showDetails
    ]);
    const $date = /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $f3293be3ff66996f$export$2e2bcd8739ae039), {
        date: date,
        showYear: showYear
    });
    if (!showDetails) return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "is-flex", "is-justify-content-space-between", "is-align-content-center", "px-5", "is-unselectable", "is-clickable"),
        onClick: toggleDetails,
        children: [
            $date,
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames,
                compact: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "px-5"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex", "mb-3", "is-justify-content-space-between", "is-align-content-center"),
                children: [
                    $date,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex", "is-relative", "is-justify-content-center", "is-align-items-center", "has-text-weight-bold", "is-family-secondary", "is-size-5", "has-text-white"),
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: "100%",
                            backgroundColor: $feb21048dd71ecac$var$getBallColor(game.ball)
                        },
                        "data-tooltip": `Played with ${game.ball.slice(game.ball.startsWith("H") ? 1 : 0)}lbs ball ${game.ball.startsWith("H") ? "(house ball)" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-block"),
                                children: game.ball.slice(game.ball.startsWith("H") ? 1 : 0)
                            }),
                            game.ball.startsWith("H") && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-light"),
                                style: {
                                    position: "absolute",
                                    bottom: -1,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    fontSize: 9
                                },
                                children: "H"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("button", {
                        type: "button",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("delete"),
                        onClick: toggleDetails,
                        children: "(hide details)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))(game.note ? "mb-1" : "mb-3"),
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                        children: "Lane Oil Pattern:"
                    }),
                    $feb21048dd71ecac$var$NBSP,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-italic"),
                        children: game.oilPattern || "none/dry"
                    })
                ]
            }),
            game.note && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-3"),
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    $feb21048dd71ecac$var$NBSP,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-italic"),
                        children: game.note
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $c48726348e80dbc5$export$2e2bcd8739ae039), {
                game: game
            })
        ]
    });
};
var $feb21048dd71ecac$export$2e2bcd8739ae039 = $feb21048dd71ecac$var$Game;



const $02f9a7873cc13bf6$var$NBSP = "\u00a0";
const $02f9a7873cc13bf6$var$Games = ()=>{
    const { games: games, filters: filters, stats: stats } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const [reverseOrder, setReverseOrder] = (0, $b7Z9x.useState)(true);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle", "is-flex", "is-flex-direction-row", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("span", {
                        children: [
                            "Games",
                            $02f9a7873cc13bf6$var$NBSP,
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("small", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-7", "is-va-middle", "has-text-grey"),
                                children: `(${games.length})`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-7", "is-va-middle"),
                        href: "#",
                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                            setReverseOrder(!reverseOrder);
                        }),
                        children: "(\u21C5 reverse order)"
                    })
                ]
            }),
            (reverseOrder ? Array.from(games).reverse() : games).map((game, i)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $feb21048dd71ecac$export$2e2bcd8739ae039), {
                    game: game,
                    isBest: stats.avg.best === game.score,
                    isWorst: stats.avg.worst === game.score,
                    showYear: filters.year === null
                }, `${Object.values(game.date).join("-")}-${i}`))
        ]
    });
};
var $02f9a7873cc13bf6$export$2e2bcd8739ae039 = $02f9a7873cc13bf6$var$Games;


/* @leny/bowlstats
 *
 * /src/components/graphs/index.tsx
 */ 
/* @leny/bowlstats
 *
 * /src/components/graphs/score.tsx
 */ 


var $b7Z9x = parcelRequire("b7Z9x");
/* @leny/bowlstats
 *
 * /src/components/graphs/base.tsx
 */ 
/**
 * @fileOverview Composed Chart
 */ 








var $b7Z9x = parcelRequire("b7Z9x");










var $d38d652d8600506a$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
function $d38d652d8600506a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d38d652d8600506a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d38d652d8600506a$var$_typeof(obj);
}
function $d38d652d8600506a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d38d652d8600506a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d38d652d8600506a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d38d652d8600506a$var$_extends() {
    $d38d652d8600506a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d38d652d8600506a$var$_extends.apply(this, arguments);
}
function $d38d652d8600506a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d38d652d8600506a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d38d652d8600506a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d38d652d8600506a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d38d652d8600506a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d38d652d8600506a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d38d652d8600506a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d38d652d8600506a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d38d652d8600506a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d38d652d8600506a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d38d652d8600506a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d38d652d8600506a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d38d652d8600506a$var$_setPrototypeOf(subClass, superClass);
}
function $d38d652d8600506a$var$_setPrototypeOf(o, p) {
    $d38d652d8600506a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d38d652d8600506a$var$_setPrototypeOf(o, p);
}
function $d38d652d8600506a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d38d652d8600506a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d38d652d8600506a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d38d652d8600506a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d38d652d8600506a$var$_possibleConstructorReturn(this, result);
    };
}
function $d38d652d8600506a$var$_possibleConstructorReturn(self, call) {
    if (call && ($d38d652d8600506a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d38d652d8600506a$var$_assertThisInitialized(self);
}
function $d38d652d8600506a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d38d652d8600506a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d38d652d8600506a$var$_getPrototypeOf(o) {
    $d38d652d8600506a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d38d652d8600506a$var$_getPrototypeOf(o);
}
function $d38d652d8600506a$var$_defineProperty(obj, key, value) {
    key = $d38d652d8600506a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d38d652d8600506a$var$_toPropertyKey(arg) {
    var key = $d38d652d8600506a$var$_toPrimitive(arg, "string");
    return $d38d652d8600506a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d38d652d8600506a$var$_toPrimitive(input, hint) {
    if ($d38d652d8600506a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d38d652d8600506a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d38d652d8600506a$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $d38d652d8600506a$var$_inherits(Area, _PureComponent);
    var _super = $d38d652d8600506a$var$_createSuper(Area);
    function Area() {
        var _this;
        $d38d652d8600506a$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d38d652d8600506a$var$_defineProperty($d38d652d8600506a$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $d38d652d8600506a$var$_defineProperty($d38d652d8600506a$var$_assertThisInitialized(_this), "id", (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts-area-'));
        $d38d652d8600506a$var$_defineProperty($d38d652d8600506a$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $d38d652d8600506a$var$_defineProperty($d38d652d8600506a$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $d38d652d8600506a$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $d38d652d8600506a$var$_objectSpread($d38d652d8600506a$var$_objectSpread($d38d652d8600506a$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $d38d652d8600506a$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($fad4eca9fe13ba8f$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $d38d652d8600506a$var$_objectWithoutProperties(_this$props4, $d38d652d8600506a$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1), $d38d652d8600506a$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1), $d38d652d8600506a$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1), $d38d652d8600506a$var$_extends({}, (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $d38d652d8600506a$var$_objectSpread($d38d652d8600506a$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($de32b1105f498fbd$exports)))(baseLine)) {
                            var _interpolator = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $d38d652d8600506a$var$_objectSpread($d38d652d8600506a$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $423c5b3e35d96d0c$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $761130a126329e24$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $b7Z9x.PureComponent));
$d38d652d8600506a$var$_defineProperty($d38d652d8600506a$export$ea1a111407f37557, "displayName", 'Area');
$d38d652d8600506a$var$_defineProperty($d38d652d8600506a$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$d38d652d8600506a$var$_defineProperty($d38d652d8600506a$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $201aa8e07b0747a2$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return min;
        if (baseValue === 'dataMax') return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$d38d652d8600506a$var$_defineProperty($d38d652d8600506a$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $d38d652d8600506a$export$ea1a111407f37557.getBaseValue(props, item, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($e9f4eab8a3ba19aa$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(originalValue);
        if (layout === 'horizontal') return {
            x: (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === 'horizontal') return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, 'value[0]')) && !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, 'y')) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, 'value[0]')) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, 'value[0]')) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($d946048a435dc4a5$exports)))(entry, 'value[0]')) : null,
            y: entry.y
        };
    });
    else if (layout === 'horizontal') baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $d38d652d8600506a$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$d38d652d8600506a$var$_defineProperty($d38d652d8600506a$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $91e8d465d4ebe72b$export$d046b3c4a416f60d), $d38d652d8600506a$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});








var $b7Z9x = parcelRequire("b7Z9x");






/**
 * @fileOverview Z Axis
 */ var $c6f2e058e654908f$export$2363a7fa7edfe988 = function ZAxis() {
    return null;
};
$c6f2e058e654908f$export$2363a7fa7edfe988.displayName = 'ZAxis';
$c6f2e058e654908f$export$2363a7fa7edfe988.defaultProps = {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
};









function $3760210cf4fd40bf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3760210cf4fd40bf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3760210cf4fd40bf$var$_typeof(obj);
}
function $3760210cf4fd40bf$var$_extends() {
    $3760210cf4fd40bf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3760210cf4fd40bf$var$_extends.apply(this, arguments);
}
function $3760210cf4fd40bf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3760210cf4fd40bf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3760210cf4fd40bf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3760210cf4fd40bf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3760210cf4fd40bf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3760210cf4fd40bf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3760210cf4fd40bf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3760210cf4fd40bf$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3760210cf4fd40bf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3760210cf4fd40bf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3760210cf4fd40bf$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3760210cf4fd40bf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3760210cf4fd40bf$var$_setPrototypeOf(subClass, superClass);
}
function $3760210cf4fd40bf$var$_setPrototypeOf(o, p) {
    $3760210cf4fd40bf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3760210cf4fd40bf$var$_setPrototypeOf(o, p);
}
function $3760210cf4fd40bf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3760210cf4fd40bf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3760210cf4fd40bf$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3760210cf4fd40bf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3760210cf4fd40bf$var$_possibleConstructorReturn(this, result);
    };
}
function $3760210cf4fd40bf$var$_possibleConstructorReturn(self, call) {
    if (call && ($3760210cf4fd40bf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3760210cf4fd40bf$var$_assertThisInitialized(self);
}
function $3760210cf4fd40bf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3760210cf4fd40bf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3760210cf4fd40bf$var$_getPrototypeOf(o) {
    $3760210cf4fd40bf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3760210cf4fd40bf$var$_getPrototypeOf(o);
}
function $3760210cf4fd40bf$var$_defineProperty(obj, key, value) {
    key = $3760210cf4fd40bf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3760210cf4fd40bf$var$_toPropertyKey(arg) {
    var key = $3760210cf4fd40bf$var$_toPrimitive(arg, "string");
    return $3760210cf4fd40bf$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3760210cf4fd40bf$var$_toPrimitive(input, hint) {
    if ($3760210cf4fd40bf$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3760210cf4fd40bf$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3760210cf4fd40bf$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    $3760210cf4fd40bf$var$_inherits(Scatter, _PureComponent);
    var _super = $3760210cf4fd40bf$var$_createSuper(Scatter);
    function Scatter() {
        var _this;
        $3760210cf4fd40bf$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$var$_assertThisInitialized(_this), "id", (0, $201aa8e07b0747a2$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $3760210cf4fd40bf$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                return points.map(function(entry, i) {
                    var props = $3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread({
                        key: "symbol-".concat(i)
                    }, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), $3760210cf4fd40bf$var$_extends({
                        className: "recharts-scatter-symbol"
                    }, (0, $f321872aac18bbfb$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        role: "img"
                    }), Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $0a5c28282f32194f$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $201aa8e07b0747a2$export$d871d53bd7eeb390)(0, entry.size);
                        return $3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($a2615da14a6e744e$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(children, (0, $234881ad2855ab77$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var direction = item.props.direction;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(item, {
                        key: i,
                        // eslint-disable-line react/no-array-index-key
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(this.props);
                var customLineProps = (0, $423c5b3e35d96d0c$export$d697c39a2985a4c)(line);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $201aa8e07b0747a2$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $8ee86b32b3d05985$export$b0e83c3ef8d2db1), $3760210cf4fd40bf$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $fdd33d93262f23bd$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $761130a126329e24$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "renderSymbolItem",
            value: function renderSymbolItem(option, props) {
                var symbol;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).isValidElement(option)) symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3946d51b8802f963$exports)))(option)) symbol = option(props);
                else if (typeof option === 'string') symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b7Z9x))).createElement((0, $6382e2250f308631$export$fa456266707bf4e4), $3760210cf4fd40bf$var$_extends({}, props, {
                    type: option
                }));
                return symbol;
            }
        }
    ]);
    return Scatter;
}((0, $b7Z9x.PureComponent));
$3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$export$1c460fb4285edadc, "displayName", 'Scatter');
$3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $51c8fb4726a2e81c$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $3760210cf4fd40bf$var$_defineProperty($3760210cf4fd40bf$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $423c5b3e35d96d0c$export$fdd5e64c0e8495bb)(item.props.children, (0, $f8f3ac98b98deceb$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $c6f2e058e654908f$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(zAxisDataKey) && (0, $3bb158ee6cd3f1ec$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($ee60f1bf9820924c$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $3bb158ee6cd3f1ec$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $3760210cf4fd40bf$var$_objectSpread($3760210cf4fd40bf$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $3760210cf4fd40bf$var$_objectSpread({
        points: points
    }, offset);
});






var $4cdc2777110dac8a$export$f881f4f9e4007a57 = (0, $451a5e3ff2cbaa23$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $079ac3c80abbf2ba$export$17d680238e50603e),
        (0, $d38d652d8600506a$export$ea1a111407f37557),
        (0, $a9b5532e74641027$export$bbc6c6369b38e3d1),
        (0, $3760210cf4fd40bf$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $5a089bb377232adf$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $9b81e5e543052ce8$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $c6f2e058e654908f$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $d709a5412861b060$export$ece7de1383db5ac)
});


const $ae12be518f56504e$var$BaseGraph = ({ data: data, axisId: axisId, axisLabel: axisLabel, domain: domain, padding: padding, referenceLine: referenceLine, hideBall: hideBall = false })=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $c31ab2f543d48c8b$export$e60a4704009a0009), {
        width: "100%",
        height: 350,
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $4cdc2777110dac8a$export$f881f4f9e4007a57), {
            width: 500,
            height: 500,
            data: data,
            margin: {
                top: 10,
                right: 5,
                left: 0,
                bottom: 5
            },
            children: [
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $6774215ffc20680c$export$6440e27b9f186856), {
                    strokeDasharray: "2 2"
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $4d6b5192df4a4236$export$ed247974535929c7), {}),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $5a089bb377232adf$export$ea77231de273b52d), {
                    dataKey: "name",
                    padding: {
                        left: 20,
                        right: 20
                    }
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9b81e5e543052ce8$export$f96c4024c52de8f4), {
                    yAxisId: axisId,
                    domain: domain,
                    interval: "equidistantPreserveStart",
                    orientation: "left",
                    padding: padding
                }),
                referenceLine && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $bdfd78e0730e9c70$export$b2f28e248e7838eb), {
                    yAxisId: axisId,
                    y: referenceLine,
                    stroke: "#257942"
                }),
                !hideBall && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9b81e5e543052ce8$export$f96c4024c52de8f4), {
                            yAxisId: "ball",
                            domain: [
                                6,
                                16
                            ],
                            orientation: "right",
                            tickCount: 6
                        }),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $a9b5532e74641027$export$bbc6c6369b38e3d1), {
                            name: "Ball Weight",
                            dataKey: "ball",
                            yAxisId: "ball",
                            barSize: 20,
                            fill: "#33993366",
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $761130a126329e24$export$835fcf23ab7bf88), {
                                dataKey: "ball",
                                position: "insideBottom"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $079ac3c80abbf2ba$export$17d680238e50603e), {
                    name: "Average",
                    type: "monotone",
                    dataKey: "avg",
                    yAxisId: axisId,
                    stroke: "#ff3860",
                    dot: false
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $079ac3c80abbf2ba$export$17d680238e50603e), {
                    name: axisLabel,
                    type: "monotone",
                    dataKey: axisId,
                    yAxisId: axisId,
                    stroke: "#209cee"
                })
            ]
        })
    });
var $ae12be518f56504e$export$2e2bcd8739ae039 = $ae12be518f56504e$var$BaseGraph;



const $1326d3f4a86a8706$var$ScoreGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const { stats: { avg: { best: best, worst: worst } } } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const data = (0, $b7Z9x.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                score: game.score,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.score : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle"),
                children: "Score"
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Score per game",
                axisId: "score",
                domain: [
                    Math.max(0, worst),
                    Math.min(300, best)
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $1326d3f4a86a8706$export$2e2bcd8739ae039 = $1326d3f4a86a8706$var$ScoreGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/strikes.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");


const $82ccdbc8de77544d$var$StrikesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $b7Z9x.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                strikes: game.stats.strikes,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.strikes : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle", "mt-5"),
                children: "Strikes"
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Strikes per game",
                axisId: "strikes",
                domain: [
                    0,
                    12
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $82ccdbc8de77544d$export$2e2bcd8739ae039 = $82ccdbc8de77544d$var$StrikesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/spares.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");


const $39cce9dfb40ebdd3$var$SparesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $b7Z9x.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                spares: game.stats.spares.total,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.spares.total : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle", "mt-5"),
                children: "Spares"
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Spares per game",
                axisId: "spares",
                domain: [
                    0,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $39cce9dfb40ebdd3$export$2e2bcd8739ae039 = $39cce9dfb40ebdd3$var$SparesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/avg-first-ball-pinfall.tsx
 */ 

var $b7Z9x = parcelRequire("b7Z9x");


const $7a6799eb5c22ef7d$var$AvgFirstBallPinfallGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const data = (0, $b7Z9x.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                afbp: game.stats.avgFirstBallPinfall,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.avgFirstBallPinfall : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle", "mt-5"),
                children: "Average First Ball Pinfall"
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Avg First Ball Pinfall",
                axisId: "afbp",
                domain: [
                    3,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $7a6799eb5c22ef7d$export$2e2bcd8739ae039 = $7a6799eb5c22ef7d$var$AvgFirstBallPinfallGraph;




const $97746599f7bd9693$var$NBSP = "\u00a0";
const $97746599f7bd9693$var$Graphs = ()=>{
    const { games: games } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)((0, $fcb5aa05d5cac59c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $1326d3f4a86a8706$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgScorePerGame
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $7a6799eb5c22ef7d$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgFirstBallPinfall
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $82ccdbc8de77544d$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $39cce9dfb40ebdd3$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            })
        ]
    });
};
var $97746599f7bd9693$export$2e2bcd8739ae039 = $97746599f7bd9693$var$Graphs;



const $59c24c5bc192cdb1$var$GamesContainer = ()=>{
    const [user, setUser] = (0, $b7Z9x.useState)('Mike');
    const [year, setYear] = (0, $b7Z9x.useState)(null);
    const [month, setMonth] = (0, $b7Z9x.useState)(null);
    const [day, setDay] = (0, $b7Z9x.useState)(null);
    const [withHouseBallGames, setWithHouseBallGames] = (0, $b7Z9x.useState)(false);
    const [withDryLaneGames, setWithDryLaneGames] = (0, $b7Z9x.useState)(false);
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $7b5212127b697ff5$export$b514f4c5cf6dd8e6), {
        value: (0, $7b5212127b697ff5$export$431f78a03a8ddc84)(user, year, month, day, withHouseBallGames, withDryLaneGames),
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero-body"),
                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("title", "is-size-3"),
                            children: "Games"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("section", "pt-1"),
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $af6a744d86cd9c4a$export$2e2bcd8739ae039), {
                        user: user,
                        year: year,
                        month: month,
                        day: day,
                        withHouseBallGames: withHouseBallGames,
                        withDryLaneGames: withDryLaneGames,
                        onYearChange: (y)=>{
                            setYear(y);
                        },
                        onMonthChange: (m)=>{
                            setMonth(m);
                        },
                        onDayChange: (d)=>{
                            setDay(d);
                        },
                        onUserChange: (u)=>setUser(u),
                        toggleHouseBallGames: (b)=>{
                            setWithHouseBallGames(b);
                        },
                        toggleDryLaneGames: (b)=>{
                            setWithDryLaneGames(b);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("section"),
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $d1d8966ef2294ff3$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("section", "columns"),
                    children: [
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $02f9a7873cc13bf6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $97746599f7bd9693$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
};
var $59c24c5bc192cdb1$export$2e2bcd8739ae039 = $59c24c5bc192cdb1$var$GamesContainer;


/* @leny/bowlstats
 *
 * /src/containers/leagues.tsx
 */ 


/* @leny/bowlstats
 *
 * /src/components/leagues.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $b7Z9x = parcelRequire("b7Z9x");



/* @leny/bowlstats
 *
 * /src/components/league-day.tsx
 */ 




var $b7Z9x = parcelRequire("b7Z9x");

const $a1bcaa7379a44d59$var$NBSP = "\u00a0";
const $a1bcaa7379a44d59$var$LeagueDay = ({ day: day })=>{
    const date = (0, $b7Z9x.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a256cbbcc8ae3716$exports)))(new Date(day.date.year, day.date.month - 1, day.date.day)), [
        day
    ]);
    const $date = /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $f3293be3ff66996f$export$2e2bcd8739ae039), {
        date: date,
        showYear: true
    });
    const $dayTitle = /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("columns", "mb-2"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column", "is-one-fifth"),
                children: [
                    "Day",
                    $a1bcaa7379a44d59$var$NBSP,
                    day.dayIndex
                ]
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("h5", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column", "is-flex", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                        children: day.team
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-7", "has-text-grey"),
                        children: "vs"
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                        children: day.vs
                    })
                ]
            })
        ]
    });
    if (day.bye) return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-italic", "has-text-centered", "my-5"),
                        children: "bye"
                    }),
                    day.note && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $a1bcaa7379a44d59$var$NBSP,
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ol", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-no-list"),
                        children: day.games.map((game, idx)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-2"),
                                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                                    scratch: game.scratch,
                                    handicap: game.handicap,
                                    score: game.score,
                                    frames: game.frames,
                                    hideHeader: idx > 0
                                })
                            }, game.id))
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-grey"),
                                        children: `Oil patterns (left, right):`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                        children: day.oilPatterns.join(", ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-grey"),
                                        children: `Average:`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                        children: day.avg
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-grey"),
                                        children: `Handicap:`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                        children: day.handicap
                                    })
                                ]
                            })
                        ]
                    }),
                    day.note && /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $a1bcaa7379a44d59$var$NBSP,
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a1bcaa7379a44d59$export$2e2bcd8739ae039 = $a1bcaa7379a44d59$var$LeagueDay;


const $0f9404ff1097dea7$var$Leagues = ()=>{
    const { leagues: leagues } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const [selectedLeague, setSelectedLeague] = (0, $b7Z9x.useState)(leagues[0]);
    if (!leagues.length) return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("section", "py-6"),
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("has-text-centered", "has-text-grey", "my-6", "py-6"),
            children: "No leagues yet."
        })
    });
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("section", "columns", "pt-1"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column", "is-one-fifth"),
                children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("pt-6"),
                    children: leagues.map((league)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("li", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("mb-2"),
                            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("button", "is-fullwidth", selectedLeague.name === league.name && "is-primary"),
                                onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                    setSelectedLeague(league);
                                }),
                                children: league.name
                            })
                        }, league.name))
                })
            }),
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("column", "is-three-fifths"),
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h4", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("is-size-4", "mb-4"),
                        children: selectedLeague.name
                    }),
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
                        children: Array.from(selectedLeague.days).reverse().map((day, index)=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $a1bcaa7379a44d59$export$2e2bcd8739ae039), {
                                day: day
                            }, `league-${selectedLeague.name}-day-${day}-idx-${index}`))
                    })
                ]
            })
        ]
    });
};
var $0f9404ff1097dea7$export$2e2bcd8739ae039 = $0f9404ff1097dea7$var$Leagues;


const $36087b6da2c23874$var$LeaguesContainer = ()=>{
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $7b5212127b697ff5$export$b514f4c5cf6dd8e6), {
        value: (0, $7b5212127b697ff5$export$431f78a03a8ddc84)(),
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("hero-body"),
                        children: [
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h3", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("title", "is-size-3"),
                                children: "Leagues"
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("subtitle", "is-size-5", "has-text-grey"),
                                children: "Records of my league nights."
                            }),
                            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("p", {
                                children: "Those records are only my scores, and not the whole team's."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $0f9404ff1097dea7$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $36087b6da2c23874$export$2e2bcd8739ae039 = $36087b6da2c23874$var$LeaguesContainer;


/* @leny/bowlstats
 *
 * /src/components/footer.tsx
 */ 

const $a9b762fc9098935a$var$BSP = "\u0020";
const $a9b762fc9098935a$var$Footer = ()=>/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("footer", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("footer", "mt-6", "pb-6"),
        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("content", "has-text-centered"),
            children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                        href: "https://github.com/leny/bowlstats",
                        target: "_new",
                        children: /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("strong", {
                            children: "bowlstats"
                        })
                    }),
                    $a9b762fc9098935a$var$BSP,
                    "by",
                    $a9b762fc9098935a$var$BSP,
                    /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)("a", {
                        href: "https://leny.me",
                        target: "_new",
                        children: "leny"
                    })
                ]
            })
        })
    });
var $a9b762fc9098935a$export$2e2bcd8739ae039 = $a9b762fc9098935a$var$Footer;


const $40aa2f7a1bc2f665$var$RootContainer = ()=>{
    const [mode, setMode] = (0, $b7Z9x.useState)("games");
    const $content = mode === "games" ? /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $59c24c5bc192cdb1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $36087b6da2c23874$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($db31a18109b31285$exports)))("container", "is-fluid", "px-0"),
        children: [
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $a59ed6e022fedf74$export$2e2bcd8739ae039), {
                mode: mode,
                onChangeMode: (v)=>{
                    setMode(v);
                }
            }),
            $content,
            /*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $a9b762fc9098935a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $40aa2f7a1bc2f665$export$2e2bcd8739ae039 = $40aa2f7a1bc2f665$var$RootContainer;


const $9b561ab6dfb0f536$var$container = document.querySelector("#root");
(0, $47a9201888aae4ca$export$882461b6382ed46c)($9b561ab6dfb0f536$var$container).render(/*#__PURE__*/ (0, $fcb5aa05d5cac59c$exports.jsx)((0, $40aa2f7a1bc2f665$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.0cbee6c4.js.map
